import { Row } from "react-bootstrap"

let translation = {
    en: {
      locale: 'en-US',
      messages: {
        /*********form response***********/
        //required
        stockMinRequired:'The trigger threshold is required',
        stockGoodRequired:'The restock quantity is required',
        nameRequired: 'The "name" field is required',
        firstnameRequired: 'The "first name" field is required',
        customFieldArticleMatchRequired: 'The "custom field" field is required',
        emailRequired: 'The "email" field is required',
        mailRelanceRequired: 'The "Reminder email" field is required',
        passwordRequired: 'The "password" field is required',
        password_confirmationRequired: 'The "password confirmation" field is required',
        companyRequired: 'The "company" field is required',
        moduleRequired: 'The "module" field is required',
        sectionRequired: 'The "shop" field is required',
        sexeRequired: "The \"sex\" field is required",
        sizeTagRequired:'You must indicate a size',
        typefideliteRequired: 'The "Type of Loyalty Card" field is required',
        maxusemoisRequired: 'The "Period of validity" field is required',
        maxusemoisproformaRequired: 'The "Validity period of a proforma" field is required',
        modepaiementRequired: 'The "Payment methods" field is required',
        themeRequired: 'The "Theme" field is required',
        donneeclientRequired: 'The "Activate the obligation to collect customer data " field is required',
        objectifvendeurRequired: 'The "Seller objective" field is required',
        objectifcommerceRequired: 'The "Shop objective" field is required',
        dixmilleRequired: 'You must indicate the number of 10 000 XPF banknotes',
        cinqmilleRequired: 'You must indicate the number of 5 000 XPF banknotes',
        milleRequired: 'You must indicate the number of 1 000 XPF banknotes',
        cinqcentRequired: 'You must indicate the number of 500 XPF banknotes',
        deuxcentRequired: 'You must indicate the number of  200 XPF coins',
        centRequired: 'You must indicate the number of  100 XPF coins',
        cinquanteRequired: 'You must indicate the number of  50 XPF coins',
        vingtRequired: 'You must indicate the number of  20 XPF coins',
        dixRequired: 'You must indicate the number of  10 XPF coins',
        cinqRequired: 'You must indicate the number of  5 XPF coins',
        deuxRequired: 'You must indicate the number of  2 XPF coins',
        unRequired: 'You must indicate the number of  1 XPF coins',
        gradeRequired: 'You must indicate a grade',
        caRequired: 'You must indicate a CA HT',
        cattcRequired: 'You must indicate a CA TTC',
        pmRequired: 'You must indicate a PM HT',
        pmttcRequired: 'You must indicate a PM TTC',
        tfRequired: 'You must indicate a TF',
        ivRequired: "You must indicate an IV",
        entreRequired: "You must indicate a number of customer visits (entry and exit)",
        beginRequired: "You must indicate the start date",
        endRequired: "You must indicate the end date",
        dayRequired: 'You must indicate the day',
        telephoneRequired: 'Phone is required',
        adresseRequired: "Physical address is required",
         adresseLivraisonRequired: "Delivery address is required",
        adressepostaleRequired: "Postal address is required",
        newsletterRequired: 'You must check the newsletter',
        civiliteRequired: 'Civility is required',
        csvEncodeRequired: 'CSV Encode is required',
        csvSeparatorRequired: 'CSV Separator is required',
        csvDateFormatRequired: 'CSV Date Format is required',
        codeRequired:'Code is required',
        rcsRequired:'RCS is required',
        adressRequired:"Address is required",
        codePostalRequired:'Zip code is required',
        villeRequired:'Town is required',
        paysRequired:'Country is required',
        paysInvalid:'Selected country is not valid',
        codeBanqueRequired: 'Bank Code is required',
        codeGuichetRequired: 'Sort Code is required',
        numeroCompteRequired: 'Account Number is required',
        cleRibRequired: 'RIB Key is required',
        clientTypeRequired: 'A type is required',
        quartierRequired: 'An area is required',
        typeRequired: 'A type is required',
        unspecified:'Unspecified',
        dateDeNaissanceRequired: 'A date of birth is required',
        providerNameRequired: 'You must indicate a provider name',
        contactNameRequired: 'You must indicate a contact name',
        statusRequired: 'You must indicate a status',
        itemFamilyNameRequired: 'You must indicate an item family name',
        brandNameRequired: "You must indicate a brand name",
        categoryRequired: 'You must indicate a category',
        referenceRequired: 'You must indicate a UPC Code',
        referenceToRequired: 'You must indicate a reference',
        skuRequired: 'You must indicate a SKU',
        internalidRequired: 'You must indicate the internal ID of the item',
        priceRequired: "You must indicate a tax-inclusive price",
        tgcRequired: 'You must indicate the {taxe} rate',
        prmpRequired: 'You must indicate the Average Cost',
        havestockRequired: 'You must indicate if this item must be dependent on a stock',
        toPrepareRequired: 'You must indicate if this item must be prepared',
        colorHexaRequired: 'You must indicate a hexadecimal color code',
        banqueRequired: 'You must indicate the bank name',
        customFieldRequired: 'You must fill the "{name}"',
        numeroShipmentRequired:'You must indicate the shipment number',
        cartonRequired:'You must indicate the box reference',
        shdeCartonNameRequired:'You must indicate the box reference',
        shdeQuotaPrevuRequired:"You must indicate the expected quantity",
        firstStartBinsRequired:'You must indicate the beginning of the first level',
        firstEndBinsRequired:'You must indicate the end of the first level',
        zoneRequired:'You must indicate the zone',
        secondEndBinsRequiredWith:"You must indicate the end of the first level if the beginning of the first level is filled",
        thirdEndBinsRequiredWith:"You must indicate the end of the second level if the beginning of the second level is filled",
        fourthEndBinsRequiredWith:"You must indicate the end of the third level if the beginning of the third level is filled",
        fifthEndBinsRequiredWith:"You must indicate the end of the fourth level if the beginning of the fourth level is filled",
        firstBinsRequired:'You must indicate the first level',
        quotaRequired: 'The quantity is required',
        actionRequired:'You must indicate the action',
        binsRequired:'You must indicate the bins',
        quantiteRequired:"You must indicate the quantity",
        fieldRequired:'This field is required',
        expectedRequired: 'The desired date of execution is required',
        rhRequired: 'A staff is required',
        rhBarreRequired: 'A staff barcode is required',
        osectionRequired: 'The origin shop is required',
        fsectionRequired: 'The destination shop is required',
        rpRequired: 'The reorder point is required',
        pslRequired: 'The preferred stock level is required',
        toMaxRequired: "The maximum number of instructions in a transfer order is required",
        articleRequired: 'You must choose an item',
        promotionRequired: "You must choose a promotion",
        allFieldsRequired: 'All fields should be filled',
        promoImport:'Promotions import',
        codeCaisseRequired: 'A POS identifier is required',
        caisseIdentRequired:'The POS identifier is required',
        hostRequired:'You must provide an IP address',
        comPortRequired:'You must provide a COM port',
        modelRequired:'You must choose a model',
        poRequired:'Purchase Order is required',
        waitingEpt:'Waiting for EPT',
        errorEpt:'Error response EPT',
        newCheckoutShortcutProfil:"New shortcut profile",
        newKpiFilter:'New KPI filter',
        checkoutShorcutProfil:"Shortcut profiles",
        nbrCelluleParLigne:'Number of cells per row',
        fromCustomField:'Custom field',
        fullCustom:'Other group',
        customFieldN1:'Based on custom field',
        valueCustofieldN1:'Custom field value',
        niveauCustomField:'Level {n} based on custom field',
        addLevel:'Add a level',
        kpiFilter:'KPI filter',
        itemFilter:'Item filter',
        itemCompareFilter:'Item compare filter',
        titreRequired:'Title is required',
        messageRequired:'Message is required',
        dateRequired:'Date is required',
        capitalRequired:'Capital is required',
        exerciceStartRequired:'Exercise start is required',
        montantRequired:'You must provide an amount',
        itemsRequiredInTo:'You can\'t submit a transfer order without items',
        selectShopsBeforeSearch:'Select an origin and destination shop before searching for an item',
        confirmChangeShopTitle:'Change shop?',
        confirmChangeShopText:'Changing the origin or destination shop will clear your item list. Do you want to continue?',
        pageNamerequired:'You must indicate the page name',
        filtreNamerequired:'You must indicate the favorite name',
        heureRequired:'Hours is required',
        minuteRequired:'Minutes is required',
        valueRequired:'A value is required',
        clientRequired:'Client is required',
        noteRequired:'Note is required',
        delaiReglementRequired:"Payment time is required",
        modeReglementRequired:"Payment time is required",
        modePaiementRequired:"You must indicate a default payment mode",
        modePaiementInvalid:'The value entered is not a valid payment method for this company',
        clientTypeInvalid:'The value entered is not a valid client type for this company',
        modeReglementInvalid:'The value entered is not a valid payment term',
        prefixRequired:'You must indicate a prefix',
        articleListRequired:'You must indicate if you want to generate an item list',
        articleListNameRequired:'You must indicate an item list name',
        replaceRequired:'You must indicate if you want to replace existing barcode',
        itemReplaceRequired:'You must indicate if you want to replace existing items',
        sectionAndZoneAdvanceParamsRequired:'You must configure a default store and zone for item listings in the company\'s advanced settings.',
        cardRequired:'Card is required',
        deviseAchatRequired:'The buying currency is required',
        internalIdRequired:'The internalid is required',
        //Min
        capitalMin1:'The capital must be at least 1 XPF',
        fondCaisseMin1:'The cash float must be at least 1 XPF',
        poidsMin1:'The minimum weight is 1',
        exerciceStartMin1:"The exercise start must be at least 1 (January)",
        pageNameMin2: 'The page name must be at least 2 characters long',
        filtreNameMin2: 'The favorite name must be at least 2 characters long',
        nameMin2: 'The "name" field must be at least 2 characters long',
        nameMin5: 'The "name" field must be at least 3 characters long',
        skuMin2: 'The "Sku" field must be at least 2 characters long',
        firstnameMin2: 'The "first name" field must be at least 2 characters long',
        passwordMin8: 'The "password" field must be at least 8 characters long',
        phonedMin6: 'The "phone" field must be at least 6 characters long',
        phoneMin6: 'The "phone" field must be at least 6 characters long',
        maxusemoisdMin1: 'The "Period of validity" field must be at least 1 month',
        maxusemoisproformaMin1: 'The "Validity period of a proforma" field must be at least 1 month',
        dixmilleMin0: 'The number of 10 000 XPF banknotes must be at least 0',
        cinqmilleMin0: 'The number of 5 000 XPF banknotes must be at least 0',
        milleMin0: 'The number of 1 000 XPF banknotes must be at least 0',
        cinqcentMin0: 'The number of 500 XPF banknotes must be at least 0',
        deuxcentMin0: 'The number of 200 XPF coins must be at least 0',
        centMin0: 'The number of 100 XPF coins must be at least 0',
        cinquanteMin0: 'The number of 50 XPF coins must be at least 0',
        vingtMin0: 'The number of 20 XPF coins must be at least 0',
        dixMin0: 'The number of 10 XPF coins must be at least 0',
        cinqMin0: 'The number of 5 XPF coins must be at least 0',
        deuxMin0: 'The number of 2 XPF coins must be at least 0',
        unMin0: 'The number of 1 XPF coins must be at least 0',
        caMin0: 'The CA HT must be at least 0',
        cattcMin0: 'The CA TTC must be at least 0',
        pmMin0: 'The PM HT must be at least 0',
        pmttcMin0: 'The PM TTC must be at least 0',
        tfMin0: 'The TF must be at least 0',
        ivMin0: 'The IV must be at least 0',
        entreMin0: "The number of customer visits (entry and exit) must be at least 0",
        codeMin3: 'The "code" field must be at least 3 characters long',
        codeMin2: 'The "code" field must be at least 2 characters long',
        rcsMin5: 'The "RCS" field must be at least 5 characters long',
        codeBanqueMin5: 'The "Bank Code" field must be at least 5 characters long',
        codeGuichetMin5: 'The "Sort Code" field must be at least 5 characters long',
        numeroCompteMin11: 'The "Account Number" field must be at least 11 characters long',
        cleRibMin2: 'The "RIB Key" field must be at least 2 characters long',
        nomContactMin2: 'Contact name must be at least 2 characters long',
        priceMin: 'The price can\'t be under 0',
        promoPriceMin: 'The promotionnal price can\'t be under 0',
        tgcMin: 'The TGC rate can\'t be under 0',
        colorHexaMin: "The hexadecimal color code must have 6 characters",
        buyPriceMin: 'The buying price can\'t be under 0',
        prmpMin: 'The Average Price can\'t be under 0',
        prMin: 'The Cost Price can\'t be under 0',
        lastBuyPriceMin: 'The last buy price can\'t be under 0',
        lastBuyePriceDeviseMin: 'The last buy price in currency can\'t be under 0',
        indicePrmpMin: 'The Average Cost indice can\'t be under 0',
        indicePrMin: 'The Cost Price indice can\'t be under 0',
        deviseAchatMin: 'The buying currency must have 3 characters',
        quotaMin: 'The quantity can\'t be under 0',
        quotaCommandeMin: 'The quantity can\'t be under 0',
        numeroShipmentMin2:'The field "shipment number" must be at least 2 characters long',
        cartonMin1: 'The box reference must be at least 1 characters long',
        shdeCartonNameMin2: 'The box reference must be at least 2 characters long',
        shdeQuotaPrevuMin: 'The expected quantity can\'t be under 0',
        firstStartBinsMin0:'The beginning of the first level can\'t be under 0',
        firstEndBinsMin0:'The end of the first level can\'t be under 0',
        secondStartBinsMin0:'The beginning of the second level can\'t be under 0',
        secondEndBinsMin0:'The end of the second level can\'t be under 0',
        thirdStartBinsMin0:'The beginning of the third level can\'t be under 0',
        thirdEndBinsMin0:'The end of the third level can\'t be under 0',
        fourthStartBinsMin0:'The beginning of the fourth level can\'t be under 0',
        fourthEndBinsMin0:'The end of the fourth level can\'t be under 0',
        fifthStartBinsMin0:'The beginning of the fifth level can\'t be under 0',
        fifthEndBinsMin0:'The end of the fifth level can\'t be under 0',
        firstBinsMin0:'The first level can\'t be under 0',
        secondBinsMin0:'The second level can\'t be under 0',
        thirdBinsMin0:'The third level can\'t be under 0',
        fourthBinsMin0:'The fourth level can\'t be under 0',
        fifthBinsMin0:'The fifth level can\'t be under 0',
        referencePoMin2:'The purchase order reference must be at least 2 characters long',
        rpIsMin0:'{name} reorder point RP can\'t be under 0',
        pslIsMin0:'{name} preferred stock level PSL can\'t be under 0', 
        quantityRequired:'The quantity is required',
        quantiteMin0:'The quantity can\'t be under 0',
        quantiteGreaterThan0:'The quantity must be greater than 0',
        referenceToMin2:'Reference must be at least 2 characters long',
        rpMin0:'The reorder point can\'t be less than 0',
        pslMin0:"The preferred stock level can't be less than 0",
        toMaxMin10:"The maximum number of instructions in a transfer order can't be less than 10",
        giftCardMin1:'The validity period of a deposit on a gift card cannot be less than 1 month',
        giftCardMontantMin: 'The Gift Card amount can\'t be less than 1',
        paiementMin: "The payment indications must be over 0",
        modifManualValueMin0: 'The value must be equal or over 0',
        modifManualValueMin1: 'You cannot enter a value lower than 1',
        codeCaisseMin4: 'The POS ident must be at least 4 characters long',
        detailModePaiementMin0: 'The values can\'t be less than 0',
        titreMin2: 'The title can\'t be less than 2 characters long',
        messageMin2:"The message can't be less than 2 characters long",
        typeMin2:"The type can't be less than 2 characters long",
        ticketNameMin1:"The title on receipt can't be less than 1 character long",
        heureMin0:'Hours can\'t be less than 0',
        minuteMin0:'Minutes can\'t be less than 0',
        prefixMin1Max12:'The prefix must be between 1 and 12 characters.',
        articleListNameMin2:'The item list name must be at least 2 characters long',
        creditMin:'Credit can\'t be less than 0',
        abonnementMin:"Subscription can't be less than 0",
        weightMin:"Volume can't be less than 0",
        minimumCommandeMin:'The minimum order quantity can\'t be less than 0',
        valueMin0:'Value can\'t be less than 0',
        //Max
        exerciceStartMax12:"The exercise start cannot be higher than 12 (December)",
        poidsMax100:'The maximum weight is 100',
        lineLimitationZoneContent:'The display is limited to 1000 lines',
        quantiteMax8000000:'The quantity must be less than 8 000 000',
        quantityMax9999999:'The quantity must be less than 9 999 999',
        pageNameMax191:'The page name must be less than 191 characters',
        filtreNameMax191:'The favorite name must be less than 191 characters',
        nameMax191: 'The "name" field must be less than 191 characters',
        nameMax250: 'The "name" field must be less than 250 characters',
        nameMax50: 'The "name" field must be less than 50 characters',
        skuMax250: "The \"Sku\" field must be less than 250 characters",
        nbrCelluleMin1:'The number of cells must be at least 1',
        nbrCelluleMax20:'The number of cells must be less than 20',
        phoneMax20: 'The "phone" field must be less than 20 characters',
        firstnameMax50: 'The "first name" field must be less than 50 characters',
        firstnameMax191: 'The "first name" field must be less than 191 characters',
        nameMax20: 'The "name" field must be less than 20 characters',
        logoMax50: 'The "logo" field must be less than 50 characters',
        gradeMax50: 'The "grade" field must be less than 50 characters',
        maxusemoisdMax120: 'The "Period of validity" field cannot exceed 120 months',
        maxusemoisproformaMax120: "The \"Validity period of a proforma\" field cannot exceed 120 months",
        caMax2000000000: 'The CA HT cannot exceed 2 000 000 000 XPF',
        cattcMax2000000000: 'The CA TTC cannot exceed 2 000 000 000 XPF',
        pmMax2000000000: 'The PM HT cannot exceed 2 000 000 000 XPF',
        pmttcMax2000000000: 'The PM TTC cannot exceed 2 000 000 000 XPF',
        fondCaisseMax1000000: 'The cash float cannot exceed 1 000 000 XPF',
        tfMax100: 'The TF cannot exceed 100 %',
        ivMax999: 'The IV cannot exceed 999 items',
        entreMax10000000: "The number of customer visits (entry and exit) cannot exceed 10 000 000",
        codeMax5: 'The "code" field must be less than 5 characters',
        rcsMax20: 'The "RCS" field must be less than 20 characters',
        codeBanqueMax5: 'The "Bank Code" field must be less than 5 characters',
        codeGuichetMax5: 'The "Sort Code" field must be less than 5 characters',
        numeroCompteMax11: 'The "Account Number" field must be less than 11 characters',
        cleRibMax2: 'The "RIB Key" field must be less than 2 characters',
        nomContactMax191: 'Contact name must be less than 191 characters',
        priceMax: 'The price can\'t be over 999999999.99',
        referenceMax191: 'The UPC code must be less than 191 characters',
        reference2Max191: 'The UPC code 2 must be less than 191 characters',
        internalIdMax191: 'The internal ID must be less than 191 characters',
        referenceToMax191: 'The reference must be less than 191 characters',
        skuMax191: 'The SKU must be less than 191 characters',
        parentNameMax250: 'The Parent Name must be less than 250 characters',
        promoPriceMax: 'The promotionnal price can\'t be over 999999999.99',
        prmpMax: 'The Average Cost can\'t be over 999999999.99',
        prMax: 'The Cost Price can\'t be over 999999999.99',
        lastBuyPriceMax: 'The last buy price can\'t be over 999999999.99',
        lastBuyePriceDeviseMax: 'The last buy price in currency can\'t be over 999999999.99',
        tgcMax: 'The TGC rate can\'t be over 100',
        imageMax250: 'The image link must be less than 250 characters',
        colorHexaMax: "The hexadecimal color code must have 6 characters",
        buyPriceMax: 'The buying price can\'t be over 999999999.99',
        indicePrmpMax: 'The indice Average Cost can\'t be over 999999999.99',
        indicePrMax: 'The indice Coast Price can\'t be over 999999999.99',
        deviseAchatMax: 'The buying currency must have 3 characters',
        maxPhoneLength6: "Phone number must contain a maximum of 6 digits",
        quotaCommandeMax: 'The quantity can\'t be over 8000000',
        quotaMax: 'The quantity can\'t be over 8000000',
        quotaMax10000: 'The quantity can\'t be over 10000',
        numeroShipmentMax190:'The shipment number must be less than 190 characters',
        cartonMax250: 'The box reference must be less than 250 characters',
        shdeCartonNameMax250: 'The box reference must be less than 250 characters',
        shdeQuotaPrevuMax: 'The expected quantity can\'t be over 8000000',
        firstStartBinsMax32000:"The beginning of the first level can't be over 32000",
        firstEndBinsMax32000:"The end of the first level can't be over 32000",
        secondStartBinsMax32000:"The beginning of the second level can't be over 32000",
        secondEndBinsMax32000:"The end of the second level can't be over 32000",
        thirdStartBinsMax32000:"The beginning of the third level can't be over 32000",
        thirdEndBinsMax32000:"The end of the third level can't be over 32000",
        fourthStartBinsMax32000:"The beginning of the fourth level can't be over 32000",
        fourthEndBinsMax32000:"The end of the fourth level can't be over 32000",
        fifthStartBinsMax32000:"The beginning of the fifth level can't be over 32000",
        fifthEndBinsMax32000:"The end of the fifth level can't be over 32000",
        firstBinsMax32000:"The first level can't be over 32000",
        secondBinsMax32000:"The second level can't be over 32000",
        thirdBinsMax32000:"The third level can't be over 32000",
        fourthBinsMax32000:"The fourth level can't be over 32000",
        fifthBinsMax32000:"The fifth level can't be over 32000",
        referencePoMax190:'The purchase order reference must be less than 190 characters',
        rpIsMax8000000:"{name} reorder point RP can't be over 8000000",
        pslIsMax8000000:"{name} preferred stock level PSL can't be over 8000000",
        generateBarcodeMax1000:"You can't generate more than 1000 barcodes",
        rpMax8000000:'The reorder point can\'t be over 8000000',
        pslMax8000000:"The preferred stock level can't be over 8000000",
        toMaxMax1000:"The maximum number of instructions in a transfer order can't be over 1 000",
        giftCardMax120:"The validity period of a deposit on a gift card cannot be more than 120 months",
        giftCardMontantMax: 'The Gift Card amount can\'t be over 100 000 000',
        paiementMax: "The payment indications must be less than 1 000 000 000",
        codeCaisseMax30: 'The POS ident must be less than 30 characters long',
        cashOutReasonMax100: 'The cash out reason must be less than 100 characters',
        titreMax250: 'The title must be less than 250 characters',
        typeMax50: 'The type must be less than 50 characters',
        ticketNameMax15:'The title on receipt must be less than 15 characters long',
        heureMax23:'Hours must be less than 23',
        minuteMax59:'Minutes must be less than 59',
        articleListNameMax191:'The item list name must be less than 191 characters',
        creditMax:'Credit must be less than 999999',
        abonnementMax:'Abonnement must be less than 999999',
        unitMax191:'Unit must be less than 191',
        weightMax:"Volume must be less than 999999",
        minimumCommandeMax:'The minimum order quantity must be less than 999999999',
        defaultConditionnementNameMax250:'The default packaging name must be less than 250 characters long',
        valueMax100:'Value must be less than 100',
        //email
        emailEmail: 'The "email" field must be a valid email',
        //unique
        emailUnique: 'There is already an account registered with this email address',
        emailExists: 'A customer with this email address already exists',
        nameUnique: 'This name already exists',
        skuUnique: 'An other item already have the same Sku',
        referenceUnique: 'The UPC Code is already use by an other item',
        referenceEnumereUnique: 'The bar code of the packagin is already use by an other an other packaging',
        reference2Unique: 'The UPC Code 2 is already use by an other item',
        skuUnique: 'The SKU is already use by an other item',
        alreadyExist: 'has already been assigned',
        sectionUnique: 'This section already exist',
        zoneInventaireAlreadyExists: 'You already have an inventory area with the same name',
        alreadyAvoirAndCantBeCancelled:'This invoice is alreay link with a credit note and cannot be cancelled',
        //confirmed
        passwordConfirmed: 'The password was incorrectly confirmed',
        confirmDifferentQuantityCollected:'The collected quantity does not match with the quantity asked, confirm ?',
        confirmDifferentQuantityReceipt:'The received quantity does not match with the collected quantity, confirm ?',
        confirmCancelSaleOrder:'Are you sure you want to cancel this sale order',
        confirmValidateDocument:'Are you sure you want to validate this document',
        confirmCancelDocument:'Are you sure you want to cancel this invoice ? That will create a Credit note.',
        confirmValidateDeliveryNote:'Are your sure you want to validate this delivery note ? This will remove the items from this delivery note from stock',
        confirmConvertDeliveryNoteToInvoice:'Are your sure you want to convert this document in invoice?',
        //In
        roleIn: 'The assigned role is not accepted',
        sexeIn: 'The assigned sexe is not accepted',
        themeIn: 'The assigned theme is not accepted',
        modepaiementIn: 'One of the payment methods indicated is not accepted',
        priorityIn: 'The "Priority" value must be equal to Yes or No',
        customFieldIn: 'The field "{name}" has an invalid value',
        encryptionIn: 'The encryption must be ssl or tls',
        incorrectRemiseType:'Incorrect remise type',
        //exists
        fileDoesntExists:'File does not exist',
        companyExists: 'This company does not exist',
        moduleExists: 'This module does not exist',
        sectionExists: 'This shop does not exist',
        rhExists: 'This staff does not exist',
        gradeExists: 'This grade does not exist',
        typefideliteExists: 'This type of Loyalty Card does not exist',
        programfideliteExists: 'This program of Loyalty Card does not exist',
        programgiftcardExists: 'This program of Gift Card does not exist',
        clientExists: 'There is already a registered customer with this firstname and last name',
        clientIdNotExists: 'This client ID does not exist',
        fournisseurIdNotExists:'This provider ID does not exist',
        giftCardExists: 'There is already a registered Gift Card with this reference',
        internalIdExists: 'Internal ID is incorrect',
        expectedInternalIdAlreadyExists: 'Expected Internal ID alrready exist',
        internalNotIdExists: 'Internal Id already exists',
        firstlevelcatExists: 'No match found with the "Classification" field',
        secondlevelcatExists: 'No match found with the "Femille" field',
        thirdlevelcatExists: 'No match found with the "Sous-famille" field',
        fourthlevelcatExists: 'No match found with the "Catégorie" field',
        fifthlevelcatExists: 'No match found with the "Sous-catégorie" field',
        fournisseurExists: 'No match found with the "Fournisseur" field',
        fournisseurExistsImport:'Provider already exist',
        marqueExists: 'No match found with the "Marque" field',
        nameExists: 'This name is already in use',
        referenceExists: 'This reference is already in use',
        articleNameExists: 'No item matches this item name',
        articleNameAlreadyExists: 'This item name is already use by an other item',
        supplementListNameAlreadyExists: 'This supplement list name is already use by a another list',
        articleSkuExists: 'No item matches this Sku',
        poNameExists: 'This purchase orders doesn\'t exist',
        devisNotExists: 'This quotation doesn\'t exist',
        sectionCodeExists: 'This shop code doesn\'t exist',
        numeroShipmentExists: 'This shipment number is already used',
        shipmentNameExists: 'This shipment number doesn\'t exists',
        idsExists: 'ID is wrong',
        binsExists: 'A bins with the same adress already exist for this stock zone',
        shdeCartonNameExists: 'This box doesn\'t exist in this shipment',
        binsAlreadyExistsInSection: 'There is already a bins with the same adress in this shop',
        binsNotInThisSection: 'This bins doesn\'t exists in this shop',
        binsNotInThisZone: 'This bins doesn\'t exists in this location',
        zoneNotInThisSection: 'This location doesn\'t exists in this shop',
        binsNotExist: 'This bins doesn\'t exists',
        binsNotExistInToList: 'This bins doesn\'t appear in this tansfer order',
        binsNotExistInInventory:'This bins not appear in your inventory zone',
        itemNotExistInInventory:'This item not appear in your inventory zone',
        codeCaisseExists: 'This POS ident is already use',
        caisseIdentExists:'This POS identifier doesn\'t exist',
        namePeripheriqueExists:'This device name is already in use',
        articleAlreadyInTo:'Item is already in this transfer order',
        defaultConditionnementExists:'This packaging does not exist',
        //array
        moduleArray: 'An unexpected error has occurred',
        sectionArray: 'An unexpected error has occurred',
        rhArray: 'An unexpected error has occurred',
        modepaiementArray: 'An unexpected error has occurred',
        raisonmodifprixArray: 'An unexpected error has occurred',
        componentsIsArray: 'An unexpected error has occurred',
        articlesArray: 'An unexpected error has occurred',
        cartonArray: 'An unexpected error has occurred',
        //General
        sectionGeneral: 'An unexpected error has occurred',
        rhGeneral: 'An unexpected error has occurred',
        programfideliteGeneral: 'An unexpected error has occurred',
        programgiftcardGeneral: 'An unexpected error has occurred',
        forbiddenGeneral: 'You are not authorized to perform this action',
        //Numeric
        maxusemoisNumeric: 'The "Period of validity" field must be a numeric value',
        maxusemoisproformaNumeric: 'The "Validity period of a proforma" field must be a numeric value',
        dixmilleNumeric: 'The 10 000 XPF banknotes must be a numeric value',
        cinqmilleNumeric: 'The 5 000 XPF banknotes must be a numeric value',
        milleNumeric: 'The 1 000 XPF banknotes must be a numeric value',
        cinqcentNumeric: 'The 500 XPF banknotes must be a numeric value',
        deuxcentNumeric: 'The 200 XPF coins must be a numeric value',
        centNumeric: 'The 100 XPF coins must be a numeric value',
        cinquanteNumeric: 'The 50 XPF coins must be a numeric value',
        vingtNumeric: 'The 20 XPF coins must be a numeric value',
        dixNumeric: 'The 10 XPF coins must be a numeric value',
        cinqNumeric: 'The 5 XPF coins must be a numeric value',
        deuxNumeric: 'The 2 XPF coins must be a numeric value',
        unNumeric: 'The 1 XPF coins must be a numeric value',
        caNumeric: 'The CA HT must be a numeric value',
        cattcNumeric: 'The CA TTC must be a numeric value',
        pmNumeric: 'The PM HT must be a numeric value',
        pmttcNumeric: 'The PM TTC must be a numeric value',
        tfNumeric: 'The TF must be a numeric value',
        ivNumeric: 'The IV must be a numeric value',
        capitalNumeric:'The capital must be a numeric value',
        exerciceStartNumeric:'The exercise start must be a numeric value',
        entreNumeric: "The number of customer visits (entry and exit) must be a numeric value",
        codeBanqueNumeric: 'The "Bank Code" must be a numeric value',
        codeGuichetNumeric: 'The "Sort Code" must be a numeric value',
        numeroCompteNumeric: 'The "Account Number" must be a numeric value',
        cleRibNumeric: 'The "RIB Key" must be a numeric value',
        priceNumeric: 'The Price must be a numeric value',
        promoPriceNumeric: "The Promotional Price must be a numeric value",
        prmpNumeric: "The Average Cost must be a numeric value",
        prNumeric: 'The Cost Price must be a numeric value',
        lastBuyPriceNumeric: 'The last buy price must be a numeric value',
        lastBuyePriceDeviseNumeric: 'The last buy price in currency must be a numeric value',
        tgcNumeric: 'The TGC rate must be a numeric value',
        invalidTauxTgc: 'Invalid TGC rate',
        invalidTauxTva: 'Invalid VAT rate',
        buyPriceNumeric: 'The buying price must be a numeric value',
        indicePrmpNumeric: "The Average Cost index must be a numeric value",
        indicePrNumeric: "The Cost Price index must be a numeric value",
        internalIdNumeric: 'Internal Id must be a numeric value',
        componentInternalIdNumeric: 'Component Internal Id must be a numeric value',
        expectedInternalIdNumeric: 'Expected Internal Id must be a numeric value',
        referenceNumeric: 'The UPC code must be a numeric value',
        quotaNumeric: 'The quantity must be a numeric value',
        quotaCommandeNumeric: 'The quantity must be a numeric value',
        shdeQuotaPrevuNumeric: 'The expected quantity must be a numeric value',
        firstStartBinsNumeric: 'The beginning of the first level must be a numeric value',
        firstEndBinsNumeric: 'The end of the first level must be a numeric value',
        secondStartBinsNumeric: 'The beginning of the second level must be a numeric value',
        secondEndBinsNumeric: 'The end of the second level must be a numeric value',
        thirdStartBinsNumeric: 'The beginning of the third level must be a numeric value',
        thirdEndBinsNumeric: 'The end of the third level must be a numeric value',
        fourthStartBinsNumeric: 'The beginning of the fourth level must be a numeric value',
        fourthEndBinsNumeric: 'The end of the fourth level must be a numeric value',
        fifthStartBinsNumeric: 'The beginning of the fifth level must be a numeric value',
        fifthEndBinsNumeric: 'The end of the fifth level must be a numeric value',
        firstBinsNumeric: 'The first level must be a numeric value',
        secondBinsNumeric: 'The second level must be a numeric value',
        thirdBinsNumeric: 'The third level must be a numeric value',
        fourthBinsNumeric: 'The fourth level must be a numeric value',
        fifthBinsNumeric: 'The fifth level must be a numeric value',
        rpIsNumeric:'{name} reorder point RP must be a numeric value',
        pslIsNumeric:'{name} preferred stock level PSL must be a numeric value',
        quantiteNumeric:'The quantity must be a numeric value',
        rpNumeric:"The reorder point must be a numeric value",
        pslNumeric:"The preferred stock level must be a numeric value",
        toMaxNumeric:'The maximum number of instructions in a transfert order must be a numeric value',
        giftCardNumeric:'The validity period of a deposit on a gift card must be a numerical value',
        giftCardMontantNumeric: 'The Gift Card amount must be a numeric value',
        paiementNumeric: "The payment indications must be numeric values",
        modifManualValueNumeric: 'The value must be numeric',
        detailModePaiementNumeric: 'All values must be numerics',
        maxArticleInventaire:'Your inventory cannot contain more than 500 references',
        maxZoneInventaire:'Your inventory cannot contain more than 500 inventory areas',
        prefixNumeric:'The prefix must be a numeric value',
        weightNumeric:'Weight must be a numeric value',
        minimumCommandeNumeric:'The minimum order quantity must be a numeric value',
        pourcentageRefacturationNumeric:'The commission percentage must be a numeric value',
        valueNumeric:'Value must be a numeric value',
        // Integer
        creditInteger:'Credit must be an integer',
        abonnementInteger:'Abonnement must be an integer',
        nbrCelluleInteger:'The number of cells must be an integer',
        //Boolean
        noNoteForArticleRetour:'You must indicate a note on return items',
        donneeclientBoolean: 'An unexpected error has occurred',
        objectifvendeurBoolean: 'An unexpected error has occurred',
        objectifcommerceBoolean: 'An unexpected error has occurred',
        replaceBoolean:'An unexpected error has occurred',
        articleListBoolean:'An unexpected error has occurred',
        lockLineIsBoolean:'An unexpected error has occurred',
        //General
        unknowError: 'An unexpected error has occurred',
        /*********AI assistant***********/
        chatbotIaTitle: 'AI assistant',
        chatbotIaOpen: 'Open the AI assistant',
        chatbotIaClose: 'Close',
        chatbotIaExpand: 'Enlarge',
        chatbotIaReduce: 'Reduce',
        chatbotIaNewChat: 'New conversation',
        chatbotIaPlaceholder: 'Ask your question...',
        chatbotIaSend: 'Send',
        chatbotIaMicStart: 'Dictate your message',
        chatbotIaMicStop: 'Stop dictation',
        chatbotIaMicDenied: 'Microphone access is blocked. Allow it in your browser settings (and, on iPhone, enable Dictation in Settings > General > Keyboard).',
        chatbotIaMicError: 'Voice dictation is unavailable right now.',
        chatbotIaAttach: 'Attach a document (PDF or image)',
        chatbotIaAttachRemove: 'Remove this attachment',
        chatbotIaFileDefaultText: 'Here is a document.',
        chatbotIaFileTooMany: 'Up to 5 documents per conversation. Start a new conversation to attach others.',
        chatbotIaFileTooLarge: 'This document is too large (5 MB maximum).',
        chatbotIaFileInvalid: 'This document could not be read.',
        chatbotIaFileUnsupported: 'Unsupported format: PDF, JPEG, PNG, GIF or WebP only.',
        chatbotIaFilePdfTooLong: 'This PDF has too many pages (100 maximum).',
        chatbotIaFileDownload: 'Download',
        chatbotIaFileLines: '{nb} item(s), to review before importing',
        chatbotIaMemory: "Assistant's memory",
        chatbotIaMemoryHint: 'To add an instruction, say for example "remember that..." in the chat. These instructions apply to you only.',
        chatbotIaMemoryEmpty: 'Nothing remembered yet.',
        chatbotIaMemoryCount: '{nb} / {max} instructions',
        chatbotIaMemoryDelete: 'Forget this instruction',
        chatbotIaMemoryBack: 'Back to the conversation',
        chatbotIaMemorySaved: 'Instruction remembered',
        chatbotIaMemoryReplaced: 'Instruction replaced',
        chatbotIaMemoryForgotten: 'Instruction forgotten',
        chatbotIaRecording: 'Recording...',
        chatbotIaSpeakOn: 'Read replies aloud',
        chatbotIaSpeakOff: 'Stop reading replies aloud',
        chatbotIaSpeakStop: 'Stop speaking',
        chatbotIaWelcome: 'Hello, how can I help you?',
        chatbotIaUsage: 'Monthly usage',
        chatbotIaConfirm: 'Confirm',
        chatbotIaCancel: 'Cancel',
        chatbotIaCancelled: 'Action cancelled',
        chatbotIaNotAllowed: 'You are not authorized to use the AI assistant. Please contact your administrator.',
        chatbotIaBusy: 'The assistant is very busy, please try again in a moment.',
        chatbotIaUnavailable: 'The assistant is unavailable at the moment.',
        chatbotIaNoAnswer: 'I could not answer this question. Could you rephrase it?',
        chatbotIaNoPack: "The AI assistant is not available: no AI pack is active for your company.",
        chatbotIaQuotaGlobal: "Your company's AI quota has been reached for this month.",
        chatbotIaQuotaUser: "Your personal AI quota has been reached for this month. Please contact your administrator.",
        chatbotIaUsagePersonal: "Your usage",
        chatbotIaUsagePackEnd: "End of the pack",
        chatbotIaUnlockLabel: "Unlock an overage for this month",
        chatbotIaUnlockButton: "Unlock",
        chatbotIaUnlocked: "Overage unlocked. You can ask your question again.",
        chatbotIaAmountInvalid: "Invalid amount.",
        chatbotIaQuotaPercentInvalid: "The percentage must be between 0 and 100.",
        chatbotIaQuotaTab: "AI usage",
        chatbotIaQuotaMonth: "Month",
        chatbotIaQuotaPack: "Monthly pack",
        chatbotIaQuotaCompanyUsage: "Company usage",
        chatbotIaQuotaCap: "Monthly overage cap",
        chatbotIaQuotaCapHelp: "On top of the pack, renewed every month. Empty = no automatic overage.",
        chatbotIaQuotaUnlocked: "Unlocked this month",
        chatbotIaQuotaOverageUsed: "Overage used",
        chatbotIaQuotaLimit: "Limit (% of the allowed total)",
        chatbotIaQuotaNoLimit: "No limit",
        chatbotIaQuotaShare: "Share of the allowed usage",
        chatbotIaQuotaOwnProgress: "Progress on own limit",
        chatbotIaQuotaAccess: "AI assistant access",
        chatbotIaQuotaAccessHelp: "Unchecked: the user no longer sees the assistant, from their next page load.",
        chatbotIaQuotaLimitHelp: "A limit is a ceiling, not a reservation: the sum may exceed 100%. Empty = no limit.",
        chatbotIaConversationTooLong: 'The conversation is too long, please start a new one.',
        chatbotIaMessageTooLong: 'Your message is too long.',
        chatbotIaPageRead: 'Page read',
        chatbotIaHighlighted: 'Element circled on the page',
        chatbotIaChartReopen: 'Reopen the chart',
        chatbotIaChartView: 'Chart',
        chatbotIaChartRendering: 'Rendering',
        chatbotIaChartLabels: 'Labels',
        chatbotIaChartLabelsNone: 'None',
        chatbotIaChartLabelsPercent: 'Percentage',
        chatbotIaChartReset: 'Reset',
        chatbotIaChartPieOnePeriod: 'A pie chart shows a single period',
        chatbotIaChartTypeBar: 'Grouped bars',
        chatbotIaChartTypeBarEmpile: 'Stacked bars',
        chatbotIaChartTypeBarHorizontal: 'Horizontal bars',
        chatbotIaChartTypeLine: 'Lines',
        chatbotIaChartTypeArea: 'Areas',
        chatbotIaChartTypeAreaEmpile: 'Stacked areas',
        chatbotIaChartTypeCamembert: 'Pie chart',
        chatbotIaSearchProposed: 'I suggest a web search:',
        chatbotIaSearchAllow: 'Allow the search',
        chatbotIaSearchRefuse: 'Decline',
        chatbotIaSearchAllowed: 'Search allowed',
        chatbotIaSearchRefused: 'Search declined',
        chatbotIaWriteProposed: 'I am about to save this change:',
        chatbotIaWriteProposedMany: 'I am about to save these changes on {nb} items:',
        chatbotIaWriteEmpty: '(empty)',
        chatbotIaWriteConfirmed: 'Change saved',
        chatbotIaWriteRefused: 'The change could not be saved:',
        chatbotIaWriteBulk: 'Careful: the company update rules will also apply this value to the other items sharing the same {critere}.',
        chatbotIaWriteBulkCount: 'Careful: this value will also be applied to {nb} items sharing the same {critere}.',
        chatbotIaExportProposed: 'I am about to start this CSV export:',
        chatbotIaExportTotal: '{nb} item(s) matching',
        chatbotIaExportColumnsAll: 'every column you can see',
        chatbotIaExportColumnsSome: '{nb} selected column(s)',
        chatbotIaExportApostrophe: 'with a leading apostrophe on each cell',
        chatbotIaFamilleProposedCreer: 'I am about to create these {niveau} values:',
        chatbotIaFamilleProposedRenommer: 'I am about to rename this {niveau} value:',
        chatbotIaFamilleProposedArchiver: 'I am about to archive these {niveau} values:',
        chatbotIaFamilleProposedDesarchiver: 'I am about to restore these {niveau} values:',
        chatbotIaFamilleConfirmed: 'Classification catalogue updated',
        chatbotIaOutdated: 'This page is running an older version of the assistant. Please reload the page (Ctrl+F5) and ask again.',
        chatbotIaSources: 'Sources',
        unknowKiosqueError: 'An unexpected error has occurred, please contact a manager',
        identFailed: 'Login credentials are incorrect',
        //divers
        originArticleCannotBeTransformArticle: 'A transformed item cannot be transformed from an already transformed item',
        allKpiCompareMustBeSelected:"You have to select a value for the two fields",
        noreplace_item_by_itself:'You cannot replace an item with itself',
        dlThePdf:'Download the PDF',
        loyaltyPoints:'Loyalty points',
        importLoyaltyPoints:'Import loyalty points',
        pinrtStartPosition:'Start printing the tag at the position',
        loadingTagsMsg:'Generation of tags in progress, this action can takes time...',
        generateAndDownLoad:'Generate and download',
        margeTopPdf:'Margin on the top of page',
        margeBottomPdf:'Margin on the bottom of the page',
        margeLeftPdf:'Margin on the left of the page',
        margeRightPdf:'Margin on the right of the page',
        downloadListPdf:'Download the list as a PDF',
        margeParDefautA4:'Default A4 margins',
        mustBeOneLineConverted:'You must have at least one converted item to perform this action',
        noReliquatInDocument:"There is no remaining balance in this document",
        importCustomer:'Import customers',
        cliendtId:'Customer ID',
        createCustomer:'Create a customer',
        last_purchase_price:'Last purchase price',
        last_purchase_price_devise:'Last purchase price in currency',
        convertedIntoInvoice:'Converted into an invoice',
        addItemsMass:'Add articles in bulk',
        massAssociateSupplementList:'Assign this supplement list to articles',
        filterArticlesMode:'Filter articles',
        existingArticleListMode:'Use an existing article list',
        existingArticleList:'Article list',
        duplicateSupplementConfig:'Duplicate this supplement configuration',
        duplicateSupplementConfigBtn:'Duplicate this configuration to other articles',
        importItemSupplementListAssign:'Import supplement list assignments',
        validateModif:'Validate the modifications',
        defaultQteItems:"Default quantity of items",
        codeComptableGeneral:'General accounting code',
        codeComptable:'Accounting code',
        libelleComptableGeneral:'General accounting wording',
        libelleAttribueAcompte:'The wording assigned during the configuration of the payment method codes will be applied to the payment methods listed below',
        cantDuplicateAcompteOnSelectedType: "The mapping cannot be duplicated for the specified type",
        cantDuplicatePaiementOnDifferentType: "Payment mapping cannot be done on a different type",
        unavailableConfigForDuplicate:"It is not possible to duplicate this configuration",
        configType: "The specified configuration has the wrong type",
        unvalidConfig: "There is an error in the configuration",
        unavailableVentilation: "One of the selected breakdowns is not applicable",
        acompteDebitMissing: "The debit code is missing for the deposit configuration",
        acompteCreditMissing: "The credit code is missing for the deposit configuration",
        paiementModeMissingAcompte: "Correspondence codes are missing for one or more payment methods",
        selectBreakdownField:'Select the breakdown field',
        codeJournalMissing:'No configured journal code ',
        emailAccountSend:'Sending email account',
        firstDateOfExport:'First date of export',
        autoExportConfMsgDestinataire:'Add multiple recipients separated by a ";", press the "Enter" key to add them',
        quotidien:'Daily',
        hebdomadaire:'Weekly',
        mensuel:'Monthly',
        facturation_auto:'Automatic billing',
        facturationFrequenceRequired:'Billing frequency required',
        facturation_frequence:'Automatic billing frequency',
        interface_goot:'GOOT interfacing',
        interfaceGootUndefined:'Undefined (based on client type)',
        facturationMensuelle:'Monthly billing',
        facturationBL:'Delivery note billing',
        noBlToBilling:'No delivery note to convert in invoice',
        infosConversionBcBl:'Only collected items can be converted into a delivery note. Uncollected items are therefore not included in this list.',
        convertThePurchaseOrder:'Convert the purchase order',
        convertTheQuotation:'Convert the quotation',
        convertTheCreditNote:'Convert the credit note',
        convertTheInvoice:'Convert the invoice',
        inBl:"in delivery note",
        inPo:'in purchase order',
        inRn:'in return note',
        inCn:'in credit note',
        returnToPurachaseOrder:"Return to purchase order",
        returnToQuotation:'Return to quotation',
        returnToCreditNote:'Return to credit note',
        returnToInvoice:'Return to invoice',
        autoFacturationMensuelle:'Automatic billing',
        autoFacturationMensuelleFrequency:'Automatic billing frequency',
        allDeliveryNote:'All delivery notes',
        autoExportConf:'Configuration of automatic export',
        total_remise_ht: 'Total amount of discount taxes excluded',
        ht_remise: 'Amount of discount taxes excluded',
        supplierInvoiceRef:'Supplier invoice reference',
        franchise_en_base:'VAT exemption scheme',
        byItem:'By item',
        exportConfRequiredVentilation:'A configuration of the export file is required to allocate by item',
        selectConf:'Select the configuration(s)',
        duplicateBreakdown:'Duplicate the breakdown',
        AddNewBreakdownLine:'Add a new breakdown line',                       
        exportHeaderOnFlatFile:'Export headers on flat files',
        ventilationItem:'Breakdown by item',
        breakdownTgcByItem:'Breakdown of {taxe} by item',
        correspondanceMissing: 'No existing code configuration',
        configMissing: "An error exists in the configuration of your export file",
        codeClientConfigMissing : 'No existing customer code configuration',
        paiementModeMissing : "An error exists in the configuration of your payment mode export file",
        taxeMissing : "An error exists in the configuration of your taxes export file",
        caisseIdentMissing : "An error exists in the configuration of your cash register export file",
        commerceMissing : "An error exists in the configuration of your shops export file",
        codeFournisseurConfigMissing : 'No existing supplier code configuration',
        cantDuplicatePaiementOnDifferentType : 'It is impossible to duplicate these payment methods',
        duplicateComptaConfig:'Duplicate a configuration',
        duplicateExistingComptaConfig:'Duplicate an existing configuration',
        duplicateComptaConfigFrom:'Duplicate a configuration from',
        receiptRef:'Receipt reference',
        paymentNumber:'Payment accounting code',
        paymentWording:'Payment wording',
        taxeWording:'{taxe} wording',
        taxeNumber:'{taxe} accounting code',
        acompteWording:'Deposit wording',
        acompteNumber:'Deposit accounting code',
        shopTel:'Shop phone number',
        shopEmail:'Shop e-mail',
        shopHoraire:'Shop hours',
        shopType:'Shop type',
        shopItemPrice:'Items prices in the shop',
        shopEcomType:'E-commerce type',
        shopAccountingCode:'Shop accounting code',
        customerAccountingCode:"Customer accounting code",
        providerAccountingCode:'Provider accounting code',
        custmomerIcrementNum:"Customer increment number",
        providerIncrementNum:'Provider increment number',
        oldAccountingClientCode:'Old customer accounting code',
        oldAccountingProviderCode:'Old provider accounting code',
        customerTel:'Customer phone number',
        customerEmail:'Customer e-mail',
        customerType:'Customer type',
        customerName:'Customer name',
        customerFirstName:'Customer firstname',
        cashRegisterAccountingCode:'Cash register accounting code',
        cashRegisterCode:'Cash register code',
        ticketDate:'Receipt date',
        receiptType:'Receipt type',
        selectionOfTheDataTypeToAssociate:'Selection of the data type to associate',
        exports:'Exports',
        exportConfigurationB2b:'Accounting exports B2B sales',
        exportConfigurationB2c:'Accounting exports B2C sales',
        exportConfigurationPurchase:'Accounting exports of purchases',
        purchase:'Purchase',
        b2cSale:'B2C sale',
        b2bSale:'B2B sale',
        configurationTypeSelection:'Selection of the configuration type',
        noExistingShopForThisCompany:'No existing shop for this company',
        noExistingCashRegisterForThisCompany:'No existing cash register for this company',
        receipts:'Receipts',
        wording:'Wording',
        accountingCodeConfiguration:'Accounting code configuration',
        accountingFileConfiguration:'Accounting file configuration',
        salesJournalCode:'Sales journal code',
        salesJournalConfigurationB2c:'B2C sales journal configuration',
        salesJournalConfigurationB2b:'B2B sales journal configuration',
        flatFile:'Flat file',
        csvFile:'CSV file',
        purchasesExport:'Purchases export',
        noExistingExportConfiguration:'No existing export configuration',
        selectCompany:'Select a company',
        exportTiersClient:'Export of customer third parties',
        exportTiersFournisseur:'Export of supplier third parties',
        exportTiersClientFournisseur:'Export of customer/supplier third parties',
        addColumn:'Add a column',
        exportHeader:'Export header',
        associatedData:'Associated data',
        defaultValue:'Default value',
        correspondenceField:'Correspondence field',
        numberOfDigitsToIncrement:'Length of the increment section',
        numberOfSection:'Number of section',
        codeFournisseur:'Supplier code',
        codeClient:'Customer code',
        codeClientDefault:'Default customer code',
        codeFournisseurDefault:'Default provider code',
        codeConfigurationFournisseur:'Supplier codes configuration',
        codeConfigurationClient:'Customer codes configuration',
        codeConfigurationModePay:'Mode payment codes configuration',
        codeConfigurationDeposit:'Deposit codes configuration',
        codeConfigurationTaxe:'{taxe} codes configuration',
        codeConfigurationTaxeArticles:'{taxe} codes configuration by items',
        codeConfigurationShop:'Shop codes configuration',
        codeConfigurationCaisse:'Cash register codes configuration',
        codeConfigurationJournal:'Journal codes configuration',
        exportConfigurationClient:'Customer accounting exports',
        exportConfigurationFournisseur:'Supplier accounting exports',
        syncInProgres:'Items synchronisation in progress...',
        synchronizeItemsList:'Synchronize the items list',
        additionToList:'Addition to the list',
        replacementOfTheList:'Replacement of the list',
        dynamicFilter:'Dynamic filter',
        existingDynamicFilter:'Existing dynamic filter',
        dynamicUpdateByFilter:'Items update by dynamic filtering',
        actionOnDynamicFilter:'Action on items affected by dynamic filtering',
        itemsWillReplaceItemPromo:'The articles affected by the filter selection will replace those in the promotion',
        firstValue:"First value",
        secondValue:"Second value",
        thirdValue:"Third value",
        numeroTgc:'{taxe} number',
        siren:'SIREN',
        siret:'SIRET',
        labelAssujettiTva:'Subject to VAT',
        notSpecified:'Not specified',
        sirenInvalid:'SIREN must contain 9 valid digits',
        siretInvalid:'SIRET must contain 14 valid digits',
        siretSirenMismatch:'SIRET does not match SIREN',
        sirenRequired:'SIREN is required',
        siretRequired:'SIRET is required',
        assujettiTvaRequired:'VAT status is required',
        paysLegacyValue:'Current value not recognised: "{pays}". Select a country from the list.',
        factureNoPaymentM:"No {documentType} available for this customer",
        factureNoPaymentF:"No {documentType} available for this provider",
        column:'Column',
        noPaymentModeAvailable:'No payment method available',
        availableStock:'Available stock',
        unavailableStock:'Unavailable stock',
        totalStock:'Total stock',
        usedOnDoc:'Used on the following document(s)',
        amountLeft:'Amount left',
        used:'Used',
        unUsed:'Unused',
        partiallyUsed:'Partially used',
        unUsedF:'Unused',
        surDocument:'For document',
        tousDocTitle:'All {documentType}',
        toutesDocTitle:'All {documentType}',
        tgcDefault:'Default {taxe} for item creation',
        sectionArticleListDefault:'Default shop for item list',
        zoneArticleListDefault:'Default zone for item list',
        defaultReservationTime:'Default reservation duration',
        minutes:'minutes',
        kpiFilterDefault:'Default KPI filter',
        kpiFilterDefaultCompare:'Default KPI filter compare',
        generateUpc:'Generate UPC code',
        itemsTransform:'Processed items',
        editItemsTransform:'Processed items edit',
        notItemTransform:'This item is not a processed item',
        convertToItemTransform:'Convert to processed item',
        prefix:'You must fill the prefix',
        replace:'Replace existing barcode',
        article_list:'Generate an item list',
        article_list_name:'You must fill a name for the item list',
        generateUpcStart:'Start of barcode generation',
        generateUpcSuccess:'Barcode generated',
        generateUpcSuccessList:'Barcode and item list generated',
        generateUpcInProgress:"Generating barcode in progress. This task can take some time, please do not leave the page...",
        prefixConfigError:'Barcodes could not be generated, please check the prefix configuration.',
        errorInvoicingRecordsMsg:'There are errors on the following tickets',
        reviewOfAccountingRecords:'Review of accounting records',
        allAccountingEntriesAreCorrect:'All accounting entries are correct',
        refundOnEspecePay:'Proceed to a cash refund',
        refundOnOtherPay:"Proceed to another refund",
        selectedRows:'Selected rows',
        noDiscounts:'Normal price',
        confirmArticleEdition:'Are you sure you want to edit the field {articleField}',
        editConfirmation:'Edit confirmation',
        refundMode:'Refund mode',
        errorMsgTotalPay:'The total amount of payments does not match the cart total',
        cartTotal:'Cart total',
        deleteAnItemsList:'Delete an items list',
        createdFromItemsList:'Created from the list of items',
        noExistingCurrency:'No existing currency',
        addACurrency:'Add a currency',
        roundNumberValue:'Rounded amount value',
        roundNumberMsg:'Leave this field empty if you do not manage rounded number',
        currency:'Currency',
        addARateOf:'Add a rate of {taxe}',
        tvaPo:'Provider rate of {taxe}',
        infoOnItemLine: 'Informations on item line',
        organizeInAlphabeticalOrder:'Organize in alphabetical order',
        organizeByFolderNumberCroissant:'Organize by folder number (ascending order)',
        organizeByFolderNumberDecroissant:'Organize by folder number (descending order)',
        nextFolder:'Next folder',
        previousFolder:'Previous folder',
        ascending:'Ascending',
        descending:'Descending',
        sortAndGroup:'Sorting and grouping',
        dragAndDropItemsOrder: 'Drag and drop the items into the desired order.',
        reorderSortGroupPriority: 'Sorting and/or grouping is configured on this document: it takes priority, the manual order only applies between items it leaves tied.',
        editManualEntry: 'Edit manual entry',
        prmpLine: 'Line average cost',
        receptionSuccess:'Reception successfully completed',
        collectionSuccess:'Collection successfully completed',
        confirmCollectAll:'Are you sure you want to collect all the items ?',
        confirmReceiveAll:'Are you sure you want to receive all the items ?',
        urlFichierCommande:'Order file URL',
        urlApi:'API URL',
        commerceRetraitStock:'Stock pickup location',
        startDateOrderProcessing:'Start date of order processing on the application',
        uncertainty:'Uncertainty',
        code_barre:'UPC code',
        sku_vendeur:'SKU',
        famille:'Family',
        sous_famille:'Subfamily',
        sous_sous_famille:'Sub-subfamily',
        images:'Images',
        longueur:'Length',
        largeur:'Width',
        hauteur:'Height',
        weight:'Weight',
        weight_unit:'Weight unit',
        short_description:"Short description",
        actionOnOtherModePay:'Action performed if the cart total is less than the payment method amount',
        item_price_zero:'Addition of an item',
        historicalExportSales:'Sales export historical',
        thirdPartyExport:'Third party export',
        saleExport:'Sales export',
        accounting:'Accounting',
        paymentInterface:'Payment interface',
        default:'Default',
        checkoutInterface:'Checkout interface',
        lastCloseCaisse:'Last checkout closing',
        errorDeclarationEsp: 'Declaration error on the line {monnaie}, the maximum number is {maxNbr}',
        filter:'Filter',
        itemsWillBe:'The items will be',
        includedToPromo:'Included to the promotion',
        includedToPercentageException:'Include to percentage exception',
        includedToPersonalizedPrice:'Included to the personalized price',
        excludedToPromo:'Excluded from promotion',
        excludedToPercentageException:'Excluded from percentage exception',
        excludedToPersonalizedPrice:'Excluded from personalized price',
        excludeItemToPromo:'Exclude items from promotion',
        excludeItemToKpi:'Exclude items from KPI filter',
        includedToFidelite:'Included to the loyalty plan',
        excludedToFidelite:'Excluded from the loyalty plan',
        confFondCaisseMsg:'If no cash float is configured, the one entered at the cash register closing will be used by default',
        autoDistributionCashFund:'Automatic distribution of cash float',
        automaticReminderPayment:'Automatic creation of a payment reminder after xx day(s)',
        defaultRefacturationPercentage:'Rebilling commission as a percentage',
        defaultRefacturationCategorieTarif:'Rebilling price category',
        defaultRefacturationCategorieTarifHelp:'Name of the ArticlePrice price category used when this company rebills another one. If set, it takes precedence over per-article exceptions and over the rebilling percentage. If not found, article.price_b2b is used, otherwise 0.',
        defaultRefacturationDate:'First effective date for rebilling',
        defaultShopStock:'Default stock',
        associatedClientFournisseur:'Customer and supplier associated with the company for rebilling',
        facturationCompteMail:'Default email account for automated billing emails',
        clientAlreadyUsed:'Customer already used',
        fournisseurAlreadyUsed:'Supplier already used',
        selectionOfCustomers:'Customers selection',
        selectionOfClientType:'Customer type selection',
        extraCustomFieldsExposed:'Additional exposed free fields',
        noArticleCustomFieldConfigured:'No article free field configured',
        unknownCustomField:'Unknown custom field',
        itemsFromWillBeExcluded:'The items of your selection will be excluded from the promotion',
        itemsFromPercentageExceptionWillBeExcluded:'The items of your selection will be excluded from the percentage exception',
        itemsFromPersonalizedPriceWillBeExcluded:'The items of your selection will be excluded from the personalized price',
        itemsFromFideliteWillBeExcluded:'The items of your selection will be excluded from the loyalty plan',
        keepAfterCopnversion:'Keep after conversion',
        cashPayment:'Cash payment',
        days7Payment:'7 days',
        days15Payment:'15 days',
        days30PaymentFixed:'30 days',
        days30Payment:'30 days end month',
        days45Payment:'45 days end month',
        days60Payment:'60 days end month',
        days90Payment:'90 days end month',
        nbTickets:'Number of receipts',
        nbFactures:'Number of invoices',
        unassigned:'Unassigned',
        passages:'Passages',
        bestTicket:'Best receipt',
        apostropheBeginningCell:'Apostrophe at the beginning of a cell',
        compare_date:'Compare the date rather than the day',
        justificatif:'Download supporting document',
        documentSaved:'Saved documents',
        confirmReinstateItemsInStock:'Are you sure you want to reinstate all the items in your inventory',
        confirmCollectItem:"Are you sure you want to collect the uncollected items",
        confirmRemoveItemsFromStock:'Are you sure you want to remove the items from your inventory',
        removeItemFromStock:'Remove items from stock',
        collectAllItem:'Collect all the uncollected items from',
        warninStockMsgFacture:"The whole or part of the items in this invoice are not included in a delivery note. Please fill out the form below to process the removal of the relevant items from inventory",
        dupliquer:'Duplicate this document',
        noteRequiredMsg:"A note is required",
        noteRequiredReturnItem:"Mandatory note on returned items",
        returnItems:'handling items return',
        wmsAuthentication:"WMS Authentication",
        wmsAuthRequired:"Required",
        wmsAuthRequiredRequired:'The "WMS authentication required" field is required',
        wmsAuthRequiredBoolean:'The "WMS authentication required" field must be true or false',
        binsCollectOrder:"BIN collection order",
        binsCollectOrderAsc:"Ascending",
        binsCollectOrderDesc:"Descending",
        binsCollectOrderRequired:'The "BIN collection order" field is required',
        binsCollectOrderIn:'The "BIN collection order" field must be "asc" or "desc"',
        displayOtherSectionsTo:"Other sections' transfer orders",
        displayOtherSectionsToLabel:"Display other sections' in-progress transfer orders on the WMS",
        displayOtherSectionsToRequired:'The "display other sections\' transfer orders" field is required',
        displayOtherSectionsToBoolean:'The "display other sections\' transfer orders" field must be true or false',
        dontApplyDiscountedItem:'Do not apply to discounted items',
        totalPriceEdition:'Total price edit',
        selectTheTransferArea:'Select the transfer area',
        noPrice:"No price is configured for this item",
        zoneAlreadyHaveCommandeB2b:"A B2B purchase order zone already exist",
        noZoneCommandeB2b:"No existing B2B purchase order zone",
        factureAlreadyReceptione:"This document has already been received",
        factureArticleAlreadyReceptione:"This item has already been received on this document",
        itemAdditionFrom:'Items addition from',
        signHere:'Sign here',
        leaveBox:'Leave the box',
        noDeliveryNote:'No delivery notes',
        confirmFianlizeDeliveryNote:'Are you sure you want to finalize this delivery note',
        voucherInProgress:'Vouchers in progress',
        nbItemsCantBeHigherThanOrdered:'The quantity of scanned items cannot exceed the ordered quantity',
        itemNotInOrderedList:'This item doesn\'t appear in the list of ordered items',
        addItemsInDeliveryNote:'Addition of items in the delivery note',
        selectionPoWms:'Selection of purchase orders',
        delivery:'Delivery',
        createDeliveryVoucher:'Create a voucher',
        validationDelivery:'Vouchers delivery',
        returnNotes:'Return notes',
        shipmentVouchers:'Shipment vouchers',
        poB2bWms:'Customer purchase order B2B',
        poB2cWms:'Customer purchase order B2C',
        createListItem:'Create a list of items',
        customizeTag:'Customize tag',
        generatedByPurchaseOrder:'Generated by the purchase order',
        gestionReliquats:'Management of balances',
        reliquat:'Remainder',
        convertedValue:'Converted items value',
        reliquatValue:'Reminder value',
        billingInvoireGeneratedMsg:'A purchase invoice has been generated with this purchase order',
        selectAPrinter:'Select a printer',
        printerNameRegistered:'Printer name resgistered on Windows',
        image_file:'Image file (Windows)',
        defaultCustomer:'Default customer',
        default_conditionnement:'Default conditionnement',
        lessThanMOQ:'One or many items do not meet the minimum order quantity. Do you want to continue ?',
        deletePersonalizedPrice:'Do you  want to delete the personalized price on this line ?',
        minimum_commande:'Minimum order quantity',
        priceEditableOnTheFly:'On the fly editable price (PEV)',
        priceEditableOnTheFlyInfo:'Allows the price to be edited via a popup shown when the item is added to the cart.',
        personalized_price:'Personalized price',
        personalized_price_delete:'personalized price for',
        personalized_price_percent:'Personalized price percentage discount',
        personalized_price_franche:'Personalized price net discount',
        personalized_price_prixfixe:'Personalized price fixed price',
        permanent:'Permanent',
        noFolderLinked:'No related folder',
        convertPoBillinBuyErr:'This purchase order can\'t be converted because it contains more than one currency',
        convertIntoBillingBuy:'Convert into purchase invoice',
        dont:'Including',
        last_pr:'Last cost price',
        last_date_buy:'Last date of purchase',
        first_stock_entry_date:'First stock entry date',
        ecotaxe:'Eco-participation',
        quotaIsOverArticleQuantity:'The quantity is over the item quantity',
        qteToReceive:'Quantity to receive',
        docCompletelyReceived:'Document completely received',
        noMoreItemReceive:'There are no more items to receive',
        noReturnNote:'No return note',
        receiptReturnNote:'Receipt of return note',
        returnNote:'Return note',
        addToBoxMsg:'Do you want to integrate the selection into a box ?',
        poB2b:'Customer purchase order',
        collectPoClient:'Collection of customer purchase order',
        cancelFiltre:'Cancel the filter',
        showOnlyLineToBeConverted:'Show only the lines to be converted',
        allItemsConverted:'All the items have been converted',
        notemsToConvert:'No items to convert',
        cancelledDocu:'Cancelled document',
        factureVerrouillee: 'Locked document — read-only',
        factureVerrouilleeError: 'This document is locked and can no longer be modified. Please reload the page.',
        lockDocument: 'Lock',
        unlockDocument: 'Unlock',
        confirmLockDocument: 'Are you sure you want to lock this document? It will no longer be editable.',
        confirmUnlockDocument: 'Are you sure you want to unlock this document? It will become editable again.',
        documentClosedAt:'Document closed at',
        confirmCancelpo:"Are you sure you want to cancel this purchase order?",
        cancelDocument:'Cancel {document}',
        quantityAlreadyPo:'Quantity already converted',
        quantityToConvert:'Quantity to convert',
        convertToPo:'Convert to purchase order',
        convertFolderPo:'Convert purchase order',
        convertFolderPoSwal:'Convert all the folder purchase order into delivery note ? Warning: only the collected items will be considered',
        convertToCreditNote:'Convert to credit note',
        convertToCreditNoteBuy:'Convert to purchase credit note',
        convertToDeliveryNote:'Convert to delivery note',
        convertFolderDeliveryNote:'Convert delivery note',
        convertFolderDeliveryNoteSwal:'Convert all the folder delivery note into invoice ?',
        deliveryNote:'Delivery Note',
        validateDeliveryNote:'Validate the delivery',
        convertToReturnOrder:'Convert to return order',
        returned_in:'Item returned in ticket',
        mustHave1Bouton:"The download button tag is required ([bouton]) and must be unique",
        documentClosedFieldLocked:"This document has been issued: its printed content can no longer be modified (only internal notes, alerts and payments remain editable)",
        pennylaneStatusTitle:"Pennylane transmission",
        pennylaneSelectAllOnPage:"Select all on this page",
        pennylaneBulkSend:"Send to Pennylane",
        pennylaneBulkConfirm:"Transmit {count} ticket(s) to Pennylane, using the customer already attached to each?",
        pennylaneTicketButton:"Pennylane invoice",
        pennylaneTicketTitle:"Pennylane invoice of ticket",
        pennylaneTicketCustomer:"Invoiced customer",
        pennylaneTicketCustomerLocked:"The attached customer is an identified company: it cannot be replaced.",
        pennylaneTicketNotTransmittable:"This ticket cannot be transmitted:",
        pennylaneTicketModeImportOnly:"The invoice will be imported into Pennylane for accounting, without e-invoicing.",
        pennylaneTicketModeEInvoice:"The invoice will be transmitted as an e-invoice.",
        pennylaneTicketModeDisabled:"Transmission of POS invoices is disabled for this issuer.",
        pennylaneTicketSend:"Send to Pennylane",
        pennylaneTicketBlockedOutro:"You can complete the customer record before sending, or send now: the transmission will wait until the data is fixed.",
        pennylaneTicketMixedNotSupported:"Ticket mixing a sale and a return (exchange): cannot be transmitted",
        pennylaneTicketGiftCardLine:"Ticket containing a gift card: cannot be transmitted",
        pennylaneTicketRefundOriginAmbiguous:"Refund covering several tickets: cannot be transmitted",
        pennylaneTicketRefundOriginNotTransmitted:"The refunded ticket was not transmitted to Pennylane",
        pennylaneTicketAlreadyRequested:"A Pennylane invoice has already been requested for this ticket",
        pennylaneTicketClientLocked:"This ticket was transmitted to Pennylane: its customer can no longer be changed",
        pennylaneConnections:"Pennylane connections",
        pennylaneConnectionsHelp:"One connection per issuing company. The API token is generated in Pennylane (administrator account); it is never displayed again.",
        pennylaneIssuer:"Issuer",
        pennylaneAccount:"Pennylane company",
        pennylaneEnvironment:"Environment",
        pennylaneEnvironment_sandbox:"Sandbox",
        pennylaneEnvironment_production:"Production",
        pennylaneOptions:"Options",
        pennylaneActiveFrom:"Since",
        pennylaneState:"State",
        pennylaneB2b:"Invoicing module invoices",
        pennylaneB2c:"POS invoices",
        pennylaneConvert:"E-invoice",
        pennylaneNotConnected:"Not connected",
        pennylaneActive:"Active",
        pennylaneInactive:"Inactive",
        pennylaneConfigure:"Configure",
        pennylaneDeactivate:"Deactivate",
        pennylaneDeactivateConfirm:"Deactivate the Pennylane connection of",
        pennylaneConnectionOf:"Pennylane connection of",
        pennylaneToken:"Pennylane API token",
        pennylaneTokenKeep:"Leave empty to keep the saved token",
        pennylaneB2bHelp:"Transmit invoices and credit notes of the invoicing module",
        pennylaneB2cHelp:"Transmit invoices requested at the POS",
        pennylaneConvertHelp:"Convert eligible invoices to e-invoices (Factur-X)",
        pennylaneActiveHelp:"Active connection",
        pennylaneActiveFromHelp:"Transmit documents closed from",
        pennylaneReplaceConnection:"Replace the connection",
        pennylaneMissingScopes:"Connection saved, but the token lacks some permissions",
        pennylaneClassification:"Line classification in Pennylane",
        pennylaneClassificationHelp:"Account numbers are decided in Pennylane by the accountant. Choose the article custom fields (lists) giving the nature of sales and their analytical category.",
        pennylaneNature:"Nature",
        pennylaneNatureField:"Article custom field giving the nature",
        pennylaneNoField:"None",
        pennylaneFieldValue:"Field value",
        pennylaneNature_none:"Not specified (Pennylane default account)",
        pennylaneNature_goods:"Goods",
        pennylaneNature_services:"Services",
        pennylaneCategory:"Analytical category",
        pennylaneCategoryField:"Article custom field giving the analytical category",
        pennylaneCategoryGroups:"Pennylane category groups to synchronise",
        pennylaneNoCategoryGroup:"No group found: check that a connection is active",
        pennylaneSyncCategories:"Synchronise Pennylane categories",
        pennylaneLastSync:"Last synchronisation",
        pennylaneCategoriesFound:"categories",
        pennylaneCategoriesAdded:"Added to the list",
        pennylaneCategoriesMissing:"List values missing in Pennylane (kept):",
        pennylaneArticles:"items",
        pennylaneEnvironmentInvalid:"Invalid environment",
        pennylaneActiveFromInvalid:"Invalid start date",
        pennylaneTokenRequired:"The API token is required for a first connection",
        pennylaneTokenRequiredForEnvironmentChange:"Changing the environment requires a token",
        pennylaneConnectionAccountChanged:"This token belongs to another Pennylane company or environment. Replace the existing connection?",
        pennylaneTokenInvalid:"Invalid or revoked Pennylane token",
        pennylaneTokenVerificationFailed:"Token verification failed, try again later",
        pennylaneSandboxTokenForProduction:"This token belongs to a sandbox: it cannot be used in production",
        pennylaneProductionTokenForSandbox:"This token does not belong to a sandbox",
        pennylaneCustomFieldNotEligible:"Only list-type article custom fields can be used",
        pennylaneCustomFieldsMustDiffer:"Nature and category must use two different fields",
        pennylaneNatureInvalid:"Invalid nature",
        pennylaneCategoryGroupsNotSelected:"Choose at least one category group to synchronise",
        pennylaneCategoryNotFound:"Analytical category missing in Pennylane",
        pennylaneCategoriesNotAssigned:"Analytical categories could not be assigned",
        pennylaneStatus_pending:"pending",
        pennylaneStatus_pdf_ready:"PDF generated, sending",
        pennylaneStatus_importing:"importing",
        pennylaneStatus_import_unknown:"import result being checked automatically",
        pennylaneStatus_imported:"imported",
        pennylaneStatus_awaiting_conversion:"e-invoice conversion in progress",
        pennylaneStatus_retry_wait:"new attempt scheduled",
        pennylaneStatus_waiting_origin:"waiting for the original invoice to be transmitted",
        pennylaneStatus_blocked:"blocked, conditions not met",
        pennylaneStatus_validation_error:"refused by Pennylane",
        pennylaneStatus_skipped:"not transmitted",
        pennylaneStatus_error:"Pennylane connection or permission error",
        pennylaneImportedWithoutEInvoice:"Imported for accounting, without e-invoicing",
        pennylaneRetry:"Retry transmission",
        pennylaneRetryLaunched:"Transmission restarted",
        pennylaneRetryNotAllowed:"This transmission cannot be restarted",
        pennylaneConfirmTitle:"Pennylane import conditions not met",
        pennylaneConfirmBlockedIntro:"This document cannot be imported into Pennylane:",
        pennylaneConfirmBlockedOutro:"You can fix the customer record before validating, or validate now: the transmission will wait until the data is fixed. Note that customer details are printed on the issued document.",
        pennylaneValidateAnyway:"Validate anyway",
        eInvoiceDocumentTypeNotCovered:"Document type not covered",
        eInvoiceCreditNoteWithoutOrigin:"Credit note without original invoice",
        eInvoiceCreditNoteEmitterMismatch:"Credit note and original invoice have different issuers",
        eInvoiceCreditNoteRecipientMismatch:"Credit note and original invoice have different customers",
        eInvoiceRecipientMissing:"No customer on the document",
        eInvoiceCurrencyNotInPilot:"Currency not supported (EUR only)",
        eInvoiceB2cFlagWithProfessionalRecipient:"Document flagged B2C for a professional customer",
        eInvoiceEmitterCountryMissing:"Issuer country missing",
        eInvoiceEmitterCountryNotCoded:"Issuer country not recognised (country code expected)",
        eInvoiceEmitterTerritoryExcluded:"Issuer outside the e-invoicing territory",
        eInvoiceEmitterTerritoryToReview:"Issuer territory to be confirmed",
        eInvoiceEmitterNotInFrance:"Issuer not established in France",
        eInvoiceEmitterVatStatusUnknown:"Issuer VAT liability not set",
        eInvoiceEmitterNotVatLiable:"Issuer not liable for VAT",
        eInvoiceEmitterSirenMissing:"Issuer SIREN missing",
        eInvoiceEmitterSirenInvalid:"Issuer SIREN invalid",
        eInvoiceRecipientCountryMissing:"Customer country missing",
        eInvoiceRecipientCountryNotCoded:"Customer country not recognised (country code expected)",
        eInvoiceRecipientTerritoryExcluded:"Customer outside the e-invoicing territory",
        eInvoiceRecipientTerritoryToReview:"Customer territory to be confirmed",
        eInvoiceRecipientNotInFrance:"Customer not established in France",
        eInvoiceRecipientVatStatusUnknown:"Customer VAT liability not set",
        eInvoiceRecipientNotVatLiable:"Customer not liable for VAT",
        eInvoiceRecipientSirenMissing:"Customer SIREN missing",
        eInvoiceRecipientSirenInvalid:"Customer SIREN invalid",
        pennylaneQualificationNeedsReview:"Data to complete before transmission",
        pennylaneChannelDisabled:"Transmission disabled for this document type",
        pennylaneCreditNoteOriginNotTransmitted:"The credit note's original invoice was not transmitted to Pennylane",
        pennylaneCreditNoteOriginFailed:"The original invoice transmission failed",
        pennylaneFacturXDocumentTypeNotSupported:"This document type cannot be converted to an e-invoice",
        pennylaneFacturXCreditNoteOriginMissing:"The credit note's original invoice is missing or has no number",
        pennylaneFacturXIdentifierMissing:"A SIREN is missing on the issuer or the customer",
        pennylaneFacturXExemptNotSupported:"VAT-exempt lines are not supported for e-invoicing yet",
        pennylaneFacturXVatRateNotMapped:"This VAT rate has no e-invoicing equivalent",
        pennylaneSendToPaFailed:"The e-invoice could not be sent to the certified platform",
        pennylaneAttachmentUsedByAnotherDocument:"The PDF is already attached to another Pennylane document",
        pennylaneSchematronInvalid:"The e-invoice generated by Pennylane is invalid",
        pennylaneConversionTimeout:"E-invoice conversion took too long",
        pennylaneMaxAttemptsReached:"Maximum number of attempts reached",
        pennylaneAlreadyTransmitted:"This document has already been sent to Pennylane",
        pennylaneFactureNeverSent:"This document has never been sent to Pennylane",
        pennylaneFactureBulkConfirm:"Send {count} missing document(s) to Pennylane?",
        pennylaneDocumentNotClosed:"Document not closed",
        pennylaneDocumentTypeNotCovered:"Document type cannot be transmitted",
        pennylaneInvoiceNumberNotConvertible:"Invoice number not compatible with e-invoicing (35 characters, letters, digits and -+_/)",
        pennylaneCurrencyNotSupported:"Currency not supported (EUR only)",
        pennylaneAmountsMismatch:"Line amounts do not match the document totals",
        pennylaneNegativeInvoice:"Invoice with a negative amount",
        pennylaneZeroRateWithoutExemption:"0% VAT line without exemption",
        pennylaneVatRateNotMapped:"VAT rate not supported by Pennylane",
        pennylaneNoBillableLine:"No billable line",
        pennylaneVatGroupMissing:"Incomplete VAT breakdown",
        pennylaneExemptDocumentWithTax:"Exempt document carrying VAT",
        pennylaneRecipientMissing:"No customer on the document",
        mustHaveTicketAndFactureBouton:"The [bouton ticket] and [bouton facture] tags are both required and must each be unique",
        linkToDouaneCat:'Link to a customs category',
        noPurchaseOrderFound:'No purchase order to convert',
        allPurchaseOrdersAlreadyConverted:"All purchase orders are already converted",
        noDeliveryNoteFound:'No delivery note to convert',
        allDeliveryNotesAlreadyInvoiced:"All delivery notes are already converted",
        noSupplierProvided:'No supplier provided',
        noCurrencyProvided:'No currency provided',
        exchangeRate:'Exchange rate',
        indiceCalcul:"PRMP index calculation",
        categorie_douane:'Customs category',
        position:'Position',
        unit:'Unit',
        qtyUnit:"Qty unit",
        price_unit:'Price per unit',
        price_unit_b2b:'Price per unit B2B',
        confirmCancelFactureAchat:'Are you sure you want to cancel this invoice',
        billingBuy:'Purchase invoice',
        mustDeletePaymentBeforeCancel:'You must either cancel all the payments or complete the missing payments before canceling the invoice',
        linkToFolder:'Link to the folder',
        linkTo:'Link to',
        billingDeposit:'Deposit invoice',
        depositLabel:'Deposit',
        quotationExpireAt: 'This quotation expired on',
        quotationNotConverted: 'This quotation has generated neither a purchase order nor an invoice',
        quotationConverted: 'This quotation has generated one or more related documents',
        billingDepositUnUsed: 'This deposit invoice has not been used',
        billingDepositPartiallyUsed: 'This deposit invoice has been partially used',
        billingDepositUsed: 'This deposit invoice has not been fully used',
        purchaseOrderB2bNotCollected: 'The collection of this purchase order has not started',
        purchaseOrderB2bPartialCollected: 'The collection of this purchase order is in progress',
        purchaseOrderB2bCollected: 'The collection of this purchase order is completed',
        purchaseOrderB2bNotConverted: 'This purchase order has not generated any delivery note',
        purchaseOrderB2bPartialConverted: 'This purchase order has already generated at least one delivery note; however, some items have not yet been converted',
        purchaseOrderB2bConverted: 'All items in this purchase order have been converted into delivery notes',
        deliveryNoteNotDelivery: 'This delivery note has not yet been delivered',
        deliveryNoteDelivery: 'This delivery note has been delivered',
        deliveryNoteNotConverted: 'This delivery note has not generated any invoice',
        deliveryNoteConverted: 'All items in this delivery note have been converted into invoices',
        invoiceNotAcquitte: 'This invoice has not been paid',
        invoicePartiallyAcquitte: 'This invoice has been partially paid',
        invoiceAcquitte: 'This invoice has been paid',
        avoirUnUsed: 'This credit note has not been used',
        avoirPartiallyUsed: 'This credit note has been partially used',
        avoirUsed: 'This credit note has been fully used',
        avoirNotConverted: 'This credit note has not generated any return note',
        avoirPartialConverted: 'This credit note has already generated at least one return note; however, some items have not yet been converted into return notes',
        avoirConverted: 'All items in this credit note have been converted into return notes',
        returnNoteNotCollected: 'The collection of this return note has not started',
        returnNotePartialCollected: 'The collection of this return note is in progress',
        returnNoteCollected: 'The collection of this return note is completed',
        error404Msg:'Sorry! The page you were looking for doesn\'t exist',
        retourAccuil:'Go back to home',
        noEmailAdressConfigured:'No e-mail address configured',
        errDestinataireEmail:'Please include "@" in the email address',
        addMoreRecipientsMsg:"Add more recipients by separating e-mail addresses with a \",\"",
        destinatairesRequired:'At least one recipient is required',
        destinatairesIsArray:'Recipients must be a list',
        destinatairesElemRequired:'A recipient cannot be empty',
        urlRequired:'The consultation link is required',
        urlMin2:'The consultation link is invalid',
        documentAlreadyUseForPaiement:"This document is already used for the payment of another invoice",
        montantIsOver:'The amount indicated is higher than the remaining balance',
        changeFolder:'Change folder',
        allInfosCorrect:'Is all the information correct ?',
        allDocuments:'All documents',
        noPriorityPricing:'No priority price',
        priorityPricingCat:'Priority pricing category',
        priorityPricingCatB2C:'Priority pricing category B2C',
        priorityPricingCatB2B:'Priority pricing category B2B',
        defaultCategorieTva:'Special {taxe} category',
        noDefaultCategorieTva:'No default category',
        associatedCategorieTva:'Associated {taxe} category',
        noCategorieTvaAssociated:'No associated category',
        selectArticlePrice:'Select a pricing category',
        noPricingCat:'No pricing category',
        articlePriceNotFound: 'No price found for this item and this pricing category',
        noB2cPrice:'No B2C price provided for this item',
        noTvaRate:'No tax rate configured for this item for the register\'s tax category',
        searchForExistingFolder:'Search for an existing folder',
        folderNotExist: 'The folder n° {numeroDossier} doesn\'t exist',
        folder:'Folder',
        folders:'Folders',
        ongoingFiles:'Ongoing files',
        linkToOtherCompany:'Link to an other company',
        docName:'Folder name',
        linkToDoc:'Link to a folder',
        createFolder:'Create a folder',
        newFolder:'New folder',
        createDocument:'Create a document',
        createTemplate:'Create a template',
        editTemplate:'Edit a template',
        deleteEmailAccount:"Delete the e-mail account",
        send:'Send',
        sendTestEmail:'Send a test e-mail',
        smtpConfigError:'Could not send the e-mail: the SMTP configuration of this account seems incorrect (host, port or credentials). Please check the account settings.',
        addEmailAccount:'Add an e-mail account',
        emailAccount:'Emails accounts',
        emailLayout:'Emails layouts',
        miseEnPage:'Layout',
        emetteurClient:'Issuer / Client data',
        dataEmitterPdf:'Issuer data',
        dataClientPdf:'Client data',
        capital:'Capital',
        logoField:'Logo',
        balisesPossibles:'Possibles anchors',
        newEmailAccount:'New email account',
        accountName:'Account name',
        emailAdress:"E-mail address",
        hostOutgoing:'Outgoing mail server',
        username:'User name',
        allFieldRequiredForEnumere:'All the packaging list fields must be filled (name, bar code, quantity)',
        price:'Price',
        prixAchat:'Buy price',
        addAdditionalPrice:'Add an additional price',
        portrait:'Portrait',
        landscape:'Landscape',
        generateExport:'Generate an export',
        referedToQuotation:'Refered to quotation n°',
        referedToDocument:'Refered to document n°',
        parentToDocument:'Parent of document(s)',
        childToDocument:'Child of document(s)',
        priceTtcB2c:'B2C price with duty included',
        priceTtcB2b:"B2B price with duty included",
        priceHtB2b:'Price B2B without duty',
        priceHtB2c:'Price B2C without duty',
        margeNB2b:'B2B gross margin',
        margePB2b:'B2B margin %',
        margeB2c:'B2C gross margin',
        margePB2c:'B2C margin %',
        b2bPrice:'B2B price',
        b2cPrice:'B2C price',
        mustIndicateAPrice:'You must indicate at least one price',
        additionalPriceName:'Additional price name',
        additionalPrice:'Additional price',
        includedTaxe:'Taxes included',
        useB2bPrice:'Use B2B price',
        useB2cPrice:'Use B2C price',
        itemPrice:'Item price',
        usedArticlePrice:'Item price used, please clear from all configuration before deleting',
        productPriceMaxNumber:'Maximum number of additional price for a product',
        categorieTva:'Additional {taxe} categories',
        categorieTvaName:'Category name',
        addCategorieTva:'Add a {taxe} category',
        categorieTvaArray:'The tax categories must be an array',
        categorieTvaRequired:'The tax category name is required',
        categorieTvaNameRequired:'The tax category name is required',
        categorieTvaNameString:'The tax category name must be text',
        categorieTvaNameMax191:'The tax category name must not exceed 191 characters',
        categorieTvaTauxRequired:'At least one rate is required for this tax category',
        categorieTvaTauxArray:'The tax category rates must be an array',
        categorieTvaTauxNumeric:'The tax category rates must be numeric',
        categorieTvaTauxMin0:'The tax category rates must be at least 0',
        categorieTvaTauxMax100:'The tax category rates must not exceed 100',
        CategorieTvaIsNotValid:'The TVA category is not valid',
        categorieTvaDefaultMax191:'The default TVA category must not exceed 191 characters',
        noDefaultTaux:'None',
        paysExonereTva:'{taxe} exempted countries',
        paysExonereTvaDescription:'Clients or suppliers located in these countries will automatically be exempted from {taxe} on invoices issued by this entity.',
        paysExonereTvaArray:'Exempted countries must be a list',
        paysExonereTvaInvalid:'One of the selected countries is not valid',
        categorieTvaDefaultTauxIn:'The default rate must be one of the rates defined for this category',
        taux_categorie_tva:'{taxe} rate',
        noUserRestricted:'No users are restricted',
        unauthorized:'Unauthorized',
        fieldReading:'Field reading',
        fieldEditing:'Field editing',
        fieldReadingNotAvl:'Reading not available for',
        fieldEditingNotAvl:'Editing not available for',
        fieldEditingAlertNotAvl:"Edit confirmation alert for",
        designation:'Designation',
        accessMenu:'Access',
        usersListing:'User listing',
        email:'Email',
        modules:'Modules',
        emailAccess:'Email access',
        access:'Access',
        noModuleAssigned:'No module assigned',
        noEmailAccountAssigned:'No e-mail account assigned',
        stockInZoneNotSufficient:'The stock in your area or bins is not sufficient to perform your action',
        padFormat:'PAD format',
        clotureFormatPdf:'Cash register closing PDF format',
        clotureFormatA5:'Standard A5',
        clotureFormatSlip:'Slip (Epson slip printer)',
        smallPad:'Small PAD',
        bigPad:'Big PAD',
        seuilMiniCashBack:'Minimum cashback threshold',
        plafondCashBack:'Cashback accumulation limit',
        reliquatCashBack:'Requirement to use all cashback',
        reliquatFidelite:'Requirement to use all loyalty',
        hostname:'Hostname',
        hostnameOrIpAdress:"Hostname or host IP address",
        noHostnameAssigned:'No hostname assigned',
        clientAlreadyAssigned:'This customer has already been associated or is in the process of association',
        relatedCompanies:'Related companies',
        poids:'Weight',
        companyOrOtherCompany:'Company or other company',
        noAssignablePromo:'No assignable promotions',
        noAssignedPromo:'No assigned promotions',
        assignablePromo:'Assignable promotions',
        assignedPromo:'Assigned promotions',
        assignPromoClient:'Assign promotion',
        addCustomer:'Add customers',
        allModificationWillBeLost:'All modifications will be lost, continue ?',
        allCustomer:'All customers',
        listOfCustomer:'List of customer',
        selectionOfCustomer:'Selection of customer',
        selectionTemplate:'Select Template',
        voucherManagement:'Voucher management',
        itemListWillBeDelete:'Your selection of items will be deleted, continue ?',
        convertIntoToCollected:'Transfer order already collected',
        convertThisList:'Convert this list',
        quantityManualModificationListeArticle:'Manual quantity modification on items lists',
        noList:'No list',
        listName:'List name',
        listOfItems:'List of items',
        supplementList:'Supplement list of items',
        multiple_choice:'Multiple choice',
        required_choice:'Required choice',
        max_choices:'Maximum number of choices',
        max_choices_unlimited:'Unlimited if empty',
        max_choices_reached:'Maximum number of choices reached',
        packaging:'Packaging',
        packagedQuantity:'Quantity packaged',
        packagingName:'Packaging name',
        enumere:'Packaging list',
        packagingList:'Packaging list',
        pricingHt:'Pricing excluding taxes',
        nbSales:'Number of sales',
        qteSold:'Quantity sold',
        salesStatistics:'Sale statistics',
        copy:'Copy',
        copied:'Copied',
        infoZoneAffectedByRestock:'By default, freebird use all storage areas if no configuration is existing',
        zoneAffectedByARestock:'Zone concerned by an internal restock',
        triggerThresholdInternalRestock:'Trigger threshold of an internal restock',
        seuilDeclenchement:'Trigger threshold',
        seuilTypeCA:'Configure a revenue-based trigger threshold',
        seuilTypeQuantity:'Configure a quantity-based trigger threshold',
        seuilQuantityValue:'Quantity threshold',
        seuilQuantityType:'Quantity threshold type',
        seuilQuantitySameArticle:'The exact same item',
        seuilQuantityDistinctArticles:'Items from the list',
        seuilQuantitySameArticleHelp:'At least N units of the exact same item from this promotion\'s item list must be purchased.',
        seuilQuantityDistinctArticlesHelp:'At least N units in total (any mix) from this promotion\'s item list must be purchased.',
        seuilExclusive:'The revenue threshold and the quantity threshold cannot be set at the same time',
        seuilQuantityNumeric:'The quantity threshold must be a whole number',
        seuilQuantityMin:'The quantity threshold must be at least 1',
        seuilQuantityMax:'The quantity threshold is too high',
        seuilQuantityTypeIn:'Please choose a quantity threshold type',
        quantityToRestock:'Optimal stock',
        internalRestockException:'Internal restock exception',
        noZoneOfStock:'No zone of stock',
        rppslMenuName:'RP/PSL',
        rppslFournisseurMenuName:'RP/PSL Supplier',
        emptyValue:'Empty value',
        reopenQuotation:'Reopen quotation',
        devisValidite:'Quotation validity period',
        quotationGenerated:'Your quotation has been generated',
        continueWithoutIdentification:'Continue without identification',
        expired:'Expired',
        notExpired:'Not expired',
        notAvailable:'Not available',
        pickupInStore:'Pickup in store',
        isPickupAvailable:'Can be selected for in-store pickup',
        gpsCoordinatesContact:'GPS coordinates (contact page)',
        labelLatitude:'Latitude',
        labelLongitude:'Longitude',
        latitudeNumeric:'Latitude must be a number',
        latitudeBetween:'Latitude must be between -90 and 90',
        longitudeNumeric:'Longitude must be a number',
        longitudeBetween:'Longitude must be between -180 and 180',
        tablePlan:'Table Plan',
        openTablePlan:'Configure table plan',
        tables:'tables',
        reservations:'Reservations',
        addReservation:'Add a reservation',
        createTicketForTable:'Create ticket',
        openTicketForTable:'Open ticket',
        ticketEnCours:'Current ticket',
        tableAlreadyHasOpenTicket:'This table already has an open ticket',
        reservationName:'Name',
        reservationDate:'Date',
        reservationDateDebut:'Start date',
        reservationDateFin:'End date (optional)',
        reservationTime:'Time',
        reservationNote:'Note',
        noReservationToday:'No reservation for today',
        kpiNbReservations:'Reservations',
        kpiNbPersons:'Persons',
        kpiAvgPersons:'Avg. per reservation',
        allZones:'All zones',
        tableStatusAvailable:'Available',
        tableStatusUpcoming:'Upcoming reservation',
        tableStatusOngoing:'Ongoing reservation',
        tableStatusPast:'Past',
        phone:'Phone',
        obstacle:'Obstacle',
        addObstacle:'Add obstacle',
        color:'Color',
        posDefaultClient:'POS client',
        editReservation:'Edit reservation',
        reservationOverlap:'This time slot overlaps an existing reservation',
        planningView:'Planning',
        planningFullDay:'Full day',
        confirmDeleteReservation:'Are you sure you want to delete this reservation?',
        searchAvailability:'Search',
        noAvailableTable:'No available table for this time slot',
        addPlan:'Add a plan',
        planName:'Plan name',
        editPlan:'Edit plan',
        planDimensions:'Dimensions (px)',
        uploadBackground:'Background image',
        removeBackground:'Remove background',
        deletePlan:'Delete plan',
        confirmDeletePlan:'Are you sure you want to delete this plan? All tables will be deleted.',
        noPlanYet:'No table plan configured yet.',
        services:'Services',
        addService:'Add a service',
        serviceName:'Service name',
        serviceHeureDebut:'Start time',
        serviceHeureFin:'End time',
        noServiceYet:'No service configured.',
        editService:'Edit service',
        confirmDeleteService:'Are you sure you want to delete this service?',
        table:'Table',
        addTable:'Add a table',
        editTable:'Edit table',
        tableNumber:'Table number',
        nbPersons:'persons',
        confirmDeleteTable:'Are you sure you want to delete this table?',
        tableShape:'Shape',
        tableShapeSquare:'Square',
        tableShapeCircle:'Round',
        tableWidth:'Width (px)',
        tableHeight:'Height (px)',
        tableDiameter:'Diameter (px)',
        infosOnReceipt:'Infos to display on the receipt',
        infosOnTopReceipt:'Infos to display on the top of the receipt',
        infosOnBottomReceipt:'Text to display on the bottom of the receipt',
        noteAutomatiqueHeader:'Automatic note on item',
        noteAutomatiqueLabel:'Custom field to use as automatic note',
        noteAutomatiqueHelp:'When adding an item to a ticket in this section, if this custom field is filled in on the item, its value automatically pre-fills the item note.',
        selectNone:'None',
        customFieldUsedAsAutomaticNote:'This custom field cannot be renamed or deleted while it is used as an automatic item note.',
        buffaloPreparationTrigger:'Pizza station preparation',
        buffaloPreparationValue:'Expected value',
        buffaloPreparationAnyValue:'Any value',
        buffaloPreparationHelp:'Items whose custom field matches the expected value trigger the preparation at the pizza station. Without an expected value, any item where this field is filled in triggers it.',
        buffaloPreparationValueMax191:'The expected value must not exceed 191 characters',
        customFieldUsedAsBuffaloPreparation:'This custom field cannot be renamed or deleted while it is used for the pizza station preparation.',
        excludeArticlesFromSearch:'Exclude items from the search:',
        searchExclusionNone:'Exclude nothing',
        searchExclusionValue:'Value that excludes the item',
        searchExclusionHelp:'On the POS, items whose custom field has exactly this value (case-insensitive) no longer appear in the item search bar.',
        searchExclusionValueMax191:'The exclusion value must not exceed 191 characters',
        customFieldUsedAsSearchExclusion:'This custom field cannot be renamed or deleted while it is used to exclude items from the POS search.',
        listedUserWillBeNotified:'The listed users will be notified',
        cancellationOfInvoice:'Cancellation of invoice n°',
        cancelledByCreditNote:'Cancelled by the credit note n°',
        assignCountZeroEmptyBins:'Assign a count of zero to all remaining bins',
        confirmAssignCountZeroEmptyBins:'Do you really want to assign a count of zero to all remaining bins',
        confirmDeleteTemplate:'Do you really want to delete this template?',
        assignPointsManually:'Assign points manually',
        exclureFidelite:'Exclude from the loyalty program',
        confirmInnerFidelite:'Include this customer in the loyalty program ?',
        confirmExcluFidelite:'Exclude this customer from the loyalty program ?',
        unauthorizedMovement:'Stock transfer to this zone is not allowed',
        nbPointsToAssign:'Number of points to assign',
        priceCalculationMethod: "Price calculation method for custom-made item",
        calculationValue: "Calculation value",
        customMadeItem: "Custom-made item",
        itemWithoutUpcCode: "Items without UPC code",
        showCustomMadeItem: "Show only the custom-made items",
        typePercent: "Percent",
        subtraction: "Subtraction",
        reminder:'Reminder',
        programedReminder:'Scheduled reminder',
        reminders:'Reminders',
        fromDocument:'From document',
        a:'To',
        list:'List',
        listMin1:'The list value must be 1 or 2',
        listMax2:'The list value must be 1 or 2',
        title:'Title',
        addSettle:'Settle the document',
        bulkSettle:'Bulk settle',
        bulkSettleSelectedCount:'Selected invoices',
        bulkSettleSelectedInvoices:'Selected invoices',
        bulkSettleResultSuccess:'{count} invoice(s) settled successfully',
        bulkSettleResultError:'{count} invoice(s) could not be settled',
        bulkSendEmail:'Send by e-mail',
        bulkSendEmailSelectedDocuments:'Selected documents',
        bulkSendEmailResultSuccess:'{count} document(s) sent successfully',
        bulkSendEmailResultError:'{count} document(s) could not be sent',
        bulkSendEmailFillMain:'Add main address of each client',
        bulkSendEmailFillAll:'Add all addresses of each client',
        bulkSendEmailFillRelance:'Add reminder addresses only',
        noCommonPaymentMode:'The selected invoices have no common payment method available',
        modePaiementNotAvailable:'Payment method not available for this invoice',
        factureAlreadyAcquitte:'This invoice is already settled',
        invalidDocumentType:'This document is not an invoice',
        factureNotFinalized:'This invoice is not finalised yet',
        addLimitDate:'Add a limit date of payment',
        addLimitDateValidity:'Add a limit date of validity',
        addFund:'Add funds on the gift card',
        addUsers:'Add users',
        addItems:'Add items',
        addingItemsToPromo:"Adding items to the promotion",
        addTopText:'Add text on top part',
        addBottomText:"Add text on bottom part",
        specifyASeller:'Specify a seller',
        message:'Message',
        retraitZone:'Withdrawal zone',
        transferAllProducts:'Transfer all the products',
        toMomentarilyFiniched:'The collection of this transfer order is temporarily completed',
        toFiniched:'The collection of this transfer order is completed',
        collectOrderFinish:'The collection of items for this order is completed',
        toReceiptMomentarilyFiniched:'The receipt of this transfer order is temporarily completed',
        toReceiptFiniched:'The receipt of this transfer order is completed',
        reassortInterneCollectFinish:'The picking of this internal restock is completed',
        toItemCollectMessage:'This item is either out of stock or has been fully collected',
        assignedTo:'Assigned to',
        assignedToAllClient:'Assigned to all clients',
        finalize:'Finalize',
        finalized:'Finalized',
        getToItemsSelection:'Get to items selection',
        selectCustomer:'Select a customer',
        orderedInThisShop:'Ordered in this shop',
        toBeCollectedInThisShop:'To be collected in this shop',
        informPaymentLate:'Inform customer on the consequences of late payment',
        toCollect:'To collect',
        toCollectWms:'To collect from your WMS',
        enCoursTo:'Subject to a transfer order',
        necessaryActionOrder:'A manual action is necessary to complete the collection of this item',
        createATransferOrder:'Create a transfer order',
        generateAnTransferOrder:"Generate a transfer order",
        dontIndicate:'Don\'t indicate',
        itemManagement:'Items management',
        autoCreationItemInfos:'Automatic creation of classifications, families, subfamilies, categories, subcategories, brands and suppliers',
        skuObligation:"Obligation to create a SKU",
        barCodeObligation:'Obligation to create a barcode',
        temporary:'Temporary',
        ecomTemporaryMsg:'This item cannot be uploaded because it is currently provisional',
        showOnlyTemporaryItem:'Display only the temporary items',
        temporaryItem:'Temporary item',
        addThisItemToItemBase:'Add permanently this item to the item base',
        other:'Other',
        autre:'Other',
        hour:'Hour',
        ordered:'Ordered',
        noteInterne:'Internal note',
         seeOriginalDocument:'See the original document',
        errorDifferenceQteValidate:'There is an existing difference of value on the following items',
        paiementFideliteButNoFideliteArticle:"Loyalty payment is not accepted in this cart",
        closeWithDifference:'Your checkout account does not appear to be correct. Do you still want to close as is ?',
        changePaiement:'The refund will be lost and the payment recalculated. Do you want to continue ?',
        onReceipt:'On receipt',
        articleNoReferenceFind: 'No item corresponds to this reference',
        mustIndicateReasonRetrait: 'You must indicate the reason for withdrawing cash',
        gradeHasUser: "You can't delete this grade because some staff have this grade. To delete this grade you must first remove this grade for all staff who have it.",
        modepaiementRemove: 'You cannot delete this payment method because it is assigned to some of your shops. If you really want to delete it, you must first remove it from shops for which this payment method is assigned.',
        adminOverQuota: 'You cannot add the "Configuration" module to this user because your users quota for this module has already been reached. Please contact Ciweb if you wish to modify this quota.',
        erpOverQuota: 'You cannot add the "ERP" module to this user because your users quota for this module has already been reached. Please contact Ciweb if you wish to modify this quota.',
        usersOverQuota: 'You cannot add the "Users" module to this user because your users quota for this module has already been reached. Please contact Ciweb if you wish to modify this quota.',
        wmsOverQuota: 'You cannot add the "WMS" module to this user because your users quota for this module has already been reached. Please contact Ciweb if you wish to modify this quota.',
        posOverQuota: 'You cannot add the "POS" module to this user because your users quota for this module has already been reached. Please contact Ciweb if you wish to modify this quota.',
        endUnderrBegin: 'The period end date cannot be lower than the period start date',
        perdioExceedAYear: 'The period cannot be longer than one year',
        dayDateFormat: 'The date of this CSV row is not in a correct format. The correct format is the one indicated in your company\'s advanced settings.',
        commandeDateFormat: 'The date of order is not in a correct format. The correct format is the one indicated in your company\'s advanced settings.',
        expectedDateFormat: 'The date of transfer is not in a correct format. The correct format is the one indicated in your company\'s advanced settings.',
        expeditionDateFormat: 'The delivery date is not in a correct format. The correct format is the one indicated in your company\'s advanced settings.',
        expectedReceptionDateFormat: 'The expected receipt date is not in a correct format. The correct format is the one indicated in your company\'s advanced settings.',
        realExpeditionDateFormat: 'The real delivery date is not in a correct format. The correct format is the one indicated in your company\'s advanced settings.',
        receptionDateFormat: 'The expected receipt date is not in a correct format. The correct format is the one indicated in your company\'s advanced settings.',
        beginDateFormat: 'The start date is not in a correct format. The correct format is the one indicated in your company\'s advanced settings.',
        endDateFormat: 'The end date is not in a correct format. The correct format is the one indicated in your company\'s advanced settings.',
        dateDepartDateFormat: 'The departure date is not in a correct format. The correct format is the one indicated in your company\'s advanced settings.',
        dateArriveDateFormat: 'The arrival date is not in a correct format. The correct format is the one indicated in your company\'s advanced settings.',
        dateFormat: 'The date is not in a correct format. The correct format is the one indicated in your company\'s advanced settings.',
        lastDateBuyDateFormat: 'The last buy date is not in a correct format. The correct format is the one indicated in your company\'s advanced settings.',
        rppslAutoGenerationDateDateFormat: 'The automatic RP/PSL generation date is not in a correct format. The correct format is YYYY-MM-DD.',
        beginRequiredWithEnd: "You must indicate a start date since you indicated an end date",
        endRequiredWithBegin: 'You must indicate an end date since you indicated a start date',
        sizeLineCsv: 'This row of the CSV file doesn\'t contain the correct numbers of column',
        row: 'Row',
        lines: 'Lines',
        noRhOrNoAuth: 'Non-existent or unauthorized staff to access this section',
        rhNoAuth: 'Staff unauthorized for this action',
        staffNotAttributeToInventory:'Staff not attributed to this inventory',
        noRhOrNoAttributed: 'Non-existent staff or not attributed to this inventory',
        noRhTos: 'You don\'t have pending transfers orders',
        noInternetTos: 'You don\'t have pending orders',
        imageUrl: 'The image link must be a valid URL',
        havestockIn: 'You must indicate if this item must be dependent on a stock',
        zoneAlreadyHaveCommercial: 'This shop already has a stock zone with the type selling area',
        zoneAlreadyHaveCommande: 'This shop already has a stock zone with the type order area',
        archiveZoneAddArticle: 'This stock zone has some items and therefore can\'t be archived',
        deleteZoneAddArticle: 'This stock zone has some items and therefore can\'t be deleted',
        customFieldsAlreadyExists: 'A custom field with the same name already exist',
        youMustIndicateField: 'You must fill the field',
        ecomMustBeConfigured:'This e-commerce is not configured',
        limitCsv: 'The CSV file must be less than {limit} lines',
        filename: 'File name',
        name:'Name',
        description:'Description',
        categorization:'Categorization',
        ptype:'Product type',
        pcat:'Product category',
        image:'Image',
        couleur:'Color',
        couleurs:'Colors',
        headerColor:'Header color',
        cardHeaderColor:'Card header color',
        tabsColor:'Tabs color',
        taille:'Size',
        notANameForCustomFields: 'This name cannot be given to a custom field',
        quotaCommandeInteger: 'The quantity must be an integer',
        quotaInteger: 'The quantity must be an integer',
        selectBinsOrZone: 'You must scan a bins or select a zone',
        shipmentLineAlreadyReceptione:'This block has already been validated',
        shipmentCartonAlreadyReceptione:'This box has already been received',
        changHaveBinsMustEqualZero:'You cannot change the bins option for an area that already contains items. This area currently contains: {quota} items',
        toIsClosed:'This Transfer Order is closed',
        rhNotInSection:'This staff doesn\'t exist or doesn\'t work in this origin shop',
        communToLineNotTheSame:'Some data that must be common to all lines of the same transfer order is not',
        noDoubleArticleTo:'This item is already present in another line of this transfer order',
        noAutorizedUpdateTo:'You cannot update a transfer order that has passed the collection stage',
        cantDeleteLine: 'You cannot delete this line',
        newLine: 'Add a line',
        newSupplementList: 'Add a supplement list',
        configArticleSupplementList: 'Configure a supplement list for a new item',
        configArticleAbonnement: 'Configure a subscription gestion for a new item',
        pslGte: "The preferred stock level can't be less than the reorder point",
        noDockForReassort: 'You have no warehouse defined',
        noArticleForReassort: 'There are no items in your selection',
        noToMaxForReassort: 'You must first set the maximum number of instructions a transfer order can contain in your company settings',
        valuePromotionNotOk: 'The promotions values are incorrect',
        amountOverDue:"Paid amount can't be more than due amount",
        hasBillingDeposit:"Deposit invoices are available for document payment",
        hasCreditNote:"Credit notes are available for document payment",
        resteIsOverTicket: 'The amount paid is higher than the remaining amount of the ticket',
        majorPaiementError: "Major payment error, the customer has paid more than the asked price",
        paiementIsNegative: 'The amount payable cannot be negative',
        paiementIsPositive: 'The outstanding amount must be 0',
        noCommercialZone:'No commercial zone is define for this shop',
        noGiftCardFound: 'No gift card matches this reference',
        noFactureFound: 'No document found',
        noTicketFound: 'No ticket matches this reference',
        noCommandeFound: 'No sales order matches this reference',
        noPossibilityToReturnArticle:'An error prevents the return of the item',
        articleAlreadyReturn: 'This item has been already return',
        hostIp:"This is not a valid IP address",
        optional:'Optional',
        orderTitle:'Order',
        sectionDontHaveCommandeZone: 'The sections affected by this command do not have a command zone',
        commandeAlreayCancel: 'This sales order has already been cancelled',
        mustSpecifyRemboursement: 'You must specify the method of refund',
        mustSpecifyGiftCardReference: 'You must specify the gift card bar code',
        mustChooseOneRaccourci: 'You must choose a shortcut',
        someItemsNotPresentInPo: 'Some items are not present in the associate purchase order',
        poLineAlreadyReceptione:'This bloc has already been received',
        ZoneWithBins:'No bins has been provided for this zone',
        someItemsNotPresentInPo:'Some of the received items are not part of the purchase order',
        unauthorizedDivision:'The line you want to duplicate cannot be split by the remainder',
        thisItemsNotPresentInPo: "This item doesn't appear in the associated purchase order ({name})",
        lineCannotBeDelated: "This line cannot be deleted",
        thisArticleNotLinkToStock: "This item is not linked to a stock",
        articleIsNotInPo:'This item doesn\'t appear in this purchase order',
        articleIsNotInTo:'This item doesn\'t appear in this transfert order',
        articleIsNotInRestock:'This item doesn\'t appear in this internal restock',
        toQuantityCantBeEdit: 'The status of this transfer order does not allow you to edit the quantities to be collected',
        tooManyOrTooLongTags:"There are too many tags (250 max) or one of them is too long (255 chars max)",
        ecommerceSendError:"The E-shop sends the error {erreur}",
        variantAreTheSame:'Child items are not itemized correctly and are therefore interpreted as the same items by Shopify. Check the options you specified.',
        noUserToSendAlert:'No users are configured to receive this type of alert',
        noUser:'No user has been assigned',
        indicateBinsInZoneThatHaveNoBins: 'You specified a bins for a location that does not contain one',
        binsOrZone:"You must specify a bins or a zone",
        reassortInterneAlreadyOpen:'You already have an open reassort. Please close it before generate a new one',
        noZoneReassortInterneConfig:'There is no configuration for internal restock area',
        negativeShopStockAndNoAutoPossibilities:'The following items have negative stock in your trade area. You must first readjust their stock before you can generate a restock',
        reassortCantDeleteAlreadyMove:"You can't delete a line that has already started being collected",
        clientNotMatchWithDossier:'This customer didn\'t match with this case',
        exportEtatCompte:"Export account statement",
        mailEtatCompte:"Account statement email",
        etatCompteOnlyOngoing:"Export: ongoing documents only (unpaid invoices and unused credit notes)",
        exportZCaisse:'Export cash register Z',
        exportZCaisseWarning:'The cash register sessions taken into account in this report are only those that were opened during the period indicated above, then closed. Attention: if the closing of one or more of these sessions took place after the end date of the period indicated above, the entirety of each session is still taken into account. Conversely, if a cash register session was opened before the start date of the period indicated above, it will not be taken into account, even if its closing was carried out during this period.',
        jourCloture:'closing day',
        du:'from',
        au:'to',
        sessionCaisse:'cash session',
        baseHt:'Excl. tax base',
        montant:'Amount',
        delete_current_to_pos:'Do you really want to cancel the creation of the transfer order? The current selection will be permanently lost.',
        /*************Modules name**************/
        moduleadmin:'Configuration',
        moduleerp:'ERP',
        modulewms:'WMS',
        moduleposs:'POS',
        modulepos:'POS',
        moduleusers:'Users',
        moduleinvoice:'Invoice',
        modulegeneral:'General',
        chatbotIa:'AI assistant',
        modulerhtime:'Working time management',
        /*********divers***********/
        noDeliveryNoteToConvert:'No delivery note to convert',
        noSelection:'No selection',
        resetQuantity:'Reset quantity',
        resetDefault:'Reset to default',
        pointFideliteIsOverClientPointFidelite:'The customer does not have enough loyalty points',
        stockAdjustmentSupportingDocument:'Stock adjustment supporting document',
        addDiscountSelection:'Add discount on selection', 
        addDiscountAll:"Add discount on all items",
        documentCantBeDeleteBecauseLinesAlreadyProcessed:"This document cannot be cancelled because some lines of this document have already been processed",
        convert:'Convert',
        chat:'Message',
        thisLine:'This line',
        manualCounting:'Manual counting',
        cetteLigne:'this line',
        emisLe:'Issued on',
        acquittee:"Paid",
        cancelInvoice:'Cancel this invoice',
        acquitterFacture:'Pay this invoice',
        generateNewFrom:'Generate a new document from this one',
        sendDocEmail:'Send this document by e-mail',
        sendTicketEmail:'Send this ticket by e-mail',
        mailTicketBodyHeader:"Receipt e-mail body",
        factureA4FooterHeader:"A4 invoice footer text",
        factureA4FooterTextLabel:"Text displayed at the bottom of the A4 invoice generated from the register",
        factureA4FooterSizeLabel:"Font size",
        defaultMail:"Hello,<br /><br />Click the button just under to download the [type]<br /><br />[bouton]<br /><br />Regards,<br />",
        saveDocTemplate:'Save this document as a template',
        createReminderFromDoc:'Create a reminder for this document',
        editReminderDoc:'Edit the reminder for this document',
        convertToInvoice:'Convert to invoice',
        notConvertToInvoice:'Not convert to invoice',
        allLocalisations:'All localisations',
        filterTheSelection:'Filter the selection',
        exludeConvertedLines:'Remove completely converted lines',
        filterBysection:'Filter by shop',
        referenceItem: "Reference item",
        complementaryItem: "Complementary item",
        supplierOrder:'Supplier order',
        addSupplierItem: "Add a supplier's item",
        addItemFromBase: "Add an item from the base",
        yes: 'Yes',
        no: 'No',
        signIn: 'Sign In',
        password: 'Password',
        newPassword: 'New password',
        signOut: 'Sign Out',
        administration: 'Configuration',
        users: 'Licences',
        gestionStockCommandes: 'ERP',
        shops: 'Shops',
        shop: 'Shop',
        showedStock: 'Showed stock',
        delete: 'Delete',
        cancelCollect: 'Cancel collect',
        remove: 'Remove',
        update: 'Update',
        upload:'Upload',
        online:'Online',
        optional:'Optional',
        offline:'Offline',
        calculationMethod:'Calculation method',
        activeOnPromotion:'Active on promotions',
        forAmountOf:'For an amount of',
        perSlice:'Per slice',
        inProportion:'In proportion',
        activateOnPromotion:'Activate on promotions',
        totalCumulLoyaltyPoint:'Total cumulative loyalty points',
        fusionClientInfo:"The selected customer will disappear from your customer database, and all of his information will be merged with {clientName}",
        earnedLoyaltyPoint:'Earned loyalty points',
        confirmDeleteAllPage:'Do you really want to delete all the lines on the page',
        confirmDeleteUser: 'Are you sure you want to delete the user',
        confirmDeleteGrade: 'Are you sure you want to delete the grade',
        typeDeleteX: 'Are you sure you want to delete ',
        typeCancelCollectX: 'Are you sure you want to cancel the collect of',
        typeDeleteReminderX: 'Are you sure you want to delete the reminder for ',
        confirmDeleteCheckDeposit: 'Are you sure you want to delete this check deposit ?',
        typeRemoveX: 'Are you sure you want to remove ',
        confirmArchiveX: 'Are you sure you want to archive ',
        confirmActiveX: "Are you sure you want to activate",
        confirmDeleteGoals: "Are you sure you want to delete the goals of this period:",
        confirmRemoveRh: 'Are you sure you want to remove',
        confirmOpenFonCaisse: 'Are you sure you want to open this checkout with ',
        confirmAddClientForm: 'Are you sure you want to add a client form',
        confirmRemoveClientForm: 'Are you sure you want to remove the client form',
        selectLoyaltyRewardMode:'Select the loyalty reward mode',
        noRewardModeSelected:'No loyalty reward mode selected',
        loyaltyRewardConfig:'Loyalty rewards configuration',
        cashback:'Cashback',
        availableCashBack:'Available cashback',
        toApplyTo:'To apply to',
        recompense:'Free item',
        ofFondCaisse: 'of cash float',
        confirmUnarchiveX: "Are you sure you want to activate",
        confirmClockingX: 'Are you sure you want to clock in ',
        confirmValidateLine:'Are you sure you want to validate this block',
        confirmValidateAll:'Are you sure you want to validate all',
        confirmCancelReceiptTo: "Are you sure you want to cancel the receipt of this item",
        confirmCancelSaleOrder:'Are you sure you want to cancel this sale order',
        warningToCancelSaleOrder:'Transfer orders are associated with this sale order, it is strongly recommended to cancel them',
        confirmClosefondCaisse:'Are you sure you want to close checkout with ',
        confirmDifferenceFondCaisse:'Are you sure you want to open this checkout with a difference of ',
        confirmValidateInventory:'Are you sure you want to validate this inventory, this action will be irreversible',
        clotureDetailPdf:'Checkout closing detail',
        returnToItemReceipt:'Return to items receipt',
        associateToAnItem:'Replace by an existing item',
        addPermanentlyMsg:'Attention, this action is irreversible',
        de: 'From',
        vers: 'To',
        exerciseStart:'Exercise start',
        ecart:'Difference',
        closeNote:'Note',
        irreversibleAction: 'Warning: this action will be irreversible',
        company: 'Company',
        allCompany:"All companies",
        canceled: 'Canceled',
        noLogoActualy: 'No logo currently',
        noPhotoActualy: 'No picture currently',
        man: 'Man',
        woman: "Woman",
        rh: 'Staff',
        modePaiement: 'Payment method',
        loyaltyMode:'Loyalty mode',
        general: 'General',
        genere:'Generate',
        proposal:'Propo',
        newTotalValueStock:'Total value of the new stock',
        oldTotalValueStock:'Total value of the old stock',
        totalValueSaleOrder:'Total value of sales order',
        totalPaiementSaleOrder:'Total value of deposits paid',
        tarifSellerModification: 'Manual modification of a price',
        width:'Width',
        height:'Height',
        openFondCaisse: 'Checkout opening - Cash float',
        fond_caisse:'Cash float',
        closeFondCaisse: 'Checkout closing',
        closeCaisse:'Checkout closing',
        repartGoals: 'Goals distribution',
        openCaisse: 'Open checkout',
        openTiroir:'Open cash drawer',
        loyalty:'Loyalty',
        customerLoyalty:'Customer loyalty',
        loyaltyPlan:'Loyalty plan',
        accumulatedPoints:'Accumulated points',
        spentPoints:'Spent points',
        open:'Open',
        opened:"Opened",
        closeWith:'Close with',
        a: 'at',
        allShops:'All shops',
        allUsers:'All users',
        searchArticle: 'Search item...',
        searchInWait: 'Searching',
        cashier: 'Cashier',
        inventory:'Inventory',
        clickOnZoneWithoutBins:'Click on a zone without bins',
        mustCompleteOrCancelReceipt:'You must complete or cancel your current receipt',
        inventaireZone:'Inventory type zone',
        inventaireBins:'Inventory type bins',
        inventaireCategorie:'Inventory type category',
        finalizedInventory:'Finalized inventory',
        inventoryType:'Inventory type',
        inventaireImport:'Inventory importation',
        loyaltyPlanImport:'Loyalty importation',
        ajustImport:"Imported stock adjustment",
        returnInventory:'Return to inventory',
        returnInventoryHome:'Return to inventory homepage',
        startCounting:'Start counting',
        seeInventoryReport:'See the inventory report',
        validateInventory:'Validate inventory',
        addSelection:'Add the selection',
        validateCount:'Validate count',
        addToInventoryList:'Add to the inventory list',
        cancelCount:'Cancel count',
        cancelAllCount:'Cancel all counts',
        cancelComparisonwithStok:'Cancel the comparison with the stock',
        allInventories:'All inventories',
        readInventoryDetail:'Read inventory detail',
        compareInventoryToStock:'Compare inventory to stock',
        inventoryComparison:'Inventory comparison',
        allCounts:'All counts',
        selectCancellationOption:'Select the cancellation option',
        countNotFinished:'Count not finished',
        wrongCount:'Wrong count',
        inventoryBinsMsg:"The system will automatically create several inventories if the number of bins in this zone is too high",
        confirmSecondCount:'You have already done this count, do you really want to do a new one',
        zone:'Zone',
        zoneName:'Zone name',
        customerPlacehlder: 'Customer...',
        refineSearchResults: 'Refine your search to see more results',
        supplementListPlaceholder: 'Supplement list...',
        noRhForSection: 'No staff have been allocated for this point of sale',
        consultPriceItem: 'See price item...',
        seeSaleOrder:'See the sale order',
        selectColumnFileToMatch:'Select the column from the file to match',
        selectColumnBaseToMatch:'Select the column from the item base to match',
        stockArea: 'Stock Area',
        createStockArea: 'Create storage Area',
        creerGiftCard:'Create a gift card',
        creerAbonnementCard:"Create a subscription card",
        stockHaveBins: 'This stock area must Have Bins',
        stockZoneEmpty:'This stock area is empty',
        errorEcomOrderTraitement:'Error on a sale order',
        newEcomOrder:'New sale order',
        itemReference: 'Item Reference...',
        cashOut: 'Cash withdrawal',
        consulter: 'Consult',
        attribuer: 'Attribute',
        attribuerA: 'Attribute to',
        synchronized:'Synchronised',
        notSynchronized:'Not synchronised',
        synchronizeItems:'Synchronise items',
        itemMustHaveParentToBeOnline:'This item must have a parent name to be online',
        attribuerSelection: 'Attribute the selection',
        generateReassort: 'Generate a proposal restock',
        validateProposalReassortFournisseur: 'Are you sure you want to convert this restocking proposal into purchase orders?',
        waitConvertInPo: 'Purchase order(s) being created. You will be redirected soon. This task may take a few minutes...',
        qteToOrder: 'Qty to order',
        reassortGenerate:'Generate a restock',
        addToFavorite:'Add to favorites',
        editFavorite:'Edit favorite',
        listOfFavorite:'List of favorites',
        favoriteName:'Favorite name',
        generateReadjustment:'Generate a readjustment',
        proposalReassortList: 'Restock proposal',
        forDepotBanque: 'This withdrawal is for a bank deposit',
        depotEnBanque: 'Bank Deposit',
        typeRetrait: 'Type',
        retraitForOtherReason: 'This withdrawal is for an other reason',
        retraitOtherLabel: 'Indicate the reason you are withdrawing cash',
        confirmRetraitOtherReason: 'Are you sure you want to withdraw cash in the amount of',
        confirmRetraitBanqueReason:'Are you sure you want to deposit an amount of',
        confirmDeleteCustomerAssociate: 'Are you sure you want to delete this customer association',
        confirmDeleteDivers: "Are you sure you want to delete",
        confirmDelete: 'Confirm deletion',
        confirmGenerateTo:"Are you sure you want to generate a transfer order from this shipping order",
        successOperation: 'Operation performed successfully',
        deleteSelection: 'Delete selection',
        draftsSelected: 'selected draft(s)',
        bulkDeleteResult: '{deleted} draft(s) deleted, {skipped} skipped',
        successInHistorique: 'Import launched successfully. You can follow the import status in your import history.',
        ruleUpDateAlreadyAssigned:"This field has already been assigned to an update rule",
        addClient: 'Add Customer',
        editColumnPdf: 'Edit columns',
        editRecapPdf: 'Edit lines',
        addLogo: 'Add a logo',
        cattc:'Turnover taxes included',
        caht:'Turnover taxes excluded',
        goalsttc:'Goals taxes included',
        taxesExcluded:'Taxes excluded',
        taxesIncluded:'Taxes included',
        totalTTC:'Total Taxes included',
        goalsht:'Goals taxes excluded',
        grossMargin:'Gross margin',
        grossMarginPercent:'Gross margin in %',
        beginIsGreaterThanEnd:'The beginning  of the period cannot  be greater than the end of the period',
        periodIsGreaterThanAYear:'The selected period must be less than one year',
        importGoals: 'Import goals',
        createGrade: 'Create Grade',
        createModePaiement: 'Add a payment method',
        createCashOutReason: 'Add proof of cash withdrawal at the POS',
        cashOutMore: 'Your proof of cash withdrawal at the cash POS',
        modePaiementForced: 'Basic payment methods',
        modePaiementMore: 'Your added payment methods',
        items: 'Items',
        onlyUncollectedItemsProposed: '(only items not yet collected in the order are shown)',
        today: 'Today',
        hier: 'Yesterday',
        demain: 'Tomorrow',
        noObjectif: "There are no POS goals for this period.",
        objectifs: 'Goals',
        realise: 'Achieved',
        nbrEntreClient: 'Number of customers passages (entry and exit)',
        edit: 'Edit',
        period: 'Period',
        oneDay: 'One day',
        manyDays: 'Many days',
        searchBy:"Search by",
        day: 'Day',
        de: 'From',
        toA: 'To',
        seeAll:'See all',
        seeMore:'See more',
        createNotification:'Create a notification',
        notifications:'Notifications',
        notificationModule:'Module',
        notificationAction:'Action',
        notificationLocation:'Location',
        notificationNotifiedUsers:'Notified user(s)',
        notificationBulkEditUsers:'Edit notified users',
        notificationBulkDelete:'Delete selection',
        notificationSelectedCount:'{count} selected',
        selectAll:'Select all',
        selectPlaceholder:'-- Select --',
        salesOrderNew:'New order to prepare',
        salesOrderError:'Order processing error',
        sectionNotAllowedForDomain:'This domain cannot be restricted to a specific shop',
        notificationActionShipment:'Packing slip to receive',
        notificationActionTo:'Transfer order to collect',
        notificationActionItem:'Temporary item created',
        notificationActionSalesOrderNew:'New e-commerce order to prepare',
        notificationActionSalesOrderError:'E-commerce order cannot be processed',
        notificationActionSalesOrderCollectAssigned:'B2C sale order collect assigned',
        notificationActionRppslPack:'Missing RP/PSL configuration on an RP/PSL pack',
        allRequired:'This field is required',
        disponible: "Available",
        scannedTab: "Scanned",
        addCashOut: 'CashOut',
        noEnougthForReassort: '{name} does not have enough stock to execute this change',
        confirmAddItemPromo: 'Confirm the selection of {quantity} items',
        needEntre: "This chart will be available when the number of customer passages will be filled in",
        createGoals: 'Create Shop Goals',
        attributeStaffGoals: 'Attribute Goals to Staff',
        deleteGoals: 'Delete Goals',
        createOneDayGoals: 'Create goal of one day',
        report:'Reporting',
        datas:'Datas',
        dropCsv: 'Drop CSV file here or click to upload.',
        noDataInCsv: 'No data found in this csv file',
        zoneCsvImportBtn: 'Import zones from CSV',
        zoneCsvImportSuccess: '{inserted} zone(s) imported successfully',
        zoneCsvImportPartial: '{inserted} of {total} zone(s) imported. See details below.',
        zoneCsvNoHeaderHelp: 'The file must not contain a header row.',
        csvLineError: 'Line {line} ({value}): {errors}',
        fileCsvToLarge: 'The file exceeds the maximum allowed size of 7 megabytes',
        objectifCsvFileToLong: 'The csv file must have 1000 line maximum',
        doublonCsv: 'Some columns of the csv file are used on multiple data',
        indicateRecurrence:'Indicate a recurrence',
        indicateRecurrenceMsg:'Indicate the day of the month for which you want this recurrence to apply for the template {modeleName}',
        deleteRecurrence:'Delete the recurrence',
        exonerateFromTaxes:'Exonerate from {taxe}',
        every:'Every',
        ofMonth:'th of the month',
        template: 'Template',
        recurrence:'Recurrence',
        reprogramRecurrenceOnNextMonth:'Reprogram the recurrence for the next month',
        templateConfiguration: 'Template configuration',
        templateEmailConfiguration: 'Email template configuration',
        emailBodyQuotation:'Default body of a quotation email',
        emailBodyInvoice:'Default body of a invoice email',
        emailBodyCreditNote:'Default body of a credit note email',
        msgInfoContenuMail:'The elements noted within brackets [] will be retrieved from the information in the document. Here is the complete list of elements that you can write within brackets:',
        msgInfoContenuMailClient:'will be replaced by the customer name',
        msgInfoContenuMailNumero:'will be replaced by document number',
        msgInfoContenuMailMontant:'will be replaced by the total amount with taxes included of the document',
        msgInfoContenuClient:'[customer]',
        msgInfoContenuNumero:'[number]',
        msgInfoContenuMontant:'[amount]',
        msgEmailConfigure:'When you create an invoice, quotation or a credit note, you will be able to send this document by e-mail. Here you can configure the body of this e-mail.',
        seeMyTemplate:'see the template',
        importedRows: 'Imported rows: ',
        infoModePaiement: 'This is to list the possible payment methods for your shop. Please note: each of your shops can use different payment methods. Therefore, you must go to the options of each of your shops to indicate the payment methods that are accepted there.',
        restrictionStaff: 'Staff Restrictions',
        reassortWait:'Restock proposal is being calculated. This task may take a few minutes...',
        rebillingWait:'Intercompany rebilling in progress. This task may take a few minutes...',
        interSocieteGenerationDone: 'Generation completed with errors',
        interSocieteGenerationErrorFile: 'At least one error occurred during generation. A report file has been generated:',
        inventoryCompareWait:'The comparison of the inventory with the stock is being calculated. This task may take a few minutes...',
        inventoryValidateWait:'The inventory is being validated. This task may take a few minutes...',
        waitReassortTo:'Transfer order(s) being created. You will be redirected soon. This task may take a few minutes...',
        authorized: 'Authorized',
        noRestriction: 'No restriction',
        scanBadge: 'Scan your badge here...',
        scanSellerBadge: 'Scan your seller badge here...',
        scanBadgeOrSearch:'Scan your badge here or search a staff',
        formclient: 'Customer form',
        explicationFormClient: 'Indicate the fields you want to appear in the customer creation form',
        noFilter:'No filter',
        field:'Field',
        obligatoire:'Required',
        requiredField: 'Required Field',
        notRequiredField: 'Not Required Field',
        uniqueField: "Single value",
        notUniqueField: 'Not Single Value',
        freeField: 'Free value',
        fieldListData: 'Submitted to a data list',
        civilite: 'Civility',
        activer: 'Activate',
        adressePhysique: "Physical Address",
        adressePostale: "Postal Address",
        communeVille:'City/Town',
        inscriptionNewsletter: 'Newsletter Subscription',
        noFormClient: 'The customer form for your company is not configured',
        customerReward:'Customer rewards',
        homme: 'Man',
        femme: 'Woman',
        noClientToEdit: 'You must first indicate a customer',
        noCashierIndicated : 'You must indicate a cashier',
        periodHigherOneMonth:'The selected period must be less than 1 month',
        newItem: 'New item',
        stamp:'Stamp',
        parameterName: 'Avanced parameters',
        otherCompany: 'Other companies',
        interSociete: 'Inter-company rebilling',
        executeInterSociete: 'Execute inter-company rebilling ?',
        refacturation:'Rebilling',
        exceptionRefacturation:'Rebilling exception',
        mailSent:'Mail sent',
        mailOpened:'Mail opened',
        clientType: 'Client type',
        quartier: 'Area',
        dateDeNaissance: 'Date of birth',
        selectAType: 'Please select a type',
        customField: 'Custom field',
        customFields: 'Custom fields',
        category: 'Categories',
        providerName: 'Provider name',
        contactName: 'Contact Name',
        categoryName: 'Category name',
        companyName: 'Company name',
        legalForm:'Legal form',
        documentType:'Document type',
        documentDeleted:'Document deleted',
        allType:'All types',
        draftListMsgInfo:'Only drafts less than 48 hours are saved',
        fieldName: 'Field name',
        defaultFields: 'Default fields',
        providers: 'Providers',
        nouveauFournisseur: 'New provider',
        editFournisseur: 'Edit provider',
        CDD: 'CDD',
        CDIE: 'CDI - Trial period',
        CDI: 'CDI',
        archive: 'Archive',
        archiveSelection: 'Archive selection',
        activateSelection: 'Activate selection',
        confirmArchiveSelection: 'Do you really want to archive the selected items:',
        confirmActivateSelection: 'Do you really want to activate the selected items:',
        noItemSelected: 'No item selected',
        itemsArchived: 'Items archived successfully',
        itemsActivated: 'Items activated successfully',
        itemsRemovedFromList: 'Items removed successfully',
        thisStaffIsArchive: 'Please note: this staff is archived',
        includeArchiveStaff: 'Include archived staff',
        includeArchiveProvider: 'Include archived providers',
        includeArchiveData: 'Include archived datas',
        includeArchivetem: 'Include archived items',
        clientAssocie: 'Associated customer',
        clientArchiveAccocie: 'This Staff is archived and therefore cannot be associated with a customer',
        clientArchiveBadge: 'This Staff is archived and therefore this is not possible to generate a badge',
        deleteCheckDeposit:'Delete check deposit',
        makeSale:'Make a sale',
        downloadCSV: 'Export csv file',
        downloadZone:'Export zone content',
        downloadBins:'Export bins content',
        downloadQuickCSVSelection:'Export a quick version of the selected lines in csv',
        downloadCSVSelection: 'Export selected column in csv',
        downloadCSVPeriod: 'Export selected period in csv',
        downloadCSVThisSelection: 'Export this selection in csv',
        downloadCSVThisSalesSelection: 'Export the sales of this selection in csv',
        downloadCSVThisTicketsSelection: 'Export the tickets of this selection in csv',
        downloadCSVThisDocumentsSelection: 'Export the documents of this selection in csv',
        downloadCSVThisPaiementSelection: 'Export the paiements method of this selection in csv',
        downloadCSVAll: "Export all columns in csv",
        downloadAllPoCsv:'Export selected purchase order contain in csv',
        downloadSelectedPoCsv:'Export headers of selected purchase order in csv',
        downloadAllToCsv:'Export selected transfer order contains in csv',
        downloadAllToWithoutDetailsCsv:'Export only selected rows from the current table',
        exportTransferOrdersInProgress:'Export the transfer orders in progress in csv',
        downloadAllShipmentCsv:'Export all shipment in csv',
        downloadAllGiftCardCsv:'Export all gift cards in csv',
        downloadAllAbonnementCardCsv:'Export all abonnement cards in csv',
        downloadSelectGiftCardCsv:'Export just the selection in csv',
        downloadSelectAbonnementCardCsv:'Export just the selection in csv',
        exportRefactureSelection: 'Export rebilling selection',
        exportRefactureTotal: 'Export rebilling all lines',
        downloadStockGap:'Export stocks gap',
        downloadExcel: 'Export excel file',
        downloadArticlesCSV: 'Export items in csv',
        downloadCSVecotaxe: 'Export eco-participation in csv',
        downloadCSVecotaxeDetail: 'Export eco-participation detail in csv',
        downloadCSVThisPreparationsSelection: 'Export the preparations of this selection in csv',
        downloadCSVThisPreparationsDetailsSelection: 'Export the preparations of this selection and their details in csv',
        listDonnéesCsv: 'Export the possibles datas list',
        firstlevelcat:'Classification',
        secondlevelcat: 'Family',
        thirdlevelcat: 'Subfamily',
        fourthlevelcat:'Category',
        fifthlevelcat: 'Subcategory',
        imageLink: 'Item image link',
        categorysingular: 'Category',
        addone: 'Add a',
        addOption:'Add an option',
        tagsMsg:'You can combine multiple tags by separating them with a comma',
        emailsCumul:'You can combine multiple emails by separating them with a comma',
        tagsMax:'You can combine up to 250 tags',
        staffIsAssociate: "This Staff is associated to customer",
        staffIsNotAssociate: "This Staff is not associated to any customer",
        newbrand: 'New brand',
        includeArchiveBrands: 'Include archived brands',
        formBrand: 'Brand form',
        archivedBrand: 'This brand is archived',
        archivedProvider:'This provider is archived',
        associationStaffCustomer: 'Association of a staff and a customer',
        transferOrderPriority:'Priority of transfer order collection',
        transferOrderAssociation:'Transfer orders association',
        saleOrderAssociation:'Sale order association',
        noAssociateCustomerResult: 'There is no association possibilities found',
        impossibleDeletingFamily: 'Deleting is impossible !',
        familyContainItems: 'This category contains items',
        impossibleArchivingFamily: 'Archiving is impossible !',
        formItem: 'Item form',
        internalId: 'Internal ID',
        internalid: 'Internal ID',
        componentInternalId: 'Component internal ID',
        componentOf: 'Component: {field}',
        expectedInternalId: 'Expected internal ID',
        fournisseur: 'Provider',
        notConnectedToFreebird:'Not connected to Freebird',
        otherItemWithSameRefName:'Other items with the same reference name',
        marque: 'Brand',
        reference: 'UPC code',
        reference2: 'UPC code 2',
        arrowUp: 'Arrow Up',
        arrowDown: 'Arow Down',
        ecoTaxe: 'Eco-participation',
        barcode: 'Barcode',
        barcodePackaginglist: 'Packaging barcode',
        shopCode:'Shop code',
        itemName: 'Item name',
        priceTtc: 'Price with duty included',
        priceHt: 'Price without duty',
        supplierPrice: "Supplier price",
        priceHtWithoutDiscount: 'Price without duty and without discount',
        marge: 'Margin',
        margeNet: 'Net Margin',
        totalMargeNet: 'Total Brut Margin',
        differenceMargeNet: 'Difference Net Margin',
        totalBuyPrice:'Total buy price in currency',
        margePercent: 'Margin %',
        discountPrice: 'Discount price',
        discountProfil: 'Discount profil',
        percentageExceptionProfil: 'Percentage exception profil',
        discountProfilPersonalizedPrice: 'Discount profil personalized price',
        unitDiscount:'Unit discount',
        discountType:'Discount type',
        editionPrix:'Price edition',
        buy_price: 'Buying price in currency',
        devise_achat: 'Buying currency',
        last_devise_achat: 'Last buying currency',
        stores: 'Stores',
        tgc: '{taxe} Rate',
        downloadBadge: 'Download badge',
        generateBadge: 'Generate badge',
        thisItemMustHaveStock: 'This item will be dependent on a stock',
        thisItemMustBePrepare: 'This item will have to be prepared',
        thisItemIsArchived:'This item is archived',
        itemHaveStock: 'Stock dependent',
        itemToPrepare: 'Item to prepare',
        btnPrepare: 'Preparation',
        buffaloPreparationFtpError: 'The preparation ticket could not be sent to the FTP server',
        buffaloPreparationOrigin: 'Preparation from Buffalo',
        preparations: 'Preparations',
        sendTicketToPreparation: 'Send the ticket content to preparation',
        ticketPrintDestination: 'Where should the ticket be printed?',
        preparationPrinter: 'Preparation',
        invalidItemForPreparation:'Invalid items for preparation are present in ticket',
        noPreparationFound:'No preparation found',
        customizationBadge: 'Badge customization',
        addIdPicture: 'Add a picture on the badge',
        addGrade: 'Add the grade',
        addShopName: 'Add the entity name',
        addLastname: 'Add the lastname',
        addShopLogo:'Add shop logo',
        chooseYouCompany: 'Select the entity',
        chooseYourBgColor: 'Choose the background color',
        chooseYourTextEntityColor: 'Choose the entity text color',
        chooseRefundMethod:'Choose the refund method',
        enterYourCustomColor: 'Add a background  color in hexadecimal',
        addCustomColor: 'Add a custom background  color',
        fieldToUpdate:'Field to update',
        fieldAutoUpdateItemRule:'All items with this field filled in the same way will be automatically updated',
        noUpdateRule:'No update rule',
        noEntity: 'No entity',
        red: 'Red',
        blue: 'Blue',
        yellow: 'Yellow',
        pink: 'Pink',
        green: 'Green',
        black: 'Black',
        white: 'White',
        pr:'Cost price',
        prmp:'Average price',
        beneficiary: 'Beneficiary',
        selectABeneficiary: 'Select a beneficiary',
        muststock: 'Item Has Stock',
        mobil: 'Transit area',
        collect:'Collect',
        receive:'Receive',
        chosseMobile: 'Choose the delivery vehicle',
        choseReceptionZone:'Choose the reception zone',
        receiptPoDefaultZone:'Default purchase order receipt zone',
        receiptToDefaultZone:'Default transfer order receipt zone',
        collectToDefaultZone:'Default transfer order collect zone',
        receiptAndCollectDefaultZone: 'Default receipt and collect zone',
        choseAReceptionZoneToReceive:'Choose a zone to receive the transfer order',
        choseAReceptionZoneToCollect:'Choose a zone to collect the transfer order',
        choseAReceptionZoneToReceivePo:'Choose a zone to receive the purchase order',
        unauthorizedActionOnZoneBins:'The selected zone contains bins, please use your WMS for the reception of this transfer order',
        duplicatePoReliquat:'Duplicate the line based on the remainder',
        duplicatePoReliquatConfirm:'Are you sure you want to duplicate the line based on the remainder',
        duplicate: 'Duplicate',
        reception: 'Receiving area',
        commerciale: 'Selling area',
        prive: 'No accessible selling area and stock mouvments',
        unpaidInvoice:'Unpaid invoices',
        nonAcquitte:'Unpaid',
        stockage: 'Traditional storage area',
        commande: 'B2C Order area',
        commandeB2b: 'B2B Order area',
        zoneArchived: 'Please note : this area is archived',
        importHistory: 'Imports',
        importReport: 'Import report',
        articleImport: 'Item import',
        articleTransformImport: 'Processed item import',
        clientImport: 'Clients import',
        supplementListImport: 'Item supplements import',
        poImport: 'PO import',
        toImport: 'TO import',
        shipmentImport: 'Shipment Voucher Import',
        rppslImport: 'RP/PSL Import',
        rppslFournisseurImport: 'RP/PSL Supplier Import',
        enCours: 'In progress',
        open:'Opened',
        close:'Closed',
        on:'On',
        dataListpossible: 'List of possible data',
        editPersonalField: 'Edit custom field',
        customFieldCreation:'Custom field creation',
        updateDatasRule:'Data update rule',
        editBrand: 'Edit a brand',
        clocking: 'Clocking in',
        errorClocking: 'Badge not assigned this shop or incorrect',
        errorPriorityCollect:'You cannot set the same shop twice',
        errorNoBinsSelected:'No bins has been selected',
        validateProposalReassort: 'Are you sure you want to convert this restocking proposal into a transfer order ?',
        errorClotureSaveTicket:'Please delete all your saved receipts before closing the checkout',
        nonAttribue: 'Not assigned',
        detailHistory: 'History details',
        detailArticle: 'Item details',
        detailPrice: 'Price details',
        detailItem:'Item details',
        stockItem:'Stock item',
        stockItemPos:'Stock item',
        negativeStock:'Negative stock',
        importStock:'Import stock adjustment',
        stockParent:'Stock parent',
        colonnes: 'Columns',
        rechercheSurValeurUnique: 'Single value search',
        deleteLineItem:'Delete an item line',
        removeQuantityOnLineItem:'Remove quantity from an item line',
        removeDepositPayment:'Delete payment line',
        filtres: 'Filters',
        noFilter: 'No filter',
        filterRppsl: 'RP/PSL Filter',
        filterRppslPack: 'RP/PSL Pack Filter',
        prmpIndice: 'Average Cost index',
        prIndice: 'Cost price index',
        parent_name: 'Parent name',
        itemInfos: 'Item informations',
        paymentInfos:'Payment informations',
        limitDatePay:'Limit date of payment',
        limitDateValidity:'Limit date of validity',
        detail:'Detail',
        customer: 'Customer',
        customerProfil:'Customer profile',
        customerInfos: 'Customer informations',
        requiredInformations:'Required informations',
        principalInfo: 'Principal informations',
        secondInfo: 'Secondary informations',
        warningImportInventaire:'Please note, this feature will irreversibly overwrite your previous stock with the new stock indicated in your file, for each of the items found there and in each of the indicated locations. You should NEVER import the inventory of an item for a location, if you have not carried out its complete inventory for the whole of this location.',
        infoImportInventaireAddStock:'Please note, this feature will add to your actual stock the new stock indicated in your file, for each of the items found there and in each of the indicated locations.',
        infoSupplementListArticle: "Listed here are all articles that have a supplement list, but do not themselves belong to any supplement list.",
        infoAbonnementArticle: "Listed here are all articles that have subscription configuration",
        itemLinkAndNotLinkToTock: 'Stock and no stock items',
        itemLinkToTock: 'Stock items',
        itemNotLinkToTock: 'No stock items',
        itemNoHavestock: 'The item is not stocked',
        itemWithAndWitoutStock:'Items with and without stock',
        itemWithStock:'Items stock',
        itemWWitoutStock:'Items without stock',
        carreposOutStock:'Carrepos sale',
        setHook:'Activate hook',
        noCarreposConfig:'Carrepos config not completed',
        carreposConnexionFailed:'Carrepos authentification failed',
        storeUnavailable:'Store unavailable',
        connectorConfigMissing:'Connector field config missing',
        referConfigMissing:'Reference field config missing',
        productNotFound:'Product not found',
        deleteHook:'Delete hook',
        unavailable:'Unavailable',
        diverseInfo: 'Diverses informations',
        devise: 'Currency',
        inDevise: 'In currency',
        migrate: 'Migrate',
        migrateFrom: 'Migrate from',
        vers: 'to',
        errorMsgMin2:'Your message must be at least 2 characters long',
        errorSelectFamily: 'You must indicate a valid destination of migration',
        aucune: 'No',
        aucunArticleRaccourci: 'No item',
        noShops:'No shops',
        noSalesOrder:'No sale order',
        justItemsWhoHaveStock: 'Only items that have stock',
        impossibleExport: 'Unable to export',
        maxLineAuth: 'You can export a maximum of {limit} rows at once. You are currently trying to export some {actual}',
        csvWillBeReady: 'Export request recorded. Your CSV file will be available shortly in your CSV file download manager',
        exportRefactureFidelite: 'Export special file',
        inventoryUpdateWillBeReady: 'Inventory update in progress, it will take effect within 5 minutes on {ecomName}',
        lastExportCsv: 'Last export of CSV files',
        exportDate: 'Export date',
        exportSelectedColumnToCsv:'Export selected colmumn to csv',
        state:'State',
        itemHasNoStock:'This item has no stock',
        errorExport: 'An error occurred during the export',
        errorImport: 'An error occurred during the import',
        errorNoStaffSelected:'No Staff has been selected',
        attributeSelectionToStaff:'Do you want to attribute the selection now',
        download: 'Download',
        editArticle: 'Item edit',
        editClient:'Customer edit',
        havestockInImport: 'You must indicate if this item must be dependent on a stock',
        archivedInImport: 'You must indicate whether this item is archived (yes/no)',
        itemCard: 'Item card',
        defaultConfig: 'Default configuration',
        personalizedConfig: 'Personalized configuration',
        addNewSection:'Add a new section',
        add: 'Add',
        newApiKey:'New API key',
        apiKey:'API key',
        msgApiKeyExpire:'Your API key will expire in less than 30 days',
        msgNoApiKey:'No API key',
        noUserConf: 'No personalized configuration',
        createApiKey:'Create an API key',
        activeApiKey:'Active API key',
        createNewApiKey:'Create a new API key',
        msgApiKey:'Here your API key',
        msgRecreateApiKey:'Are you sure you want to regenerate an API key',
        transformArticleAndOriginIsSame:'One of the lines that makes up the transformed article is identical to the article itself',
        originAndComponentIsTheSame:'Internal ids are the same',
        deleteUserConf: 'Delete the personalized configuration',
        persoConfigVide: 'Your personalized configuration is empty',
        defautConfigVide: 'Your default configuration is empty',
        noDefaultConf:'No default configuration',
        noConfAvailable:'No available configuration',
        itemAndZoneDetail:'Items and Zones detail',
        customizeInterface: 'Customize the interface',
        customizationInterface: 'Interface customization',
        importArticleAlreadyInProgress:'An items import is already in progress.',
        purchaseOrder:'Provider\'s purchase order ',
        selectMultiplePo:'Select multiple purchase orders',
        cancelMultiSelection:'Cancel multiple selection',
        receiveSelection:'Receive the selection',
        multiPoReceipt:'Multiple purchase orders reception',
        setReceptionPriority:'Set the reception priority order',
        purchaseOrderB2b:'Purchase order',
        purchaseOrderForm:'Purchase order form',
        orderDate: 'Date of order',
        expectedDeliveryDate:'Expected delivery date',
        requestedDeliveryDate:'Requested delivery date',
        requestedDeliveryDateNoAccent:'Requested delivery date',
        realDeliveryDate:'Real delivery date',
        estimateDeliveryDate:'Expected delivery date',
        expectedReceiptDateDock:'Expected date of receipt at the dock',
        expectedReceiptDateInShop:'Expected date of receipt at the shop',
        deliveryDate:'Delivery date',
        deliveryDateNoAccent:'Delivery date',
        expectedReceiptDate:'Expected receipt date',
        expectedReceiptDateNoAccent:'Expected receipt date',
        estimatedDelivery:'Expected delivery',
        lastSalesOrder:'Last sale order',
        lastQuotation:'Last quotation',
        searchSalesOrder:'Search a sale order',
        searchBins:'Search a bins',
        quantity:'Quantity',
        quantiteParent:'Parent quantity',
        addOrRemoveStock:'Add or remove stock',
        maxQuantity:'Max quantity',
        leave:'Leave',
        leaveConversation:'Leave the conversation',
        leaveNotifConfirm:'Are you sure you want to withdraw from this conversation',
        quantityTotal:'Total quantity',
        quantityDisp:'Quantity on hand',
        quantityBloque:'Blocked quantity',
        quantiteOnPurchase: 'Ordered quantity',
        quantiteWait: 'Pending quantity',
        purchaseOrders:'Purchase orders',
        createPurchaseOrder:'Create a purchase order',
        purchaseOrderName:'Purchase order name',
        createdAt:'Date of creation',
        dateBeginAbonnement:'Subscription begin date',
        dateEndAbonnement:'Subscription end date',
        dateEnd:'End date',
        availableCredit:'Available credit',
        lostCredit:'Lost credit',
        abonnementCardNotValid:'Card not valid, please contact a manager',
        noAbonnementCardFound:'No card found, please contact a manager',
        abonnementCardTimeout:'Card validated less than 5 minutes ago, try again later',
        abonnementCardExists:'Card already exist, please try again',
        abonnementcard:'Subscription card',
        noClientAbonnementcard:'A customer is required to sell a subscription',
        dateBeginAndEndRequired:'The start and end dates must be entered together',
        lastUpdate:'Last update',
        divers:'Other',
        createBy: 'Create by',
        staff:'Staff',
        finalised:'Finalised',
        acquitte:'Acquitted',
        notAcquitte:'Not acquitted',
        partiallyAcquitte:'Partially acquitted',
        delivered:'Received',
        notDelivered: 'Not received',
        delivered2:'Delivered',
        deliveredOk:'Delivered completed',
        notDelivered2: 'Not delivered',
        notDeliveredLines: 'lines not received',
        poCompletelyReceived:'Purchase order completely received',
        noMoreItemToReceive:'There are no more items to receive in this purchase order',
        completed: 'Completed',
        notCompleted: 'Not Completed',
        includeAllPurchaseOrders: 'Include completed purchase orders',
        editPurchaseOrder: 'Edit purchase order',
        importPo: 'Import Purchase Orders Contents',
        importShipment: 'Import Shipment Voucher Contents',
        importReassort: 'Import Automatic Restock Contents',
        importReassortFournisseur: 'Import Supplier Automatic Restock Contents',
        importTo: 'Import Transfers Orders Contents',
        refer:'Reference name',
        billingRef:'Invoice reference',
        quota_recu: 'Received quantity',
        confirmLogout:'Do you really want to change the staff',
        status:'Status',
        etat:'State',
        etat_conversion:'Conversion state',
        etat1:'State 1',
        etat2:'State 2',
        excludeCancelledDocument:'Exclude cancelled documents',
        includeCancelledDocument:'Include cancelled documents',
        justCancelledDocument:'Just cancelled documents',
        fromTo:'From transfert order',
        fromPo:'From purchase order',
        since:'Since',
        statusItems:'Items Status',
        statusLines:'Lines Status',
        regenerate:'Regenerate',
        depotBanqueTitle:'Cash desposit attestation',
        remiseCheckTitle:'Check deposit attestation',
        toAlreadyCompleted: 'This transfer order has already been completed',
        allItems: 'All items',
        itemsTotallyReceived: 'Items totally received',
        itemsPartiallyReceived: 'Items partially received',
        itemsNotReceived: 'Items not received',
        sku:'SKU',
        january:'January',
        february:'February',
        march:'March',
        april:'April',
        may:'May',
        june:'June',
        july:'July',
        august:'August',
        september:'September',
        october:'October',
        november:'November',
        december:'December',
        member:'Members',
        writeNewMessageHere:'Write your message here...',
        relatedRecord: 'Related records',
        relatedItems:'Related items',
        addItemsInfoPromo:'Use the filter to target the items to add to the promotion',
        redirect:'Redirect',
        updatePoRecords: 'Update in',
        insertPoRecords: 'Insert in',
        updateShipmentRecords: 'Update in',
        updateInventory:'Stock update',
        updateTheInventory:'Update the stock',
        insertShipmentRecords: 'Insert in',
        entreStockRecords: 'Stock entry',
        voirLe: 'See',
        saleOrderCanceled:'This sale order has been canceled',
        saleOrderFinish:'This sale order has been completed',
        saleOrderFinishTicket:'This sale order has been completed. Invoice numbre: ',
        itemsDetail:'Items detail',
        registrationDate:'Registration date',
        shipmentVoucher: 'Packing list',
        shipment: 'Packing list',
        transferOrder: 'Transfer Order',
        transferOrders: 'Transfer Orders',
        shipmentVoucherAccent: 'Packing list',
        entre: 'Entry',
        expected:'Expected',
        numero_shipment: 'Packing list number',
        numero_container_shipment: 'Container number',
        numero_container_shipment_accent: 'Container number',
        date_depart_shipment:'Departure date',
        date_depart_shipment_accent:'Departure date',
        date_arrive_shipment:'Arrival date',
        date_alert:'Reminder date',
        date_arrive_shipment_accent:'Arrival date',
        status_shipment:'Status',
        createShipmentVoucher: 'Create a shipment voucher',
        manualEntry:'Manual entry',
        inventoryZone:'Inventory zone',
        inventoryOption:'Inventory option',
        inventoryZoneList:'Inventory zone list',
        countFromInventory:'Inventory count',
        cours_chargement: 'Loading in progress',
        alert_texte:'Reminder text',
        cancelReminder:'Cancel reminder',
        warehouse:'Warehouse',
        mer: 'On the sea',
        douane: 'At the custom office',
        dock: 'Receipt in progress',
        receptione:'Received',
        receipt:'Receipt',
        receptioneLines:'received lines',
        includeAllShipmentVoucher: 'Include all shipment voucher',
        exceptReceivedVoucher: 'Except received voucher',
        depositDate:'Deposit date',
        only:'Only',
        customCreateForm: 'Customize the creation form',
        customVoucherDetails: 'Customize the voucher details',
        PurchaseOrderCard: 'Purchase order card',
        shipmentVoucherCard:'Packing list card',
        shipmentVoucherForm:'Packing list form',
        toCustomForm:'Transfer Order Form',
        no_box:'No box',
        shde_carton_name:'Box reference',
        shde_quota_prevu:'Expected quantity in box',
        shde_quota_prevu_accent:'Expected quantity in box',
        shde_quota_recu:'Received quantity',
        shde_carton_recu:'Card received',
        shde_carton_recu_accent:'Card received',
        receiptShipmentVoucher:'Receipt of shipment voucher',
        receiptPo:'Receipt of supplier purchase order',
        scanBoxHere:'Scan a box here',
        scanBoxToCheckHere:'Scan a box here',
        scanItems:'Scan an item here',
        boxeChoice:'Box choice',
        itemChoice:'Item choice',
        drawerName:'Drawer\'s name',
        priorityBox:'Priority box',
        french:'French',
        english:'English',
        spanish:'Spanish',
        po: 'Provider\'s purchase order',
        to: 'Transfer order',
        totalPrmp: 'Average Cost total',
        totalPr: 'Cost pirce total',
        allBoxes: 'All Boxes',
        allSalesOrder:'All sales order',
        allLines: 'All lines',
        allInvoices:'All invoices',
        allCompanies:'All Companies',
        onlyUnpaidInvoices:'Only unpaid invoices',
        boxesStatus: 'Boxes status',
        assignAWms: 'Assign to a WMS',
        forCollect: 'for collection of items',
        forSignAndDelivery: 'for signature and delivery',
        forSotckReentry: 'for restocking',
        assignAShop: 'Assign to a shop',
        sectionReception:'Receiving section',
        noWmsAttribution: 'No attribution to a WMS',
        noShipmentVoucher: 'No shipment voucher',
        noPurchaseOrder: 'No purchase order',
        noReassortInterne: 'No internals restocking',
        editShipmentVoucher: 'Edit shipment voucher',
        editTransferOrder: 'Edit transfer order',
        receivedBy:'Received by',
        of:'of',
        cannotOpenToBecauseAllClose: 'You cannot reopen this transfer order because all the actions are achieved',
        cannotEditToBecauseIsClose: 'You cannot edit this tranfer order because it is closed',
        errorScan:'The box {barcode} does not exist',
        successScan:'The box {barcode} has been successfully scanned',
        reinstateScan:'The box {barcode} has already been scanned, would you like to reinstate to unscanned boxes ?',
        successReinstate:'The box {barcode} has been successfully reinstate',
        checkingBoxes:'Boxes receipt',
        checkingItems:'Items receipt',
        itemsReceipt:'Items receipt',
        itemsCollect:'Items collection',
        notScannedYet:'This box has not been scanned yet, would you like to be redirected to the boxes receipt ?',
        quantityCommande:'Ordered quantity',
        createStorageSpace:'Create bins in bulk',
        binsList:'Bins List',
        exportBinsListCsv:'Export bins list CSV',
        showNeverUsedBinsOnly:'Show only bins never used',
        binsHaveStockCantDelete:'This bins currently contains stock, it cannot be deleted',
        binsHaveStockCantDeletePlural:'These bins currently contain stock, they cannot be deleted',
        replacementBinsMustBeDifferent:'The replacement bins must be different from the bins being deleted',
        replacementBinsMustBeSameZone:'The replacement bins must be in the same zone as the bins being deleted',
        replacementBinsTitle:'Replacement bins',
        replacementBinsExplanation:'One or more of the selected bins have already had stock movements in the past. To delete them, choose another bins in the same zone that will take over their movement history (e.g. 1-2-3).',
        binsMustBeSameZone:'The selected bins must all be in the same zone',
        deleteBinsSelection:'Delete selection',
        confirmDeleteBinsSelection:'Do you really want to delete the selected bins:',
        createOneBins:'Create a bins',
        beginningFirstLevel:'Beginning of the first level',
        endFirstLevel:'End of the first level',
        beginningSecondLevel:'Beginning of the second level',
        endSecondLevel:'End of the second level',
        beginningThirdLevel:'Beginning of the third level',
        endThirdLevel:'End of the third level',
        beginningFourthLevel:'Beginning of the fourth level',
        endFourthLevel:'End of the fourth level',
        beginningFifthLevel:'Beginning of the fifth level',
        endFifthLevel:'End of the fifth level',
        firstEndBinsGte:"The end of the first level value can't be higher than the beginning of the first level",
        secondEndBinsGte:'The end of the second level value can\'t be higher than the beginning of the second level',
        thirdEndBinsGte:'The end of the third level value can\'t be higher than the beginning of the third level',
        fourthEndBinsGte:'The end of the fourth level value can\'t be higher than the beginning of the fourth level',
        fifthEndBinsGte:'The end of the fifth level value can\'t be higher than the beginning of the fifth level',
        firstBins:'First level',
        secondBins:'Second level',
        thirdBins:'Third level',
        fourthBins:'Fourth level',
        fifthBins:'Fifth level',
        zone:'Area',
        successBinsSkip:'Operation performed successfully, however those bins have not been created because they already exist',
        scanedBox:'Scanned boxes',
        scanBinsHere:'Scan the bins here',
        attributeAStorageArea:'Attribute to a storage area',
        selectAStorageArea:'Select a storage area',
        billing:'Invoice',
        billings:'Invoices',
        quotation:'Quotation',
        quotationCreate:'Quotation creation',
        purchaseOrderB2bCreate:'Purchase order creation',
        deliveryNoteCreate:'Delivery note creation',
        creditNoteCreate:'Credit note creation',
        returnNoteCreate:'Return note creation',
        billingBuyCreate:'Billing buy creation',
        creditNoteBuyCreate:'Purchase credit note creation',
        poB2bCollectedUp:'Purchase order: collect',
        poB2bCollectedDown:'Purchase order: put in order area',
        cancelledPoB2bCollectedUp:'Purchase order: cancelled collect',
        cancelledPoB2bCollectedDown:'Purchase order: cancelled put in order area',
        poB2bMouvement:"Purchase order movement",
        deliveryNoteOutStock:'Out of stock delivery note',
        outStock:'Out of stock',
        billingOutStock:'Billing out of stock',
        cancelledOutStock:'Cancelled out of stock',
        returnNoteReturnInStock:'Return in stock return note',
        rnReceipt:'Return in stock',
        creditNote:'Credit note',
        creditNoteBuy:'Purchase credit note',
        creditNotes:"Credit notes",
        searchModel:'Search a model',
        searchRoughtDraft:'Search a rought draft',
        selectOnProductList:'Select on the products list',
        itemsSelection:'Items selection',
        addStock:'Import stock',
        or:'Or',
        totalStock:'Total in stock',
        boxesInfos:'Boxes informations',
        binsNumber:'Bins number',
        binsNumb:'Bins number',
        storageArea:'Storage area',
        articlesList:'Items list',
        boxNotScaned:'Box not scanned',
        itemNotExist:'The item {sku} does not exist',
        itemNotExistInThisTo:'The scanned item does not appear in this transfer order',
        itemNotExistInThisPoB2b:'The scanned item does not appear in this purchase order',
        finishScanBefore:'You need to finish scanning this item before scanning another',
        selectRowScan:'Select the block to scan',
        location:'Location',
        binsDetails: 'Bins content',
        zoneDetails: 'Zones content',
        onOrder:'On order from supplier ',
        receivedLines: 'Received line',
        totalHt: 'Total without duty',
        differencePrmp:'Average Cost difference',
        differencePr:'Cost price difference',
        differenceHt:'Without duty difference',
        caddie:'Cart',
        providedCashFund:'Expected cash float',
        prevu:'Expected cash float',
        prevu_session:'Expected',
        recipient:'Recipient',
        limitDayPayment:'Limit date of payment',
        caseLatePayment:'In case of late payment',
        optionalNoteMsg:'Optional note to include on the document',
        settleInvoice:'Do you want to settle this invoice ?',
        cancelLimitDatePaymentMsg:'That will cancel the limit date of payment if you have filled it in',
        cancelSettleMsg:'That will cancel the settlement if you have filled it in',
        indicateLimitDateOfPayment:"Do you want to indicate a limit date of payment ?",
        indicateLimitValidDate:"Do you want to indicate a limit date of validity ?",
        addTextOnTopPart:'Do you want to add a text on the top part of the document ?',
        addTextOnBottomPart:'Do you want to add a text on the bottom part of the document ?',
        topText:'Top text',
        topTextSize:'Top text size',
        bottomText:'Bottom text',
        bottomTextSize:'Bottom text size',
        texteDocuments:'Document texts',
        modeReplaceConfig:'Replaces default configuration',
        modeAddConfig:'Added to default configuration',
        sortField:'Sort field',
        groupField:'Group field',
        paidOn:'Paid on',
        generateFreebird:'Powered by Freebird',
        dashboard:'Dashboard',
        total:'Total',
        totalWithoutDiscount:'Total without discount',
        tax:'Tax',
        openWith:'Open with',
        binsMovement:'Stock movement',
        stockDeplacement: 'Moving stock',
        simpleMove: 'Simple moving',
        massMouvement:'Mass stock movement',
        avlQuantity:'Available quantity',
        qteToTransfer:'Quantity to transfer',
        qteReceived:'Received quantity',
        receivedOn:'Received on',
        qteToMove:'Quantity to move',
        qteThinkMove:'Quantity picked',
        qteIsMove:'Quantity deposed',
        collectedAt:'Picked at',
        deposedAt:'Deposed at',
        collected:'Picked',
        converted:'Converted',
        notConverted:'Not converted',
        isFactured:'Invoiced',
        isNotFactured:'Not Invoiced',
        partiallyConverted:'Partially converted',
        qteToCollect:'Quantity to collect',
        inLivraison:'On delivery',
        outLivraison:'Out of delivery',
        devisNonConvertis: 'Unconverted quotes',
        bonDeCommandeNonCollectes: 'Uncollected purchase orders',
        bonDeCommandeNonConvertis: 'Unconverted purchase orders',
        bonDeLivraisonNonLivres: 'Undelivered delivery notes',
        bonDeLivraisonNonFactures: 'Uninvoiced delivery notes',
        avoirNonUtilises: 'Unused credit notes',
        bonDeRetourNonCollectes: 'Uncollected return notes',
        factureAcompteNonUtilise: 'Unused deposit invoices',
        factureAchatNonAcquitte: 'Unpaid purchase invoices',
        shipmentDelivery:'Shipment and delivery', 
        carriers:'Carriers',
        orderPreparationZone:'Order preparation zone',
        matchInternalId:'Match internal id',
        matchingInternalIdImport:'Matching of internal id',
        deposed:'Deposed',
        qteReached:'Maximum quantity reached',
        qteExceed:'Maximum quantity exceed',
        qteAvlInsufficient:'Available quantity is insufficient',
        qteAvlInsufficientForItem:'Available quantity is insufficient for {name}',
        selectStorageDestination:"Select the storage area",
        cantScanDifferentItem:"You cannot scan several items at the same time",
        itemNotInThisArea:"This item does not appear in this storage area",
        moveAllArticles:"Move all",
        scannedArticlesList:"Scanned items",
        clickToSeeRecommendedDestinations:"Click an item to see its recommended destinations",
        origin:'Origin',
        destination:'Destination',
        scanTheItemHere:'Scan the item here',
        binsContent:'Bin\'s content',
        emptyBins:'This bins is empty',
        emptyTrolley:'Your trolley is empty',
        totalDevise:'Total in currency',
        totalEquivalenceDevise:'Equivalence {devise}',
        equivalenceDeviseOption:'Show currency equivalence',
        equivalenceDeviseHelp:'Configure below the free currencies that can be offered for display on invoices and account statements. Rate = number of local-currency units for 1 unit of the chosen currency (the amount shown is the total divided by this rate).',
        equivalenceDeviseCode:'Currency code',
        noEquivalenceDevise:'None',
        addEquivalenceDevise:'Add a currency',
        tauxConversion:'Conversion rate',
        deviseEquivalenceDuplicate:'A currency code is used more than once',
        deviseEquivalenceRequired:'Currency equivalence required',
        deviseEquivalenceInvalid:'Invalid currency equivalence',
        referencePo:"Reference",
        internetRef:'Internet order reference',
        seeReceiptVoucher:'See the receipt voucher',
        voucherNumber:'Voucher number',
        receiptDate:"Receipt date",
        boxNumber:'Box number',
        itemsDetails:'Items details',
        receiptVoucher:'Receipt voucher',
        cancelBoxReceipt:'Receipt box cancellation',
        cancelItemReceipt:'Receipt item cancellation',
        cancellationOnReceipt:'Cancellation on receipt',
        cancelAllReceipt:'Cancel all receipt',
        confirmCancelAllReceipt:'This will cancel the ENTIRE receipt of this shipment voucher: stock will be restored and quantities will be removed from the associated purchase order. This action is irreversible, confirm?',
        cancelAllReceiptSuccess:'The entire receipt has been successfully cancelled',
        inactiveStockArticles:'Inactive stock articles',
        lastMovementType:'Last movement type',
        lastMovementDate:'Last movement date',
        someItemsAlreadyScan: 'Action impossible, items from this box are already in stock',
        cancelItemsEntry:'Cancel items entry in stock',
        itemsReinstate:'Items reintegration',
        cancellationStockEntry:'Cancellation stock entry',
        resolveNegative:'Automatic In-Store Stock Resolution',
        errorReinstateNotPossible:'You can\'t reinstate an item that has not been received',
        selectBlockToReinstate:'Select the block to reinstate',
        selectBlocksToReinstate:'Select the blocks to reinstate',
        qteInSalesPoint:'Stock in sales point',
        qteInReserve:'Quantity in reserve',
        errorStockReassortMsg:"There are currently items with negative stock quantities in your sales area. The affected items are listed below. We strongly recommend correcting these negative stock levels before continuing. Otherwise, items with negative stock will not be taken into account in the internal restocking process",
        btnReadjustmentAndRestock:'Apply this readjustment and generate a restock',
        btnReadjustmentAndNoRestock:'Continue without correcting negative stock levels',
        autoRestock:'Automatic restock',
        autoRestockInternal:'Internal automatic restock',
        autoRestockSupplier:'Supplier automatic restock',
        reassortInterne:'Internals restocking',
        resolveNegative:'Automatic stock correction',
        resolveShopNegative:'Correction of negative stock in shop',
        internalRestock:'Internal restock',
        backToInternalRestockList:'Back to internal restock list',
        priorityInternalRestock:'Priority internal restock',
        restockList:'Restocks list',
        listSelection:'List selection',
        actionOnExistingListItem:'Action on the existing list of items',
        orderList:'Sales order list',
        underwayRestockMsg:'A restocking is underway',
        toCorrectionDeposed:'Stock correction for difference between quantity collected and quantity delivered',
        reorderPoint: 'Reorder point',
        referenceTo:'Reference',
        trolley:'Trolley',
        referenceToNoAccent:'Reference',
        transfert_leNoAccent: 'To be transferred on',
        transfert_le: 'To be transferred on',
        origin_section: 'Origin Shop',
        availableInOriginSection: 'Available in origin shop',
        destination_section: 'Destination Shop',
        rhBarre: 'Barcode staff',
        preferredStockLevel:'Preferred Stock Level',
        rppslAutoConfigTitle: 'Automatic RP/PSL restock configuration',
        rppslAutoGenerationDate: 'Automatic RP/PSL generation date',
        rppslPack: 'RP/PSL Pack',
        enableRppslPackFeature: 'Enable the RP/PSL pack feature',
        rppslPackNameAlreadyExists: 'A RP/PSL pack with this name already exists.',
        exportRppslPackMissingArticles: 'Export targeted articles without RP/PSL',
        exportRppslPackConfig: 'Export pack configuration',
        importRppslPack: 'Import RP/PSL Pack',
        csvPackName: 'Pack name',
        csvPackMatching: 'Matching',
        createRppslPack: 'Create RP/PSL pack',
        editRppslPack: 'Edit RP/PSL pack',
        packType: 'Pack type',
        typeSpecial: 'Special',
        customFieldArticleMatch: 'Custom field (article match)',
        restrictToSections: 'Restrict to specific sections',
        allSections: 'All sections',
        confirmDeleteRppslPack: 'Delete this RP/PSL pack',
        pslGteRp: 'PSL must be greater than or equal to RP',
        productNomenclatureFilters: 'Product nomenclature filters',
        addFilterGroup: 'Add a criteria selection',
        noFilterGroup: 'No criteria selection added',
        noFilterFieldConfigured: 'No field configured for pack filters. Configure it in Administration > Customization > RP/PSL > RP/PSL Pack Filter.',
        rpPslByValueTitle: 'Set the Reorder Point (RP) and Preferred Stock Level (PSL) for each "{field}" value',
        rpPslValuesOptionalHint: 'You can leave values blank and validate the pack anyway — they can be filled in later via CSV import.',
        and: 'AND',
        filterMode: 'Filter mode',
        filterModeInclude: 'Inclusion',
        filterModeExclude: 'Exclusion',
        concernedArticles: 'Concerned articles',
        noMatchingArticleValue: 'No matching article found for the selected criteria',
        rpPslValuesInvalid: 'Please fill in a valid RP and PSL (PSL must be greater than or equal to RP) for every value',
        excludeFilterSwitch: 'Exclude matching products instead of including them',
        backToPackList: 'Back to pack list',
        exportCsvArticles: 'Export articles to CSV',
        excludeFilterHelp: 'By default, only products matching the selections above are included in this pack. Enable this to exclude them instead: every other product will be included. With no selection and exclusion enabled, all products are included.',
        creationDate: 'Creation date',
        actualStockDisp:'Actual stock on hand',
        actualStock:'Actual stock',
        reassortEnCours:'Restock to come',
        recommendedDestination:'Recommended destinations',
        sameItem:'Same Item',
        sameParent:'Same Parent',
        box:'Box',
        tagSize:'Tag size',
        rpInteger:"{name} reorder point RP must be an integer",
        pslInteger:"{name} preferred stock level PSL must be an integer",
        rppslAllOrNone:"You cannot enter an RP without a PSL (and vice versa) for {name}",
        detailProvider:'Provider details',
        providerCard:'Provider card',
        allPo:'All purchase orders',
        generateABarCode:'Generate a barcode',
        generateMasseBarCode:'Generate barcodes in bulk',
        generateMasseBarCodePdf:'Generate pdf barcodes in bulk',
        generateABarCodePdf:'Generate a pdf barcodes',
        quantityManualModification:'Manual quantity modification',
        stockReorganization:'Stock reorganization',
        removeFromStock:'Remove from stock',
        removeOption:'Remove an option',
        addToStock:'Add to stock',
        chooseAnAction:'Choose an action',
        choisir:'Choose',
        selectSection:'Select a shop',
        selectType:'Adjustment type',
        stockError:'Stock error',
        transferOrderError:'Transfer order error',
        stockIntegration:'Stock integration',
        stockRemove:'Stock remove',
        stockAdjustment:'Stock adjustment',
        massStockAdjustment:'Mass stock adjustment',
        stockAdjustmentConfirmation:'Do you confirm the stocks adjustments?',
        stockAdjustmentResetConfirmation:'The items list will be cleared, do you confirm the reset of the stock adjustment ?',
        attemptedStockAdjustment:"Attempted stock adjustment",
        error_open_checkout:'Error on checkout opening',
        error_close_checkout:'Error on checkout closing',
        validateAll:'Validate all',
        reinstateAllItems:'Reinstate all items',
        reinstateOneItem:'Reinstate one item',
        reinstateSelection:'Reinstate the selection',
        confirmReinstateItems:'Do you really want to reinstate all the items ?',
        noBarcodeFounded:"No barcode found",
        rppsl:'Rppsl',
        allTransferOrders:'All transfer orders',
        exceptFinished:'except finished',
        transferOrderNotStarted:'Transfer orders not started',
        notStarded:'Not started',
        processOfCollecting:'In process of collecting',
        toEnCours:"Transfer Orders in process only",
        processOfDelivery:'In process of delivery',
        processOfEmptying:'In process of emptying',
        transferOrderEdit:'Edit a transfer order',
        errorDeleteTO:'You can\'t delete this transfer order',
        wrongBins:'You have scanned the wrong bins',
        wrongItem:'You have scanned the wrong item',
        stockNegativeAlert:"Negative stock alert",
        stockNegativeAlertLabel:"Alert when selling if the item sold is or will be in negative stock",
        stockNegativeAlertMsg:"The item you just added will have a negative stock if you finalize the sale",
        stockNegativeAlertMsgAutoReassort:"The item you just added will have a negative stock if you finalize the sale. If it is available in the %zone% zone, a stock adjustment will be performed automatically when the sale is finalized",
        reassortAutoLabel:"Automatic restock",
        zoneReassortAutoLabel:"Reserve zone to use",
        allowTransferOrderWithDifferentValue:'Transfer orders and orders with different quantity',
        zoneWithoutBins:'Zone without bins',
        uncompletedLines:'Uncompleted lines',
        transferTo:'Transfer to',
        transferOrderCompleted:'Transfer order completed',
        errorToStockMissing:'The transfer order could not be correctly finalized due to a missing stock',
        confirmValidateAsIs:'Are you sure you want to validate as is ?',
        confirmCheckDeposit:'Are you sure you want to validate your check deposit ?',
        confirmGenerateRestockNoReadjust:'Are you sure you want to continue ? The items with negative stock will not be considered for restocking',
        transferOrdersToCollect:'Transfer orders to collect',
        transferOrdersToReceive:"Transfer orders to receive",
        stockTransfer:'Stock transfer',
        stockTransferConfirm:'Are you sure you want to transfer the stock',
        ecomToCollect:'Sales order to collect',
        transferOrderRelatedPo:"This transfer order is related to a sales order",
        quantityToReceive:'Received quantity',
        receiveAllItems:'Receive all items',
        receiveItemsByItems:'Item by item reception',
        collectionAllItems:'Collection of all items',
        collectionItemsByItems:'Item by item collection',
        validAllArticlePoReceive:'Validation of all items from a purchase order at the reception',
        validAllArticleToReceive:'Validation of all items from a transfer order at the reception',
        validAllArticleToCollecte:'Validation of all items from a transfer order at the collection',
        noTransferOrdersToReceive:'No transfer orders to receive',
        consultationTransferOrders:'View in-progress transfer orders',
        noTransferOrdersInProgress:'No transfer orders in progress',
        filterAllStatus:'All',
        confirmReceptionWithDifferentQte:'The receive quantity is different from the collected quantity, that will generate a stock readjustment, continue ?',
        linesNumber:'Lines number',
        notCollected:'Not collected',
        lineConverted:'Line already converted',
        collectInProgress:'Collect in progress',
        alertItemsNotCollected:'Not all items have been collected. If you proceed, you may encounter stock errors in the future. Do you really want to continue ?',
        collection:'Collection',
        depose:'Depose',
        closed:'Closed',
        website:'Website',
        previousMonthTurnover:'Turnover for the previous month',
        presentMonthTurnover:'Turnover for the present month',
        itemsBase:'Items base',
        stockInShop:'Stock in this shop',
        stockInOtherShop:'Stock in other shop',
        priority:'Priority',
        toBeCollectedpriority: 'To be collected as a priority',
        restockPriority:'Restock priority',
        collectedOn:'Collected on',
        collectedBy:'Collected by',
        rppslNotConfigured:'The item\'s RPPSL has not been configured',
        rppslEdit:'Rppsl edit',
        nbMaxToInstruction:'Maximum number of instructions in a transfer order',
        nbMaxEnumere:"Maximum number of packing lists",
        allItemsAlreadyScaned:"All the items have been scanned",
        ecommerce:'E-shop',
        carrepos:'Carré POS',
        shopLiaison:'Shop liaison',
        seller:'Seller',
        discount:'Discount',
        unitaireDiscount:'Unit discount',
        unitairePrice:'Unit price',
        unitaireDiscountPrice:'Unit discount price',
        unitairePriceModif:'Unit price modification',
        priceWithoutDiscount:'Price without discount',
        priceEdit:'Unit price edit',
        priceModification:'Price modification',
        newPrice:'New price',
        setArticlePrice:'Set the article price',
        titleOnReceipt:'Title on receipt',
        discountPercent:'Discount %',
        cancelDiscount:'Cancellation of manual discount',
        discountNet:'Value discount',
        noDiscount:'No discount',
        addNote:'Add a note',
        editToPrepare:'Edit quantity to prepare',
        modifColumnPosition:'Change the column position',
        clickToHideOrShow:'Click to hide or show a {param}',
        dragAndDropToChangePosition:'Drag and drop to change the position of a {param}',
        espece:'Cash',
        check:'Check',
        card:'Card',
        kiosqueCard:'Card',
        scanCard:'Scan Card',
        amount:'Amount',
        amountTtc:'Amount With Taxes Included',
        montantDu:"Amount due",
        montantDisponible:"Available amount",
        insertToRecords:'Addition to transfer order',
        discountedPrice:'Discounted price',
        programmedRecurrence:'Programmed recurrences',
        availableTemplate:'Available templates',
        checkNumber:'Check number',
        modePay:'Payment method',
        modePayInvoice:'Invoice payment method',
        bank:'Bank',
        checkNum:'Check number',
        reason:'Reason',
        numberGiftCard:'Gift card ident',
        payment:'Payment',
        due:'Due',
        promotion:'Promotions',
        percentageException:'Percentage exception',
        percentageExceptionFixe:'Amount exception',
        percentageExceptionImport:'Rebilling exception',
        zoneNameErrorCarac:'The zone name must not contain special characters',
        percent:'Discount %',
        badgeExceptionPercentage:'Commission percentage',
        franche:'Net discount',
        prixfixe:'Price modification',
        xpoury:"Offer X for Y",
        percentsecond:'Discount % on the Nth item',
        xpourfixe:'Fixed price for N items',
        cadeaupourx:'Gift for purchase higher than',
        suppercent:'Additional discount in % on item already discounted in %',
        suppercentInstruction:'Add the discounts in %, separating them with a comma',
        noPromoPeriodDefined:'No ending date',
        specifyPaymentMode:'Specify the payment mode',
        createPromo:'Create a promotion',
        createPercentageException:'Create a percentage exception',
        createPersonalizedPrice:'Create a personalized price',
        personalizedPrice:'Personalized price',
        deletePersonalizedPriceConfirm:'What would you like to do with this personalized price ?',
        deleteFromLine:'Delete from line',
        deleteDefinitive:'Permanently delete',
        qteItems:'Item quantity',
        qteItemsRetour:'Item quantity to return',
        addImage:'Add an image',
        seeTheList:'See the list',
        reviewAllGols:'Review all sellers goals',
        reviewIndividualGoals:'Review individual goals',
        percentDesc:"Percentage discount, example : -20%",
        francheDesc:'Net discount of the price, example : -XXX {monnaie}',
        prixfixeDesc:'Assignment of a fixed price to an item',
        xpouryDesc:"Sell a quantity of X items for the price of Y items, example : 2 for the price of 1",
        percentsecondDesc:"Percentage discount on the Nth item, example : -50% on the 3rd item",
        onPosition:'on position',
        positionArticle:'Item position (N)',
        positionMin2:'Position must be 2 or higher',
        xpourfixeDesc:"Sell a quantity of X items for a fixed price, example : 2 for XXX {monnaie}",
        cadeaupourxDesc:"A gift for a minimum amount of purchase, example : buy for 100$, get a free tee-shirt",
        suppercentDesc:'Additional percentage discount on an already discounted item : an additional -10% on an item already discounted at -30%',
        for:'For',
        automaticRestockConfiguration:'Configuration of automatic restock',
        reassortGrouping:'Article grouping',
        reassortGroupingFieldsLabel:'Grouping fields (order matters)',
        reassortGroupingFieldGeneral:'Invalid article grouping field',
        preparationTicketHeader:'Preparation ticket',
        preparationGroupingField:'Grouping field',
        noPreparationGrouping:'No grouping',
        preparationGroupOthers:'Others',
        preparationSentAt:'Sent at',
        preparationGroupingOrder:'Sort order',
        preparationPrintedItems:'Items printed on the preparation ticket',
        preparationPrintAll:'All items',
        preparationPrintOnlyToPrepare:'Only items to prepare',
        preparationGroupOrder:'Group print order',
        preparationGroupOrderHelp:'Groups are printed in this order. A value missing from the list is printed after, in alphabetical order.',
        preparationGroupMoveUp:'Move up',
        preparationGroupMoveDown:'Move down',
        preparationGroupValuesEmpty:'No value found for this field',
        preparationGroupSearch:'Search a value to add...',
        preparationGroupRemove:'Remove from list',
        reassortGroupingFieldsRequired:'Select at least one grouping field',
        reassortGroupingFieldDuplicate:'A grouping field cannot be selected more than once',
        itemCreation:'Item creation',
        beginPromo:'Beginning of the promotion',
        beginPersonalizedPrice:'Beginning of the personalized price',
        numberPointCumule:'Accumulated number of points',
        numberPointsToAccumulate:'Number of points to accumulate',
        totalFideliteCumul:'Total accumulated points',
        totalFideliteSpent:'Total spent points',
        totalFideliteAdjustment:'Total of manual adjustment',
        mergeWithCustomer:'Merge with an other customer',
        perSliceOf:'Per slice of',
        endPromo:'End of the promotion',
        endPersonalizedPrice:'End of the personalized price',
        assignedPoint:'Assigned points',
        editLoyaltyPlan:'Edit loyalty plan',
        createLoyaltyPlan:'Create loyalty plan',
        editPromo:'Edit a promotion',
        editPercentageException:'Edit a percentage exception',
        editPersonalizedPrice:'Edit a personalized price',
        undefined:'Undefined',
        editGeneralInfos:'Edit the general infos',
        generalInfos:'General infos',
        addPromotion:'Add a promotion',
        currentAndUpcomingLoyaltyPlan: 'Current and upcoming loyalty plans',
        allLoyaltyPlans:'All loyalty plans',
        currentAndUpcomingPromo: 'Current and upcoming promotions',
        currentAndUpcomingPersonalizedPrice: 'Current and upcoming personalized price',
        currentPromo:'Current promotion',
        currentPersonalizedPrice:'Current personalized price',
        upcomingPromo:'Upcoming promotion',
        upcomingPersonalizedPrice:'Upcoming personalized price',
        currentLoyaltyPlan:'Current loyalty plan',
        upcomingLoyaltyPlan:'Upcoming loyalty plan',
        noCurrentPromo:'No current promotions',
        noUpcomingPromo:'No upcoming promotions',
        addToTheSelection:'Add to the list',
        replaceTheList:'Replace the list',
        addToPromotion:'Add to the promotion',
        additionPromo:'Addition of the promotion',
        dependingItemPrice:'Depending on items prices',
        giftOffered:'Gift offered',
        receiptSaved:'Saved receipts',
        receiptNumber:'Receipt number',
        saleSaved:'Sale saved',
        favoriteSaved:'Favorite saved',
        noCurrentSale:'No current sale',
        noSalesSaved:'No sales saved',
        createGiftCard:'Gift card creation',
        createAbonnementCard:'Abonnement card creation',
        editAbonnementCard:'Abonnement card edition',
        prmpOnItemTransform:'PRMP not editable on processed item',
        codeBarreContain:'Whose barcode contains',
        deposit:'Deposit amount',
        totalDeposit:'Total deposit',
        totalDiscountPrice:'Total discounted',
        discountTotal:'Discount total',
        cashDepositExecutedBy:'Cash deposit executed by',
        checkDeposit:'Check deposit',
        checkDepositHistorical:'Check deposit historical',
        noCheckDeposit:'No check deposit',
        checkAndCash:'Cash / Check',
        qteMoneyIn:'Quantity of money in',
        doneOn:'Done on',
        changeBack:'Change back',
        deposited:'Deposited',
        giveChange:'Give change',
        notValidGiftCard:'This gift card is not valid in this shop',
        noFundAvailable:'No fund available on this gift card',
        noEnoughFund:'Not enough funds on this gift card',
        reminderMsg:'You have scheduled a reminder for the following documents',
        recurrenceMsg:'You have scheduled a recurrence for the following documents',
        moreDetails:'More details',
        credit:'Credit',
        debit:'Debit',
        abonnement:'Subscription',
        abonnement_article:'Subscription item',
        abonnement_achat_article:'Subscription purchase item',
        abonnementCredit:'Credit and subscription',
        abonnementFrom:'Subscription from',
        abonnementTo:'to',
        dateExpire:'Date of expiration',
        itemReturn:'Item return',
        dontRemise:'Discount',
        scanReceiptHere:'Scan the receipt here',
        scanSalesOrderHere:'Scan the sale order here',
        scanQuotationHere:'Scan the quotation here',
        scanDocHere:'Scan the bar code here',
        docNum:'Document number',
        document:'Document',
        documents:'Documents',
        searchOneReceipt:'Search one receipt',
        receiptSearch:'Receipt search',
        devisSearch:'Quotation search',
        enterRefundMethod:'Enter the refund method',
        ticket:'Ticket',
        tickets:'Tickets',
        vente:'Sale',
        retour:'Return',
        eatin:'Eat in',
        takeout:'Take away',
        toDeliver:'To deliver',
        refundEspece:'Cash refund',
        refund:'Refund',
        refundGiftcard:'Gift card refund',
        refundOther:'Other refund',
        noItemsToReturn:'No items to return',
        noItems:'No items',
        paid:'Paid',
        historical:'Historical',
        salesHistorical:'Sales historical',
        customerHistorical:"Customer historical",
        availableFund:'Available funds',
        lostFund:'Lost funds',
        totalDepot:'Total funds deposits',
        depot:'Deposite',
        numberDepot:'Number of deposits',
        itemsNumber:'Number of items',
        bosexNumber:'Number of boxes',
        receiptInProgress:'Receipt in progress',
        messageEndReceipt:'thanks you for your visit',
        downloadingPdf:'Pdf downloading',
        downloadInProgress:'Download in progress, please wait...',
        lastSale:'Last sale',
        noPreviousSale:'No sale has been done previously',
        noPreviousDevis:'No quotation has been done previously',
        selectConcernedPeriod:'Select the concerned period',
        addNewPayment:'Add a payment',
        beginningPeriod:'Beginning of period',
        endPeriod:'End of period',
        editPaymentMethod:'Payment method edition',
        noPaymentMethodToEdit:'No payment method to edit',
        checkoutState:'Checkout state',
        totalWithGiftCard:'Total sales with gift card',
        totalWithoutGiftCard:'Total sales without gift card',
        averageReceiptWithGiftCard:'Average receipt with gift card',
        averageReceiptWithoutGiftCard:'Average receipt without gift card',
        wholeShop:'Whole shop',
        filterByEmployee:'Filter by employee',
        filterByCashRegister:'Filter by cash register',
        allStaff:'All staff',
        thisCashRegister:'This cash register',
        concernedShop:'Concerned shops',
        typePromo:'Promotion type',
        typePersonalizedPrice:'Personalized price type',
        statePromo:'Promotion state',
        statePersonalizedPrice:'Personalized price state',
        messageBienvenue:'Hello - Welcome',
        acroTel:"Tel",
        postalAdress:'Postal adress',
        depotGiftCard: 'Gift Card Deposites',
        finished:'Finished',
        poNbr:'Purchase order n°',
        removeAllArticlesConfirm:'Do you really want to remove all items from this promotion',
        removeSelectedArticlesConfirm:'Do you really want to remove the selected items from this promotion',
        removeSelectedPromotionsConfirm:'Do you really want to delete the selected promotions',
        removeAllArticlesConfirmPricePersonalized:'Do you really want to remove all items from this personalized price',
        manualDiscountPercent:'Manual discount %',
        manualDiscountNet:'Manual value discount',
        manualDeposit:'Manual deposit',
        autreFrais:"Other cost",
        ecomConnexion:'E-commerce connection',
        caisseIdent:'POS identifier',
        posName:'POS name', 
        actualSumCaisse:'Expected cash fund',
        actualEspeceCaisse:'Expected cash out',
        sortieEspece:'Cash out',
        cashDepositgroup:'Grouped cash deposit',
        bill:'Banknotes',
        coin:'Coins',
        form:'Form',
        preview:'Preview',
        acutalSession:'Actual session',
        cashTotalInCaisse:'Total of cash',
        checksTotalDeposit:'Total of checks on the deposit',
        derniersRetraitEspeces: 'Last cash out',
        dernierRetraitEspecesSingle: 'Last cash out',
        retraitEspeces: 'Cash withdrawal',
        exportRetraitEspeces: 'Export cash withdrawals',
        remiseEnBanque: 'Bank deposit',
        lastTenRetraitEspeces: 'Last 10 cash withdrawals',
        thisRetraitEspeces: "this cash withdrawal",
        generateAutoCashDeposit:'Generate a cash bank deposit with the total of cash not including the cash float',
        newStaff:'New staff',
        refresh:'Refresh',
        correspondanceItem:'Item details correspondence ',
        correspondanceMarque:'Brand details correspondence',
        connector:'E-commerce connector',
        personalizedFilter:'Personalized filter',
        periodFilter:'Filter by period',
        correspondenceDeliveryCost:'Correspondence of delivery cost',
        correspondenceDatas:"Data matching",
        currentWeek:'Current week',
        lastWeek:'Last week',
        nextWeek:'Next week',
        month:'Month',
        currentMonth:'Current month',
        lastMonth:'Last month',
        nextMonth:'Next month',
        currentYear:'Current year',
        lastYear:'Last year',
        saveSale:'Save a sale',
        cancelSaleAndOrder:'Cancel sales or orders',
        paymentDetail:'Payment detail',
        receiptDetail:'Receipt detail',
        depositDetail:'Deposit detail',
        giftCardCredit:'Gift card credit',
        giftCardPerimeterTitle:'Gift card perimeter',
        giftCardPerimeterDesc:'Businesses in which a gift card sold at this business can be used',
        printItemTag:'Print a item tag',
        printItemTags:'Print items tags',
        includeArchives:'Include archives',
        includeExpiredGiftCard:'Include expired gift cards',
        includeExpiredAbonnementCard:"Include expired subscription cards",
        saleOrderDetail:'Sale order details',
        devisDetail:'Quotation details',
        openSaleOrder:'Open sale order',
        objectifAndCa:'Goals and turnover',
        user:'User',
        active:'Active',
        draft:'Draft',
        thisDraft:'this draft',
        thisSavedDocument:'this saved document',
        roughDraftList:'Rough draft list',
        templateList:'Templates list',
        archived:'Archived',
        peripheralDevice:'Peripheral devices',
        newPeripheralDevice:'New peripheral device',
        model:'Model',
        checkoutShortcut:'Checkout shortcut',
        checkoutShortcuts:'Checkout shortcuts',
        newShortcut:'New checkout shortcut',
        new:'New',
        allNotifications:'All notifications',
        noNotifications:'No notification',
        notifTypeSalesOrder:'Customer order (B2C)',
        markAllAsRead:'Mark all as read',
        confirmMarkAllAsRead:'Do you want to mark all notifications as read?',
        noNewNotifications:'No new notifications',
        seeReceipt:'See the receipt',
        read:'Read',
        unread:'Unread',
        newShipmentToPick:'New packing list assigned',
        newTo:"New transfer order to pick",
        ipAdress:'IP adress or COM port',
        afficheur:'Display',
        tpe:"TPE",
        ingenico:'Ingenico',
        comPort:'COM port',
        imprimante_ticket:'Receipt printer',
        imprimante_ticket_preparation:'Preparing receipt printer',
        imprimante_cheque:'Check printer',
        imprimante_etiquette:'Tag printer',
        etiquette:'Tag',
        matchBarCode:'Match a bar code',
        matchBarCodeToItem:'Match a bar code to an item',
        epson_tm_h6000V:'Epson TM-H6000V',
        zebra_zd421:'ZPL (Windows)',
        printCaisseIdent:'Print the checkout ident',
        aures_2_l:'Aures display',
        second_screen_display:'Second screen display',
        notAttributedPeripheral:'Not attributed peripherals',
        noPeripheral:'No peripheral',
        noConfiguredPeripheral:'No configured peripheral',
        otherSection:'Other shop',
        disponibleMini:'Avail',
        blockedMini:'Bloc',
        workTimeToday: 'Specify working hours',
        workTimeDetails:'Distribution of your working time',
        workTime:'Working time',
        chooseProject: 'Select a project',
        allProject: 'All project',
        chooseTask: 'Select a task',
        work_project:'Project',
        work_project_detail:'Task',
        nbrHours: 'Number of hours',
        nbrMinutes: 'Number of minutes',
        aVenir:'To come',
        datasRecorded:'Recorded datas',
        reorganizeColum:'Reorganize columns',
        changePrinter:'Change printer',
        changeZone:'Change zone',
        changeCustomer:'Change customer',
        qteTag:'Tag quantity',
        tagPrint:'Tag print',
        limitTagPrint100:'The limit of tag printing is 100',
        mintTagPrint1:'The minimum quantity of tag printing is 1',
        bankDeposit:'Bank deposit',
        salesOrder:'Sale order',
        addToOrder:'Add to sale order',
        expectedCollectDate:'Expected date of collect',
        numberShopifyOrder:'E-Com Order Number',
        collectZone:'Collect location',
        collectZoneChangeTitle:'Already collected items',
        collectZoneChangeText:'This sale order already contains collected items. Do you want these items to be automatically marked as collected in the new collect location, or should they be marked as to collect in the new collect location?',
        collectZoneChangeKeepCollected:'Mark as collected',
        collectZoneChangeResetToCollect:'Mark as to collect',
        collectZoneDifferentTitle:'Different collect location',
        collectZoneDifferentText:'The chosen collect location is different from the current shop. Do you want the goods to be collected immediately at this location, or should they remain to be collected?',
        order:'Order',
        commandeChangeCollectZone: 'Change of the collect location',
        commandeOut: 'Leaving the shop area',
        commandeRemoveOut: 'Leaving the order area for transfer order action',
        commandePut: 'Put in sales order area',
        commandeRemovePut: 'Put in sales shop area for transfer order action',
        commandeCancelledOut: 'Sales order cancelled - Leaving the sales order area',
        commandeCancelledPut: 'Sales order cancelled - Put in the shop area',
        orderHistorical:'Sales order historical',
        devisHistorical:'Quotation historical',
        preparationHistorical:'Preparation historical',
        searchByCreationDate:'Search by date of creation',
        searchByCollectDate:'Search by expected date of collect',
        searchASalesOrder:'Search a sale order',
        searchAQuotation:'Search a quotation',
        searchSalesOrder:'Search sales order',
        article:'Item',
        noCheckoutShortcut:'No checkout shortcut',
        validateNewOrder:'Confirm the new order',
        transferHere:'Transfer here',
        transferToOtherShop:'Transfer to other shop',
        expireSession:'Your session has expired ! You\'re gonna be redirected',
        myTime:'My Time',
        addQuantityByEnumere:'Add quantities from the packaging list',
        justMinQuantity:'Just for minimum quantity',
        changeDocument:'Change of document',
        bipeurNumber: "Beeper number",
        bipeurLabelSetting: "Term displayed for the order number",
        bipeurLabelBipeur: "Beeper",
        /************button********/
        btnAccess: 'Go !',
        btnCancelSalesOrder:'Cancel the sale order',
        cancelPosOnly:'Leave the order',
        cancelCommandeOrPosTitle:'What would you like to do?',
        btnSeeEditDelete : 'See / Edit / Delete',
        btnValidate: 'Ok',
        btnValidateAndSave:"Validate and save",
        btnValidateStockAdjustment: 'Validate the stock adjustment',
        btnDeleteUser: 'Delete this user',
        btnDeleteGrade: 'Delete this grade',
        btnAddRewardLevel:'Add a reward level',
        btnDeleteRh: 'Delete this staff',
        btnYes: "Yes",
        btnNo: "No",
        btnDelete: "Delete",
        editColor: "Edit color",
        editName: "Edit name",
        btnAddField: "Add field",
        btnRemoveRh: "Remove from store",
        btnRemove: "Remove",
        btnGoClotureCaisse: 'Close Checkout',
        btnAddAllItems:'Add all items from the item base',
        btnFilterItemsToAdd:'Select the items to add',
        btnCancel: 'Cancel',
        btnBackToWelcome: 'Return to Home',
        btnPay: 'Pay',
        btnEffacer: "Clear",
        btnReset: 'Reset',
        btnClose: 'Close',
        closeFolder: 'Close folder',
        btnImport: 'Import',
        btnAddClientForm: 'Add client form',
        btnRemoveClientForm: 'Remove client form',
        btnArchiveStaff: 'Archive this Staff',
        btnActiveStaff: 'Activate this Staff',
        btnArchiveProvider: 'Archive this provider',
        btnDeleteProvider: 'Delete this provider',
        btnUnarchiveProvider: "Activate this provider",
        btnSeeProfil: "See profile",
        btnDeleteAssociate: 'Delete this association',
        btnSearchAssociateCustomer: 'Start a search for association possibilities',
        btnUnarchiveBrand: "Activate this brand",
        btnArchiveBrand: 'Archive this brand',
        btnDeleteBrand: 'Delete this brand',
        btnAssociate : 'Associate',
        btnCreateNewStaffCustomer: 'Generate a new customer associate to this Staff',
        btnUnarchiveZone: "Activate this area",
        btnArchiveZone: "Archive this area",
        btnDeleteZone: 'Delete this area',
        btnShowDetails: 'Show details',
        btnShowReminders:'Show reminders',
        btnInsert: 'Insert',
        btnUpdate: 'Update',
        btnBack: 'Back',
        btnMove:'Move',
        btnReturn:'Return',
        btnSeeBinsContent:'See bins content',
        btnSeeParentProfil:"Parent profile",
        btnValidateAsIs:'Validate as is',
        btnSeeStock:'Get the stock',
        btnItemProfil:"Item profile",
        btnModifier:'Edit',
        btnSave:'Save',
        btnSeePdf:'See the pdf receipt',
        btnPdf:"See the pdf",
        btnSeeDevisPdf:'See the pdf quotation',
        btnPrint:'Print',
        btnSendMailTicket:'Send by e-mail',
        btnPayPrint:'Pay & Print',
        btnGiftPrint:'Gift Print',
        btnRemoveAllItems:'Remove all items',
        btnRemoveSelectedItems:'Remove selected items',
        btnCancelDiscount:'Cancel the current discount',
        btnNewDocumentReliquat:"Generate new document from remainders",
        btnNextStep:'Next step',
        /***********Menu**************/
        welcome: 'Home',
        usersList: 'Users List',
        usersCreate: 'Create User',
        rhCreate: 'Create Staff',
        newCustomer:'New customer',
        administrationGenerale: 'General Administration',
        administrationModePaiement: 'Payment methods',
        administrationObjectifPos : 'Goals',
        administrationTurnoverPos : 'Turnover',
        ticketSalesOrder:'Tickets / Sales Order / Quotation',
        administrationCustomForm: 'Custom Forms',
        administrationClientForm: 'Customer',
        administrationFournisseurForm: 'Provider',
        administrationMarqueForm: 'Brand',
        administrationArticleForm: 'Item',
        administrationStaff: 'Staff',
        administrationStaffList: 'Staff List',
        year:'Year',
        shopName:'Shop name',
        allCreate: 'Create',
        searchStock: 'Search Stock',
        cashRegister: 'Cash Register',
        item: 'Item',
        licence_notification: 'Releases',
        addToCart:'Add to cart',
        addItem: 'Add new item',
        addImageLink:"Add the link of your item's image",
        importItem: 'Import Items',
        importFournisseur:'Import providers',
        importPromotion: 'Import Promotions',
        importPersonalizedPrice: 'Import personalized price',
        importPercentageException: 'Import percentage exception',
        number:'Number',
        importInventory:'Import an inventory',
        inventaireStaffDelete:'The counts will be removed for the deleted staffs.',
        importStockOrInventory:'Import a stock or an inventory',
        importItemLoyaltyPlan: 'Import items in the loyalty plan {name}',
        importItemPercentageException: 'Import items in {name} percentage exception',
        importItemPromotion: 'Import items in {name} promotion',
        importItemPromotionA: 'Import items on list A in the promotion {name}',
        importItemPromotionB: 'Import items on list B in the promotion {name}',
        importItemSupplementList: 'Import items on supplement list',
        importItemPersonalizedPrice: 'Import items in {name} personalized price',
        listAMsgInfo:'Import here the items that will trigger the promotion',
        listBMsgInfo:'Import here the items that will benefit from the promotion',
        listTriggerPromo:'Items list that will trigger the promotion',
        listBenefitPromo:'Items list that will benefit from the promotion',
        noRestockNeeded:'No restock is needed',
        facturation: 'Invoicing',
        productOn:'Product(s) on',
        createBillingQuotation:'Create invoice/quotation',
        formProvider: 'Provider form',
        formSaleOrder: 'Sale order form',
        itemFamily: 'Item families',
        brand: 'Brands',
        client: 'Customers',
        customizedInterface: 'Customized interface',
        createRead:'Create and read',
        import: 'Import',
        allPromotions:'All promotions',
        allPersonalizedPrice:'All personalized price',
        promoWeight:'Promotion weight',
        percentageExceptionWeight:'Percentage exception weight',
        personalizedPriceWeight:'Personalized price weight',
        valueBetween:'Value between',
        printingInProgress:'Printing in progress',
        movePeripheralsShop: "Are you sure you want to move {deviceName} to {shopName} ?",
        session:'Session',
        byShop:'By shop',
        sessionsEnCours:'Open sessions',
        sessionsFermees:'Closed sessions',
        onlyProblemSessions:'Sessions with a discrepancy only',
        neverOpened:'Never opened',
        closedOn:'Closed on',
        billingVsCreditNote:'Nbr Billing / Nbr Credit Note',
        etatCompte:"Account statement",
        donneesLigneArticle:'Additional data on item line',
        value:'Value',
        confirmConvertReliquat:'Are you sure you want to convert the remainder to the new {documentType}? The current {documentType} now contains only the already converted articles and the new {documentType} contains all the remainders',
        created_at:'Created at',
        exportDataConfiguration:'Export datas',
        bbg_inventory_item:'Inventory items',
        bbg_non_inventory_item:'Non inventory items',
        bbg_item_parent_dates:'Item parent dates',
        bbg_item_parent_monthly:'Item parent monthly',
        bbg_item_monthly:'Item monthly',
        bbg_item_parent_weekly:'Item parent weekly',
        bbg_item_soh:'Item stock on hand',
        bbg_sales:'Sales',
        bbg_paiements:'Payment methods',
        bbg_kpis:'KPIs',
        bbg_objectifs:'Objectives',
        bbg_promotions:'Promotions',
        bbg_pos:'Purchase orders',
        bbg_tos:'Transfer orders',
        bbg_shipments:'Shipments',
        bbg_gift_card:'Gift cards',
        bbg_failed_stock_adjustment:'Failed stock adjustments',
        showReportConfiguration:'Reports dislay',
        pbi_items:'Items',
        pbi_stock_items:'Stock',
        pbi_stock_items_monthly:'Monthly stock',
        pbi_stock_items_weekly:'Weekly stock',
        pbi_client:'Customers',
        pbi_fournisseur:'Suppliers',
        pbi_sales:'B2C Sales',
        pbi_paiements:'B2C Payment methods',
        pbi_promotion:'Promotions',
        pbi_factures:'B2B Sales',
        pbi_documents_b2b:'B2B Documents',
        pbi_po:'Purchase orders',
        pbi_to:'Transfer orders',
        pbi_listes:'Item lists',
        pbi_objectifs:'Objectives',
        pbi_kpis:'KPIs',
        pbi_items_content:'Item content',
        pbi_passages:'Passages',
        pbiFileName:'File name',
        pbiExportActivate:'Activate',
        pbiExportLastExecution:'Last end execution',
        pbiExportInProgress:'In progress',
        pbiExportRefresh:'Refresh status',
        pbiExportGenerate:'Generate now',
        pbiExportNotActivated:'Not activated',
        pbiGenerationInProgress:'Generation in progress',
        alreadyInProgress:'Already in progress',
        /***********Table***********/
        dataTable:'Data Table',
        tableSearch: 'Search',
        tableName: 'Name',
        tableFirst: 'First',
        tableBack: 'Back',
        tableNext: 'Next',
        tableLast: 'Last',
        tableFistTitle: 'First Page',
        tableBackTitle: "Previous Page",
        tableNextTitle: 'Next Page',
        tableLastTitle: 'Last Page',
        tableNoData: 'No Data',
        tableNoModePaiement: 'No payment method added',
        tableNoCashOutReason: 'No proof of cash withdrawal added',
        tableSex: 'Sex',
        tableFirstName: 'Firstname',
        tablePhone: 'Phone',
        tableRemove: 'Remove',
        tableBarCode: 'Bar Code',
        tableOtherPhone: 'Other phone',
        tableProviderName: 'Provider name',
        tableContactName: 'Contact name',
        tableBrandName: 'Brand name',
        tableContraintes: 'Constraints',
        /*********** Label Form ***********/
        labelSex: 'Sex',
        labelName: 'Name',
        labelCsvSeparator: 'CSV Separator',
        labelCsvEncode: 'CSV Encode',
        labelArticleMatching: 'Article matching',
        labelMatchingField: 'Matching field for this import',
        labelArticleIdentificationField: 'Article identification field',
        labelPromoImportAction: 'Item import mode',
        promoImportActionAdd: 'Add items to the promotion',
        promoImportActionReplace: 'Replace the promotion items',
        promoImportActionHelp: 'Applies only to promotions that already exist. When replacing, each list (1 or 2) present in the file is replaced; a list absent from the file remains unchanged.',
        matchingFieldInvalid: 'The selected matching field is invalid',
        matchingFieldDisabled: 'The selected matching field is no longer enabled',
        matchingFieldNotMapped: 'The selected matching field is not mapped to a CSV column',
        matchingFieldEmpty: 'The matching value is empty',
        matchingFieldNotFound: 'No article matches this value',
        matchingFieldAmbiguous: 'Several articles match this value',
        matchingFieldCreateOrUpdate: 'Creation / Update',
        matchingFieldUpdateOnly: 'Update',
        importModeCreateTitle: 'Creation',
        importModeUpdateTitle: 'Update',
        importModeCreateText: 'The data below will be created because you have not indicated any match for {field} with your CSV file.',
        importModeUpdateText: 'The data below will be updated because you have indicated a match for {field} with your CSV file.',
        labelFirstName: 'First Name',
        labelPassword: 'Password',
        labelPasswordConfirmation: 'Password Confirmation',
        labelPhone: 'Phone',
        labelMaxusemoisproforma: "Lifespan of a proforma (in months)",
        labelRaisonmodifprix: 'Reasons why a seller can justify manually changing the price of an item',
        labelInfosTicket:'The provided informations will be displayed exactly as you have written it and in the order in which you added it.',
        labelPriorityCollect: 'Define the order in which the collection of a transfer order should be done',
        labelPriorityInternalReassort: 'Define the priority order of reserve areas for internal restock',
        labelDateFormat: 'Date format',
        labelAdress: 'Adress',
        labelAdressLivraison: 'Delivery adress',
        labelCodePostal: 'Zip code',
        labelVille: 'Town',
        labelPays: 'Country',
        labelCodeBank: 'Bank code',
        labelCodeGuichet: 'Sort code',
        labelNumeroDeCompte: 'Account number',
        labelCleRib: 'RIB key',
        labelBank: 'Bank',
        labelHoraires: 'Hours',
        labelProviderName: 'Provider name',
        labelContactName: 'Contact name',
        labelArchived: 'Archived',
        labelBankName: 'Bank name',
        labelSelectConfigue: 'Choose your configuration',
        labelReason:'Reason',
        labelMaxReaInterne: "Max quantity by item for an internal restock",
        labelDelaiReglement: 'Payment time',
        labelModePaiement: 'Payment method',
        labelContact: 'Contact',
        labelMailrelance: "Reminder emails",
        /********** Success Form Response ************/
        sucessUserCreate: 'User created successfully !',
        /**********Power BI module ********************/
        reportPbi:'Reporting',
        listOfGroup:'List of reports group',
        createAGroup:'Create a group of report',
        addPbiLink:'Add report links',
        link:'Link',
        adressRequired:'The link is required',
        adressUrl:'The link must be a valid adress',
        filterByUser:'Filter by user',
        filterByModule:'Filter by module',
        noReportingAvl:'No report available',
        /**********Payment methode ********************/
        espece: 'Cash',
        cheque: 'Check',
        emv_touch:'EMV contactless payment',
        emv_multiple:'EMV Instalment payments',
        amex_touch:'American Express contactless payment',
        amex_multiple:'American Express Instalment payments',
        cb: 'Bleue/Visa Card',
        amex: 'American Express',
        mastercard: 'Mastercard',
        jade: 'Jade Card',
        jcb: 'Jcb Card',
        giftcard: 'Gift card',
        giftcardAvoir: 'Gift card (credit note)',
        recapVenteGiftCard: 'Gift cards sold',
        virement: 'Bank Transfer',
        emv:'EMV',
        fidelite: 'Loyalty',
        bonmalistecadeaux: 'Coupon "Ma Liste Cadeaux"',
        bonatelierdujouet: 'Coupon "Atelier du Jouet"',
        annulCommande: 'Sales order cancelled',
        card:'Debit card',
        /********** Week days ************/
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
        sunday: 'Sunday',
        /********** Access ************/
        createCreditNote:'Create a credit note',
        settleInvoiceAccess:'Settle an invoice',
        assignUser:'Assign users',
        authorizationRequiredForThisAction:'An authorization is required to achieve this action',
        /********** Global Search ************/
        globalSearchPlaceholder:'Search...',
        globalSearchSearching:'Searching...',
        globalSearchNoResult:'No result found',
        searchCatArticle:'Articles',
        searchCatTo:'Transfer orders',
        searchCatShipment:'Shipments',
        searchCatPo:'Purchase orders',
        searchCatFacture:'B2B documents',
        searchCatTicket:'Tickets',
        /*********journal comptable (PDF)***********/
        journalComptaVente:'Sales journal',
        journalComptaAchat:'Purchases journal',
        journalComptaEclatement:'With net & VAT breakdown',
        journalComptaEdit:'Edit the journal',
        journalComptaPeriodeFacturation:'Invoicing date: from {begin} to {end}',
        journalComptaEditionDevise:'Edition in {devise} of all invoices',
        journalComptaTotaux:'Totals',
        journalComptaDateEdition:'Edition date',
        journalComptaPage:'Page {current} of {total}',
        journalComptaColDate:'Date',
        journalComptaColPiece:'Document',
        journalComptaColTiers:'Third party',
        journalComptaColTtc:'Incl. VAT',
        journalComptaColHt:'Net',
        journalComptaColTva:'VAT',
        journalComptaApercu:'Journal preview',
        journalComptaApercuVide:'Set the period then edit the journal to display it here.',
        journalComptaTelecharger:'Download the PDF',
        journalComptaNoDocument:'No document over the selected period',
        journalComptaEcartHt:'The sum of the breakdowns does not match the net amount of the documents (difference: {ecart})',
        unvalidDate:'Invalid date',
        unvalidPeriode:'The start date must be earlier than the end date',
        journalComptaFiltreCommerce: "Stores",
        journalComptaFiltreCaisse: "Checkouts",
        journalComptaFiltreVendeur: "Sellers",
        journalComptaFiltreTous: "All",
        journalComptaFiltreToutSelectionner: "Select all",
        journalComptaFiltreEffacer: "Clear",
        journalComptaFiltreAucuneOption: "No option",
        journalComptaFiltreChoisirCommerce: "Select a store first",
        razCaisseTitle: "Checkout Z report",
        razCaisseEdit: "Edit the Z report",
        razCaisseApercu: "Z report preview",
        razCaisseApercuVide: "Set the period then edit the Z report to display it here.",
        razCaisseEmetteur: "Issuer",
        razCaissePeriode: "Period from {begin} to {end}",
        razCaisseSelectionCentre: "Store selection",
        razCaisseSelectionCaisse: "Checkout selection",
        razCaisseSelectionVendeur: "Seller selection",
        razCaisseSelectionTous: "All",
        razCaisseStatistiques: "General statistics",
        razCaisseNbTickets: "Receipts",
        razCaisseNbArticles: "Items",
        razCaissePanierMoyenTtc: "Average basket incl. VAT",
        razCaissePanierMoyenHt: "Average basket net",
        razCaisseArticleMoyenTtc: "Average item incl. VAT",
        razCaisseTotalRemise: "Total discount",
        razCaisseMoyenneRemise: "Average discount",
        razCaisseTotalTtcBrut: "Gross total incl. VAT",
        razCaisseTotalHtBrut: "Gross total net",
        razCaisseTotalTtcNet: "Net total incl. VAT",
        razCaisseTotalHtNet: "Net total",
        razCaisseTotalTva: "Total VAT",
        razCaisseTotalRetour: "Total returns",
        razCaisseCoutAchat: "Purchase cost",
        razCaisseMargeNette: "Net margin",
        razCaisseMargePercent: "Margin",
        razCaisseCoefficient: "Coefficient",
        razCaisseVentesParTaux: "Sales by VAT rate",
        razCaisseEncaissements: "Payments by payment method",
        razCaisseTotaux: "Totals",
        razCaisseColCode: "Code",
        razCaisseColLibelle: "Label",
        razCaisseColCaht: "Net turnover",
        razCaisseColCattc: "Turnover incl. VAT",
        razCaisseColNbArticles: "Items",
        razCaisseColTva: "VAT",
        razCaisseColMode: "Payment method",
        razCaisseColVentes: "Sales",
        razCaisseColRemboursements: "Refunds",
        razCaisseColPrelevements: "Cash withdrawals",
        razCaisseColDepenses: "Expenses",
        razCaisseColTotal: "Total",
        razCaisseFondCaisse: "Cash float",
        razCaisseNbSessions: "{nb} sessions",
        destinatairesRequired: "At least one recipient is required",
        destinatairesIsArray: "The recipient list is invalid",
        destinatairesElemRequired: "A recipient is empty",
        destinatairesElemMin2: "Each recipient must contain at least 2 characters",
        destinatairesElemIsEmail: "Each recipient must be a valid email address",
        pdfMustBeAFile: "The attached PDF is not a valid file",
        pdfMustBeAPdf: "The attached file must be a PDF",
        pdfTooLarge: "The attached PDF exceeds 50 MB",
        recurrenceRequired: "A recurrence is required",
        dateDebutRequired: "A first execution date is required",
        dateDebutIsDate: "The first execution date is invalid",
        journalComptaEnvoyerMail: "Send by email",
        journalComptaCorpsMail: "Message (optional)",
        journalComptaMailInfo: "The PDF currently displayed is attached to the email, along with a download link.",
        journalComptaPublicChargement: "Generating the document, please wait...",
        journalComptaLienInvalide: "This link is invalid or has expired.",
        journalAutoExportTitre: "Automatic sending of journals / Z reports",
        journalAutoExportRegle: "Each execution sends the period preceding its due date: the day before (daily), the previous 7 days (weekly) or the previous month (monthly). Example: a monthly due date on 10/01 sends 09/01 to 09/30. The email only contains a link to download the document, no attachment.",
        journalAutoExportSansMail: "No email account or recipient: the execution will take place but no email will be sent",
        journalAutoExportAjouter: "Add a configuration",
        journalAutoExportModifier: "Edit the configuration",
        journalAutoExportSupprimerConfirm: "Delete this automatic sending?",
        journalAutoExportAucune: "No automatic sending configured",
        journalAutoExportType: "Document",
        journalAutoExportFiltres: "Filters",
        journalAutoExportPremiereEcheance: "First execution",
        journalAutoExportNbSelection: "{nb} selected",
      }
    },
    fr: {
      locale: 'fr',
      messages: {
        /*********form response***********/
        //required
        stockMinRequired:'Le seuil de déclenchement est obligatoire',
        stockGoodRequired:'La quantité à réassortir est obligatoire',
        nameRequired: 'Le champ "nom" est obligatoire',
        firstnameRequired: 'Le champ "prénom" est obligatoire',
        customFieldArticleMatchRequired: 'Le champ "champ personnalisé" est obligatoire',
        emailRequired: 'Le champ "e-mail" est obligatoire',
        mailRelanceRequired: 'Le champ "Mails de relance" est obligatoire',
        passwordRequired: 'Le champ "mot de passe" est obligatoire',
        password_confirmationRequired: 'Le champ "confirmer mot de passe" est obligatoire',
        companyRequired: 'Le champ "entreprise" est obligatoire',
        moduleRequired: 'Le champ "module" est obligatoire',
        sectionRequired: 'Le champ "commerce" est obligatoire',
        sexeRequired: 'Le champ "sexe" est obligatoire',
        sizeTagRequired:'Vous devez indiquer une dimension',
        typefideliteRequired: 'Le champ "Type de Carte de Fidelité" est obligatoire',
        maxusemoisRequired: 'Le champ "Durée de validité" est obligatoire',
        maxusemoisproformaRequired: 'Le champ "Durée de validité d\'une proforma" est obligatoire',
        modepaiementRequired: 'Le champ "Modes de paiement" est obligatoire',
        themeRequired: 'Le champ "Theme" est obligatoire',
        donneeclientRequired: 'Le champ "Activer l\'obligation de collecte des données client" est obligatoire',
        objectifvendeurRequired: 'Le champ "Activer les objectifs vendeurs" est obligatoire',
        objectifcommerceRequired: 'Le champ "Activer les objectifs commerce" est obligatoire',
        dixmilleRequired: 'Vous devez indiquer le nombre de billets de 10 000 XPF',
        cinqmilleRequired: 'Vous devez indiquer le nombre de billets de 5 000 XPF',
        milleRequired: 'Vous devez indiquer le nombre de billets de 1 000 XPF',
        cinqcentRequired: 'Vous devez indiquer le nombre de billets de 500 XPF',
        deuxcentRequired: 'Vous devez indiquer le nombre de pièces de 200 XPF',
        centRequired: 'Vous devez indiquer le nombre de pièces de 100 XPF',
        cinquanteRequired: 'Vous devez indiquer le nombre de pièces de 50 XPF',
        vingtRequired: 'Vous devez indiquer le nombre de pièces de 20 XPF',
        dixRequired: 'Vous devez indiquer le nombre de pièces de 10 XPF',
        cinqRequired: 'Vous devez indiquer le nombre de pièces de 5 XPF',
        deuxRequired: 'Vous devez indiquer le nombre de pièces de 2 XPF',
        unRequired: 'Vous devez indiquer le nombre de pièces de 1 XPF',
        gradeRequired: 'Vous devez indiquer un grade',
        caRequired: 'Vous devez indiquer un CA HT',
        cattcRequired: 'Vous devez indiquer un CA TTC',
        pmRequired: 'Vous devez indiquer un PM HT',
        pmttcRequired: 'Vous devez indiquer un PM TTC',
        tfRequired: 'Vous devez indiquer un TF',
        ivRequired: 'Vous devez indiquer un IV',
        entreRequired: 'Vous devez indiquer un nombre de passages clients (entrée et sortie)',
        beginRequired: 'Vous devez indiquer la date de début',
        endRequired: 'Vous devez indiquer la date de fin',
        dayRequired: 'Vous devez indiquer le jour',
        telephoneRequired: 'Vous devez indiquer le téléphone',
        adresseRequired: 'Vous devez indiquer l\'adresse physique',
        adresseLivraisonRequired: 'Vous devez indiquer l\'adresse de livraison',
        adressepostaleRequired: 'Vous devez indiquer l\'adresse postale',
        newsletterRequired: 'Vous devez cocher la newsletter',
        civiliteRequired: 'Vous devez indiquer la civilité',
        csvEncodeRequired: 'Vous devez indiquer l\'encodage CSV',
        csvSeparatorRequired: 'Vous devez indiquer le séparateur CSV',
        csvDateFormatRequired: 'Vous devez indiquer le format de date CSV',
        codeRequired:'Vous devez indiquer un code',
        rcsRequired:'Vous devez indiquer un RCS',
        adressRequired:'Vous devez indiquer l\'adresse',
        codePostalRequired:'Vous devez indiquer un code postal',
        villeRequired:'Vous devez indiquer une ville',
        paysRequired:'Vous devez indiquer un pays',
        paysInvalid:'Le pays sélectionné n\'est pas valide',
        codeBanqueRequired: 'Vous devez indiquer un code banque',
        codeGuichetRequired: 'Vous devez indiquer un code guichet',
        numeroCompteRequired: 'Vous devez indiquer un numéro de compte',
        cleRibRequired: 'Vous devez indiquer une clé RIB',
        clientTypeRequired: 'Vous devez indiquer un type',
        quartierRequired: 'Vous devez indiquer un quartier',
        typeRequired: 'Vous devez indiquer un type',
        unspecified:'Non spécifié',
        dateDeNaissanceRequired: 'Vous devez indiquer une date de naissance',
        providerNameRequired: 'Vous devez indiquer un nom de fournisseur',
        contactNameRequired: 'Vous devez indiquer un nom de contact',
        statusRequired: 'Vous devez indiquer un status',
        itemFamilyNameRequired: 'Vous devez indiquer un nom de famille d\'article',
        brandNameRequired: 'Vous devez indiquer un nom de marque',
        categoryRequired: 'Vous devez indiquer une catégorie',
        referenceRequired: 'Vous devez indiquer un code UPC',
        referenceToRequired: 'Vous devez indiquer une référence',
        skuRequired: 'Vous devez indiquer un SKU',
        internalidRequired: 'Vous devez indiquer l\'ID interne de l\'article',
        priceRequired: 'Vous devez indiquer un prix TTC',
        tgcRequired: 'Vous devez indiquer un taux de {taxe}',
        prmpRequired: 'Vous devez indiquer un PRMP',
        havestockRequired: 'Vous devez indiquer si cet article doit être dépendant d\'un stock',
        toPrepareRequired: 'Vous devez indiquer si cet article doit être préparé',
        colorHexaRequired: "Vous devez indiquer un code couleur hexadécimal",
        banqueRequired: 'Vous devez indiquer le nom de la banque',
        customFieldRequired: 'Vous devez renseigner le champ "{name}"',
        numeroShipmentRequired:'Vous devez indiquer le numéro d\'expédition',
        cartonRequired:'Vous devez indiquer une référence carton',
        shdeCartonNameRequired:'Vous devez indiquer une référence carton',
        shdeQuotaPrevuRequired:'Vous devez indiquer la quantité prévue',
        firstStartBinsRequired:'Vous devez indiquer le début du premier niveau',
        firstEndBinsRequired:'Vous devez indiquer la fin du premier niveau',
        zoneRequired:'Vous devez indiquer une zone',
        secondEndBinsRequiredWith:'Vous devez indiquer la fin du premier niveau si le début du premier niveau est renseigné',
        thirdEndBinsRequiredWith:'Vous devez indiquer la fin du second niveau si le début du second niveau est renseigné',
        fourthEndBinsRequiredWith:'Vous devez indiquer la fin du troisième niveau si le début du troisième niveau est renseigné',
        fifthEndBinsRequiredWith:'Vous devez indiquer la fin du quatrième niveau si le début du quatrième niveau est renseigné',
        firstBinsRequired:'Vous devez indiquer le premier niveau',
        quotaRequired: 'Vous devez indiquer la quantité',
        actionRequired:'Vous devez indiquer le champ action',
        binsRequired:'Vous devez indiquer la bins',
        quantiteRequired:'Vous devez indiquer la quantité',
        fieldRequired:'Ce champ est requis',
        expectedRequired: 'La date souhaitée d\'exécution est requise',
        rhRequired: 'Vous devez indiquer un staff',
        rhBarreRequired: 'Vous devez indiquer le code-barre d\'un staff',
        osectionRequired: 'Vous devez indiquer un commerce d\'origine',
        fsectionRequired: 'Vous devez indiquer un commerce de destination',
        rpRequired: 'Vous devez indiquer le niveau de stock minimum',
        pslRequired: 'Vous devez indiquer le niveau de stock optimal',
        toMaxRequired: 'Le nombre maximum d\'instructions pour un ordre de transfert est obligatoire',
        articleRequired: 'Vous devez choisir un article',
        promotionRequired: "Vous devez choisir une promotion",
        allFieldsRequired: 'Tous les champs doivent être remplis',
        promoImport:'Import promotions',
        codeCaisseRequired: 'Vous devez indiquer un code d\'identification de la caisse',
        caisseIdentRequired:'Vous devez indiquer l\'identifiant de caisse',
        hostRequired:'Vous devez indiquer une adresse IP',
        comPortRequired:'Vous devez indiquer un port COM',
        modelRequired:'Vous devez choisir un modèle',
        poRequired:'Vous devez choisir un bon de commande',
        waitingEpt:'En attente TPE',
        errorEpt:'Erreur réponse TPE',
        newCheckoutShortcutProfil:'Nouveau profil de raccourci',
        newKpiFilter:'Nouveau filtre de KPI',
        checkoutShorcutProfil:'Profils de raccourci',
        nbrCelluleParLigne:'Nombre de cellules par ligne',
        fromCustomField:'Champ personnalisé',
        fullCustom:'Autre groupe',
        customFieldN1:'A partir du champ personnalisé',
        valueCustofieldN1:'Valeur du champ personnalisé',
        niveauCustomField:'Niveau {n} à partir du champ personnalisé',
        addLevel:'Ajouter un niveau',
        kpiFilter:'Filtre de KPI',
        itemFilter:'Filtre article',
        itemCompareFilter:'Comparer filtre article',
        titreRequired:'Vous devez indiquer un titre',
        messageRequired:'Vous devez indiquer un message',
        dateRequired:'Vous devez indiquer une date',
        capitalRequired:'Vous devez indiquer le capital',
        exerciceStartRequired:'Vous devez indiquer le début de l\'exercice',
        montantRequired:'Vous devez indiquer un montant',
        itemsRequiredInTo:'Vous ne pouvez pas valider un ordre de transfert sans articles',
        selectShopsBeforeSearch:'Sélectionnez un commerce d\'origine et de destination avant de rechercher un article',
        confirmChangeShopTitle:'Changer de commerce ?',
        confirmChangeShopText:'Changer le commerce d\'origine ou de destination va effacer votre liste d\'articles. Voulez-vous continuer ?',
        pageNamerequired:'Vous devez indiquer le nom de la page',
        filtreNamerequired:'Vous devez indiquer le nom du favori',
        heureRequired:'Vous devez indiquer le nombre d\'heures',
        minuteRequired:'Vous devez indiquer le nombre de minutes',
        valueRequired:'Vous devez indiquer une valeur',
        clientRequired:'Vous devez indiquer un client',
        noteRequired:'Vous devez indiquer une note',
        delaiReglementRequired:'Vous devez indiquer un délai de règlement',
        modeReglementRequired:'Vous devez indiquer un délai de règlement',
        modePaiementRequired:'Vous devez indiquer un mode de paiement par défaut',
        modePaiementInvalid:'La valeur saisie n\'est pas un mode de paiement valide pour cette entreprise',
        clientTypeInvalid:'La valeur saisie n\'est pas un type de client valide pour cette entreprise',
        modeReglementInvalid:'La valeur saisie n\'est pas un délai de règlement valide',
        prefixRequired:"Vous devez indiquer un préfixe",
        articleListRequired:'Vous devez indiquer si vous souhaitez générer une liste d\'articles',
        articleListNameRequired:'Vous devez indiquer un nom de liste d\'article',
        replaceRequired:'Vous devez indiquer si vous souhaitez remplacer le code barre des articles existants',
        itemReplaceRequired:'Vous devez indiquer si vous souhaitez remplacer les articles existants',
        sectionAndZoneAdvanceParamsRequired:"Vous devez configurer un commerce et une zone par défaut pour les listes d'articles dans les paramètres avancés de la compagnie",
        cardRequired:'Carte obligatoire',
        deviseAchatRequired:'La devise d\'achat est obligatoire',
        internalIdRequired:'L\'id interne est obligatoire',
        //Min
        capitalMin1:'Le capital doit au moins être 1 XPF',
        fondCaisseMin1:'Le fond de caisse doit au moins être 1 XPF',
        poidsMin1:'Le poids minimum est 1',
        exerciceStartMin1:'Le début de l\'exercice doit au moins être 1 (janvier)',
        pageNameMin2: 'Le nom de la page doit comporter au moins 2 caractères',
        filtreNameMin2: 'Le nom du favori doit comporter au moins 2 caractères',
        nameMin2: 'Le champ "nom" doit comporter au moins 2 caractères',
        nameMin5: 'Le champ "nom" doit comporter au moins 3 caractères',
        skuMin2: 'Le champ "sku" doit comporter au moins 2 caractères',
        firstnameMin2: 'Le champ "prénom" doit comporter au moins 2 caractères',
        passwordMin8: 'Le champ "mot de passe" doit comporter au moins 8 caractères',
        phonedMin6: 'Le champ "téléphone" doit comporter au moins 6 caractères',
        phoneMin6: 'Le champ "téléphone" doit comporter au moins 6 caractères',
        maxusemoisdMin1: 'Le champ "Durée de validité" doit être au minimum à 1 mois',
        maxusemoisproformaMin1: 'Le champ "Durée de validité d\'une proforma" doit être au minimum à 1 mois',
        dixmilleMin0: 'Le nombre de billets de 10 000 XPF ne peut pas être inférieur à 0',
        cinqmilleMin0: 'Le nombre de billets de 5 000 XPF ne peut pas être inférieur à 0',
        milleMin0: 'Le nombre de billets de 1 000 XPF ne peut pas être inférieur à 0',
        cinqcentMin0: 'Le nombre de billets de 500 XPF ne peut pas être inférieur à 0',
        deuxcentMin0: 'Le nombre de pièces de 200 XPF ne peut pas être inférieur à 0',
        centMin0: 'Le nombre de pièces 100 XPF ne peut pas être inférieur à 0',
        cinquanteMin0: 'Le nombre de pièces 50 XPF ne peut pas être inférieur à 0',
        vingtMin0: 'Le nombre de pièces 20 XPF ne peut pas être inférieur à 0',
        dixMin0: 'Le nombre de pièces 10 XPF ne peut pas être inférieur à 0',
        cinqMin0: 'Le nombre de pièces 5 XPF ne peut pas être inférieur à 0',
        deuxMin0: 'Le nombre de pièces 2 XPF ne peut pas être inférieur à 0',
        unMin0: 'Le nombre de pièces 1 XPF ne peut pas être inférieur à 0',
        caMin0: 'Le CA HT ne peut pas être inférieur à 0',
        cattcMin0: 'Le CA TTC ne peut pas être inférieur à 0',
        pmMin0: 'Le PM HT ne peut pas être inférieur à 0',
        pmttcMin0: 'Le PM TTC ne peut pas être inférieur à 0',
        tfMin0: 'Le TF ne peut pas être inférieur à 0',
        ivMin0: 'Le IV ne peut pas être inférieur à 0',
        entreMin0: 'Le nombre de passages clients (entrée et sortie) ne peut pas être inférieur à 0',
        codeMin3: 'Le champ "code" doit comporter au moins 3 caractères',
        codeMin2: 'Le champ "code" doit comporter au moins 2 caractères',
        rcsMin5: 'Le champ "RCS" doit comporter au moins 5 caractères',
        codeBanqueMin5: 'Le champ "Code Banque" doit comporter au moins 5 caractères',
        codeGuichetMin5: 'Le champ "Code Guichet" doit comporter au moins 5 caractères',
        numeroCompteMin11: 'Le champ "Numéro de Compte" doit comporter au moins 11 caractères',
        cleRibMin2: "Le champ \"Clé RIB\" doit comporter au moins 2 caractères",
        nomContactMin2: 'Le nom du contact doit comporter au moins 2 caractères',
        priceMin: 'Le prix ne peut être inférieur à 0',
        promoPriceMin: 'Le prix promotionnel ne peut être inférieur à 0',
        tgcMin: 'Le taux de TGC ne peut être inférieur à 0',
        colorHexaMin: "Le code couleur hexadécimal doit faire 6 caractères",
        buyPriceMin: 'Le prix d\'achat ne peut être inférieur à 0',
        prmpMin: 'Le PRMP ne peut être inférieur à 0',
        prMin: 'Le prix de revient ne peut être inférieur à 0',
        lastBuyPriceMin: 'Le dernier prix d\'achat ne peut être inférieur à 0',
        lastBuyePriceDeviseMin: 'Le dernier prix d\'achat en devise ne peut être inférieur à 0',
        indicePrmpMin: 'L\'indice PRMP ne peut être inférieur à 0',
        indicePrMin: 'L\'indice prix de revient ne peut être inférieur à 0',
        deviseAchatMin: "La devise d'achat doit comporter 3 caractères",
        quotaMin: "La quantité ne peut pas être inférieure à 0",
        quotaCommandeMin: "La quantité ne peut pas être inférieure à 0",
        numeroShipmentMin2:'Le champ "numéro d\'expédition" doit comporter au moins 2 caractères',
        cartonMin1: 'La référence carton doit faire au moins 1 caractères',
        shdeCartonNameMin2: 'La référence carton doit faire au moins 2 caractères',
        shdeQuotaPrevuMin: 'La quantité prévue ne peut pas être inférieur à 0',
        firstStartBinsMin0:'Le début du premier niveau ne peut pas être inférieur à 0',
        firstEndBinsMin0:"La fin du premier niveau ne peut pas être inférieure à 0",
        secondStartBinsMin0:'Le début du second niveau ne peut pas être inférieur à 0',
        secondEndBinsMin0:"La fin du second niveau ne peut pas être inférieure à 0",
        thirdStartBinsMin0:'Le début du troisième niveau ne peut pas être inférieur à 0',
        thirdEndBinsMin0:"La fin du troisième niveau ne peut pas être inférieure à 0",
        fourthStartBinsMin0:'Le début du quatrième niveau ne peut pas être inférieur à 0',
        fourthEndBinsMin0:"La fin du quatrième niveau ne peut pas être inférieure à 0",
        fifthStartBinsMin0:'Le début du cinquième niveau ne peut pas être inférieur à 0',
        fifthEndBinsMin0:"La fin du cinquième niveau ne peut pas être inférieure à 0",
        firstBinsMin0:'Le premier niveau ne peut pas être inférieur à 0',
        secondBinsMin0:'Le second niveau ne peut pas être inférieur à 0',
        thirdBinsMin0:'Le troisième niveau ne peut pas être inférieur à 0',
        fourthBinsMin0:'Le quatrième niveau ne peut pas être inférieur à 0',
        fifthBinsMin0:'Le cinquième niveau ne peut pas être inférieur à 0',
        referencePoMin2:'La référence de bon de commande doit comporter au moins 2 caractères',
        rpIsMin0:"Le niveau de stock minimum RP de {name} ne peut pas être inférieur à 0",
        pslIsMin0:"Le niveau de stock optimal PSL de {name} ne peut pas être inférieur à 0",
        quantityRequired:'La quantité est requise',
        quantiteMin0:"La quantité ne peut être inférieure à 0",
        quantiteGreaterThan0:"La quantité doit être supérieure à 0",
        referenceToMin2:'La référence doit faire au moins 2 caractères',
        rpMin0:'Le niveau de stock minimal ne peut pas être inférieur à 0',
        pslMin0:'Le niveau de stock optimal ne peut pas être inférieur à 0',
        toMaxMin10:"Le nombre maximum d'instructions pour un ordre de transfert ne peut pas être inférieur à 10",
        giftCardMin1:"La durée de validité d'un dépôt sur une carte cadeau ne peut pas être inférieure à 1 mois",
        giftCardMontantMin: 'Le montant de la carte cadeau ne peut pas être inférieur à 1',
        paiementMin: "Les indications de paiement doivent être supérieures à 0",
        modifManualValueMin0: "La valeur doit être supérieure ou égale à 0",
        modifManualValueMin1: "Vous ne pouvez pas saisir une valeur inférieur à 1",
        codeCaisseMin4: 'L\'identifiant de caisse doit comporter au moins 4 caractères',
        detailModePaiementMin0: "Les valeurs ne peuvent pas être inférieures à 0",
        titreMin2: 'Le titre doit faire au moins 2 caractères',
        messageMin2:'Le message doit faire au moins 2 caractères',
        typeMin2:'Le type doit faire au moins 2 caractères',
        ticketNameMin1:'L\'intitulé sur ticket doit faire au moins un caractère',
        heureMin0:"Les heures ne peuvent pas être inférieures à 0",
        minuteMin0:"Les minutes ne peuvent pas être inférieures à 0",
        prefixMin1Max12:"Le préfixe doit faire entre 1 et 12 caractères",
        articleListNameMin2:'Le nom de la liste d\'article doit comporter au moins 2 caractères',
        creditMin:'Crédit ne peut pas être inférieur à 0',
        abonnementMin:'Abonnement ne peut pas être inférieur à 0',
        weightMin:'Le volume ne peut pas être inférieur à 0',
        minimumCommandeMin:"Le minimum de commande ne peut pas être inférieur à 0",
        valueMin0:"La valeur ne peut pas être inférieure à 0",
        //Max
        exerciceStartMax12:"Le début de l'exercice ne peut être supérieur à 12 (décembre)",
        poidsMax100:'Le poids maximum est 100',
        lineLimitationZoneContent:'L\'affichage est limitée à 1000 lignes',
        quantiteMax8000000:"La quantité doit être inférieure à 8 000 000",
        quantityMax9999999:'La quantité doit être inférieure à 9 999 999',
        pageNameMax191:'Le nom de la page doit comporter moins de 191 caractères',
        filtreNameMax191:'Le nom du favori doit comporter moins de 191 caractères',
        nameMax191: 'Le champ "nom" doit comporter moins de 191 caractères',
        nameMax250: 'Le champ "nom" doit comporter moins de 250 caractères',
        nameMax50: 'Le champ "nom" doit comporter moins de 50 caractères',
        skuMax250: 'Le champ "Sku" doit comporter moins de 250 caractères',
        nbrCelluleMin1:'Le nombre de cellules doit être au minimum 1',
        nbrCelluleMax20:'Le nombre de cellules doit être inférieur à 20',
        phoneMax20: 'Le champ "téléphone" doit comporter moins de 20 caractères',
        firstnameMax50: 'Le champ "prénom" doit comporter moins de 50 caractères',
        firstnameMax191: 'Le champ "prénom" doit comporter moins de 191 caractères',
        nameMax20: 'Le champ "nom" doit comporter moins de 20 caractères',
        logoMax50: 'Le champ "logo" doit comporter moins de 50 caractères',
        gradeMax50: 'Le champ "grade" doit comporter moins de 50 caractères',
        maxusemoisdMax120: 'Le champ "Durée de validité" ne peut pas excéder 120 mois',
        maxusemoisproformaMax120: 'Le champ "Durée de validité d\'une proforma" ne peut pas excéder 120 mois',
        caMax2000000000: 'Le CA HT ne peut pas excéder 2 000 000 000 XPF',
        cattcMax2000000000: 'Le CA TTC ne peut pas excéder 2 000 000 000 XPF',
        pmMax2000000000: 'Le PM HT ne peut pas excéder 2 000 000 000 XPF',
        pmttcMax2000000000: 'Le PM TTC ne peut pas excéder 2 000 000 000 XPF',
        fondCaisseMax1000000: 'Le fond de caisse ne peut pas excéder 1 000 000 XPF',
        tfMax100: 'Le TF ne peut pas excéder 100 %',
        ivMax999: 'Le IV ne peut pas excéder 999 articles',
        entreMax10000000: 'Le nombre de passages clients (entrée et sortie) ne peut pas excéder 10 000 000',
        codeMax5: 'Le champ "code" doit comporter moins de 5 caractères',
        rcsMax20: 'Le champ "RCS" doit comporter moins de 20 caractères',
        codeBanqueMax5: 'Le champ "Code Banque" doit comporter moins de 5 caractères',
        codeGuichetMax5: 'Le champ "Code Guichet" doit comporter moins de 5 caractères',
        numeroCompteMax11: 'Le champ "Numéro de Compte" doit comporter moins de 11 caractères',
        cleRibMax2: "Le champ \"Clé RIB\" doit comporter moins de 2 caractères",
        nomContactMax191: 'Le nom du contact doit comporter moins de 191 caractères',
        priceMax: 'Le prix ne peut pas être supérieur à 999999999.99',
        referenceMax191: 'Le code UPC doit faire moins de 191 caractères',
        reference2Max191: 'Le code UPC 2 doit faire moins de 191 caractères',
        internalIdMax191: 'L\'ID interne doit faire moins de 191 caractères',
        referenceToMax191: 'Le référence doit faire moins de 191 caractères',
        skuMax191: 'Le SKU doit faire moins de 191 caractères',
        parentNameMax250: 'Le Nom Parent doit faire moins de 250 caractères',
        promoPriceMax: 'Le prix promotionnel ne peut pas être supérieur à 999999999.99',
        prmpMax: 'Le PRMP ne peut pas être supérieur à 999999999.99',
        prMax: 'Le prix de revient ne peut pas être supérieur à 999999999.99',
        lastBuyPriceMax: 'Le dernier prix d\'achat ne peut pas être supérieur à 999999999.99',
        lastBuyePriceDeviseMax: 'Le dernier prix d\'achat en devise ne peut pas être supérieur à 999999999.99',
        tgcMax: 'Le taux de TGC ne peut pas être supérieur à 100',
        imageMax250: 'Le lien image article doit comporter moins de 250 caractères',
        colorHexaMax: "Le code couleur hexadécimal doit faire 6 caractères",
        buyPriceMax: 'Le prix d\'achat ne peut pas être supérieur à 999999999.99',
        indicePrmpMax: 'L\'indice PRMP ne peut pas être supérieur à 999999999.99',
        indicePrMax: 'L\'indice prix de revient ne peut pas être supérieur à 999999999.99',
        deviseAchatMax: "La devise d'achat doit comporter 3 caractères",
        maxPhoneLength6: 'Le numéro de téléphone doit comporter 6 chiffres maximum',
        quotaCommandeMax: "La quantité ne peut pas être supérieure à 8000000",
        quotaMax: "La quantité ne peut pas être supérieure à 8000000",
        quotaMax10000: "La quantité ne peut pas être supérieure à 10000",
        numeroShipmentMax190:'Le numéro d\'expédition doit faire moins de 190 caractères',
        cartonMax250: 'La référence carton doit faire moins de 250 caractères',
        shdeCartonNameMax250: 'La référence carton doit faire moins de 250 caractères',
        shdeQuotaPrevuMax: "La quantité prévue ne peut pas être supérieure à 8000000",
        firstStartBinsMax32000:'Le début de premier niveau ne peut pas être supérieur à 32000',
        firstEndBinsMax32000:"La fin du premier niveau ne peut pas être supérieure à 32000",
        secondStartBinsMax32000:'Le début de second niveau ne peut pas être supérieur à 32000',
        secondEndBinsMax32000:"La fin du second niveau ne peut pas être supérieure à 32000",
        thirdStartBinsMax32000:'Le début de troisième niveau ne peut pas être supérieur à 32000',
        thirdEndBinsMax32000:"La fin du troisième niveau ne peut pas être supérieure à 32000",
        fourthStartBinsMax32000:'Le début de quatrième niveau ne peut pas être supérieur à 32000',
        fourthEndBinsMax32000:"La fin du quatrième niveau ne peut pas être supérieure à 32000",
        fifthStartBinsMax32000:'Le début de cinquième niveau ne peut pas être supérieur à 32000',
        fifthEndBinsMax32000:"La fin du cinquième niveau ne peut pas être supérieure à 32000",
        firstBinsMax32000:'Le premier niveau ne peut pas être supérieur à 32000',
        secondBinsMax32000:'Le second niveau ne peut pas être supérieur à 32000',
        thirdBinsMax32000:'Le troisième niveau ne peut pas être supérieur à 32000',
        fourthBinsMax32000:'Le quatrième niveau ne peut pas être supérieur à 32000',
        fifthBinsMax32000:'Le cinquième niveau ne peut pas être supérieur à 32000',
        referencePoMax190:"La référence de bon de commande doit être inférieure à 190 caractères",
        rpIsMax8000000:'Le niveau de stock minimum RP de {name} ne peut pas être supérieur à 8000000',
        pslIsMax8000000:'Le niveau de stock optimal PSL de {name} ne peut pas être supérieur à 8000000',
        generateBarcodeMax1000:"Vous ne pouvez pas générer plus de 1000 code-barres",
        rpMax8000000:'Le niveau de stock minimal ne peut pas être supérieur à 8000000',
        pslMax8000000:"Le niveau de stock optimal ne peut pas être supérieur à 8000000",
        toMaxMax1000:"Le nombre maximum d'instructions pour un ordre de transfert ne peut pas être supérieur à 1 000",
        giftCardMax120:"La durée de validité d'un dépôt sur une carte cadeau ne peut pas être supérieure à 120 mois",
        giftCardMontantMax: 'Le montant de la carte cadeau ne peut pas être supérieur à 100 000 000',
        paiementMax: 'Les indications de paiement doivent être inférieures à 1 000 000 000',
        codeCaisseMax30: "L'identifiant de caisse doit faire moins de 30 caractères",
        cashOutReasonMax100: 'La raison d\'un retrait d\'espèces doit faire moins de 100 caractères',
        titreMax250: 'Le titre doit faire moins de 250 caractères',
        typeMax50: 'Le type doit faire moins de 50 caractères',
        ticketNameMax15:'L\'intitulé sur ticket doit faire moins de 15 caractères',
        heureMax23:'Les heures doivent être inférieures à 23',
        minuteMax59:"Les minutes doivent être inférieures à 59",
        articleListNameMax191:'Le nom de la liste d\'article doit comporter moins de 191 caractères',
        creditMax:'Crédit ne peut pas être supérieur à 999999',
        abonnementMax:'Abonnement ne peut pas être supérieur à 999999',
        unitMax191:'L\'unité doit être inférieur à 191',
        weightMax:'Le volume doit être inférieur à 999999',
        minimumCommandeMax:'Le minimum commande doit être inférieur à 999999999',
        defaultConditionnementNameMax250:'Le nom du conditionnement par défaut doit faire moins de 250 caractères',
        valueMax100:'La valeur ne peut pas être supérieur à 100',
        //email
        emailEmail: 'Le champ "email" doit être un e-mail valide',
        //unique
        emailUnique: 'Il y a déjà un compte enregistré avec cette adresse e-mail',
        emailExists: 'Il existe déjà un client avec cette adresse email',
        nameUnique: 'Ce nom exist déjà',
        skuUnique: 'Un autre article possède déjà la même Sku',
        referenceUnique: 'Le code UPC est déjà utilisé par un autre article',
        referenceEnumereUnique: 'Le code-barre du conditionnement est déjà utilisé par un autre conditionnement',
        reference2Unique: 'Le code UPC 2 est déjà utilisé par un autre article',
        skuUnique: 'Le SKU est déjà utilisé par un autre article',
        alreadyExist: 'à déjà été assigné',
        sectionUnique: 'Cette rubrique existe déjà',
        zoneInventaireAlreadyExists: 'Vous avez déjà une zone d\'inventaire qui porte le même nom',
        alreadyAvoirAndCantBeCancelled:'Cette facture est déjà liée à un avoir et ne peut pas être annulée',
        //confirmed
        passwordConfirmed: 'Le mot de passe a mal été confirmé',
        confirmDifferentQuantityCollected:'La quantité collectée ne correspond pas à la quantité demandée, confirmer ?',
        confirmDifferentQuantityReceipt:'La quantité réceptionnée ne correspond pas à la quantité collectée, confirmer ?',
        confirmCancelSaleOrder:'Êtes-vous sûr de vouloir annuler cette commande client',
        confirmValidateDocument:'Êtes-vous sûr de vouloir valider ce document',
        confirmCancelDocument:'Êtes-vous sur de vouloir annuler ce document ?',
        confirmValidateDeliveryNote:'Êtes-vous sur de vouloir valider ce bon de livraison? Cela va sortir du stock les articles de ce bon de livraison',
        confirmConvertDeliveryNoteToInvoice:'Êtes-vous sur de vouloir convertir ce bon de livraison en facture?',
        //In
        roleIn: 'Le role attribué n\'est pas accepté',
        sexeIn: 'Le sexe attribué n\'est pas accepté',
        themeIn: 'Le thème attribué n\'est pas accepté',
        modepaiementIn: 'Un des modes de paiements indiqué n\'est pas accepté',
        priorityIn: 'La valeur de "Priorité" doit être Oui ou Non',
        customFieldIn: 'Le champ "{name}" a une valeur non valide',
        encryptionIn: 'La valeur de encryption doit être ssl ou tls',
        incorrectRemiseType:'Type de remise incorrect',
        //exists
        fileDoesntExists:'Le fichier n\'existe pas',
        companyExists: 'Cette entreprise n\'existe pas',
        moduleExists: 'Ce module n\'existe pas',
        sectionExists: 'Ce commerce n\'existe pas',
        rhExists: 'Ce staff n\'existe pas',
        gradeExists: 'Ce grade n\'existe pas',
        typefideliteExists: 'Ce type de carte de fidelité n\'existe pas',
        programfideliteExists: 'Ce programme de fidelité n\'existe pas',
        programgiftcardExists: 'Ce programme de Gift Card n\'existe pas',
        clientExists: 'Il existe déjà un client enregistré avec ce nom et ce prénom',
        clientIdNotExists: 'Cet ID client n\'existe pas',
        fournisseurIdNotExists:'Cet ID fournisseur n\'existe pas',
        giftCardExists: 'Il existe déjà une carte cadeau avec cette référence',
        internalIdExists: 'L\'internal ID est incorrect',
        expectedInternalIdAlreadyExists: 'L\'internal ID souhaité existe déjà',
        internalNotIdExists: 'L\'internal ID existe déjà',
        firstlevelcatExists: 'Aucune correspondance trouvée avec le champ "Classification"',
        secondlevelcatExists: 'Aucune correspondance trouvée avec le champ "Famille"',
        thirdlevelcatExists: 'Aucune correspondance trouvée avec le champ "Sous-famille"',
        fourthlevelcatExists: 'Aucune correspondance trouvée avec le champ "Catégorie"',
        fifthlevelcatExists: 'Aucune correspondance trouvée avec le champ "Sous-catégorie"',
        fournisseurExists: 'Aucune correspondance trouvée avec le champ "Fournisseur"',
        fournisseurExistsImport:'Ce fournisseur existe déjà',
        marqueExists: 'Aucune correspondance trouvée avec le champ "Marque"',
        nameExists: 'Ce nom est déjà utilisé',
        referenceExists: 'Cette référence est déjà utilisée',
        articleNameExists: 'Aucun article ne correspond à ce nom d\'article',
        articleNameAlreadyExists: 'Le nom de cet article est déjà utilisé par un autre article',
        supplementListNameAlreadyExists: 'Le nom de cet liste de supplément est déjà utilisé par une autre liste',
        articleSkuExists: 'Aucun article ne correspond à ce Sku',
        poNameExists: 'Ce bon de commande n\'existe pas',
        devisNotExists: 'Ce devis n\'existe pas',
        sectionCodeExists: 'Ce code de commerce n\'existe pas',
        numeroShipmentExists: 'Ce numéro de bon d\'expédition est déjà utilisé',
        shipmentNameExists: 'Ce numéro de bon d\'expédition n\'existe pas',
        idsExists: 'L\'ID est incorrect',
        binsExists: 'Une bins avec la même adresse existe déjà pour cette zone de stockage',
        shdeCartonNameExists: 'Ce carton n\'existe pas dans ce bon d\'expédition',
        binsAlreadyExistsInSection: 'Une bins avec la même adresse existe déjà pour ce commerce',
        binsNotInThisSection: 'Cette bins n\'existe pas dans ce commerce',
        binsNotInThisZone: 'Cette bins n\'existe pas dans cette zone',
        zoneNotInThisSection: 'Cette zone n\'existe pas dans ce commerce',
        binsNotExist: 'Cette bins n\'existe pas',
        binsNotExistInToList: 'Cette bins ne figure pas dans votre ordre de transfert',
        binsNotExistInInventory:'Cette bins ne fait pas partie de votre zone d\'inventaire',
        itemNotExistInInventory:'Cet article ne fait pas partie de votre zone d\'inventaire',
        codeCaisseExists: 'Cet identifiant de caisse est déjà utilisé',
        caisseIdentExists:'Cet identifiant de caisse n\'existe pas',
        namePeripheriqueExists:'Ce nom de périphérique est déjà utilisé',
        articleAlreadyInTo:'Cet article est déjà présent dans cet ordre de transfert',
        defaultConditionnementExists:'Ce conditionnement n\'existe pas',
        //array
        moduleArray: 'Une erreur inattendue s\'est produite',
        sectionArray: 'Une erreur inattendue s\'est produite',
        rhArray: 'Une erreur inattendue s\'est produite',
        modepaiementArray: 'Une erreur inattendue s\'est produite',
        raisonmodifprixArray: 'Une erreur inattendue s\'est produite',
        componentsIsArray: 'Une erreur inattendue s\'est produite',
        articlesArray: 'Une erreur inattendue s\'est produite',
        cartonArray: 'Une erreur inattendue s\'est produite',
        //General
        sectionGeneral: 'Une erreur inattendue s\'est produite',
        rhGeneral: 'Une erreur inattendue s\'est produite',
        programfideliteGeneral: 'Une erreur inattendue s\'est produite',
        programgiftcardGeneral: 'Une erreur inattendue s\'est produite',
        forbiddenGeneral: 'Vous n\'êtes pas autorisé à réaliser cette action',
        //Numeric
        maxusemoisNumeric: 'Le champ "Durée de validité" doit être une valeur numeriqe',
        maxusemoisproformaNumeric: 'Le champ "Durée de validité d\'une proforma" doit être une valeur numeriqe',
        dixmilleNumeric: 'Le nombre de billets de 10 000 XPF doit être une valeur numérique',
        cinqmilleNumeric: 'Le nombre de billets de 5 000 XPF doit être une valeur numérique',
        milleNumeric: 'Le nombre de billets de 1 000 XPF doit être une valeur numérique',
        cinqcentNumeric: 'Le nombre de billets de 500 XPF doit être une valeur numérique',
        deuxcentNumeric: 'Le nombre de pièces de 200 XPF doit être une valeur numérique',
        centNumeric: 'Le nombre de pièces de 100 XPF doit être une valeur numérique',
        cinquanteNumeric: 'Le nombre de pièces de 50 XPF doit être une valeur numérique',
        vingtNumeric: 'Le nombre de pièces de 20 XPF doit être une valeur numérique',
        dixNumeric: 'Le nombre de pièces de 10 XPF doit être une valeur numérique',
        cinqNumeric: 'Le nombre de pièces de 5 XPF doit être une valeur numérique',
        deuxNumeric: 'Le nombre de pièces de 2 XPF doit être une valeur numérique',
        unNumeric: 'Le nombre de pièces de 1 XPF doit être une valeur numérique',
        caNumeric: 'Le CA HT doit être une valeur numérique',
        cattcNumeric: 'Le CA TTC doit être une valeur numérique',
        pmNumeric: 'Le PM HT doit être une valeur numérique',
        pmttcNumeric: 'Le PM TTC doit être une valeur numérique',
        tfNumeric: 'Le TF doit être une valeur numérique',
        ivNumeric: 'Le IV doit être une valeur numérique',
        capitalNumeric:'Le capital doit être une valeur numérique',
        exerciceStartNumeric:'Le début de l\'exercice doit être une valeur numérique',
        entreNumeric: 'Le nombre de passages clients (entrée et sortie) doit être une valeur numérique',
        codeBanqueNumeric: 'Le champ "Code Banque" doit être une valeur numérique',
        codeGuichetNumeric: 'Le champ "Code Guichet" doit être une valeur numérique',
        numeroCompteNumeric: 'Le champ "Numéro de Compte" doit être une valeur numérique',
        cleRibNumeric: "Le champ \"Clé Rib\" doit être une valeur numérique",
        priceNumeric: 'Le prix doit être une valeur numérique',
        promoPriceNumeric: 'Le prix promotionnel doit être une valeur numérique',
        prmpNumeric: 'Le PRMP doit être une valeur numérique',
        prNumeric: 'Le prix de revient doit être une valeur numérique',
        lastBuyPriceNumeric: 'Le dernier prix d\'achat doit être une valeur numérique',
        lastBuyePriceDeviseNumeric: 'Le dernier prix d\'achat en devise doit être une valeur numérique',
        tgcNumeric: 'Le taux de TGC doit être une valeur numérique',
        invalidTauxTgc: 'Taux de TGC invalide',
        invalidTauxTva: 'Taux de TVA invalide',
        buyPriceNumeric: 'Le prix d\'achat doit être une valeur numérique',
        indicePrmpNumeric: 'L\'indice PRMP doit être une valeur numérique',
        indicePrNumeric: 'L\'indice prix de revient doit être une valeur numérique',
        internalIdNumeric: 'L\'internal Id doit être une valeur numérique',
        componentInternalIdNumeric: 'L\'internal Id du composent doit être une valeur numérique',
        expectedInternalIdNumeric: 'L\'internal Id souhaité doit être une valeur numérique',
        referenceNumeric: 'Le code UPC doit être une valeur numérique',
        quotaNumeric: 'La quantité doit être une valeur numérique',
        quotaCommandeNumeric: 'La quantité doit être une valeur numérique',
        shdeQuotaPrevuNumeric: 'La quantité prévue doit être une valeur numérique',
        firstStartBinsNumeric: 'Le début du premier niveau doit être une valeur numérique',
        firstEndBinsNumeric: 'La fin du premier niveau doit être une valeur numérique',
        secondStartBinsNumeric: 'Le début du second niveau doit être une valeur numérique',
        secondEndBinsNumeric: 'La fin du second niveau doit être une valeur numérique',
        thirdStartBinsNumeric: 'Le début du troisième niveau doit être une valeur numérique',
        thirdEndBinsNumeric: 'La fin du troisième niveau doit être une valeur numérique',
        fourthStartBinsNumeric: 'Le début du quatrième niveau doit être une valeur numérique',
        fourthEndBinsNumeric: "La fin du quatrième niveau doit être une valeur numérique",
        fifthStartBinsNumeric: 'Le début du cinquième niveau doit être une valeur numérique',
        fifthEndBinsNumeric: 'La fin du cinquième niveau doit être une valeur numérique',
        firstBinsNumeric: 'Le premier niveau doit être une valeur numérique',
        secondBinsNumeric: 'Le second niveau doit être une valeur numérique',
        thirdBinsNumeric: 'Le troisième niveau doit être une valeur numérique',
        fourthBinsNumeric: 'Le quatrième niveau doit être une valeur numérique',
        fifthBinsNumeric: 'Le cinquième niveau doit être une valeur numérique',
        rpIsNumeric:'Le niveau de stock minimum RP de {name} doit être une valeur numérique',
        pslIsNumeric:'Le niveau de stock optimal PSL de {name} doit être une valeur numérique',
        quantiteNumeric:'La quantité doit être une valeur numérique',
        rpNumeric:"Le niveau de stock minimum doit être une valeur numérique",
        pslNumeric:"Le niveau de stock optimal doit être une valeur numérique",
        toMaxNumeric:'Le nombre maximum d\'instructions pour un ordre de transfert doit être une valeur numérique',
        giftCardNumeric:'La durée de validité d\'un dépôt sur une carte cadeau doit être une valeur numérique',
        giftCardMontantNumeric: 'Le montant de la carte cadeau doit être une valeur numérique',
        paiementNumeric: 'Les indications de paiement doivent être des valeurs numériques',
        modifManualValueNumeric: 'La valeur doit être numérique',
        detailModePaiementNumeric: 'Toutes les valeurs doivent être numériques',
        maxArticleInventaire:'Votre inventaire ne peut pas contenir plus de 500 références',
        maxZoneInventaire:'Votre inventaire ne peut pas contenir plus de 500 zones d\'inventaires',
        prefixNumeric:'Le prefix doit être une valeur numérique',
        weightNumeric:'Le volume doit être une valeur numérique',
        minimumCommandeNumeric:'Le minimum commande doit être une valeur numérique',
        pourcentageRefacturationNumeric:'La commission en pourcentage doit être une valeur numérique',
        valueNumeric:'La valeur doit être une valeur numérique',
        // Integer
        creditInteger:'Crédit doit être un entier',
        abonnementInteger:'Abonnement doit être un entier',
        nbrCelluleInteger:'Le nombre de cellules doit être un entier',
        //Boolean
        noNoteForArticleRetour:'Vous devez indiquer une note sur les articles retournés',
        donneeclientBoolean: 'Une erreur inattendue s\'est produite',
        objectifvendeurBoolean: 'Une erreur inattendue s\'est produite',
        objectifcommerceBoolean: 'Une erreur inattendue s\'est produite',
        replaceBoolean:'Une erreur inattendue s\'est produite',
        articleListBoolean:'Une erreur inattendue s\'est produite',
        lockLineIsBoolean:'Une erreur inattendue s\'est produite',
        //General
        unknowError: 'Une erreur inattendue s\'est produite',
        /*********Assistant IA***********/
        chatbotIaTitle: 'Assistant IA',
        chatbotIaOpen: 'Ouvrir l\'assistant IA',
        chatbotIaClose: 'Fermer',
        chatbotIaExpand: 'Agrandir',
        chatbotIaReduce: 'Réduire',
        chatbotIaNewChat: 'Nouvelle conversation',
        chatbotIaPlaceholder: 'Posez votre question...',
        chatbotIaSend: 'Envoyer',
        chatbotIaMicStart: 'Dicter votre message',
        chatbotIaMicStop: 'Arrêter la dictée',
        chatbotIaMicDenied: "L'accès au micro est bloqué. Autorisez-le dans les réglages du navigateur (et, sur iPhone, activez la dictée dans Réglages > Général > Clavier).",
        chatbotIaMicError: 'La dictée vocale est indisponible pour le moment.',
        chatbotIaAttach: 'Joindre un document (PDF ou image)',
        chatbotIaAttachRemove: 'Retirer cette pièce jointe',
        chatbotIaFileDefaultText: 'Voici un document.',
        chatbotIaFileTooMany: '5 documents au plus par conversation. Démarrez une nouvelle conversation pour en joindre d\'autres.',
        chatbotIaFileTooLarge: 'Ce document est trop volumineux (5 Mo au plus).',
        chatbotIaFileInvalid: "Ce document n'a pas pu être lu.",
        chatbotIaFileUnsupported: 'Format non pris en charge : PDF, JPEG, PNG, GIF ou WebP uniquement.',
        chatbotIaFilePdfTooLong: 'Ce PDF compte trop de pages (100 au plus).',
        chatbotIaFileDownload: 'Télécharger',
        chatbotIaFileLines: "{nb} article(s), à relire avant l'import",
        chatbotIaMemory: "Mémoire de l'assistant",
        chatbotIaMemoryHint: "Pour ajouter une consigne, dis par exemple « souviens-toi que... » dans le chat. Ces consignes ne valent que pour toi.",
        chatbotIaMemoryEmpty: 'Aucune consigne mémorisée pour le moment.',
        chatbotIaMemoryCount: '{nb} / {max} consignes',
        chatbotIaMemoryDelete: 'Oublier cette consigne',
        chatbotIaMemoryBack: 'Revenir à la conversation',
        chatbotIaMemorySaved: 'Consigne mémorisée',
        chatbotIaMemoryReplaced: 'Consigne remplacée',
        chatbotIaMemoryForgotten: 'Consigne oubliée',
        chatbotIaRecording: 'Enregistrement en cours...',
        chatbotIaSpeakOn: 'Lire les réponses à voix haute',
        chatbotIaSpeakOff: 'Ne plus lire les réponses à voix haute',
        chatbotIaSpeakStop: 'Arrêter la lecture',
        chatbotIaWelcome: "Bonjour, comment puis-je t'aider ?",
        chatbotIaUsage: 'Consommation du mois',
        chatbotIaConfirm: 'Confirmer',
        chatbotIaCancel: 'Annuler',
        chatbotIaCancelled: 'Action annulée',
        chatbotIaNotAllowed: "Vous n'êtes pas autorisé à utiliser l'assistant IA. Contactez votre administrateur.",
        chatbotIaBusy: "L'assistant est très sollicité, réessaie dans un instant.",
        chatbotIaUnavailable: "L'assistant est indisponible pour le moment.",
        chatbotIaNoAnswer: "Je n'ai pas pu répondre à cette question. Peux-tu la reformuler ?",
        chatbotIaNoPack: "L'assistant IA n'est pas disponible : aucun pack IA n'est actif pour votre société.",
        chatbotIaQuotaGlobal: "Le quota IA de votre société est atteint pour ce mois.",
        chatbotIaQuotaUser: "Votre quota IA personnel est atteint pour ce mois. Contactez votre administrateur.",
        chatbotIaUsagePersonal: "Votre consommation",
        chatbotIaUsagePackEnd: "Fin du pack",
        chatbotIaUnlockLabel: "Débloquer un dépassement pour ce mois",
        chatbotIaUnlockButton: "Débloquer",
        chatbotIaUnlocked: "Dépassement débloqué. Vous pouvez reposer votre question.",
        chatbotIaAmountInvalid: "Montant invalide.",
        chatbotIaQuotaPercentInvalid: "Le pourcentage doit être compris entre 0 et 100.",
        chatbotIaQuotaTab: "Consommation IA",
        chatbotIaQuotaMonth: "Mois",
        chatbotIaQuotaPack: "Pack mensuel",
        chatbotIaQuotaCompanyUsage: "Consommation de la société",
        chatbotIaQuotaCap: "Plafond de dépassement mensuel",
        chatbotIaQuotaCapHelp: "En plus du pack, reconduit chaque mois. Vide = aucun dépassement automatique.",
        chatbotIaQuotaUnlocked: "Débloqué ce mois",
        chatbotIaQuotaOverageUsed: "Dépassement consommé",
        chatbotIaQuotaLimit: "Limite (% du total autorisé)",
        chatbotIaQuotaNoLimit: "Sans limite",
        chatbotIaQuotaShare: "Part de la consommation autorisée",
        chatbotIaQuotaOwnProgress: "Avancement sur sa limite",
        chatbotIaQuotaAccess: "Accès à l'assistant IA",
        chatbotIaQuotaAccessHelp: "Décoché : l'utilisateur ne voit plus l'assistant, à son prochain chargement de l'application.",
        chatbotIaQuotaLimitHelp: "Une limite est un plafond, pas une réservation : la somme peut dépasser 100 %. Vide = sans limite.",
        chatbotIaConversationTooLong: 'La conversation est trop longue, commence-en une nouvelle.',
        chatbotIaMessageTooLong: 'Ton message est trop long.',
        chatbotIaPageRead: 'Page consultée',
        chatbotIaHighlighted: 'Élément entouré sur la page',
        chatbotIaChartReopen: 'Rouvrir le graphique',
        chatbotIaChartView: 'Graphique',
        chatbotIaChartRendering: 'Rendu',
        chatbotIaChartLabels: 'Étiquettes',
        chatbotIaChartLabelsNone: 'Aucune',
        chatbotIaChartLabelsPercent: 'Pourcentage',
        chatbotIaChartReset: 'Réinitialiser',
        chatbotIaChartPieOnePeriod: 'Un camembert représente une seule période',
        chatbotIaChartTypeBar: 'Histogramme groupé',
        chatbotIaChartTypeBarEmpile: 'Histogramme empilé',
        chatbotIaChartTypeBarHorizontal: 'Barres horizontales',
        chatbotIaChartTypeLine: 'Courbes',
        chatbotIaChartTypeArea: 'Aires',
        chatbotIaChartTypeAreaEmpile: 'Aires empilées',
        chatbotIaChartTypeCamembert: 'Camembert',
        chatbotIaSearchProposed: 'Je propose une recherche sur internet :',
        chatbotIaSearchAllow: 'Autoriser la recherche',
        chatbotIaSearchRefuse: 'Refuser',
        chatbotIaSearchAllowed: 'Recherche autorisée',
        chatbotIaSearchRefused: 'Recherche refusée',
        chatbotIaWriteProposed: "Je m'apprête à enregistrer cette modification :",
        chatbotIaWriteProposedMany: "Je m'apprête à enregistrer ces modifications sur {nb} articles :",
        chatbotIaWriteEmpty: '(vide)',
        chatbotIaWriteConfirmed: 'Modification enregistrée',
        chatbotIaWriteRefused: "La modification n'a pas pu être enregistrée :",
        chatbotIaWriteBulk: "Attention : d'après les règles de mise à jour de la société, cette valeur sera aussi appliquée aux autres articles ayant le même {critere}.",
        chatbotIaWriteBulkCount: "Attention : cette valeur sera aussi appliquée à {nb} articles ayant le même {critere}.",
        chatbotIaExportProposed: "Je m'apprête à lancer cet export CSV :",
        chatbotIaExportTotal: '{nb} article(s) concerné(s)',
        chatbotIaExportColumnsAll: 'toutes les colonnes que tu peux voir',
        chatbotIaExportColumnsSome: '{nb} colonne(s) sélectionnée(s)',
        chatbotIaExportApostrophe: 'avec une apostrophe au début de chaque cellule',
        chatbotIaFamilleProposedCreer: "Je m'apprête à créer ces valeurs de {niveau} :",
        chatbotIaFamilleProposedRenommer: "Je m'apprête à renommer cette valeur de {niveau} :",
        chatbotIaFamilleProposedArchiver: "Je m'apprête à archiver ces valeurs de {niveau} :",
        chatbotIaFamilleProposedDesarchiver: "Je m'apprête à réactiver ces valeurs de {niveau} :",
        chatbotIaFamilleConfirmed: 'Classifications mises à jour',
        chatbotIaOutdated: "Cette page utilise une version plus ancienne de l'assistant. Recharge la page (Ctrl+F5) puis pose à nouveau ta question.",
        chatbotIaSources: 'Sources',
        unknowKiosqueError: 'Une erreur inattendue s\'est produite, veuillez vous rapprocher d\'un responsable',
        identFailed: 'Les identifiants de connexion sont incorrects',
        //divers
        originArticleCannotBeTransformArticle: 'Un article transformé ne peut pas être transformé à partir d’un article déjà transformé',
        allKpiCompareMustBeSelected:'Vous devez selectionner une valeur pour les deux champs',
        noreplace_item_by_itself:'Vous ne pouvez pas remplacer un article par lui même',
        dlThePdf:'Télécharger le PDF',
        loyaltyPoints:'Points de fidélité',
        importLoyaltyPoints:'Importer des points de fidélité',
        pinrtStartPosition:'Débuter l\'impression d\'étiquette à la position',
        loadingTagsMsg:'Génération des étiquettes en cours, cette action peut prendre du temps...',
        generateAndDownLoad:'Générer et télécharger',
        margeTopPdf:'Marge en haut de page',
        margeBottomPdf:'Marge en pied de page',
        margeLeftPdf:'Marge à gauche de la page',
        margeRightPdf:'Marge à droite de la page',
        downloadListPdf:'Télécharger la liste en PDF',
        margeParDefautA4:'Marges par défaut A4',
        mustBeOneLineConverted:'Vous devez avoir au moins un article converti pour réaliser cette action',
        noReliquatInDocument:'Il n\'y a aucun reliquat dans ce document',
        importCustomer:'Importer des clients',
        cliendtId:'ID du client',
        createCustomer:'Créer un client',
        last_purchase_price:'Dernier prix d\'achat',
        last_purchase_price_devise:'Dernier prix d\'achat en devise',
        convertedIntoInvoice:'Converti en facture',
        addItemsMass:'Ajouter des articles en masse',
        massAssociateSupplementList:'Attribuer cette liste de suppléments à des articles',
        filterArticlesMode:'Filtrer des articles',
        existingArticleListMode:'Utiliser une liste d\'articles existante',
        existingArticleList:'Liste d\'articles',
        duplicateSupplementConfig:'Dupliquer cette configuration de suppléments',
        duplicateSupplementConfigBtn:'Dupliquer cette configuration sur d\'autres articles',
        importItemSupplementListAssign:'Importer des attributions de listes de suppléments',
        validateModif:'Valider les modifications',
        defaultQteItems:'Quantité d\'article par défaut',
        codeComptableGeneral:'Code comptable général',
        codeComptable:'Code comptable',
        libelleComptableGeneral:'Libellé comptable général',
        libelleAttribueAcompte:'Le libellé attribué lors de la configuration des codes des modes de paiement sera attribué aux modes de paiement ci-dessous',
        cantDuplicateAcompteOnSelectedType: "La correspondance ne peut pas être dupliquée pour le type indiqué",
        cantDuplicatePaiementOnDifferentType: "La correspondance des paiements ne peut pas se faire sur un type différent",
        unavailableConfigForDuplicate:'Il est impossible de dupliquer cette configuration',
        configType: "La configuration indiquée n’a pas le bon type",
        unvalidConfig: "Il y a une erreur dans la configuration",
        unavailableVentilation: "L’une des ventilations sélectionnée n’est pas applicable",
        acompteDebitMissing: "Il manque le code débit pour la configuration des acomptes",
        acompteCreditMissing: "Il manque le code crédit pour la configuration des acomptes",
        paiementModeMissingAcompte: "Il manque les codes de correspondance pour un ou plusieurs modes de paiement",
        selectBreakdownField:'Sélectionnez le champ de ventilation',
        codeJournalMissing:'Aucun code journal de configuré',
        emailAccountSend:'Compte email d\'envois',
        firstDateOfExport:'Première date d\'export',
        autoExportConfMsgDestinataire:'Ajoutez plusieurs destinataires en les séparant d\'un ";", appuyez sur la touche "Entrée" pour les ajouter',
        quotidien:'Quotidien',
        hebdomadaire:'Hebdomadaire',
        mensuel:'Mensuel',
        facturation_auto:'Facturation automatique',
        facturationFrequenceRequired:'Frequence facturation automatique obligatoire',
        facturation_frequence:'Frequence facturation automatique',
        interface_goot:'Interfaçage GOOT',
        interfaceGootUndefined:'Non défini (selon le type de client)',
        facturationMensuelle:'Facturation mensuelle',
        facturationBL:'Facturation bons de livraison',
        noBlToBilling:'Aucun bon de livraison à facturer',
        infosConversionBcBl:'Seuls les articles collectés peuvent être convertis en bon de livraison. Les articles non collectés ne sont donc pas présents dans cette liste.',
        convertThePurchaseOrder:'Conversion du bon de commande',
        convertTheQuotation:'Conversion du devis',
        convertTheCreditNote:'Conversion de l\'avoir',
        convertTheInvoice:'Conversion de la facture',
        inBl:'en bon de livraison',
        inPo:'en bon de commande',
        inRn:'en bon de retour',
        inCn:'en avoir',
        returnToPurachaseOrder:'Retourner au bon de commande',
        returnToQuotation:'Retourner au devis',
         returnToCreditNote:'Retour à l\'avoir',
        returnToInvoice:'Retourner à la facture',
        autoFacturationMensuelle:'Facturation automatique',
        autoFacturationMensuelleFrequency:'Fréquence facturation automatique',
        allDeliveryNote:'Tous les bons de livraisons',
        autoExportConf:'Configuration des exports automatiques',
        total_remise_ht: 'Total de la remise HT',
        ht_remise: 'Montant de la remise HT',
        supplierInvoiceRef:'Référence de la facture fournisseur',
        franchise_en_base:'Franchise en base',
        byItem:'Par article',
        exportConfRequiredVentilation:'Une configuration du fichier d\'export est nécessaire pour pouvoir ventiler par article',
        selectConf:'Sélectionner la ou les configuration(s)',
        duplicateBreakdown:'Dupliquer la ventilation',
        AddNewBreakdownLine:'Ajouter une nouvelle ligne de ventilation',    
        exportHeaderOnFlatFile:'Exporter les entêtes sur les fichiers plats',
        ventilationItem:'Ventilation par article',
        breakdownTgcByItem:'Ventilation par article de la {taxe}',
        correspondanceMissing: 'Aucune configuration de code existante',
        configMissing: "Une erreur existe sur la configuration du votre fichier d'export",
        codeClientConfigMissing : 'Aucune configuration de code client existante',
        paiementModeMissing : "Une erreur existe sur la configuration du fichier d'export des modes de paiement",
        taxeMissing : "Une erreur existe sur la configuration du fichier d'export des taxes",
        caisseIdentMissing : "Une erreur existe sur la configuration du fichier d'export des caisses",
        commerceMissing : "Une erreur existe sur la configuration du fichier d'export des commerces",
        codeFournisseurConfigMissing : 'Aucune configuration de code fournisseur existante',
        cantDuplicatePaiementOnDifferentType : 'Il est impossible de dupliquer ces modes de paiements',
        duplicateComptaConfig:'Dupliquer une configuration',
        duplicateExistingComptaConfig:'Dupliquer une configuration existante',
        duplicateComptaConfigFrom:'Dupliquer une configuration depuis',
        receiptRef:'Référence du ticket',
        paymentNumber:'Code comptable du paiement',
        paymentWording:'Libellé du paiement',
        taxeWording:'Libellé de {taxe}',
        taxeNumber:'Code comptable de {taxe}',
        acompteWording:'Libellé d\'acompte',
        acompteNumber:'Code comptable d\'acompte',
        shopTel:'Numéro de téléphone du commerce',
        shopEmail:'E-mail du commerce',
        shopHoraire:'Horaire du commerce',
        shopType:'Type du commerce',
        shopItemPrice:'Prix des articles en commerce',
        shopEcomType:'Type du e-commerce',
        shopAccountingCode:'Code comptable du commerce',
        customerAccountingCode:'Code comptable client',
        providerAccountingCode:'Code comptable fournisseur',
        custmomerIcrementNum:'Numéro d\'incrémentation du client',
        providerIncrementNum:'Numéro d\'incrémentation du fournisseur',
        oldAccountingClientCode:'Ancien code comptable client',
        oldAccountingProviderCode:'Ancien code comptable fournisseur',
        customerTel:'Numéro de téléphone du client',
        customerEmail:'E-mail du client',
        customerType:'Type de client',
        customerName:'Nom du client',
        customerFirstName:'Prénom du client',
        cashRegisterAccountingCode:'Code comptable caisse',
        cashRegisterCode:'Code caisse',
        ticketDate:'Date du ticket',
        receiptType:'Type de ticket',
        selectionOfTheDataTypeToAssociate:'Sélection du type de donnée à associer',
        exports:'Exports',
        exportConfigurationB2b:'Exports comptable des ventes B2B',
        exportConfigurationB2c:'Exports comptable des ventes B2C',
        exportConfigurationPurchase:'Exports comptable des achats',
        purchase:'Achat',
        b2cSale:'Vente B2C',
        b2bSale:'Vente B2B',
        configurationTypeSelection:'Sélection du type de configuration',
        noExistingShopForThisCompany:'Aucun commerce existant pour cette entreprise',
        noExistingCashRegisterForThisCompany:'Aucune caisse existante pour cette entreprise',
        receipts:'Recette',
        wording:'Libellé',
        accountingCodeConfiguration:'Configuration des codes comptable',
        accountingFileConfiguration:'Configuration des fichiers comptable',
        salesJournalCode:'Code du journal des ventes',
        salesJournalConfigurationB2c:'Configuration du journal des ventes B2C',
        salesJournalConfigurationB2b:'Configuration du journal des ventes B2B',
        flatFile:'Fichier plat',
        csvFile:'Fichier CSV',
        purchasesExport:'Export des achats',
        noExistingExportConfiguration:'Aucune configuration d\'export existante',
        selectCompany:'Sélectionner une entreprise',
        exportTiersClient:'Export des tiers client',
        exportTiersFournisseur:'Export des tiers fournisseur',
        exportTiersClientFournisseur:'Export des tiers client/fournisseur',
        addColumn:'Ajouter une colonne',
        exportHeader:'En-tête d\'export',
        associatedData:'Donnée associée',
        defaultValue:'Valeur par défaut',
        correspondenceField:'Champ de correspondance',
        numberOfDigitsToIncrement:'Longueur de la section d\'incrémentation',
        numberOfSection:'Nombre de section',
        codeFournisseur:'Code fournisseur',
        codeClient:'Code client',
        codeClientDefault:'Code client par défaut',
        codeFournisseurDefault:'Code fournisseur par défaut',
        codeConfigurationFournisseur:'Configuration des codes fournisseur',
        codeConfigurationClient:'Configuration des codes client',
        codeConfigurationModePay:'Configuration des codes des modes de paiements',
        codeConfigurationDeposit:'Configuration des codes d\'acompte',
        codeConfigurationTaxe:'Configuration des codes de {taxe}',
        codeConfigurationTaxeArticles:'Configuration des codes de {taxe} par article',
        codeConfigurationShop:'Configuration des codes commerce',
        codeConfigurationCaisse:'Configuration des codes caisse',
        codeConfigurationJournal:'Configuration des codes journal',
        exportConfigurationClient:'Exports comptable client',
        exportConfigurationFournisseur:'Exports comptable fournisseur',
        syncInProgres:'Synchronisation des articles en cours...',
        synchronizeItemsList:'Synchroniser la liste d\'article',
        additionToList:'Ajout à la liste',
        replacementOfTheList:'Remplacement de la liste',
        dynamicFilter:'Filtre dynamique',
        existingDynamicFilter:'Filtre dynamique existant',
        dynamicUpdateByFilter:'Mise à jour des articles par filtrage dynamique',
        actionOnDynamicFilter:'Action sur les articles concernés par le filtrage dynamique',
        itemsWillReplaceItemPromo:'Les articles concernés par la sélection de filtre remplaceront ceux de la promotion',
        firstValue:'Première valeur',
        secondValue:'Deuxième valeur',
        thirdValue:'Troisième valeur',
        numeroTgc:'Numéro de {taxe}',
        siren:'SIREN',
        siret:'SIRET',
        labelAssujettiTva:'Assujetti à la TVA',
        notSpecified:'Non renseigné',
        sirenInvalid:'Le SIREN doit comporter 9 chiffres valides',
        siretInvalid:'Le SIRET doit comporter 14 chiffres valides',
        siretSirenMismatch:'Le SIRET ne correspond pas au SIREN',
        sirenRequired:'Le SIREN est obligatoire',
        siretRequired:'Le SIRET est obligatoire',
        assujettiTvaRequired:'Vous devez indiquer l\'assujettissement à la TVA',
        paysLegacyValue:'Valeur actuelle non reconnue : « {pays} ». Sélectionnez un pays dans la liste.',
        factureNoPaymentM:'Aucun {documentType} disponible pour ce client',
        factureNoPaymentF:'Aucune {documentType} disponible pour ce fournisseur',
        column:'Colonne',
        noPaymentModeAvailable:'Aucun mode de paiement de disponible',
        availableStock:'Stock disponible',
        unavailableStock:'Stock non disponible',
        totalStock:'Stock total',
        usedOnDoc:'Utilisé sur le(s) document(s) suivant(s)',
        amountLeft:'Montant restant',
        used:'Utilisé',
        unUsed:'Non utilisé',
        partiallyUsed:'Partiellement utilisé',
        unUsedF:'Non utilisée',
        surDocument:'Sur document',
        tousDocTitle:'Tous les {documentType}',
        toutesDocTitle:'Toutes les {documentType}',
        tgcDefault:'{taxe} par défaut pour création d\'article',
        sectionArticleListDefault:'Commerce par défaut pour liste d\'article',
        zoneArticleListDefault:'Zone par défaut pour liste d\'article',
        defaultReservationTime:'Durée de réservation par défaut',
        minutes:'minutes',
        kpiFilterDefault:'Filtre de KPI par défaut',
        kpiFilterDefaultCompare:'Comparaison de filtre par defaut',
        generateUpc:'Génération code UPC',
        itemsTransform:'Articles transformés',
        editItemsTransform:'Edition article transformé',
        notItemTransform:'Cet article n\'est pas un article transformé',
        convertToItemTransform:'Convertir en article transformé',
        prefix:'Renseigner le prefix',
        replace:'Remplacer les codes barres existants',
        article_list:'Générer une liste d\'articles',
        article_list_name:'Renseigner un nom pour la liste d\'article',
        generateUpcStart:'Lancement de la génération des codes barres',
        generateUpcSuccess:'Les codes barres ont été générés',
        generateUpcSuccessList:'Les codes barres et la liste d\'article ont été générés',
        generateUpcInProgress:'Génération des codes barres en cours. Cette tâche peut prendre quelques minutes, ne quittez pas la page...',
        prefixConfigError:'Les codes barres n\'ont pas pu être générés, veuillez contrôler la configuration du prefix',
        errorInvoicingRecordsMsg:'Il existe des erreurs sur les tickets suivant',
        reviewOfAccountingRecords:'Contrôle des écritures comptables',
        allAccountingEntriesAreCorrect:'Toutes les écritures comptables sont correctes',
        refundOnEspecePay:'Effectuer un remboursement en espèce',
        refundOnOtherPay:'Effectuer un remboursement autre',
        selectedRows:'Lignes sélectionnées',
        noDiscounts:'Prix normal',
        confirmArticleEdition:'Etes vous sûr de vouloir editer le champ {articleField}',
        editConfirmation:'Confirmation d\'édition',
        refundMode:'Mode de remboursement',
        errorMsgTotalPay:'Le montant total des paiements ne correspond pas au total du panier',
        cartTotal:'Total du panier',
        deleteAnItemsList:'Supprimer une liste d\'articles',
        createdFromItemsList:'Créé à partir de la liste d\'articles',
        noExistingCurrency:'Aucune monnaie existante',
        addACurrency:'Ajouter une monnaie',
        roundNumberValue:'Valeur du montant de l\'arrondi',
        roundNumberMsg:'Laissez ce champ vide si vous ne gérez pas d\'arrondi',
        currency:'Monnaie',
        addARateOf:'Ajouter un taux de {taxe}',
        tvaPo:'Taux de {taxe} fournisseur',
        infoOnItemLine: 'Informations sur la ligne d\'article',
        organizeInAlphabeticalOrder:'Organiser par ordre alphabétique',
        organizeByFolderNumberCroissant:'Organiser par numéro de dossier (ordre croissant)',
        organizeByFolderNumberDecroissant:'Organiser par numéro de dossier (ordre décroissant)',
        nextFolder:'Dossier suivant',
        previousFolder:'Dossier précédent',
        ascending:'Croissant',
        descending:'Décroissant',
        sortAndGroup:'Tri et regroupement',
        dragAndDropItemsOrder: "Glissez-déposez les articles dans l'ordre souhaité.",
        reorderSortGroupPriority: "Un tri et/ou un regroupement est configuré sur ce document : il reste prioritaire, l'ordre manuel ne s'applique qu'entre les articles qu'il laisse à égalité.",
        editManualEntry: 'Modifier la saisie manuelle',
        prmpLine: 'PRMP ligne',
        receptionSuccess:'Réception finalisée avec succès',
        collectionSuccess:'Collecte finalisée avec succès',
        confirmCollectAll:'Etes vous sûr de vouloir collecter tous les articles ?',
        confirmReceiveAll:'Etes vous sûr de vouloir réceptionner tous les articles ?',
        urlFichierCommande:'URL du fichier des commandes',
        urlApi:'URL API',
        commerceRetraitStock:'Commerce de retrait du stock',
        startDateOrderProcessing:'Début du traitement des commandes sur l\'application',
        uncertainty:'Incertitude',
        code_barre:'Code UPC',
        sku_vendeur:'SKU',
        famille:'Famille',
        sous_famille:'Sous-famille',
        sous_sous_famille:'Sous-sous-famille',
        images:'Images',
        longueur:'Longueur',
        largeur:'Largeur',
        hauteur:'Hauteur',
        weight:'Poids',
        weight_unit:'Unité de poids',
        short_description:'Description courte',
        actionOnOtherModePay:'Action réalisée si le montant du panier est inférieur au montant du mode de paiement',
        item_price_zero:'Ajout d\'un article',
        historicalExportSales:'Historique des exports de vente',
        thirdPartyExport:'Export des tiers',
        saleExport:'Export des ventes',
        accounting:'Comptabilité',
        paymentInterface:'Interface de paiement',
        default:'Défaut',
        checkoutInterface:'Interface de caisse',
        lastCloseCaisse:'Dernière clôture de caisse',
        errorDeclarationEsp: 'Erreur de déclaration sur la ligne {monnaie}, le nombre maximum est {maxNbr}',
        filter:'Filtrer',
        itemsWillBe:'Les articles seront',
        includedToPromo:'Inclus à la promotion',
        includedToPercentageException:'Inclus à l\'exception de pourcentage',
        includedToPersonalizedPrice:'Inclus dans le prix personnalisé',
        excludedToPromo:'Exclus de la promotion',
        excludedToPercentageException:'Exclus de l\'exception de pourcentage',
        excludedToPersonalizedPrice:'Exclus du prix personnalisé',
        excludeItemToPromo:'Exclure les articles de la promotion',
        excludeItemToKpi:'Exclure les articles du filtre de KPI',
        includedToFidelite:'Inclus au plan de fidélité',
        excludedToFidelite:'Exclus du plan de fidélité',
        confFondCaisseMsg:'Si aucun fond de caisse est configuré, celui renseigné à la clôture de caisse sera utilisé par défaut',
        autoDistributionCashFund:'Répartition automatique du fond de caisse',
        automaticReminderPayment:'Création automatique d\'une relance de paiement après xx jour(s)',
        defaultRefacturationPercentage:'Commission refacturation en pourcentage',
        defaultRefacturationCategorieTarif:'Catégorie tarifaire de refacturation',
        defaultRefacturationCategorieTarifHelp:'Nom de la catégorie tarifaire (ArticlePrice) utilisée lors d\'une refacturation par cette société. Si renseigné, ce champ prend le pas sur les exceptions par article et sur le pourcentage de refacturation. Si non trouvé, article.price_b2b est utilisé, sinon 0.',
        defaultRefacturationDate:'Première date de prise en compte de la refacturation',
        defaultShopStock:'Stock par défaut',
        associatedClientFournisseur:'Client et fournisseur associé à l\'entreprise pour la refacturation',
        facturationCompteMail:'Compte mail par défaut pour les mails automatique de la facturation',
        clientAlreadyUsed:'Client déjà utilisé',
        fournisseurAlreadyUsed:'Fournisseur déjà utilisé',
        selectionOfCustomers:'Sélection des clients',
        selectionOfClientType:'Sélection du type de client',
        extraCustomFieldsExposed:'Champs libres supplémentaires exposés',
        noArticleCustomFieldConfigured:'Aucun champ libre article configuré',
        unknownCustomField:'Champ personnalisé inconnu',
        itemsFromWillBeExcluded:'Les articles de votre sélection seront exclus de la promotion',
        itemsFromPercentageExceptionWillBeExcluded:'Les articles de votre sélection seront exclus de l\'exception de pourcentage',
        itemsFromPersonalizedPriceWillBeExcluded:'Les articles de votre sélection seront exclus du prix personnalisé',
        itemsFromFideliteWillBeExcluded:'Les articles de votre sélection seront exclus du plan de fidélité',
        keepAfterCopnversion:'Conserver après conversion',
        cashPayment:'Paiement comptant',
        days7Payment:'7 jours',
        days15Payment:'15 jours',
        days30PaymentFixed:'30 jours',
        days30Payment:'30 jours fin de mois',
        days45Payment:'45 jours fin de mois',
        days60Payment:'60 jours fin de mois',
        days90Payment:'90 jours fin de mois',
        nbTickets:'Nombre de tickets',
        nbFactures:'Nombre de factures',
        unassigned:'Non affecté',
        passages:'Passages',
        bestTicket:'Meilleur ticket',
        apostropheBeginningCell:'Apostrophe en début de cellule',
        compare_date:'Comparer la date plutôt que le jour',
        justificatif:'Télécharger le justificatif',
        documentSaved:'Documents sauvegardés',
        confirmReinstateItemsInStock:"Êtes-vous sûr de vouloir réintégrer les articles à votre stock",
        confirmCollectItem:"Êtes-vous sûr de vouloir collecter les articles non collectés",
        confirmRemoveItemsFromStock:"Êtes-vous sûr de vouloir sortir les articles de votre stock",
        removeItemFromStock:'Sortir les articles du stock',
        collectAllItem:'Collecter l\'ensemble des articles non collectés depuis',
        warninStockMsgFacture:"Tout ou partie des articles de cette facture ne sont pas présents dans un bon de livraison. Renseignez le formulaire ci-dessous pour effectuer la sortie de stock des articles concernés",
        dupliquer:'Dupliquer ce document',
        noteRequiredMsg:'Une note est requise',
        noteRequiredReturnItem:"Note obligatoire sur les articles retournés",
        returnItems:'Faire des retours d\'article',
        wmsAuthentication:"Authentification WMS",
        wmsAuthRequired:"Requise",
        wmsAuthRequiredRequired:'Le champ "authentification WMS requise" est obligatoire',
        wmsAuthRequiredBoolean:'Le champ "authentification WMS requise" doit être vrai ou faux',
        binsCollectOrder:"Sens de tri des BINS",
        binsCollectOrderAsc:"Croissant",
        binsCollectOrderDesc:"Décroissant",
        binsCollectOrderRequired:'Le champ "sens de tri des BINS" est obligatoire',
        binsCollectOrderIn:'Le champ "sens de tri des BINS" doit être "asc" ou "desc"',
        displayOtherSectionsTo:"Ordres de transfert des autres commerces",
        displayOtherSectionsToLabel:"Afficher les ordres de transfert en cours des autres commerces sur le WMS",
        displayOtherSectionsToRequired:'Le champ "afficher les ordres de transfert des autres commerces" est obligatoire',
        displayOtherSectionsToBoolean:'Le champ "afficher les ordres de transfert des autres commerces" doit être vrai ou faux',
        dontApplyDiscountedItem:'Ne pas appliquer sur les articles remisés',
        totalPriceEdition:'Edition du prix total',
        selectTheTransferArea:'Choisir la zone de transfert',
        noPrice:'Aucun prix configuré pour cet article',
        zoneAlreadyHaveCommandeB2b:"Une zone de commande B2B existe déjà",
        noZoneCommandeB2b:"Aucune zone de commande B2B n'existe",
        factureAlreadyReceptione:"Ce document à déjà été réceptionné",
        factureArticleAlreadyReceptione:"Cet article à déjà été réceptionné sur ce document",
        itemAdditionFrom:'Ajout d\'articles depuis',
        signHere:'Signer ici',
        leaveBox:'Sortir du carton',
        noDeliveryNote:'Aucun bons de livraison',
        confirmFianlizeDeliveryNote:'Voulez-vous vraiment finaliser ce bon de livraison',
        voucherInProgress:'Bons en cours',
        nbItemsCantBeHigherThanOrdered:'La quantité d\'articles scannées ne peut pas être supérieure à la quantité commandée',
        itemNotInOrderedList:'Cet article n\'est pas présent dans la liste des articles commandés',
        addItemsInDeliveryNote:'Ajout d\'article au bon de livraison',
        selectionPoWms:'Sélection des bons de commande',
        delivery:'Livraison',
        createDeliveryVoucher:'Créer un bon',
        validationDelivery:'Livraison des bons',
        returnNotes:'Bons de retour',
        shipmentVouchers:'Bons d\'expédition',
        poB2bWms:'Commandes client B2B',
        poB2cWms:'Commandes client B2C',
        createListItem:'Créer une liste d\'articles',
        customizeTag:'Personnaliser l\'étiquette',
        generatedByPurchaseOrder:'Généré par le bon de commande',
        gestionReliquats:'Gestion des reliquats',
        reliquat:'Reliquat',
        convertedValue:'Valeur convertie',
        reliquatValue:'Valeur du reliquat',
        billingInvoireGeneratedMsg:'Une facture d\'achat a été générée par ce bon de commande',
        selectAPrinter:'Sélectionner une imprimante',
        printerNameRegistered:'Nom de l\'imprimante enregistrée dans Windows',
        image_file:'Fichier image (Windows)',
        defaultCustomer:'Client par défaut',
        default_conditionnement:'Conditionnement par défaut',
        lessThanMOQ:'Un ou plusieurs articles ne respectent pas la quantité minimum de commande. Voulez-vous continuer ?',
        deletePersonalizedPrice:'Voulez-vous supprimer le prix personnalisé sur la ligne ?',
        minimum_commande:'Minimum commande',
        priceEditableOnTheFly:'Prix éditable à la volée (PEV)',
        priceEditableOnTheFlyInfo:'Permet de rendre le prix modifiable via une fenêtre au moment de l\'ajout de l\'article au panier.',
        personalized_price:'Prix personnalisé',
        personalized_price_delete:'le prix personnalisé pour',
        personalized_price_percent:'Prix personnalisé remise pourcentage',
        personalized_price_franche:'Prix personnalisé remise franche',
        personalized_price_prixfixe:'Prix personnalisé prix fixe',
        permanent:'Permanent',
        noFolderLinked:'Aucun dossier lié',
        convertPoBillinBuyErr:'Ce bon de commande ne peut pas être converti car il contient plusieurs devises',
        convertIntoBillingBuy:'Convertir en facture d\'achat',
        dont:'Dont',
        last_pr:'Dernier prix de revient',
        last_date_buy:'Dernière date d\'achat',
        first_stock_entry_date:'Date de première entrée en stock',
        ecotaxe:'Eco-participation',
        quotaIsOverArticleQuantity:'La quantité indiquée est supérieure à la quantité attendue',
        qteToReceive:"Quantité à réceptionner",
        docCompletelyReceived:'Document entièrement réceptionné',
        noMoreItemReceive:'Il n\'y a plus d\'articles à réceptionner',
        noReturnNote:'Aucun bon de retour',
        receiptReturnNote:'Réception des bons de retour',
        returnNote:'Bon de retour',
        addToBoxMsg:'Voulez-vous intégrer la sélection à un carton ?',
        poB2b:'Bon de commande client',
        collectPoClient:'Collecte des bons de commande client',
        cancelFiltre:'Annuler le filtre',
        showOnlyLineToBeConverted:'Afficher uniquement les lignes à convertir',
        allItemsConverted:'Tous les articles ont été convertis',
        notemsToConvert:'Aucun article à convertir',
        cancelledDocu:'Document annulé',
        factureVerrouillee: 'Document verrouillé — lecture seule',
        factureVerrouilleeError: 'Ce document est verrouillé et ne peut plus être modifié. Veuillez recharger la page.',
        lockDocument: 'Verrouiller',
        unlockDocument: 'Déverrouiller',
        confirmLockDocument: 'Voulez-vous vraiment verrouiller ce document ? Il ne sera plus modifiable.',
        confirmUnlockDocument: 'Voulez-vous vraiment déverrouiller ce document ? Il redeviendra modifiable.',
        documentClosedAt:'Document finalisé le',
        confirmCancelpo:"Êtes-vous sûr de vouloir annuler ce bon de commande ?",
        cancelDocument:'Annuler {document}',
        quantityAlreadyPo:'Quantité déjà convertie',
        quantityToConvert:'Quantité à convertir',
        convertToPo:'Convertir en bon de commande',
        convertFolderPo:'Convertir les bons de commandes',
        convertFolderPoSwal:'Convertir tous les bons de commandes du dossier en bon de livraison ? Attention: seuls les articles collectés seront pris en compte.',
        convertToCreditNote:'Convertir en avoir',
        convertToCreditNoteBuy:'Convertir en avoir fournisseur',
        convertToDeliveryNote:'Convertir en bon de livraison',
        convertFolderDeliveryNote:'Convertir les bons de livraisons',
        convertFolderDeliveryNoteSwal:'Convertir tous les bons de livraisons du dossier en facture ?',
        deliveryNote:'Bon de livraison',
        validateDeliveryNote:'Valider la livraison',
        convertToReturnOrder:'Convertir en bon de retour',
        returned_in:'Article retourné dans le ticket',
        mustHave1Bouton:"La balise de bouton de téléchargement est obligatoire ([bouton]) et ne peut être présente qu'une seule fois",
        documentClosedFieldLocked:"Ce document est émis : son contenu imprimé ne peut plus être modifié (seuls la note interne, les alertes et les paiements restent modifiables)",
        pennylaneStatusTitle:"Transmission Pennylane",
        pennylaneSelectAllOnPage:"Tout sélectionner sur cette page",
        pennylaneBulkSend:"Transmettre à Pennylane",
        pennylaneBulkConfirm:"Transmettre {count} ticket(s) à Pennylane, avec le client déjà attaché à chacun ?",
        pennylaneTicketButton:"Facture Pennylane",
        pennylaneTicketTitle:"Facture Pennylane du ticket",
        pennylaneTicketCustomer:"Client facturé",
        pennylaneTicketCustomerLocked:"Le client déjà rattaché est une entreprise identifiée : il ne peut pas être remplacé.",
        pennylaneTicketNotTransmittable:"Ce ticket ne peut pas être transmis :",
        pennylaneTicketModeImportOnly:"La facture sera importée dans Pennylane pour la comptabilité, sans facturation électronique.",
        pennylaneTicketModeEInvoice:"La facture sera transmise en facture électronique.",
        pennylaneTicketModeDisabled:"La transmission des factures caisse est désactivée pour cet émetteur.",
        pennylaneTicketSend:"Envoyer à Pennylane",
        pennylaneTicketBlockedOutro:"Vous pouvez compléter la fiche client avant l'envoi, ou envoyer maintenant : la transmission restera en attente jusqu'à correction.",
        pennylaneTicketMixedNotSupported:"Ticket mêlant vente et retour (échange) : non transmissible",
        pennylaneTicketGiftCardLine:"Ticket contenant une carte cadeau : non transmissible",
        pennylaneTicketRefundOriginAmbiguous:"Remboursement portant sur plusieurs tickets : non transmissible",
        pennylaneTicketRefundOriginNotTransmitted:"Le ticket remboursé n'a pas été transmis à Pennylane",
        pennylaneTicketAlreadyRequested:"Une facture Pennylane a déjà été demandée pour ce ticket",
        pennylaneTicketClientLocked:"Ce ticket a été transmis à Pennylane : son client ne peut plus être modifié",
        pennylaneConnections:"Connexions Pennylane",
        pennylaneConnectionsHelp:"Une connexion par société émettrice. Le jeton API se génère dans Pennylane (compte administrateur) ; il n'est jamais réaffiché.",
        pennylaneIssuer:"Émetteur",
        pennylaneAccount:"Entreprise Pennylane",
        pennylaneEnvironment:"Environnement",
        pennylaneEnvironment_sandbox:"Bac à sable",
        pennylaneEnvironment_production:"Production",
        pennylaneOptions:"Options",
        pennylaneActiveFrom:"Depuis le",
        pennylaneState:"État",
        pennylaneB2b:"Factures du module facturation",
        pennylaneB2c:"Factures caisse",
        pennylaneConvert:"Facture électronique",
        pennylaneNotConnected:"Non connecté",
        pennylaneActive:"Active",
        pennylaneInactive:"Inactive",
        pennylaneConfigure:"Configurer",
        pennylaneDeactivate:"Désactiver",
        pennylaneDeactivateConfirm:"Désactiver la connexion Pennylane de",
        pennylaneConnectionOf:"Connexion Pennylane de",
        pennylaneToken:"Jeton API Pennylane",
        pennylaneTokenKeep:"Laisser vide pour conserver le jeton enregistré",
        pennylaneB2bHelp:"Transmettre les factures et avoirs du module facturation",
        pennylaneB2cHelp:"Transmettre les factures demandées en caisse",
        pennylaneConvertHelp:"Convertir en facture électronique (Factur-X) les factures éligibles",
        pennylaneActiveHelp:"Connexion active",
        pennylaneActiveFromHelp:"Transmettre les documents clôturés à partir du",
        pennylaneReplaceConnection:"Remplacer la connexion",
        pennylaneMissingScopes:"Connexion enregistrée, mais des autorisations manquent sur le jeton",
        pennylaneClassification:"Classement des lignes dans Pennylane",
        pennylaneClassificationHelp:"Les numéros de compte sont décidés dans Pennylane par l'expert-comptable. Choisissez les champs personnalisés article (listes) qui indiquent la nature des ventes et leur catégorie analytique.",
        pennylaneNature:"Nature",
        pennylaneNatureField:"Champ personnalisé article indiquant la nature",
        pennylaneNoField:"Aucun",
        pennylaneFieldValue:"Valeur du champ",
        pennylaneNature_none:"Non précisée (compte par défaut Pennylane)",
        pennylaneNature_goods:"Marchandises",
        pennylaneNature_services:"Prestations de services",
        pennylaneCategory:"Catégorie analytique",
        pennylaneCategoryField:"Champ personnalisé article indiquant la catégorie analytique",
        pennylaneCategoryGroups:"Groupes de catégories Pennylane à synchroniser",
        pennylaneNoCategoryGroup:"Aucun groupe trouvé : vérifiez qu'une connexion est active",
        pennylaneSyncCategories:"Synchroniser les catégories Pennylane",
        pennylaneLastSync:"Dernière synchronisation",
        pennylaneCategoriesFound:"catégories",
        pennylaneCategoriesAdded:"Ajoutées à la liste",
        pennylaneCategoriesMissing:"Valeurs de la liste absentes de Pennylane (conservées) :",
        pennylaneArticles:"articles",
        pennylaneEnvironmentInvalid:"Environnement invalide",
        pennylaneActiveFromInvalid:"Date de mise en service invalide",
        pennylaneTokenRequired:"Le jeton API est obligatoire pour une première connexion",
        pennylaneTokenRequiredForEnvironmentChange:"Changer d'environnement nécessite de saisir un jeton",
        pennylaneConnectionAccountChanged:"Ce jeton correspond à une autre entreprise Pennylane ou à un autre environnement. Remplacer la connexion existante ?",
        pennylaneTokenInvalid:"Jeton Pennylane invalide ou révoqué",
        pennylaneTokenVerificationFailed:"Vérification du jeton impossible, réessayez plus tard",
        pennylaneSandboxTokenForProduction:"Ce jeton correspond à un bac à sable : impossible de l'utiliser en production",
        pennylaneProductionTokenForSandbox:"Ce jeton ne correspond pas à un bac à sable",
        pennylaneCustomFieldNotEligible:"Seuls les champs personnalisés article de type liste sont utilisables",
        pennylaneCustomFieldsMustDiffer:"La nature et la catégorie doivent utiliser deux champs différents",
        pennylaneNatureInvalid:"Nature invalide",
        pennylaneCategoryGroupsNotSelected:"Choisissez au moins un groupe de catégories à synchroniser",
        pennylaneCategoryNotFound:"Catégorie analytique absente de Pennylane",
        pennylaneCategoriesNotAssigned:"Les catégories analytiques n'ont pas pu être affectées",
        pennylaneStatus_pending:"en attente",
        pennylaneStatus_pdf_ready:"PDF généré, envoi en cours",
        pennylaneStatus_importing:"import en cours",
        pennylaneStatus_import_unknown:"résultat d'import à vérifier (vérification automatique)",
        pennylaneStatus_imported:"importée",
        pennylaneStatus_awaiting_conversion:"conversion en facture électronique en cours",
        pennylaneStatus_retry_wait:"nouvelle tentative programmée",
        pennylaneStatus_waiting_origin:"en attente de la transmission de la facture d'origine",
        pennylaneStatus_blocked:"bloquée, conditions non remplies",
        pennylaneStatus_validation_error:"refusée par Pennylane",
        pennylaneStatus_skipped:"non transmise",
        pennylaneStatus_error:"erreur de connexion ou de droits Pennylane",
        pennylaneImportedWithoutEInvoice:"Importée pour la comptabilité, sans facturation électronique",
        pennylaneRetry:"Relancer la transmission",
        pennylaneRetryLaunched:"Transmission relancée",
        pennylaneRetryNotAllowed:"Cette transmission ne peut pas être relancée",
        pennylaneConfirmTitle:"Conditions d'import Pennylane non remplies",
        pennylaneConfirmBlockedIntro:"Ce document ne pourra pas être importé dans Pennylane :",
        pennylaneConfirmBlockedOutro:"Vous pouvez corriger la fiche client avant de valider, ou valider maintenant : la transmission restera en attente jusqu'à correction. Attention, les informations du client figurent sur le document émis.",
        pennylaneValidateAnyway:"Valider quand même",
        eInvoiceDocumentTypeNotCovered:"Type de document non concerné",
        eInvoiceCreditNoteWithoutOrigin:"Avoir sans facture d'origine",
        eInvoiceCreditNoteEmitterMismatch:"L'avoir et sa facture d'origine n'ont pas le même émetteur",
        eInvoiceCreditNoteRecipientMismatch:"L'avoir et sa facture d'origine n'ont pas le même client",
        eInvoiceRecipientMissing:"Client absent du document",
        eInvoiceCurrencyNotInPilot:"Devise non prise en charge (EUR uniquement)",
        eInvoiceB2cFlagWithProfessionalRecipient:"Document marqué B2C pour un client professionnel",
        eInvoiceEmitterCountryMissing:"Pays de la société émettrice non renseigné",
        eInvoiceEmitterCountryNotCoded:"Pays de la société émettrice non reconnu (code pays attendu)",
        eInvoiceEmitterTerritoryExcluded:"Société émettrice hors du territoire de la facturation électronique",
        eInvoiceEmitterTerritoryToReview:"Territoire de la société émettrice à confirmer",
        eInvoiceEmitterNotInFrance:"Société émettrice non établie en France",
        eInvoiceEmitterVatStatusUnknown:"Assujettissement à la TVA de la société émettrice non renseigné",
        eInvoiceEmitterNotVatLiable:"Société émettrice non assujettie à la TVA",
        eInvoiceEmitterSirenMissing:"SIREN de la société émettrice manquant",
        eInvoiceEmitterSirenInvalid:"SIREN de la société émettrice invalide",
        eInvoiceRecipientCountryMissing:"Pays du client non renseigné",
        eInvoiceRecipientCountryNotCoded:"Pays du client non reconnu (code pays attendu)",
        eInvoiceRecipientTerritoryExcluded:"Client hors du territoire de la facturation électronique",
        eInvoiceRecipientTerritoryToReview:"Territoire du client à confirmer",
        eInvoiceRecipientNotInFrance:"Client non établi en France",
        eInvoiceRecipientVatStatusUnknown:"Assujettissement à la TVA du client non renseigné",
        eInvoiceRecipientNotVatLiable:"Client non assujetti à la TVA",
        eInvoiceRecipientSirenMissing:"SIREN du client manquant",
        eInvoiceRecipientSirenInvalid:"SIREN du client invalide",
        pennylaneQualificationNeedsReview:"Données à compléter avant transmission",
        pennylaneChannelDisabled:"Transmission désactivée pour ce type de document",
        pennylaneCreditNoteOriginNotTransmitted:"La facture d'origine de l'avoir n'a pas été transmise à Pennylane",
        pennylaneCreditNoteOriginFailed:"La transmission de la facture d'origine a échoué",
        pennylaneFacturXDocumentTypeNotSupported:"Ce type de document ne peut pas être converti en facture électronique",
        pennylaneFacturXCreditNoteOriginMissing:"La facture d'origine de l'avoir est absente ou sans numéro",
        pennylaneFacturXIdentifierMissing:"Un SIREN est manquant sur l'émetteur ou le client",
        pennylaneFacturXExemptNotSupported:"Les lignes exonérées de TVA ne sont pas encore gérées en facturation électronique",
        pennylaneFacturXVatRateNotMapped:"Ce taux de TVA n'a pas d'équivalent en facturation électronique",
        pennylaneSendToPaFailed:"La facture électronique n'a pas pu être envoyée à la plateforme agréée",
        pennylaneAttachmentUsedByAnotherDocument:"Le PDF est déjà rattaché à un autre document Pennylane",
        pennylaneSchematronInvalid:"La facture électronique générée par Pennylane est invalide",
        pennylaneConversionTimeout:"Conversion en facture électronique trop longue",
        pennylaneMaxAttemptsReached:"Nombre maximal de tentatives atteint",
        pennylaneAlreadyTransmitted:"Ce document a déjà été envoyé à Pennylane",
        pennylaneFactureNeverSent:"Ce document n'a jamais été envoyé à Pennylane",
        pennylaneFactureBulkConfirm:"Envoyer {count} document(s) manquant(s) à Pennylane ?",
        pennylaneDocumentNotClosed:"Document non clôturé",
        pennylaneDocumentTypeNotCovered:"Type de document non transmissible",
        pennylaneInvoiceNumberNotConvertible:"Numéro de facture incompatible avec la facture électronique (35 caractères, lettres, chiffres et -+_/)",
        pennylaneCurrencyNotSupported:"Devise non prise en charge (EUR uniquement)",
        pennylaneAmountsMismatch:"Les montants des lignes ne correspondent pas aux totaux du document",
        pennylaneNegativeInvoice:"Facture de montant négatif",
        pennylaneZeroRateWithoutExemption:"Ligne à 0 % de TVA sans exonération",
        pennylaneVatRateNotMapped:"Taux de TVA non pris en charge par Pennylane",
        pennylaneNoBillableLine:"Aucune ligne facturable",
        pennylaneVatGroupMissing:"Ventilation de TVA incomplète",
        pennylaneExemptDocumentWithTax:"Document exonéré comportant de la TVA",
        pennylaneRecipientMissing:"Client absent du document",
        mustHaveTicketAndFactureBouton:"Les balises [bouton ticket] et [bouton facture] sont obligatoires et ne peuvent être présentes qu'une seule fois chacune",
        linkToDouaneCat:'Lier à une catégorie douanière',
        noPurchaseOrderFound:'Pas de bon de commande à convertir',
        allPurchaseOrdersAlreadyConverted:'Tous les bons de commandes sont déjà convertis',
        noDeliveryNoteFound:'Pas de bon de livraison à convertir',
        allDeliveryNotesAlreadyInvoiced:'Tous les bons de livraison sont déjà convertis',
        noSupplierProvided:'Aucun fournisseur renseigné',
        noCurrencyProvided:'Aucune devise renseignée',
        exchangeRate:'Taux de change',
        indiceCalcul:'Calcul des indices prmp',
        categorie_douane:'Catégorie douanière',
        position:'Position',
        unit:'Unité',
        qtyUnit:'Qty unité',
        price_unit:'Prix par unité',
        price_unit_b2b:'Prix par unité B2B',
        confirmCancelFactureAchat:"Êtes-vous sûr de vouloir annuler cette facture ?",
        billingBuy:'Facture d\'achat',
        creditNoteBuy:'Avoir fournisseur',
        creditNoteBuyCreate:'Création avoir fournisseur',
        mustDeletePaymentBeforeCancel:'Vous devez soit annuler l’ensemble des règlements ou compléter les règlements manquants avant d\'annuler la facture',
        linkToFolder:'Associé au dossier',
        linkTo:'Associé à',
        billingDeposit:'Facture d\'acompte',
        depositLabel:'Acompte',
        quotationExpireAt:'Ce devis a expiré le',
        quotationNotConverted:'Ce devis n’a généré ni bon de commande, ni facture',
        quotationConverted:'Ce devis a généré un ou plusieurs documents associés',
        billingDepositUnUsed:'Cette Facture d\'acompte n\'a pas été utilisée',
        billingDepositPartiallyUsed:'Cette Facture d\'acompte a été utilisée partiellement',
        billingDepositUsed:"Cette Facture d'acompte n'a pas été totalement utilisée",
        purchaseOrderB2bNotCollected:'La collecte de ce bon de commande n\'a pas commencé',
        purchaseOrderB2bPartialCollected:'La collecte de ce bon de commande est en cours',
        purchaseOrderB2bCollected:'La collecte de ce bon de commande est terminée',
        purchaseOrderB2bNotConverted:'Ce bon de commande n\'a généré aucun bon de livraison',
        purchaseOrderB2bPartialConverted:'Ce bon de commande a déjà généré au moins un bon de livraison, cependant certains articles n’ont pas encore été convertis',
        purchaseOrderB2bConverted:'L\'ensemble des articles de ce bon de commande ont été mis en bon de livraison',
        deliveryNoteNotDelivery:'Ce bon de livraison n\'a pas encore été livré',
        deliveryNoteDelivery:"Ce bon de livraison a été livré",
        deliveryNoteNotConverted:'Ce bon de livraison n\'a généré aucune facture',
        deliveryNoteConverted:"L'ensemble des articles de ce bon de livraison ont été mis en facture",
        invoiceNotAcquitte:'Cette facture n\'a pas été acquittée',
        invoicePartiallyAcquitte:'Cette facture n\'a été que partiellement acquittée',
        invoiceAcquitte:'Cette facture a été acquittée',
        avoirUnUsed:'Cet avoir n\'a pas été utilisé',
        avoirPartiallyUsed:'Cet avoir a été partiellement utilisé',
        avoirUsed:'Cet avoir a été totalement utilisé',
        avoirNotConverted:'Cet avoir n\'a généré aucun bon de retour',
        avoirPartialConverted:'Cet avoir a déjà généré au moins un bon de retour, cependant certains articles n’ont pas été mis en bon de retour',
        avoirConverted:'L\'ensemble des articles de cet avoir ont été mis en bon de retour',
        returnNoteNotCollected:'La collecte de ce bon de retour n\'a pas commencé',
        returnNotePartialCollected:'La collecte de ce bon de retour est en cours',
        returnNoteCollected:'La collecte de ce bon de retour est terminée',
        error404Msg:'Désolé ! La page que vous recherchez n\'existe pas',
        retourAccuil:'Retour à l\'accueil',
        noEmailAdressConfigured:'Aucune adresse e-mail configurée',
        errDestinataireEmail:'Veuillez inclure "@" dans l\'adresse e-mail',
        addMoreRecipientsMsg:'Ajouter plusieurs destinataires en les séparant d\'une ","',
        destinatairesRequired:'Au moins un destinataire est requis',
        destinatairesIsArray:'Les destinataires doivent être une liste',
        destinatairesElemRequired:'Un destinataire ne peut pas être vide',
        urlRequired:'Le lien de consultation est requis',
        urlMin2:'Le lien de consultation est invalide',
        documentAlreadyUseForPaiement:'Ce document a déjà été utilisé pour le règlement d\'une autre facture',
        montantIsOver:'Le montant indiqué est supérieur au restant du solde à payer',
        changeFolder:'Changer de dossier',
        allInfosCorrect:'Toutes les informations sont elles correctes ?',
        allDocuments:'Tous les documents',
        noPriorityPricing:'Aucun prix prioritaire',
        priorityPricingCat:'Catégorie tarifaire prioritaire',
        priorityPricingCatB2C:'Catégorie tarifaire prioritaire B2C',
        priorityPricingCatB2B:'Catégorie tarifaire prioritaire B2B',
        defaultCategorieTva:'Catégorie de {taxe} spéciale',
        noDefaultCategorieTva:'Aucune catégorie par défaut',
        associatedCategorieTva:'Catégorie de {taxe} associée',
        noCategorieTvaAssociated:'Aucune catégorie associée',
        selectArticlePrice:'Choisir une catégorie tarifaire',
        noPricingCat:'Aucune catégorie tarifaire',
        articlePriceNotFound: 'Aucun prix trouvé pour cet article et cette catégorie tarifaire',
        noB2cPrice:'Aucun prix B2C renseigné pour cet article',
        noTvaRate:'Le taux de TVA n\'est pas configuré sur cet article pour la catégorie de TVA de la caisse',
        searchForExistingFolder:'Rechercher un dossier existant',
        folderNotExist: 'Le dossier n°{numeroDossier} n\'existe pas',
        folder:'Dossier',
        folders:'Dossiers',
        ongoingFiles:'Dossiers en cours',
        linkToOtherCompany:'Lier à une autre compagnie',
        docName:'Nom du dossier',
        linkToDoc:'Lier à un dossier',
        createFolder:'Créer un dossier',
        newFolder:'Nouveau dossier',
        createDocument:'Créer un document',
        createTemplate:'Créer un modèle',
        editTemplate:'Editer un modèle',
        deleteEmailAccount:"Supprimer le compte e-mail",
        send:'Envoyer',
        sendTestEmail:'Envoyer un e-mail de test',
        smtpConfigError:'Impossible d\'envoyer l\'email : la configuration SMTP de ce compte semble incorrecte (hôte, port ou identifiants). Vérifiez les paramètres du compte.',
        addEmailAccount:'Ajouter un compte e-mail',
        emailAccount:'Comptes Email',
        emailLayout:'Modèles Email',
        miseEnPage:'Mise en page',
        emetteurClient:'Données Emetteur / Client',
        dataEmitterPdf:'Données émetteur',
        dataClientPdf:'Données client',
        capital:'Capital',
        logoField:'Logo',
        balisesPossibles:'Balises possibles',
        newEmailAccount:'Nouveau compte email',
        accountName:'Nom du compte',
        emailAdress:'Adresse e-mail',
        hostOutgoing:'Serveur mail sortant',
        username:'Nom d\'utilisateur',
        allFieldRequiredForEnumere:'Tous les champs de l\'énuméré de conditionnement doivent être renseignés (nom, code-barre, quantité)',
        price:'Prix',
        prixAchat:'Prix d\'achat',
        addAdditionalPrice:'Ajouter un prix supplémentaire',
        portrait:'Portrait',
        landscape:'Paysage',
        generateExport:'Générer un export',
        referedToQuotation:'En référence au devis n°',
        referedToDocument:'En référence au document n°',
        parentToDocument:'Parent des documents',
        childToDocument:'Enfant des documents',
        priceTtcB2c:'Prix TTC B2C',
        priceTtcB2b:'Prix TTC B2B',
        priceHtB2b:'Prix HT B2B',
        priceHtB2c:'Prix HT B2C',
        margeNB2b:'Marge Brute B2B',
        margePB2b:'Marge % B2B',
        margeB2c:'Marge Brute B2C',
        margePB2c:'Marge % B2C',
        b2bPrice:'Prix B2B',
        b2cPrice:'Prix B2C',
        mustIndicateAPrice:'Vous devez indiquer au moins un prix',
        additionalPriceName:'Nom du prix supplémentaire',
        additionalPrice:'Prix supplémentaire',
        includedTaxe:'Taxes comprises',
        useB2bPrice:'Utiliser le prix B2B',
        useB2cPrice:'Utiliser le prix B2C',
        itemPrice:'Prix article',
        usedArticlePrice:'Prix article utilisé, veuillez l\'enlever de toutes les configurations avant de le supprimer',
        productPriceMaxNumber:'Nombre maximum de prix supplémentaire pour un article',
        categorieTva:'Catégories de {taxe} supplémentaires',
        categorieTvaName:'Nom de la catégorie',
        addCategorieTva:'Ajouter une catégorie de {taxe}',
        categorieTvaArray:'Les catégories de taxe doivent être un tableau',
        categorieTvaRequired:'Le nom de la catégorie de taxe est obligatoire',
        categorieTvaNameRequired:'Le nom de la catégorie de taxe est obligatoire',
        categorieTvaNameString:'Le nom de la catégorie de taxe doit être du texte',
        categorieTvaNameMax191:'Le nom de la catégorie de taxe ne doit pas dépasser 191 caractères',
        categorieTvaTauxRequired:'Au moins un taux est requis pour cette catégorie de taxe',
        categorieTvaTauxArray:'Les taux de la catégorie de taxe doivent être un tableau',
        categorieTvaTauxNumeric:'Les taux de la catégorie de taxe doivent être numériques',
        categorieTvaTauxMin0:'Les taux de la catégorie de taxe doivent être supérieurs ou égaux à 0',
        categorieTvaTauxMax100:'Les taux de la catégorie de taxe ne doivent pas dépasser 100',
        CategorieTvaIsNotValid:'La catégorie de TVA n\'est pas valide',
        categorieTvaDefaultMax191:'La catégorie de TVA par défaut ne doit pas dépasser 191 caractères',
        noDefaultTaux:'Aucun',
        paysExonereTva:'Pays exonérés de {taxe}',
        paysExonereTvaDescription:'Les clients ou fournisseurs situés dans ces pays seront automatiquement exonérés de {taxe} sur les factures émises par cette entité.',
        paysExonereTvaArray:'Les pays exonérés doivent être une liste',
        paysExonereTvaInvalid:'Un des pays sélectionnés n\'est pas valide',
        categorieTvaDefaultTauxIn:'Le taux par défaut doit faire partie des taux définis pour cette catégorie',
        taux_categorie_tva:'Taux {taxe}',
        noUserRestricted:'Aucun utilisateurs n\'est restreint',
        unauthorized:'Non autorisé',
        fieldReading:'Lecture du champ',
        fieldEditing:'Edition du champ',
        fieldReadingNotAvl:'Lecture non disponible à',
        fieldEditingNotAvl:'Edition non disponible à',
        fieldEditingAlertNotAvl:'Alerte de confirmation à',
        designation:'Désignation',
        accessMenu:'Access',
        usersListing:'Listing des utilisateurs',
        email:'Email',
        modules:'Modules',
        emailAccess:'Accès Email',
        access:'Accès',
        noModuleAssigned:'Aucun module attribué',
        noEmailAccountAssigned:'Aucun compte mail attribué',
        stockInZoneNotSufficient:'Le stock de votre zone ou bins n\'est pas suffisant pour effectuer votre action',
        padFormat:'Format du PAD',
        clotureFormatPdf:'Format du PDF de clôture de caisse',
        clotureFormatA5:'A5 standard',
        clotureFormatSlip:'Slip (imprimante slip Epson)',
        smallPad:'Petit PAD',
        bigPad:'Grand PAD',
        seuilMiniCashBack:'Seuil minimum d\'utilisation du cashback',
        plafondCashBack:'Plafond de cumul du cashback',
        reliquatCashBack:'Obligation d\'utiliser tout son cashback',
        reliquatFidelite:"Obligation d'utiliser toute sa fidélité",
        hostname:'Nom de l\'hôte',
        hostnameOrIpAdress:'Nom ou adresse IP de l\'hôte',
        noHostnameAssigned:'Aucun nom d\'hôte attribué',
        clientAlreadyAssigned:"Ce client a soit déjà été associé ou est en cours d'association",
        relatedCompanies:'Entreprises concernées',
        poids:'Poids',
        companyOrOtherCompany:'Entreprise ou autre entreprise',
        noAssignablePromo:"Aucune promotion attribuable",
        noAssignedPromo:"Aucune promotion attribuée",
        assignablePromo:'Promotions attribuables',
        assignedPromo:'Promotions attribuées',
        assignPromoClient:'Attribuer des promotions',
        addCustomer:'Ajouter des clients',
        allModificationWillBeLost:'Toutes les modifications seront perdus, continuer ?',
        allCustomer:'Tous les clients',
        listOfCustomer:'Liste de client',
        selectionOfCustomer:'Sélection de client',
        selectionTemplate:'Selectionner un modèle',
        voucherManagement:'Gestion des bons',
        itemListWillBeDelete:'Votre sélection d\'articles sera supprimé, voulez-vous continuer ?',
        convertIntoToCollected:'Ordre de transfert déjà collecté',
        convertThisList:'Convertir cette liste',
        quantityManualModificationListeArticle:'Modification manuelle des quantitées sur les listes d\'articles',
        noList:'Aucune liste',
        listName:'Nom de la liste',
        listOfItems:'Liste d\'articles',
        supplementList:'Liste de supplément d\'articles',
        multiple_choice:'Choix multiple',
        required_choice:'Choix obligatoire',
        max_choices:'Limite de choix',
        max_choices_unlimited:'Illimité si vide',
        max_choices_reached:'Nombre maximum de choix atteint',
        packaging:'Conditionnement',
        packagedQuantity:'Quantité conditionnée',
        packagingName:'Nom du conditionnement',
        enumere:'Enuméré de conditionnement',
        packagingList:'Enuméré de conditionnement',
        pricingHt:'Tarification hors taxes',
        nbSales:'Nombre de ventes',
        qteSold:'Quantité vendue',
        salesStatistics:'Statistiques de vente',
        copy:'Copier',
        copied:'Copié',
        infoZoneAffectedByRestock:'Par défaut, freebird utilise toutes les zones de stockage si aucune configuration existe',
        zoneAffectedByARestock:'Zone concernée par un réassort interne',
        triggerThresholdInternalRestock:'Seuil de déclenchement d\'un réassort interne',
        seuilDeclenchement:'Seuil de déclenchement',
        seuilTypeCA:'Configurer un seuil de déclenchement au chiffre d\'affaires',
        seuilTypeQuantity:'Configurer un seuil de déclenchement à la quantité',
        seuilQuantityValue:'Seuil de déclenchement (quantité)',
        seuilQuantityType:'Type de seuil quantité',
        seuilQuantitySameArticle:'Le même article',
        seuilQuantityDistinctArticles:'Articles de la liste',
        seuilQuantitySameArticleHelp:'Il faut acheter au moins N fois exactement le même article de la liste de cette promotion.',
        seuilQuantityDistinctArticlesHelp:'Il faut acheter au moins N articles au total (quantités cumulées, mélange autorisé) parmi la liste de cette promotion.',
        seuilExclusive:'Le seuil au chiffre d\'affaires et le seuil à la quantité ne peuvent pas être configurés en même temps',
        seuilQuantityNumeric:'Le seuil de quantité doit être un nombre entier',
        seuilQuantityMin:'Le seuil de quantité doit être d\'au moins 1',
        seuilQuantityMax:'Le seuil de quantité est trop élevé',
        seuilQuantityTypeIn:'Veuillez choisir un type de seuil de quantité',
        quantityToRestock:'Stock optimal',
        internalRestockException:'Exception de réassort interne',
        noZoneOfStock:'Aucune zone de stock',
        rppslMenuName:'RP/PSL',
        rppslFournisseurMenuName:'RP/PSL Fournisseur',
        emptyValue:'Valeur vide',
        reopenQuotation:'Réouvrir devis',
        devisValidite:'Durée de validité du devis',
        quotationGenerated:'Votre devis a été généré',
        continueWithoutIdentification:'Continuer sans s\'identifier',
        expired:'Expiré',
        notExpired:'Non expiré',
        notAvailable:'Non disponible',
        pickupInStore:'Retrait en boutique',
        isPickupAvailable:'Peut être sélectionné pour un retrait en boutique',
        gpsCoordinatesContact:'Coordonnées GPS (page contact)',
        labelLatitude:'Latitude',
        labelLongitude:'Longitude',
        latitudeNumeric:'La latitude doit être un nombre',
        latitudeBetween:'La latitude doit être comprise entre -90 et 90',
        longitudeNumeric:'La longitude doit être un nombre',
        longitudeBetween:'La longitude doit être comprise entre -180 et 180',
        tablePlan:'Plan de table',
        openTablePlan:'Configurer le plan de table',
        tables:'tables',
        reservations:'Réservations',
        addReservation:'Ajouter une réservation',
        createTicketForTable:'Créer ticket',
        openTicketForTable:'Ouvrir ticket',
        ticketEnCours:'Ticket en cours',
        tableAlreadyHasOpenTicket:'Cette table a déjà un ticket ouvert',
        reservationName:'Nom',
        reservationDate:'Date',
        reservationDateDebut:'Date de début',
        reservationDateFin:'Date de fin (facultatif)',
        reservationTime:'Heure',
        reservationNote:'Note',
        noReservationToday:'Aucune réservation pour aujourd\'hui',
        kpiNbReservations:'Réservations',
        kpiNbPersons:'Personnes',
        kpiAvgPersons:'Moy. par réservation',
        allZones:'Toutes les zones',
        tableStatusAvailable:'Disponible',
        tableStatusUpcoming:'Réservation à venir',
        tableStatusOngoing:'Réservation en cours',
        tableStatusPast:'Passée',
        phone:'Téléphone',
        obstacle:'Obstacle',
        addObstacle:'Ajouter un obstacle',
        color:'Couleur',
        posDefaultClient:'Client POS',
        editReservation:'Modifier la réservation',
        reservationOverlap:'Ce créneau chevauche une réservation existante',
        planningView:'Planning',
        planningFullDay:'Journée',
        confirmDeleteReservation:'Êtes-vous sûr de vouloir supprimer cette réservation ?',
        searchAvailability:'Rechercher',
        noAvailableTable:'Aucune table disponible sur ce créneau',
        addPlan:'Ajouter un plan',
        planName:'Nom du plan',
        editPlan:'Modifier le plan',
        planDimensions:'Dimensions (px)',
        uploadBackground:'Image de fond',
        removeBackground:'Supprimer le fond',
        deletePlan:'Supprimer le plan',
        confirmDeletePlan:'Êtes-vous sûr de vouloir supprimer ce plan ? Toutes les tables seront supprimées.',
        noPlanYet:'Aucun plan de table configuré.',
        services:'Services',
        addService:'Ajouter un service',
        serviceName:'Nom du service',
        serviceHeureDebut:'Heure de début',
        serviceHeureFin:'Heure de fin',
        noServiceYet:'Aucun service configuré.',
        editService:'Modifier le service',
        confirmDeleteService:'Êtes-vous sûr de vouloir supprimer ce service ?',
        table:'Table',
        addTable:'Ajouter une table',
        editTable:'Modifier la table',
        tableNumber:'Numéro de table',
        nbPersons:'personnes',
        confirmDeleteTable:'Êtes-vous sûr de vouloir supprimer cette table ?',
        tableShape:'Forme',
        tableShapeSquare:'Carré',
        tableShapeCircle:'Rond',
        tableWidth:'Largeur (px)',
        tableHeight:'Hauteur (px)',
        tableDiameter:'Diamètre (px)',
        infosOnReceipt:'Infos à afficher sur le ticket',
        infosOnTopReceipt:'Infos à afficher sur le haut du ticket',
        infosOnBottomReceipt:'Texte à afficher sur le bas du ticket',
        noteAutomatiqueHeader:'Note automatique sur article',
        noteAutomatiqueLabel:'Champ personnalisé à utiliser comme note automatique',
        noteAutomatiqueHelp:'Lors de l\'ajout d\'un article à un ticket sur cette section, si ce customfield est renseigné sur l\'article, sa valeur pré-remplit automatiquement la note de l\'article.',
        selectNone:'Aucun',
        customFieldUsedAsAutomaticNote:'Ce champ personnalisé ne peut pas être renommé ou supprimé tant qu\'il est utilisé comme note automatique sur article.',
        buffaloPreparationTrigger:'Préparation planche à pizza',
        buffaloPreparationValue:'Valeur attendue',
        buffaloPreparationAnyValue:'Toute valeur',
        buffaloPreparationHelp:'Les articles dont ce champ personnalisé correspond à la valeur attendue déclenchent la préparation chez la planche à pizza. Sans valeur attendue, tout article où ce champ est renseigné la déclenche.',
        buffaloPreparationValueMax191:'La valeur attendue ne doit pas dépasser 191 caractères',
        customFieldUsedAsBuffaloPreparation:'Ce champ personnalisé ne peut pas être renommé ou supprimé tant qu\'il est utilisé pour la préparation planche à pizza.',
        excludeArticlesFromSearch:'Exclure des articles de la recherche :',
        searchExclusionNone:'Ne rien exclure',
        searchExclusionValue:'Valeur qui exclut l\'article',
        searchExclusionHelp:'Sur le POS, les articles dont ce champ personnalisé a exactement cette valeur (sans tenir compte de la casse) n\'apparaissent plus dans la barre de recherche d\'articles.',
        searchExclusionValueMax191:'La valeur d\'exclusion ne doit pas dépasser 191 caractères',
        customFieldUsedAsSearchExclusion:'Ce champ personnalisé ne peut pas être renommé ou supprimé tant qu\'il est utilisé pour exclure des articles de la recherche du POS.',
        listedUserWillBeNotified:'Les utilisateurs listés seront notifiés',
        cancellationOfInvoice:'Annulation de la facture n°',
        cancelledByCreditNote:'Annulée par l\'avoir n°',
        assignCountZeroEmptyBins:"Attribuer un comptage à zéro à l'ensemble des bins restantes",
        confirmAssignCountZeroEmptyBins:"Souhaitez-vous vraiment attribuer un compte à zéro à l'ensemble des bins restantes",
        confirmDeleteTemplate:'Souhaitez-vous vraiment supprimer ce modèle ?',
        assignPointsManually:'Attribuer des points manuellement',
        exclureFidelite:'Exclure du programme de fidelité',
        confirmInnerFidelite:'Inclure ce client dans le programme de fidélité ?',
        confirmExcluFidelite:'Exclure ce client du programme de fidélité ?',
        unauthorizedMovement:'Le transfert de stock sur cette zone n\'est pas autorisé',
        nbPointsToAssign:'Nombre de points à attribuer',
        priceCalculationMethod: "Formule de calcul du prix d’un article sur mesure",
        calculationValue: "Valeur de calcul",
        customMadeItem: "Article sur mesure",
        itemWithoutUpcCode: "Articles sans code UPC",
        showCustomMadeItem: "Afficher uniquement les articles sur mesure",
        typePercent: "Pourcentage",
        subtraction: "Soustraction",
        reminder:'Rappel',
        programedReminder:'Rappel programmé',
        reminders:'Rappels',
        fromDocument:'A partir du document',
        a:'A',
        list:'Liste',
        listMin1:'La valeur de la liste doit être 1 ou 2',
        listMax2:'La valeur de la liste doit être 1 ou 2',
        title:'Titre',
        addSettle:'Acquitter le document',
        bulkSettle:'Acquitter en masse',
        bulkSettleSelectedCount:'Factures sélectionnées',
        bulkSettleSelectedInvoices:'Factures sélectionnées',
        bulkSettleResultSuccess:'{count} facture(s) acquittée(s) avec succès',
        bulkSettleResultError:'{count} facture(s) n\'ont pas pu être acquittée(s)',
        bulkSendEmail:'Envoyer par e-mail',
        bulkSendEmailSelectedDocuments:'Documents sélectionnés',
        bulkSendEmailResultSuccess:'{count} document(s) envoyé(s) avec succès',
        bulkSendEmailResultError:'{count} document(s) n\'ont pas pu être envoyé(s)',
        bulkSendEmailFillMain:'Ajouter l\'adresse principale de chaque client',
        bulkSendEmailFillAll:'Ajouter toutes les adresses de chaque client',
        bulkSendEmailFillRelance:'Ajouter uniquement les adresses de relance',
        noCommonPaymentMode:'Les factures sélectionnées n\'ont aucun mode de paiement commun disponible',
        modePaiementNotAvailable:'Mode de paiement non disponible pour cette facture',
        factureAlreadyAcquitte:'Cette facture est déjà acquittée',
        invalidDocumentType:'Ce document n\'est pas une facture',
        factureNotFinalized:'Cette facture n\'est pas encore finalisée',
        addLimitDate:'Ajouter une date limite de paiement',
        addLimitDateValidity:'Ajouter une date limite de validité',
        addFund:'Ajouter des fonds sur la carte cadeau',
        addUsers:'Ajouter des utilisateurs',
        addItems:'Ajouter des articles',
        addingItemsToPromo:"Ajout d'articles à la promotion",
        addTopText:'Ajout de texte sur la partie supérieure',
        addBottomText:'Ajout de texte sur la partie inférieure',
        specifyASeller:'Indiquer un vendeur',
        message:'Message',
        retraitZone:'Zone de retrait',
        transferAllProducts:"Transférer tous les produits",
        toMomentarilyFiniched:'La collecte de cet ordre de transfert est momentanément terminée',
        toFiniched:'La collecte de cet ordre de transfert est terminée',
        collectOrderFinish:'La collecte des articles pour cette commande est terminée',
        toReceiptMomentarilyFiniched:'La réception de cet ordre de transfert est momentanément terminée',
        toReceiptFiniched:'La réception de cet ordre de transfert est terminée',
        reassortInterneCollectFinish:'La collecte de ce reassort interne est terminée',
        toItemCollectMessage:'Cet article n\'a soit pas de stock soit a été totalement collecté',
        assignedTo:'Attribué à',
        assignedToAllClient:'Attribuer à tous les clients',
        finalize:'Finaliser',
        finalized:'Finalisé',
        getToItemsSelection:'Accéder à la sélection des articles',
        selectCustomer:'Sélectionner un client',
        orderedInThisShop:'Commandé dans ce magasin',
        toBeCollectedInThisShop:'A collecter dans ce magasin',
        informPaymentLate:'Informer le client des conséquences d\'un retard de paiement',
        toCollect:'A collecter',
        toCollectWms:'A collecter depuis votre WMS',
        enCoursTo:'Faisant l\'objet d\'un ordre de transfert',
        necessaryActionOrder:'Stock indisponible: un transfert de stock ou une entrée en stock est nécessaire pour réaliser la collecte de cet article',
        createATransferOrder:'Créer un ordre de transfert',
        generateAnTransferOrder:'Générer un ordre de transfert',
        dontIndicate:'Ne pas indiquer',
        itemManagement:'Gestion des articles',
        autoCreationItemInfos:'Création automatique des classifications, familles, sous-familles, catégories, sous-catégorie, marques et fournisseurs',
        skuObligation:'Obligation de créer un SKU',
        barCodeObligation:'Obligation de créer un code-barre',
        temporary:'Provisoire',
        ecomTemporaryMsg:'Cet article ne peut être mis en ligne car il est actuellement provisoire',
        showOnlyTemporaryItem:'Afficher uniquement les articles provisoires',
        temporaryItem:'Article provisoire',
        addThisItemToItemBase:'Ajouter définitivement cet article à la base article',
        hour:'Heure',
        ordered:'Commandé',
        noteInterne:'Note interne',
        seeOriginalDocument:'Voir le document original',
        errorDifferenceQteValidate:'Il existe un écart de valeur sur les articles suivants',
        paiementFideliteButNoFideliteArticle:"Le paiement par fidélité n'est pas accepté dans ce panier",
        closeWithDifference:'Le compte de votre caisse ne semble pas correct. Souhaitez-vous tout de même clôturer en l\'état ?',
        changePaiement:'Le rendu sera perdu et le versement recalculé. Voulez-vous continuer ?',
        onReceipt:'Sur ticket',
        articleNoReferenceFind: 'Aucun article ne correspond à cette référence',
        mustIndicateReasonRetrait: "Vous devez indiquer la raison pour laquelle vous retirez des espèces",
        gradeHasUser: "Vous ne pouvez pas supprimer ce grade car certains membres du staff ont actuellement ce grade. Pour supprimer ce grade, vous devez d'abord retirer ce grade pour tous les membres du staff pour qui ce grade est attribué.",
        modepaiementRemove: 'Vous ne pouvez pas supprimer ce mode de paiement car il est attribué à certains de vos commerces. Si vous souhaitez vraiment le supprimer, vous devez d\'abord le retirer des commerces pour lesquels ce mode de paiement est attribué.',
        adminOverQuota: 'Vous ne pouvez pas ajouter le module "Configuration" à cet utilisateur car votre quota d\'utilisateurs pour ce module est déjà atteint. Merci de contacter Ciweb si vous souhaitez modifier ce quota.',
        erpOverQuota: 'Vous ne pouvez pas ajouter le module "ERP" à cet utilisateur car votre quota d\'utilisateurs pour ce module est déjà atteint. Merci de contacter Ciweb si vous souhaitez modifier ce quota.',
        usersOverQuota: 'Vous ne pouvez pas ajouter le module "Utilisateurs" à cet utilisateur car votre quota d\'utilisateurs pour ce module est déjà atteint. Merci de contacter Ciweb si vous souhaitez modifier ce quota.',
        wmsOverQuota: 'Vous ne pouvez pas ajouter le module "WMS" à cet utilisateur car votre quota d\'utilisateurs pour ce module est déjà atteint. Merci de contacter Ciweb si vous souhaitez modifier ce quota.',
        posOverQuota: 'Vous ne pouvez pas ajouter le module "POS" à cet utilisateur car votre quota d\'utilisateurs pour ce module est déjà atteint. Merci de contacter Ciweb si vous souhaitez modifier ce quota.',
        endUnderrBegin: "La date de fin de période ne peut pas être inférieure à celle du début de période",
        perdioExceedAYear: "La période ne peut pas être supérieure à une année",
        dayDateFormat: 'La date de cette ligne du fichier CSV n\'est pas dans un format correct. Le format correct est celui qui est indiqué dans les paramètres avancés de votre compagnie.',
        commandeDateFormat: 'La date de commande n\'est pas dans un format correct. Le format correct est celui qui est indiqué dans les paramètres avancés de votre compagnie.',
        expectedDateFormat: 'La date de transfert n\'est pas dans un format correct. Le format correct est celui qui est indiqué dans les paramètres avancés de votre compagnie.',
        expeditionDateFormat: 'La date d\'expédition n\'est pas dans un format correct. Le format correct est celui qui est indiqué dans les paramètres avancés de votre compagnie.',
        expectedReceptionDateFormat: 'La date attendue de réception n\'est pas dans un format correct. Le format correct est celui qui est indiqué dans les paramètres avancés de votre compagnie.',
        realExpeditionDateFormat: 'La date réelle d\'expédition n\'est pas dans un format correct. Le format correct est celui qui est indiqué dans les paramètres avancés de votre compagnie.',
        receptionDateFormat: 'La date attendue de réception n\'est pas dans un format correct. Le format correct est celui qui est indiqué dans les paramètres avancés de votre compagnie.',
        beginDateFormat: 'La date de commencement n\'est pas dans un format correct. Le format correct est celui qui est indiqué dans les paramètres avancés de votre compagnie.',
        endDateFormat: 'La date de fin n\'est pas dans un format correct. Le format correct est celui qui est indiqué dans les paramètres avancés de votre compagnie.',
        dateDepartDateFormat: 'La date de départ n\'est pas dans un format correct. Le format correct est celui qui est indiqué dans les paramètres avancés de votre compagnie.',
        dateArriveDateFormat: 'La date d\'arrivage n\'est pas dans un format correct. Le format correct est celui qui est indiqué dans les paramètres avancés de votre compagnie.',
        lastDateBuyDateFormat: 'La dernière date d\'achat n\'est pas dans un format correct. Le format correct est celui qui est indiqué dans les paramètres avancés de votre compagnie.',
        rppslAutoGenerationDateDateFormat: 'La date de génération des RP/PSL automatique n\'est pas dans un format correct. Le format correct est AAAA-MM-JJ.',
        dateFormat: 'La date n\'est pas au bon format. Le format correct est celui qui est indiqué dans les paramètres avancés de votre compagnie.',
        beginRequiredWithEnd: 'Vous devez indiquer une date de commencement puisque vous avez indiqué une date de fin',
        endRequiredWithBegin: 'Vous devez indiquer une date de fin puisque vous avez indiqué une date de commencement',
        sizeLineCsv: 'Cette ligne du fichier CSV ne contient pas le nombre correct de colonnes',
        row: 'Ligne',
        lines: 'Lignes',
        noRhOrNoAuth: 'Staff inexistant ou non autorisé à accéder à cette section',
        rhNoAuth: 'Staff non autorisé à réaliser cette action',
        staffNotAttributeToInventory:'Ce staff n\'est pas attribué à cet inventaire',
        noRhOrNoAttributed: 'Staff inexistant ou non attribué à cet inventaire',
        noRhTos: 'Vous n\'avez pas d\'ordres de transfert en attente',
        noInternetTos: 'Vous n\'avez pas de commande en attente',
        imageUrl: 'Le lien image article doit être une URL valide',
        havestockIn: 'Vous devez indiquer si cet article doit être dépendant d\'un stock',
        zoneAlreadyHaveCommercial: 'Ce commerce a déjà une zone de stock de type lieu de vente',
        zoneAlreadyHaveCommande: 'Ce commerce a déjà une zone de stock de type commande',
        archiveZoneAddArticle: 'Cette zone de stock contient des articles et ne peut donc pas être archivée',
        deleteZoneAddArticle: 'Cette zone de stock contient des articles et ne peut donc pas être supprimée',
        customFieldsAlreadyExists: "Un champ personnalisé avec le même nom existe déjà",
        youMustIndicateField: 'Vous devez renseigner le champ',
        ecomMustBeConfigured:'Ce e-commerce n\'est pas configuré',
        limitCsv: 'Le fichier CSV doit contenir moins de {limit} lignes',
        filename: 'Nom du fichier',
        name:'Nom',
        description:'Description',
        categorization:'Catégorisation',
        ptype:'Type de produit',
        pcat:'Catégorie de produit',
        image:'Image',
        couleur:'Couleur',
        couleurs:'Couleurs',
        headerColor:'Couleur du bandeau',
        cardHeaderColor:'Couleur des en-têtes de carte',
        tabsColor:'Couleur des onglets',
        taille:'Taille',
        notANameForCustomFields: 'Ce nom ne peut pas être donné à un champ personnalisé',
        quotaCommandeInteger: 'La quantité doit être un nombre entier',
        quotaInteger: 'La quantité doit être un nombre entier',
        selectBinsOrZone: 'Vous devez scanner une bins ou sélectionner une zone',
        shipmentLineAlreadyReceptione:'Ce bloc a déjà été validé',
        shipmentCartonAlreadyReceptione:'Ce carton a déjà été réceptionné',
        changHaveBinsMustEqualZero:'Vous ne pouvez pas modifier l\'option bins pour une zone qui contient déjà des articles. Cette zone contient actuellement: {quota} articles',
        toIsClosed:'Cet ordre de transfert a été clôturé',
        rhNotInSection:'Ce staff n\'existe pas ou ne travaille pas dans le commerce d\'origine',
        communToLineNotTheSame:"Certaines données qui doivent être communes à toutes les lignes d'un même ordre de transfert ne le sont pas",
        noDoubleArticleTo:"Cet article est déjà présent dans une autre ligne de cet ordre de transfert",
        noAutorizedUpdateTo:'Vous ne pouvez pas mettre à jour un ordre de transfert qui a passé le stade de collecte',
        cantDeleteLine: 'Vous ne pouvez pas supprimer cette ligne',
        newLine: 'Ajouter une ligne',
        newSupplementList: 'Ajouter une liste de supplément',
        configArticleSupplementList: 'Configurer une liste de supplément pour un nouvel article',
        configArticleAbonnement: 'Configurer une gestion d\'abonnement sur un nouvel article',
        pslGte: 'Le niveau de stock optimal ne peut pas être inférieur au niveau de stock minimum',
        noDockForReassort: 'Vous n\'avez aucun dock défini',
        noArticleForReassort: 'Il n\'y a aucun article dans votre sélection',
        noToMaxForReassort: 'Vous devez d\'abord définir le nombre maximum d\'instructions que peut contenir un ordre de transfert dans les paramètres de votre entreprise',
        valuePromotionNotOk: 'Les valeurs de promotion sont incorrectes',
        amountOverDue:'Le montant payé ne peut être supérieur au restant dû',
        hasBillingDeposit:'Des factures d\'acomptes sont disponibles pour le règlement du document',
        hasCreditNote:'Des avoirs sont disponibles pour le règlement du document',
        resteIsOverTicket: 'Le montant payé est supérieur au restant à payer du ticket',
        majorPaiementError: 'Erreur de paiement majeure, le client a payé plus que le prix demandé',
        paiementIsNegative: 'Le montant à payer ne peut pas être négatif',
        paiementIsPositive: 'Le restant dû doit être à 0',
        noCommercialZone:'Aucune zone commerciale n\'est définie pour ce commerce',
        noGiftCardFound: 'Aucune carte cadeau ne correspond à cette référence',
        noFactureFound: 'Aucun document trouvé',
        noTicketFound: 'Aucun ticket ne correspond à cette référence',
        noCommandeFound: 'Aucune commande ne correspond à cette référence',
        noPossibilityToReturnArticle:'Une erreur empêche le retour de l\'article',
        articleAlreadyReturn: 'Cet article a déjà été retourné',
        hostIp:'Ceci n\'est pas une adresse IP valide',
        optional:'Optionnel',
        orderTitle:'Commande',
        sectionDontHaveCommandeZone: 'Les sections concernées par cette commande ne possèdent pas de zone de commande',
        commandeAlreayCancel: 'Cette commande client a déjà été annulée',
        mustSpecifyRemboursement: 'Vous devez spécifier le mode de remboursement',
        mustSpecifyGiftCardReference: 'Vous devez indiquer le code-barres de la carte cadeau',
        mustChooseOneRaccourci: 'Vous devez choisir un raccourci',
        someItemsNotPresentInPo: 'Certains articles ne sont pas présents dans le bon de commande associé',
        thisItemsNotPresentInPo: 'Cet article n\'est pas présent dans le bon de commande associé ({name})',
        lineCannotBeDelated: 'Cette ligne ne peut pas être supprimée',
        thisArticleNotLinkToStock: 'Cet article n\'est pas lié à un stock',
        articleIsNotInPo:'Cet article n\'est pas présent dans ce bon de commande',
        articleIsNotInTo:'Cet article n\'est pas présent dans cet ordre de transfert',
        articleIsNotInRestock:'Cet article n\'est pas présent dans ce réassort interne',
        toQuantityCantBeEdit: "Le status de cet ordre de transfert ne vous permet pas d'éditer les quantités à collecter",
        tooManyOrTooLongTags:'Il y a trop de tags (250 max) ou l\'un d\'entre eux est trop long (255 caractères max)',
        ecommerceSendError:"L'ecommerce renvoie l'erreur {erreur}",
        variantAreTheSame:'Les articles enfants ne sont pas détaillées correctements et sont donc interprétés comme étant les mêmes articles par Shopify. Vérifiez les options que vous avez indiqué.',
        noUserToSendAlert:'Aucun utilisateur n\'est configuré pour recevoir ce type d\'alerte',
        noUser:'Aucun utilisateur n\'a été attribué',
        indicateBinsInZoneThatHaveNoBins: "Vous avez indiqué une bins pour une zone qui n'en contient pas",
        binsOrZone:'Vous devez indiquer une bins ou une zone',
        reassortInterneAlreadyOpen:'Il y a déjà un reassort interne ouvert. Merci de le fermer avant d\'en générer un nouveau',
        noZoneReassortInterneConfig:'Il n\'y a pas de configuration de zone de reassort interne',
        negativeShopStockAndNoAutoPossibilities:'Les articles suivants ont un stock négatif dans votre zone de commerce. Vous devez d\'abord reajuster leur stock avant de pouvoir générer un réassort.',
        reassortCantDeleteAlreadyMove:'Vous ne pouvez pas supprimer une ligne qui a déjà commencé à être collectée',
        clientNotMatchWithDossier:'Le client ne correspond pas à ce dossier',
        exportEtatCompte:'Export état compte',
        mailEtatCompte:'Mail état compte',
        etatCompteOnlyOngoing:'Export : uniquement en cours (factures non acquittées et avoirs non utilisés)',
        exportZCaisse:'Export Z caisse',
        exportZCaisseWarning:'Les sessions de caisse prises en compte dans ce rapport sont uniquement celles qui ont été ouvertes durant la période indiquée ci-dessus, puis clôturées. Attention: si la clôture d\'une ou plusieurs de ces sessions a eu lieu après la date de fin de la période indiquée ci-dessus, l\'intégralité de chaque session est tout de même prise en compte. À l\'inverse, si une session de caisse a été ouverte avant la date de début de la période indiquée ci-dessus, elle ne sera pas prise en compte, même si sa clôture a été effectuée pendant cette période.',
        jourCloture:'jour de clôture',
        du:'du',
        au:'au',
        sessionCaisse:'session caisse',
        baseHt:'Base HT',
        montant:'Montant',
        delete_current_to_pos:'Voulez-vous vraiment annuler la création de l\'ordre de transfert ? La sélection en cours sera définitivement perdue.',
        /*************Modules name**************/
        moduleadmin:'Configuration',
        moduleerp:'ERP',
        modulewms:'WMS',
        moduleposs:'CAISSES',
        modulepos:'CAISSE',
        moduleusers:'Utilisateurs',
        moduleinvoice:'Facturation',
        modulegeneral:'Général',
        chatbotIa:'Assistant IA',
        modulerhtime:'Gestion du temps de travail',
        /*********divers***********/
        noDeliveryNoteToConvert:'Aucun bon de livraison à facturer',
        noSelection:'Pas de sélection',
        resetQuantity:'Réinitialiser la quantité',
        resetDefault:'Remettre par défaut',
        pointFideliteIsOverClientPointFidelite:'Le client ne dispose pas suffisamment de points de fidelité',
        stockAdjustmentSupportingDocument:'Justificatif d\'ajustement de stock',
        addDiscountSelection:'Appliquer une remise sur la sélection', 
        addDiscountAll:'Appliquer une remise sur l\'ensemble des articles', 
        documentCantBeDeleteBecauseLinesAlreadyProcessed:'Le document ne peut pas être annulé car certaines lignes de ce document ont déjà été traitées',
        convert:'Convertir',
        chat:'Message',
        thisLine:'Cette ligne',
        manualCounting:'Comptage manuel',
        cetteLigne:'cette ligne',
        emisLe:'Emis le',
        acquittee:'Acquittée',
        cancelInvoice:'Annuler cette facture',
        acquitterFacture:'Acquitter cette facture',
        generateNewFrom:'Générer un nouveau document depuis celui-ci',
        sendDocEmail:'Envoyer ce document par e-mail',
        sendTicketEmail:'Envoyer ce ticket par e-mail',
        mailTicketBodyHeader:"Corps de l'e-mail du ticket de caisse",
        factureA4FooterHeader:"Texte de pied de page de la Facture A4",
        factureA4FooterTextLabel:"Texte affiché en bas de la Facture A4 générée depuis la caisse",
        factureA4FooterSizeLabel:"Taille de la police",
        defaultMail:'Bonjour,<br /><br />Cliquez sur le bouton ci-dessous pour télécharger votre [type]<br /><br />[bouton]<br /><br />Cordialement,<br />',
        saveDocTemplate:'Enregistrer ce document comme modèle',
        createReminderFromDoc:'Programmer un rappel pour ce document',
        editReminderDoc:'Modifier le rappel pour ce document',
        convertToInvoice:'Convertir en facture',
        notConvertToInvoice:'Ne pas convertir en facture',
        allLocalisations:'Toutes localisations',
        filterTheSelection:'Filtrer la sélection',
        exludeConvertedLines:'Retirer les lignes complètement converties',
        filterBysection:'Filtrer par commerce',
        referenceItem: "Article de référence",
        complementaryItem: "Article complémentaire",
        supplierOrder:'Commande fournisseur',
        addSupplierItem: "Ajouter un article fournisseur",
        addItemFromBase: "Ajouter un article de la base",
        yes: 'Oui',
        no: 'Non',
        signIn: 'Connexion',
        password: 'Mot de passe',
        newPassword: 'Nouveau mot de passe',
        signOut: 'Deconnexion',
        administration: 'Configuration',
        users: 'Licences',
        gestionStockCommandes: 'ERP',
        shops: 'Commerces',
        shop: 'Commerce',
        showedStock: 'Stock affiché',
        delete: 'Supprimer',
        cancelCollect: 'Annuler la collecte',
        remove: 'Retirer',
        update: 'Mettre à jour',
        upload:'Mettre en ligne',
        online:'En ligne',
        optional:'Facultatif',
        offline:'Hors ligne',
        calculationMethod:'Méthode de calcul',
        activeOnPromotion:'Actif sur les promotions',
        forAmountOf:'Pour un montant de',
        perSlice:'Par tranche',
        inProportion:'Au prorata',
        activateOnPromotion:'Activer sur les promotions',
        totalCumulLoyaltyPoint:'Total des points de fidélité cumulés',
        fusionClientInfo:"Le client sélectionné disparaîtra de votre base client et toutes ses informations seront fusionnées avec celles de {clientName}",
        earnedLoyaltyPoint:'Points de fidélité acquis',
        confirmDeleteAllPage:'Souhaitez-vous vraiment supprimer toutes les lignes de la page',
        confirmDeleteUser: 'Souhaitez-vous vraiment supprimer l\'utilisateur',
        confirmDeleteGrade: 'Souhaitez-vous vraiment supprimer le grade',
        typeDeleteX: 'Souhaitez-vous vraiment supprimer ',
        typeCancelCollectX: 'Souhaitez-vous vraiment annuler la collecte de',
        typeDeleteReminderX: 'Souhaitez-vous vraiment supprimer le rappel pour ',
        confirmDeleteCheckDeposit: 'Souhaitez-vous vraiment supprimer cette remise de chèque ?',
        typeRemoveX: 'Souhaitez-vous vraiment retirer ',
        confirmArchiveX: 'Souhaitez-vous vraiment archiver ',
        confirmActiveX: 'Souhaitez-vous vraiment activer ',
        confirmDeleteGoals: 'Souhaitez-vous vraiment supprimer les objectifs de cette période ?',
        confirmRemoveRh: 'Souhaitez-vous vraiment retirer',
        confirmOpenFonCaisse: 'Êtes-vous sur de vouloir ouvrir cette caisse avec ',
        confirmAddClientForm: 'Souhaitez-vous vraiment ajouter un formulaire client',
        confirmRemoveClientForm: 'Souhaitez-vous vraiment retirer le formulaire client',
        loyaltyRewardConfig:'Configuration des récompenses de fidélité',
        selectLoyaltyRewardMode:'Sélectionner le mode de récompense de la fidélité clientèle',
        noRewardModeSelected:'Aucun mode de récompense sélectionné',
        cashback:'Cashback',
        availableCashBack:'Cashback disponible',
        toApplyTo:'A appliquer à',
        recompense:'Article offert',
        ofFondCaisse: 'de fond de caisse',
        confirmUnarchiveX: 'Souhaitez-vous vraiment activer ',
        confirmClockingX: 'Souhaitez-vous vraiment pointer ',
        confirmValidateLine:'Etes-vous sûr de vouloir valider ce bloc',
        confirmValidateAll:'Etes-vous sûr de vouloir tout valider',
        confirmCancelReceiptTo: "Êtes-vous sûr de vouloir annuler la réception de cet article",
        confirmCancelSaleOrder:'Etes-vous sûr de vouloir annuler cette commande',
        warningToCancelSaleOrder:'Des ordres de transfert sont associés à cette commande client, il est fortement recommandé de les annuler',
        confirmClosefondCaisse:'Êtes-vous sûr de vouloir clôturer cette caisse avec ',
        confirmDifferenceFondCaisse:'Êtes-vous sûr de vouloir ouvrir cette caisse avec une différence de ',
        confirmValidateInventory:'Êtes-vous sûr de vouloir valider cet inventaire, cette action sera irréversible',
        clotureDetailPdf:'Détail clôture de caisse',
        returnToItemReceipt:'Retour à la réception des articles',
        associateToAnItem:'Remplacer par un article existant',
        addPermanentlyMsg:'Attention, cette action est irréversible',
        de: 'de',
        exerciseStart:'Début d\'exercice',
        ecart:'Écart',
        closeNote:'Note',
        irreversibleAction: 'Attention: cette action sera irréversible',
        company: 'Entreprise',
        allCompany:'Toutes entreprises',
        canceled: 'Annulé',
        noLogoActualy: 'Aucun logo actuellement',
        noPhotoActualy: 'Aucune photo actuellement',
        man: 'Homme',
        woman: 'Femme',
        rh: 'Staff',
        modePaiement: 'Mode de paiement',
        loyaltyMode:'Mode de fidélité',
        general: 'Général',
        genere:'Générer',
        proposal:'Propositions',
        newTotalValueStock:'Valeur totale du nouveau stock',
        oldTotalValueStock:'Valeur totale de l\'ancien stock',
        totalValueSaleOrder:'Valeur totale des commandes client',
        totalPaiementSaleOrder:'Valeur totale des acomptes versés',
        tarifSellerModification: 'Modification manuelle d\'un prix',
        width:'Largeur',
        height:'Hauteur',
        openFondCaisse: 'Ouverture Caisse - Fond de caisse',
        fond_caisse:'Fond de caisse',
        closeFondCaisse: 'Clôture de Caisse',
        closeCaisse:'Clôture de caisse',
        repartGoals: 'Répartition objectifs',
        openCaisse: 'Ouverture de caisse',
        openTiroir:'Ouverture du tiroir',
        loyalty:'Fidélité',
        customerLoyalty:'Fidélité client',
        loyaltyPlan:'Plan de fidélité',
        accumulatedPoints:'Points cumulés',
        spentPoints:'Points dépensés',
        open:'Ouvrir',
        opened:'Ouvert',
        closeWith:'Clôturé avec',
        a: 'à',
        allShops:'Tous les commerces',
        allUsers:'Tous les utilisateurs',
        searchArticle: 'Recherche article...',
        searchInWait: 'Recherche en cours',
        cashier: 'Caissier',
        inventory:'Inventaire',
        clickOnZoneWithoutBins:'Cliquez sur une zone sans bins',
        mustCompleteOrCancelReceipt:'Vous devez d\'abord finaliser ou annuler votre ticket en cours',
        inventaireZone:'Inventaire type zone',
        inventaireBins:'Inventaire type bins',
        inventaireCategorie:'Inventaire type categorie',
        finalizedInventory:'Inventaire finalisé',
        inventoryType:'Type d\'inventaire',
        inventaireImport:'Import d\'inventaire',
        loyaltyPlanImport:"Import fidélité",
        ajustImport:'Ajustement de stock importé',
        returnInventory:'Retour à l\'inventaire',
        returnInventoryHome:'Retour à l\'accueil des inventaires',
        startCounting:'Démarrer le comptage',
        seeInventoryReport:'Voir le bilan de l\'inventaire',
        validateInventory:'Valider l\'inventaire',
        addSelection:'Ajouter la sélection',
        validateCount:'Valider le comptage',
        addToInventoryList:'Ajouter à la liste d\'inventaire',
        cancelCount:'Annuler comptage',
        cancelAllCount:'Annuler tous les comptages',
        cancelComparisonwithStok:'Annuler la comparaison avec le stock',
        allInventories:'Tous les inventaires',
        readInventoryDetail:'Consulter le détail d\'un inventaire',
        compareInventoryToStock:'Comparer l\'inventaire au stock',
        inventoryComparison:'Comparaison de l\'inventaire',
        allCounts:'Tous les comptages',
        selectCancellationOption:'Sélectionner l\'option d\'annulation',
        countNotFinished:'Comptage non terminé',
        wrongCount:'Comptage erroné',
        inventoryBinsMsg:'Le système créera plusieurs inventaires si le nombre de bins de la zone est trop important',
        confirmSecondCount:'Vous avez déjà effectué ce comptage, voulez-vous vraiment en effectuer un nouveau',
        zoneName:'Nom de la zone',
        customerPlacehlder: 'Client...',
        refineSearchResults: 'Précisez votre recherche pour voir plus de résultats',
        supplementListPlaceholder: 'Liste de supplément...',
        noRhForSection: 'Aucun staff n\'a été attribué pour ce point de vente',
        consultPriceItem: 'Voir prix article...',
        seeSaleOrder:'Voir la commande client',
        selectColumnFileToMatch:'Sélectionner la colonne du fichier à associer',
        selectColumnBaseToMatch:'Sélectionner la colonne de la base article à associer',
        stockArea: 'Zone de Stock',
        createStockArea: 'Créer une Zone de Stock',
        creerGiftCard:'Créer une carte cadeau',
        creerAbonnementCard:'Créer une carte d\'abonnement',
        stockHaveBins: 'Cette zone de stock doit avoir des bins',
        stockZoneEmpty:'Cette zone est vide',
        errorEcomOrderTraitement:'Erreur sur une commande client',
        newEcomOrder:'Nouvelle commande client',
        itemReference: 'Référence article...',
        cashOut: 'Retrait espèces',
        consulter: 'Consulter',
        attribuer: 'Attribuer',
        attribuerA: 'Attribuer à',
        synchronized:'Synchronisé',
        notSynchronized:'Non synchronisé',
        synchronizeItems:'Synchroniser les articles',
        itemMustHaveParentToBeOnline:"Cet article doit avoir un nom de parent pour être en ligne",
        attribuerSelection: 'Attribuer la sélection',
        generateReassort: 'Générer une proposition de réassort',
        validateProposalReassortFournisseur: 'Êtes-vous sûr de vouloir convertir cette proposition de réassort en bons de commande fournisseur ?',
        waitConvertInPo: 'Bon(s) de commande en cours de création. Vous allez être bientôt redirigé. Cette tâche peut prendre quelques minutes...',
        qteToOrder: 'Qté à commander',
        reassortGenerate:'Générer un réassort',
        addToFavorite:'Ajouter aux favoris',
        editFavorite:'Modifier favori',
        listOfFavorite:'Liste des favoris',
        favoriteName:'Nom du favori',
        generateReadjustment:'Générer un réajustement',
        proposalReassortList: 'Proposition de réassort',
        forDepotBanque: 'Ce retrait est pour un dépôt en banque',
        depotEnBanque: 'Dépôt en banque',
        typeRetrait: 'Type',
        retraitForOtherReason: 'Ce retrait est pour une autre raison',
        retraitOtherLabel: 'Indiquez la raison pour laquelle vous retirez de l\'espèces',
        confirmRetraitOtherReason: 'Souhaitez-vous vraiment retirer de l\'espèces pour un montant de',
        confirmRetraitBanqueReason:' Souhaitez-vous vraiment déposer en banque un montant de',
        confirmDeleteCustomerAssociate: 'Souhaitez-vous vraiment supprimer l\'association à ce client',
        confirmDeleteDivers: 'Souhaitez-vous vraiment supprimer',
        confirmDelete: 'Souhaitez-vous confirmer la suppression',
        confirmGenerateTo:"Êtes-vous sûr de vouloir générer un ordre de transfert depuis ce bon d'expédition",
        successOperation: 'Opération effectuée avec succès',
        deleteSelection: 'Supprimer la sélection',
        draftsSelected: 'brouillon(s) sélectionné(s)',
        bulkDeleteResult: '{deleted} brouillon(s) supprimé(s), {skipped} ignoré(s)',
        successInHistorique: 'Importation lancée avec succès. Vous pouvez suivre l\'état de l\'importation dans votre historique d\'importation.',
        ruleUpDateAlreadyAssigned:'Ce champ a déjà été attribué à une règle de mise à jour',
        addClient: 'Ajouter un client',
        editColumnPdf: 'Edition des colonnes',
        editRecapPdf: "Edition des lignes récapitulatives",
        addLogo: 'Ajouter un logo',
        cattc:'CA TTC',
        caht:'CA HT',
        taxesExcluded:'HT',
        taxesIncluded:'TTC',
        totalTTC:'Total TTC',
        goalsttc:'Objectifs TTC',
        goalsht:'Objectifs HT',
        grossMargin:'Marge brute',
        grossMarginPercent:'Marge brute en %',
        beginIsGreaterThanEnd:'Le début de période ne peut être supérieur à la fin de la période',
        periodIsGreaterThanAYear:'La période sélectionnée doit être inférieure à un an',
        importGoals: 'Importer des objectifs',
        createGrade: 'Créer un grade',
        createModePaiement: 'Ajouter un mode de paiement',
        createCashOutReason: 'Ajouter un justificatif de retrait d\'espèces en caisse',
        cashOutMore: "Vos justificatifs de retrait d'espèces en caisse",
        modePaiementForced: 'Modes de paiement basiques',
        modePaiementMore: 'Vos modes de paiements ajoutés',
        items: 'Articles',
        onlyUncollectedItemsProposed: '(seuls les articles non collectés dans la commande sont proposés)',
        today: 'Aujourd\'hui',
        hier: 'Hier',
        demain: 'Demain',
        noObjectif: 'Il n\'y a aucun objectif POS pour cette période',
        objectifs: 'Objectifs',
        realise: 'Réalisé',
        nbrEntreClient: 'Nombre de passage clients (entrée et sortie)',
        edit: 'Editer',
        period: 'Période',
        oneDay: 'Une journée',
        manyDays: 'Plusieurs jours',
        searchBy:'Rechercher par',
        day: 'Jour',
        de: 'De',
        vers: 'Vers',
        toA: 'À',
        seeAll:'Voir tout',
        seeMore:'Voir plus',
        createNotification:'Créer une notification',
        notifications:'Notifications',
        notificationModule:'Module',
        notificationAction:'Action',
        notificationLocation:'Lieu',
        notificationNotifiedUsers:'Utilisateur(s) notifié(s)',
        notificationBulkEditUsers:'Modifier les utilisateurs notifiés',
        notificationBulkDelete:'Supprimer la sélection',
        notificationSelectedCount:'{count} sélectionné(s)',
        selectAll:'Tout sélectionner',
        selectPlaceholder:'-- Sélectionner --',
        salesOrderNew:'Nouvelle commande à préparer',
        salesOrderError:'Erreur de traitement de commande',
        sectionNotAllowedForDomain:'Ce domaine ne peut pas être limité à un commerce précis',
        notificationActionShipment:'Bon d\'expédition à réceptionner',
        notificationActionTo:'Ordre de transfert à collecter',
        notificationActionItem:'Article temporaire créé',
        notificationActionSalesOrderNew:'Nouvelle commande e-commerce à préparer',
        notificationActionSalesOrderError:'Commande e-commerce non traitable',
        notificationActionSalesOrderCollectAssigned:'Collecte commande client B2C attribuée',
        notificationActionRppslPack:'Configuration RP/PSL manquante sur un pack RP/PSL',
        allRequired:'Ce champ est requis',
        disponible: 'Disponible',
        scannedTab: 'Scanné',
        addCashOut: 'Retrait d\'espèces',
        noEnougthForReassort: '{name} ne possède pas suffisament de stock pour satisfaire cette modification',
        confirmAddItemPromo: 'Confirmer la sélection de {quantity} articles',
        needEntre: 'Ce graphique sera disponible lorsque le nombre d\'entrée client sera renseigné',
        createGoals: 'Créer des objectifs commerce',
        attributeStaffGoals: 'Attribuer des objectifs au staff',
        deleteGoals: 'Supprimer des objectifs',
        createOneDayGoals: 'Créer les objectifs d\'une journée',
        report:'Reporting',
        datas:'Données',
        dropCsv: 'Déposez le fichier CSV ici ou cliquez pour télécharger.',
        noDataInCsv: 'Aucne donnée n\'a été trouvé dans ce fichier csv',
        zoneCsvImportBtn: 'Importer des zones via CSV',
        zoneCsvImportSuccess: '{inserted} zone(s) importée(s) avec succès',
        zoneCsvImportPartial: '{inserted} zone(s) importée(s) sur {total}. Voir le détail ci-dessous.',
        zoneCsvNoHeaderHelp: "Le fichier ne doit pas contenir de ligne d'en-tête.",
        csvLineError: 'Ligne {line} ({value}) : {errors}',
        fileCsvToLarge: 'Le fichier dépasse la taille maximale autorisée de 7 mégabytes',
        objectifCsvFileToLong: 'Le fichier csv doit avoir au maximum 1000 lignes',
        doublonCsv: 'Certaines colones du fichier csv sont utilisées sur plusieurs données différentes',
        indicateRecurrence:'Indiquer une récurrence',
        indicateRecurrenceMsg:'Indiquer le jour du mois pour lequel vous souhaitez que cette récurrence s\'applique pour le modèle {modeleName}',
        deleteRecurrence:'Supprimer la récurrence',
        exonerateFromTaxes:'Exonérer de {taxe}',
        every:'Tous les',
        ofMonth:' du mois',
        template: 'Modèle',
        recurrence:'Récurrence',
        reprogramRecurrenceOnNextMonth:'Reprogrammer la récurrence pour le mois suivant',
        templateConfiguration: 'Configuration du modèle',
        templateEmailConfiguration: 'Configuration du modèle d\'e-mail',
        emailBodyQuotation:'Corps par défaut de l\'e-mail d\'un devis',
        emailBodyInvoice:'Corps par défaut de l\'e-mail d\'une facture',
        emailBodyCreditNote:'Corps par défaut de l\'e-mail d\'un avoir',
        msgInfoContenuMail:'Les éléments notés entre crochets [] seront récupérés à partir des informations du document . Voici l\'ensemble des éléments que vous pouvez écrire entre crochet:',
        msgInfoContenuMailClient:'sera remplacé par le nom du client',
        msgInfoContenuMailNumero:'sera remplacé par le numéro du document',
        msgInfoContenuMailMontant:'sera remplacé par le montant TTC du document',
        msgInfoContenuClient:'[client]',
        msgInfoContenuNumero:'[numero]',
        msgInfoContenuMontant:'[montant]',
        msgEmailConfigure:'Lorsque vous créez une facture, un devis ou un avoir, il vous est proposé de l\'envoyer directement par e-mail à votre client. Le corps de l\'email qui vous sera proposé pour cette envoi sera celui que vous aurez préalablement indiqué ici.',
        seeMyTemplate:'Voir le modèle',
        importedRows: 'Lignes importées: ',
        infoModePaiement: 'Il s\'agit ici de lister les modes de paiement possibles pour votre entreprise. Attention: chacun de vos commerces peut utiliser des modes de paiements différents. De ce fait, il vous faut donc vous rendre dans les options de chacun de vos commerces pour y indiquer les modes de paiements qui y sont acceptés.',
        restrictionStaff: 'Restrictions Staff',
        reassortWait:'Proposition de réassort en cours de calcul. Cette tâche peut prendre quelques minutes...',
        rebillingWait:'Refacturation inter sociétés en cours. Cette tâche peut prendre quelques minutes...',
        interSocieteGenerationDone: 'Génération terminée avec des erreurs',
        interSocieteGenerationErrorFile: 'Au moins une erreur est survenue pendant la génération. Un fichier a été généré :',
        inventoryCompareWait:'Comparaison de l\'inventaire avec le stock en cours de calcul. Cette tâche peut prendre quelques minutes...',
        inventoryValidateWait:'L\'inventaire est en cours de validation. Cette tâche peut prendre quelques minutes...',
        waitReassortTo:'Ordre(s) de transfert(s) en cours de création. Vous allez être bientôt redirigé. Cette tâche peut prendre quelques minutes...',
        authorized: 'Autorisés',
        noRestriction: 'Aucune restriction',
        scanBadge: 'Scannez votre badge ici...',
        scanSellerBadge: 'Scannez votre badge de vendeur ici...',
        scanBadgeOrSearch:'Scannez votre badge ici ou recherchez un staff',
        formclient: 'Formulaire client',
        explicationFormClient: 'Indiquez les champs que vous souhaitez faire apparaitre dans le formulaire de création d\'un client',
        noFilter:'Aucun filtre',
        field:'Champ',
        obligatoire:'Obligatoire',
        requiredField: 'Champ obligatoire',
        notRequiredField: 'Champ non obligatoire',
        uniqueField: 'Valeur unique',
        notUniqueField: 'Valeur non unique',
        freeField: 'Valeur libre',
        fieldListData: 'Soumis à une liste de données',
        civilite: 'Civilité',
        activer: 'Activer',
        adressePhysique: 'Adresse Physique',
        adressePostale: 'Adresse Postale',
        communeVille:'Commune/Ville',
        inscriptionNewsletter: 'Inscription Newsletter',
        noFormClient: 'Le formulaire client de votre entreprise n\'est pas configuré',
        customerReward:'Récompenses client',
        homme: 'Homme',
        femme: 'Femme',
        noClientToEdit: 'Vous devez d\'abord indiquer un client',
        noCashierIndicated : 'Vous devez d\'abord indiquer un caissier',
        periodHigherOneMonth:'La période sélectionnée doit être inférieur à 1 mois',
        newItem: 'Nouvel article',
        stamp:'Tampon',
        parameterName: 'Paramètres avancés',
        otherCompany: 'Autres entreprises',
        interSociete: 'Refacturation inter sociétés',
        executeInterSociete: 'Lancer la refacturation inter société ?',
        refacturation:'Refacturation',
        exceptionRefacturation:'Exception de refacturation',
        mailSent:'Mail envoyé',
        mailOpened:'Mail ouvert',
        clientType: 'Type de client',
        quartier: 'Quartier',
        dateDeNaissance: 'Date de naissance',
        selectAType: 'Veuillez choisir un type',
        customField: 'Champ personnalisé',
        customFields: 'Champs personnalisés',
        category: 'Catégories',
        providerName: 'Nom du fournisseur',
        contactName: 'Nom du contact',
        categoryName: 'Nom de la catégorie',
        companyName: 'Nom de l\'entreprise',
        legalForm:'Forme juridique',
        documentType:'Type de document',
        documentDeleted:'Document supprimé',
        allType:'Tous types',
        draftListMsgInfo:'Seuls les brouillons de moins de 48 heures sont encore sauvegardés',
        fieldName: 'Nom du champ',
        defaultFields: 'Champs par défaut',
        providers: 'Fournisseurs',
        nouveauFournisseur: 'Nouveau fournisseur',
        editFournisseur: 'Editer un fournisseur',
        CDD: 'CDD',
        CDIE: 'CDI - Période d\'essai',
        CDI: 'CDI',
        archive: 'Archiver',
        archiveSelection: 'Archiver la sélection',
        activateSelection: 'Activer la sélection',
        confirmArchiveSelection: 'Souhaitez-vous vraiment archiver les articles sélectionnés :',
        confirmActivateSelection: 'Souhaitez-vous vraiment activer les articles sélectionnés :',
        noItemSelected: 'Aucun article sélectionné',
        itemsArchived: 'Articles archivés avec succès',
        itemsActivated: 'Articles activés avec succès',
        itemsRemovedFromList: 'Articles retirés avec succès',
        thisStaffIsArchive: 'Attention: ce staff est archivé',
        includeArchiveStaff: 'Inclure les Staff archivés',
        includeArchiveProvider: 'Inclure les fournisseurs archivés',
        includeArchiveData: 'Inclure les données archivées',
        includeArchivetem: 'Inclure les articles archivés',
        clientAssocie: 'Client Associé',
        clientArchiveAccocie: 'Ce Staff est archivé et ne peut donc pas être associé à un client',
        clientArchiveBadge: 'Ce Staff est archivé et il n\'est donc pas possible de générer un badge',
        deleteCheckDeposit:'Supprimer des remises de chèques',
        makeSale:'Réaliser une vente',
        downloadCSV: 'Exporter en csv',
        downloadZone:'Exporter le contenu de la zone',
        downloadBins:'Exporter le contenu de la bins',
        downloadQuickCSVSelection: 'Exporter une version rapide des lignes sélectionnées en csv',
        downloadCSVSelection: 'Exporter uniquement les colonnes sélectionnées en csv',
        downloadCSVPeriod: 'Exporter la période sélectionnée en csv',
        downloadCSVThisSelection: 'Exporter la selection en csv',
        downloadCSVThisSalesSelection: 'Exporter les ventes de la selection en csv',
        downloadCSVThisTicketsSelection: 'Exporter les tickets de la selection en csv',
        downloadCSVThisDocumentsSelection: 'Exporter les documents de la selection en csv',
        downloadCSVThisPaiementSelection: 'Exporter les moyens de paiement de la sélection en csv',
        downloadCSVAll: 'Exporter toutes les colonnes en csv',
        downloadAllPoCsv:'Exporter le contenu des bons de commande sélectionnés en csv',
        downloadSelectedPoCsv:'Exporter les entêtes des bons de commande sélectionnés en csv',
        downloadAllToCsv:'Exporter le contenu des ordres de transfert sélectionnés en csv',
        downloadAllToWithoutDetailsCsv:'Exporter les entêtes des ordres de transfert sélectionnés en csv',
        exportTransferOrdersInProgress:'Exporter les ordres de transfert en cours en csv',
        downloadAllShipmentCsv:'Exporter tous les bons d\'expédition en csv',
        downloadAllGiftCardCsv:'Exporter toutes les cartes cadeaux en csv',
        downloadAllAbonnementCardCsv:'Exporter toutes les cartes d\'abonnement en csv',
        downloadSelectGiftCardCsv:'Exporter uniquement la sélection en csv',
        downloadSelectAbonnementCardCsv:'Exporter uniquement la sélection en csv',
        exportRefactureSelection: 'Export selection refacturation',
        exportRefactureTotal: 'Export toutes lignes refacturation',
        downloadStockGap:'Exporter les écarts de stock',
        downloadExcel: 'Exporter en excel',
        downloadArticlesCSV: 'Exporter les articles en csv',
        downloadCSVecotaxe: 'Exporter l\'éco-participation en csv',
        downloadCSVecotaxeDetail: 'Exporter l\'éco-participation et son détail en csv',
        downloadCSVThisPreparationsSelection: 'Exporter les préparations de la selection en csv',
        downloadCSVThisPreparationsDetailsSelection: 'Exporter les préparations de la selection et leurs détails en csv',
        listDonnéesCsv: 'Exporter la liste des données possibles',
        firstlevelcat:'Classification',
        secondlevelcat: 'Famille',
        thirdlevelcat: 'Sous-famille',
        fourthlevelcat:'Categorie',
        fifthlevelcat: 'Sous-categorie',
        imageLink: 'Lien image article',
        categorysingular: 'Catégorie',
        addone: 'Ajouter une',
        addOption:'Ajouter une option',
        tagsMsg:'Vous pouvez cumuler plusieurs tags en les séparant d\'une virgule',
        emailsCumul:'Vous pouvez cumuler plusieurs emails en les séparant d\'une virgule',
        tagsMax:'Vous pouvez cumuler jusqu\'à 250 tags',
        staffIsAssociate: 'Ce Staff est associé au client',
        staffIsNotAssociate: 'Ce Staff n\'est associé à aucun client',
        newbrand: 'Nouvelle marque',
        includeArchiveBrands: 'Inclure les marques archivées',
        formBrand: 'Formulaire marque',
        archivedBrand: 'Cette marque est archivée',
        archivedProvider:'Ce fournisseur est archivé',
        associationStaffCustomer: 'Association d\'un Staff et d\'un client',
        transferOrderPriority:'Priorité de collecte d\'un ordre de transfert',
        transferOrderAssociation:'Association ordres de transfert',
        saleOrderAssociation:'Association commande client',
        noAssociateCustomerResult: 'Il n\'y a pas de possibilités d\'associations trouvées',
        impossibleDeletingFamily: 'La suppression est impossible !',
        familyContainItems: 'Cette catégorie contient des articles',
        impossibleArchivingFamily: 'L\'archivage est impossible !',
        formItem: 'Formulaire article',
        internalId: 'ID interne',
        internalid: 'ID interne',
        componentInternalId: 'ID interne composant',
        componentOf: 'Composant : {field}',
        expectedInternalId: 'ID interne souhaite',
        fournisseur: 'Fournisseur',
        notConnectedToFreebird:'Non connecté à Freebird',
        otherItemWithSameRefName:'Autres articles avec le même nom de référence',
        marque: 'Marque',
        reference: 'Code UPC',
        reference2: 'Code UPC 2',
        arrowUp: 'Flêche vers le haut',
        arrowDown: 'Flêche vers le bas',
        ecoTaxe: 'Eco-participation',
        barcode: 'Code-barres',
        barcodePackaginglist: 'Code-barres du conditionnement',
        shopCode:'Code du commerce',
        itemName: 'Nom article',
        priceTtc: 'Prix TTC',
        priceHt: 'Prix HT',
        supplierPrice: "Prix fournisseur",
        priceHtWithoutDiscount: 'Prix HT non remisé',
        marge: 'Marge',
        margeNet: 'Marge Nette',
        totalMargeNet: 'Total Marge Brute',
        differenceMargeNet: 'Ecart Marge Nette',
        totalBuyPrice:'Total prix d\'achat en devise',
        margePercent: 'Marge %',
        discountPrice: 'Prix promotionnel',
        discountProfil: 'Profil de promotion',
        percentageExceptionProfil: 'Profil d\'exception de pourcentage',
        discountProfilPersonalizedPrice: 'Profil de prix personnalisé',
        unitDiscount:'Remise unitaire',
        discountType:'Type remise',
        editionPrix:'Edition du prix',
        buy_price: 'Prix achat en devise',
        devise_achat: 'Devise achat',
        last_devise_achat: 'Dernière devise achat',
        stores: 'Commerces',
        tgc: 'Taux {taxe}',
        downloadBadge: 'Télécharger le badge',
        generateBadge: 'Générer le badge',
        thisItemMustHaveStock: 'Cet article sera dépendant d\'un stock',
        thisItemMustBePrepare: 'Cet article devra être préparé',
        thisItemIsArchived:'Cet article est achivé',
        itemHaveStock: 'Liaison au stock',
        itemToPrepare: 'A préparer',
        btnPrepare: 'Préparation',
        buffaloPreparationFtpError: 'Le ticket de préparation n\'a pas pu être envoyé sur le serveur FTP',
        buffaloPreparationOrigin: 'Préparation en provenance de Buffalo',
        preparations: 'Préparations',
        sendTicketToPreparation: 'Envoyer le contenu du ticket en préparation',
        ticketPrintDestination: 'Où le ticket doit-il être imprimé ?',
        preparationPrinter: 'Préparation',
        invalidItemForPreparation:'Des articles non valides pour la préparation sont présent dans le ticket',
        noPreparationFound:'Aucune préparation trouvé',
        customizationBadge: 'Personnalisation du badge',
        addIdPicture: 'Ajouter une photo sur le badge',
        addGrade: 'Ajouter le grade',
        addShopName: 'Ajouter le nom de l\'entité',
        addLastname: 'Ajouter le nom de famille',
        addShopLogo:'Ajouter le logo du commerce',
        chooseYouCompany: 'Selectionnez l\'entité',
        chooseYourBgColor: 'Choisissez une couleur de fond',
        chooseYourTextEntityColor: 'Choisissez la couleur du texte de l\'entité',
        chooseRefundMethod:'Choisissez le mode de remboursement',
        enterYourCustomColor: 'Ajouter une couleur en hexadécimal',
        addCustomColor: 'Ajouter une couleur de fond personnalisée',
        fieldToUpdate:'Champ à mettre à jour',
        fieldAutoUpdateItemRule:'Tous les articles qui auront ce champ renseigné de la même manière, seront automatiquement mis à jour',
        noUpdateRule:'Aucune règle de mise à jour',
        noEntity: 'Aucune entité',
        red: 'Rouge',
        blue: 'Bleu',
        yellow: 'Jaune',
        pink: 'Rose',
        green: 'Vert',
        black: 'Noir',
        white: 'Blanc',
        pr:'Prix de revient',
        prmp:'PRMP',
        beneficiary: 'Bénéficiaire',
        selectABeneficiary: 'Sélectionner un bénéficiaire',
        muststock: 'Article a un stock',
        mobil: 'Zone de transition',
        collect:'Collecter',
        receive:'Réceptionner',
        chosseMobile: 'Choisir le véhicule de livraison',
        choseReceptionZone:'Choisir la zone de réception',
        receiptPoDefaultZone:'Zone de réception par défaut d\'un bon de commande',
        receiptToDefaultZone:'Zone de réception par défaut d\'un ordre de transfert',
        collectToDefaultZone:'Zone de collecte par défaut d\'un ordre de transfert',
        receiptAndCollectDefaultZone: 'Zone de réception et collecte par défaut',
        choseAReceptionZoneToReceive:'Choisir une zone pour réceptionner l\'ordre de transfert',
        choseAReceptionZoneToCollect:'Choisir une zone pour collecter l\'ordre de transfert',
        choseAReceptionZoneToReceivePo:'Choisir une zone pour réceptionner le bon de commande',
        unauthorizedActionOnZoneBins:'La zone sélectionnée contient des bins, veuillez utiliser votre WMS pour la réception de cet ordre de transfert',
        duplicatePoReliquat:'Dupliquer la ligne en fonction du reliquat',
        duplicatePoReliquatConfirm:'Êtes-vous sûr de vouloir dupliquer la ligne en fonction du reliquat',
        duplicate: 'Dupliquer',
        reception: 'Zone de réception',
        commerciale: 'Lieu de vente',
        prive: 'Zone non accéssible à la vente et aux mouvements de stock',
        unpaidInvoice:'Factures non acquittées',
        nonAcquitte:'Non acquittée',
        stockage: 'Zone traditionnelle de stockage',
        commande: 'Stockage des commandes B2C',
        commandeB2b: 'Stockage des commandes B2B',
        zoneArchived: 'Attention : cette zone est archivée',
        importHistory: 'Imports',
        importReport: 'Rapport d\'import',
        articleImport: 'Import d\'articles',
        articleTransformImport: 'Import d\'articles transformés',
        clientImport: 'Import clients',
        supplementListImport: 'Suppléments article',
        poImport: 'Import Bon de Commande',
        toImport: 'Import Ordre de Transfère',
        shipmentImport: 'Import Bon d\'Expedition',
        rppslImport: 'Import Réassort automatique',
        rppslFournisseurImport: 'Import Réassort fournisseur',
        enCours: 'En cours',
        open:'Ouvert',
        close:'Fermé',
        on:'Sur',
        dataListpossible: 'Liste possible de données',
        editPersonalField: 'Editer un champ personnalisé',
        customFieldCreation:'Création de champ personnalisé',
        updateDatasRule:'Règle de mise à jour des données',
        editBrand: 'Editer une marque',
        clocking: 'Pointage',
        errorClocking: 'Badge non attribué pour ce commerce ou incorrect',
        errorPriorityCollect:'Vous ne pouvez pas définir deux fois le même commerce',
        errorNoBinsSelected:'Aucune bins n\'a été sélectionnée ',
        validateProposalReassort: 'Êtes-vous sûr de vouloir convertir cette proposition de réassort en ordre de transfert ?',
        errorClotureSaveTicket:'Veuillez supprimer tous vos tickets sauvegardés avant de clôturer votre caisse',
        nonAttribue: 'Non attribué',
        detailHistory: 'Détails de l\'historique',
        detailArticle: 'Détails de l\'article',
        detailPrice: 'Détails du prix',
        detailItem:'Détails article',
        stockItem:'Stock article',
        stockItemPos:'Stock article',
        negativeStock:'Stock négatif',
        importStock:'Import ajustement de stock',
        stockParent:'Stock parent',
        colonnes: 'Colonnes',
        rechercheSurValeurUnique: 'Recherche sur valeur unique',
        deleteLineItem:'Supprimer une ligne d\'article',
        removeQuantityOnLineItem:'Retirer une quantité de la ligne d\'article',
        removeDepositPayment:'Supprimer une ligne de paiement',
        filtres: 'Filtres',
        noFilter: 'Pas de filtre',
        noSelection: 'Pas de sélection',
        filterRppsl: 'Filtre RP/PSL',
        filterRppslPack: 'Filtre Pack RP/PSL',
        prmpIndice: 'Indice PRMP',
        prIndice: 'Indice prix de revient',
        parent_name: 'Nom du parent',
        itemInfos: 'Informations sur l\'article',
        paymentInfos:'Informations sur le paiement',
        limitDatePay:'Date limite de paiement',
        limitDateValidity:'Date limite de validité',
        detail:'Détail',
        customer: 'Client',
        customerProfil:'Profil du client',
        customerInfos: 'Informations du client',
        requiredInformations:'Informations obligatoires',
        principalInfo: 'Informations principales',
        secondInfo: 'Informations secondaires',
        warningImportInventaire:'Attention, cette fonctionnalité écrasera de façon irreversible votre stock précédent par le nouveau stock indiqué dans votre fichier, pour chacun des articles qui s\'y trouvent et dans chacune des zones indiquées. Vous ne devez JAMAIS importer l\'inventaire d\'un article pour une zone, si vous n\'avez pas réaliser son inventaire complet sur l\'ensemble de cette zone.',
        infoImportInventaireAddStock:'Cette fonctionnalité ajoutera le stock indiqué dans votre fichier à votre stock actuel, pour chacun des articles qui s\'y trouvent et dans chacune des zones indiquées.',
        infoSupplementListArticle: "Sont listés ici tous les articles possédant une liste de suppléments, mais qui n'appartiennent eux-mêmes à aucune liste de suppléments",
        infoAbonnementArticle: "Sont listés ici tous les articles possédant une configuration d'abonnement",
        itemLinkAndNotLinkToTock: 'Articles liés et non liés au stock',
        itemLinkToTock: 'Articles liés au stock',
        itemNotLinkToTock: 'Articles non liés au stock',
        itemNoHavestock: 'L\'article n\'est pas lié au stock',
        itemWithAndWitoutStock:'Articles avec et sans stock',
        itemWithStock:'Articles avec du stock',
        itemWWitoutStock:'Articles sans stock',
        carreposOutStock:'Vente Carrepos',
        setHook:'Activer le hook',
        noCarreposConfig:'Configuration Carrepos incomplète',
        carreposConnexionFailed:'Authentification Carrepos échouée',
        storeUnavailable:'Store indisponible',
        connectorConfigMissing:'Configuration du champ de connecteur manquante',
        referConfigMissing:'Configuration du champ de reference manquante',
        productNotFound:'Produits introuvable',
        deleteHook:'Supprimer le hook',
        unavailable:'Indisponible',
        diverseInfo: 'Informations diverses',
        devise: 'Devise',
        inDevise: 'En devise',
        migrate: 'Migrer',
        migrateFrom: 'Migrer de',
        vers: 'vers',
        errorMsgMin2:'Votre message doit contenir au minimum 2 caractères',
        errorSelectFamily: 'Vous devez indiquer une destination de migration valide',
        aucune: 'Aucune',
        aucunArticleRaccourci: 'Aucun article',
        noShops:'Aucun magasins',
        noSalesOrder:'Aucune commande client',
        justItemsWhoHaveStock: 'Uniquement les articles qui ont du stock',
        impossibleExport: 'Export impossible',
        maxLineAuth: 'Vous pouvez exporter au maximum {limit} lignes d\'un coup. Vous essayez actuellement d\'en exporter {actual}',
        csvWillBeReady: 'Demande d\'export enregistrée. Votre fichier CSV sera disponible sous peu dans votre gestionnaire de téléchargement de fichier CSV',
        exportRefactureFidelite: 'Export special refacturation',
        inventoryUpdateWillBeReady: 'Mise à jour de l\'inventaire en cours, cela sera effectif d\'ici 5 minutes sur {ecomName}',
        lastExportCsv: 'Derniers exports de fichiers CSV',
        exportDate: 'Date d\'export',
        exportSelectedColumnToCsv:'Exporter les colonnes sectionnées en csv',
        state:'État',
        itemHasNoStock:'Cet article n\'a pas de stock',
        errorExport: 'Une erreur est survenue lors de l\'export',
        errorImport: 'Une erreur est survenue lors de l\'import',
        errorNoStaffSelected:'Aucun staff n\'a été sélectionné',
        attributeSelectionToStaff:'Voulez-vous attribuer dès maintenant votre sélection',
        download: 'Télécharger',
        editArticle: 'Edition d\'un article',
        editClient:'Edition client',
        havestockInImport: 'Vous devez indiquer si cet article doit être dépendant d\'un stock',
        archivedInImport: 'Vous devez indiquer si cet article est archivé (oui/non)',
        itemCard: 'Fiche Article',
        defaultConfig: 'Configuration par défaut',
        personalizedConfig: 'Configuration personnalisée',
        addNewSection:'Ajouter une nouvelle rubrique',
        add: 'Ajouter',
        newApiKey:'Nouvelle clé API',
        apiKey:'Clé API',
        msgApiKeyExpire:'Votre clé API va expirer dans moins de 30 jours',
        msgNoApiKey:'Aucune clé API',
        noUserConf: 'Aucune configuration personnalisée',
        createApiKey:'Créer une clé API',
        activeApiKey:'Clé API active',
        createNewApiKey:'Créer une nouvelle clé API',
        msgApiKey:'Voici votre clé API',
        msgRecreateApiKey:'Êtes-vous sûr de vouloir regénérer une clé API',
        transformArticleAndOriginIsSame:'Une des lignes qui compose l\'article transformé est identique à l\'article lui-même',
        originAndComponentIsTheSame:'Les id internes sont identiques',
        deleteUserConf: 'Supprimer la configuration personnalisée',
        persoConfigVide: 'Votre configuration personnalisée est vide',
        defautConfigVide: 'Votre configuration par défaut est vide',
        noDefaultConf:'Aucune configuration par défaut',
        noConfAvailable:'Aucune configuration de disponible',
        itemAndZoneDetail:'Détail articles et zones',
        customizeInterface: 'Customiser l\'interface',
        customizationInterface: 'Customisation de l\'interface',
        importArticleAlreadyInProgress:'Un import d\'articles est déjà en cours d\'exécution',
        purchaseOrder:'Bon de commande fournisseur',
        selectMultiplePo:'Sélectionner plusieurs bons de commande',
        cancelMultiSelection:'Annuler la sélection multiple',
        receiveSelection:'Réceptionner la sélection',
        multiPoReceipt:'Réception de plusieurs bons de commande',
        setReceptionPriority:"Définir l'ordre de priorité de réception",
        purchaseOrderB2b:'Bon de commande',
        purchaseOrderForm:'Formulaire bon de commande',
        orderDate: 'Date de commande',
        expectedDeliveryDate:'Date attendue d\'expedition',
        requestedDeliveryDate:'Date d\'expédition demandée',
        requestedDeliveryDateNoAccent:'Date expedition demandee',
        realDeliveryDate:'Date reelle d\'expedition',
        estimateDeliveryDate:'Date estimée d\'expedition',
        deliveryDate:'Date d\'expedition',
        deliveryDateNoAccent:'Date expedition',
        expectedReceiptDate:'Date attendue de réception',
        expectedReceiptDateNoAccent:'Date attendue reception',
        expectedReceiptDateDock:'Date attendue de réception au dock',
        expectedReceiptDateInShop:'Date attendue de réception en magasin',
        estimatedDelivery:'Livraison estimee',
        lastSalesOrder:'Dernière commande client',
        lastQuotation:'Dernier devis',
        searchSalesOrder:'Rechercher une commande client',
        searchBins:'Rechercher une bins',
        quantity:'Quantite',
        quantiteParent:'Quantité parent',
        addOrRemoveStock:'Ajouter/retirer du stock',
        maxQuantity:'Quantite maximum',
        leave:'Quitter',
        leaveConversation:'Quitter la conversation',
        leaveNotifConfirm:'Êtes-vous sûr de vouloir vous retirer de la conversation',
        quantityTotal:'Quantité totale',
        quantityDisp:'Quantité disponible',
        quantityBloque:'Quantité bloquée',
        quantiteOnPurchase: 'Quantite commande',
        quantiteWait: 'Quantité en attente',
        purchaseOrders:'Bons de commande',
        createPurchaseOrder:'Créer un bon de commande',
        purchaseOrderName:'Nom du bon de commande',
        createdAt:'Date de création',
        dateBeginAbonnement:'Date de début d\'abonnement',
        dateEndAbonnement:'Date de fin d\'abonnement',
        dateEnd:'Date de fin',
        availableCredit:'Crédit disponible',
        lostCredit:'Crédit perdu',
        abonnementCardNotValid:'Carte non valide, veuillez vous rapprocher d\'un responsable',
        noAbonnementCardFound:'Carte introuvable, veuillez vous rapprocher d\'un responsable',
        abonnementCardTimeout:'Carte validée il y a moins de 5 minutes, réessayez ultérieurement',
        abonnementCardExists:'La carte existe déjà, veuillez réessayer',
        abonnementcard:'Carte abonnement',
        noClientAbonnementcard:'Le client est obligatoire pour vendre un abonnement',
        dateBeginAndEndRequired:'Les dates de début et fin doivent être obligatoirement renseigné ensemble',
        lastUpdate:'Dernière mise à jour',
        divers:'Divers',
        createBy: 'Créé par',
        staff:'Staff',
        finalised:'Finalisé',
        acquitte:'Acquitté',
        notAcquitte:'Non acquitté',
        partiallyAcquitte:'Partiellement acquitté',
        delivered:'Réceptionné',
        notDelivered: 'Non réceptionné',
        delivered2:'Livré',
        deliveredOk:'Livraison effectuée',
        notDelivered2: 'Non livré',
        notDeliveredLines: 'les lignes non réceptionnées',
        poCompletelyReceived:'Bon de commande entièrement réceptionné',
        noMoreItemToReceive:'Il n\'y a plus d\'articles à réceptionner dans ce bon de commande',
        completed: 'Finalisé',
        notCompleted: 'Non Finalisé',
        includeAllPurchaseOrders: 'Inclure les bons de commande finalisés',
        editPurchaseOrder: 'Editer le bon de commande',
        importPo: 'Importer du contenu aux Bons de Commande',
        importShipment: 'Importer du contenu aux Bons d\'expéditions',
        importReassort: 'Importer du contenu au Réassort automatique',
        importReassortFournisseur: 'Importer du contenu au Réassort automatique Fournisseur',
        importTo: 'Importer du contenu aux Ordres de Transferts',
        refer:'Nom de référence',
        billingRef:'Référence de la facture',
        quota_recu: 'Quantite recue',
        confirmLogout:'Voulez-vous vraiment changer de staff',
        status:'Statut',
        etat:'Etat',
        etat_conversion:'Etat de conversion',
        etat1:'Etat 1',
        etat2:'Etat 2',
        excludeCancelledDocument:'Exclure les documents annulés',
        includeCancelledDocument:'Inclure les documents annulés',
        justCancelledDocument:'Uniquement les documents annulés',
        fromTo:'Depuis ordre de transfert',
        fromPo:'Depuis bon de commande',
        since:'Depuis',
        regenerate:'Regénérer',
        depotBanqueTitle:'Attestation de versement d\'espèces',
        remiseCheckTitle:'Attestation de remise de chèque',
        toAlreadyCompleted: 'Cet ordre de tranfert a déjà été finalisé',
        allItems: 'Tous les articles',
        statusItems:'Statut des articles',
        statusLines:'Statut des lignes',
        itemsTotallyReceived: 'Articles entièrement réceptionnés',
        itemsPartiallyReceived: 'Articles partiellement réceptionnés',
        itemsNotReceived: 'Articles non réceptionnés',
        sku:'SKU',
        january:'Janvier',
        february:'Février',
        march:'Mars',
        april:'Avril',
        may:'Mai',
        june:'Juin',
        july:'Juillet',
        august:'Août',
        september:'Septembre',
        october:'Octobre',
        november:'Novembre',
        december:'Décembre',
        member:'Membres',
        writeNewMessageHere:'Ecrivez votre message ici...',
        relatedRecord: 'Enregistrements liés',
        relatedItems:'Articles concernés',
        addItemsInfoPromo:'Utilisez le filtre pour cibler les articles à ajouter à la promotion',
        redirect:'Rediriger',
        updatePoRecords: 'Mise à jour dans',
        insertPoRecords: 'Ajout dans',
        updateShipmentRecords: 'Mise à jour dans',
        updateInventory:'Mise à jour du stock',
        updateTheInventory:'Mettre à jour le stock',
        insertShipmentRecords: 'Ajout dans',
        entreStockRecords: 'Entrée en stock',
        voirLe: 'Voir',
        saleOrderCanceled:'Cette commande client a été annulée',
        saleOrderFinish:'Cette commande client a été finalisée',
        saleOrderFinishTicket:'Cette commande a été finalisée sous le numéro de facture: ',
        itemsDetail:'Détail article',
        registrationDate:'Date d\'enregistrement',
        shipmentVoucher: 'Bon d\'expédition',
        shipment: 'Bon d\'expédition',
        transferOrder: 'Ordre de transfert',
        transferOrders: 'Ordres de transfert',
        shipmentVoucherAccent: 'Bon expedition',
        entre: 'Entrée',
        expected:'Prévu',
        numero_shipment: 'Bon d\'expédition',
        numero_container_shipment: 'Numéro du conteneur',
        numero_container_shipment_accent: 'Numero du conteneur',
        date_depart_shipment:'Date de départ',
        date_depart_shipment_accent:'Date depart',
        date_arrive_shipment:'Date d\'arrivage',
        date_alert:'Date de rappel',
        date_arrive_shipment_accent:'Date arrivage',
        status_shipment:'Statut',
        createShipmentVoucher: 'Créer un bon d\'expédition',
        manualEntry:'Saisie manuelle',
        inventoryZone:'Zone d\'inventaire',
        inventoryOption:'Option d\'inventaire',
        inventoryZoneList:'Liste des zones d\'inventaire',
        countFromInventory:'Comptage de l\'inventaire',
        cours_chargement: 'En cours de chargement',
        alert_texte:'Texte de rappel',
        cancelReminder:'Effacer le rappel',
        warehouse:'Dock',
        mer: 'En mer',
        douane: 'En douane',
        dock: 'En cours de réception',
        receptione:'Réceptionné',
        receipt:'Réception',
        receptioneLines:'lignes réceptionnées',
        includeAllShipmentVoucher: 'Inclure tous les bons d\'expédition',
        exceptReceivedVoucher: 'hors réceptionnés',
        depositDate:'Date de dépôt',
        only:'Uniquement',
        customCreateForm: 'Personnaliser le formulaire de création',
        customVoucherDetails: 'Personnaliser les details du bon',
        PurchaseOrderCard: 'Fiche bon de commande',
        shipmentVoucherCard:'Fiche bon d\'expédition',
        shipmentVoucherForm:'Formulaire bon d\'expédition',
        toCustomForm:'Formulaire d\'ordre de transfert',
        no_box:'Pas de carton',
        shde_carton_name:'Reference carton',
        shde_quota_prevu:'Quantité prévue en carton',
        shde_quota_prevu_accent:'Quantite prevue en carton',
        shde_quota_recu:'Quantité reçue',
        shde_carton_recu:'Carton receptionne',
        shde_carton_recu_accent:'Carton receptione',
        receiptShipmentVoucher:'Réception des bons d\'expédition',
        receiptPo:'Réception des bons de commande fournisseur',
        scanBoxHere:'Scanner un carton ici',
        scanBoxToCheckHere:'Scanner un carton ici',
        scanItems:'Scanner un article ici',
        boxeChoice:'Choix du carton',
        itemChoice:'Choix de l\'article',
        drawerName:'Nom du tireur',
        priorityBox:'Carton prioritaire',
        french:'Français',
        english:'Anglais',
        spanish:'Espagnol',
        po: 'Bon de commande fournisseur',
        to: 'Ordre de transferts',
        totalPrmp: 'Total PRMP',
        totalPr: 'Total prix de revient',
        allBoxes: 'Tous les cartons',
        allSalesOrder:'Toute les commandes client',
        allLines: 'Toutes les lignes',
        allInvoices:'Toutes les factures',
        allCompanies:'Toutes les entreprises',
        onlyUnpaidInvoices:'Seulement les factures non acquittées',
        boxesStatus: 'Statut des cartons',
        assignAWms: 'Attribution WMS',
        forCollect: 'pour collecte des articles',
        forSignAndDelivery: 'pour signature et livraison',
        forSotckReentry: 'pour rentrée en stock',
        assignAShop: 'Attribuer à un commerce',
        sectionReception:'Section de réception',
        noWmsAttribution: 'Aucune attribution à un WMS',
        noShipmentVoucher: 'Aucun bon d\'expédition',
        noPurchaseOrder: 'Aucun bon de commande',
        noReassortInterne: 'Aucun reassort interne en cours',
        editShipmentVoucher: 'Editer le bon d\'expédition',
        editTransferOrder: 'Editer l\'ordre de transfert',
        receivedBy:'Receptionne par',
        of:'sur',
        poLineAlreadyReceptione:'Ce bloc a déjà été réceptionné',
        ZoneWithBins:'Aucune bins n\'a été renseignée pour cette zone',
        someItemsNotPresentInPo:'Certains des articles réceptionnés ne font pas partie du bon de commande',
        unauthorizedDivision:'La ligne que vous souhaitez dupliquer ne peut pas être divisée par le reliquat',
        cannotOpenToBecauseAllClose: 'Vous ne pouvez rouvrir cet ordre de transfert car toutes les actions y sont achevées',
        cannotEditToBecauseIsClose: 'Vous ne pouvez pas éditer cet ordre de transfert car il est fermé',
        errorScan:'Le carton {barcode} n\'existe pas',
        successScan:'Le carton {barcode} a été scanné avec succès',
        reinstateScan:'Le carton {barcode} a déjà été scanné, voulez vous le réintégrer aux cartons non scannés ?',
        successReinstate:'Le carton {barcode} a été réintégrer avec succès',
        checkingBoxes:'Réception des cartons',
        checkingItems:'Réception des articles',
        itemsReceipt:'Réception des articles',
        itemsCollect:'Collecte des articles',
        notScannedYet:'Ce carton n\'a pas encore été scanné, voulez-vous être redirigé sur la page de réception des cartons ?',
        quantityCommande:'Quantité commandée',
        createStorageSpace:'Créer des bins en masse',
        binsList:'Liste de Bins',
        exportBinsListCsv:'Exporter la liste des bins en CSV',
        showNeverUsedBinsOnly:'Afficher uniquement les bins jamais utilisées',
        binsHaveStockCantDelete:'Cette bins contient actuellement du stock, elle ne peut pas être supprimée',
        binsHaveStockCantDeletePlural:'Ces bins contiennent actuellement du stock, elles ne peuvent pas être supprimées',
        replacementBinsMustBeDifferent:'La bins de remplacement doit être différente de la bins à supprimer',
        replacementBinsMustBeSameZone:'La bins de remplacement doit être dans la même zone que la bins à supprimer',
        replacementBinsTitle:'Bins de remplacement',
        replacementBinsExplanation:'Une ou plusieurs des bins sélectionnées ont déjà eu des mouvements de stock par le passé. Pour les supprimer, choisissez une autre bins de la même zone qui reprendra leur historique de mouvements (ex: 1-2-3).',
        binsMustBeSameZone:'Les bins sélectionnées doivent toutes être dans la même zone',
        deleteBinsSelection:'Supprimer la sélection',
        confirmDeleteBinsSelection:'Souhaitez-vous vraiment supprimer les bins sélectionnées :',
        createOneBins:'Créer une bins',
        beginningFirstLevel:'Début du premier niveau',
        endFirstLevel:'Fin du premier niveau',
        beginningSecondLevel:'Début du second niveau',
        endSecondLevel:'Fin du second niveau',
        beginningThirdLevel:'Début du troisième niveau',
        endThirdLevel:'Fin du troisième niveau',
        beginningFourthLevel:'Début du quatrième niveau',
        endFourthLevel:'Fin du quatrième niveau',
        beginningFifthLevel:'Début du cinquième niveau',
        endFifthLevel:'Fin du cinquième niveau',
        firstEndBinsGte:"La fin du premier niveau ne peut pas être supérieure à la valeur du début du premier niveau",
        secondEndBinsGte:"La fin du second niveau ne peut pas être supérieure à la valeur du début du second niveau",
        thirdEndBinsGte:"La fin du troisième niveau ne peut pas être supérieure à la valeur du début du troisième niveau",
        fourthEndBinsGte:"La fin du quatrième niveau ne peut pas être supérieure à la valeur du début du quatrième niveau",
        fifthEndBinsGte:"La fin du cinquième niveau ne peut pas être supérieure à la valeur du début du cinquième niveau",
        firstBins:'Premier niveau',
        secondBins:'Second niveau',
        thirdBins:'Troisième niveau',
        fourthBins:'Quatrième niveau',
        fifthBins:'Cinquième niveau',
        zone:'Zone',
        successBinsSkip:'Opération effectuée avec succès, cependant les bins suivantes n\'ont pas été créées car elles existent déjà',
        scanedBox:'Cartons scannés',
        scanBinsHere:'Scanner la bins ici',
        attributeAStorageArea:'Attribuer à un espace de stockage',
        selectAStorageArea:"Sélectionner une zone de stockage",
        billing:'Facture',
        billings:'Factures',
        quotation:'Devis',
        quotationCreate:'Création devis',
        purchaseOrderB2bCreate:'Création bon de commande',
        deliveryNoteCreate:'Création bon de livraison',
        creditNoteCreate:'Création avoir',
        returnNoteCreate:'Création bon de retour',
        billingBuyCreate:'Création facture d\'achat',
        poB2bCollectedUp:'Bon de commande: collecte',
        poB2bCollectedDown:'Bon de commande: mise en zone commande',
        cancelledPoB2bCollectedUp:'Bon de commande: annulation collecte',
        cancelledPoB2bCollectedDown:'Bon de commande: annulation mise en zone commande',
        poB2bMouvement:'Mouvement bon de commande',
        deliveryNoteOutStock:'Sortie de stock bon de livraison',
        outStock:'Sortie de stock',
        cancelledOutStock:'Annulation sortie du stock',
        billingOutStock:'Sortie de stock facture',
        returnNoteReturnInStock:'Retour en stock bon de retour',
        rnReceipt:'Retour en stock',
        creditNote:'Avoir',
        creditNotes:'Avoirs',
        searchModel:'Rechercher un modèle',
        searchRoughtDraft:'Rechercher un brouillon',
        selectOnProductList:'Sélectionner dans la liste de produits',
        itemsSelection:'Sélection d\'articles',
        addStock:'Importer du stock',
        or:'Ou',
        totalStock:'Total en stock',
        boxesInfos:'Informations sur les cartons',
        binsNumber:'Numéro de bins',
        binsNumb:'Numero de bins',
        storageArea:'Zone de stockage',
        articlesList:'Liste des articles',
        boxNotScaned:'Carton non scanné',
        itemNotExist:'L\'article {sku} n\'existe pas',
        itemNotExistInThisTo:'L\'article scanné n\'apparait pas dans cet ordre de transfert',
        itemNotExistInThisPoB2b:'L\'article scanné n\'apparait pas dans ce bon de commande',
        finishScanBefore:'Vous devez finir de scanner cet article avant d\'en scanner un autre',
        selectRowScan:'Sélectionner le bloc à scanner',
        location:'Localisation',
        binsDetails: 'Contenu des bins',
        zoneDetails: 'Contenu des zones',
        onOrder:'En commande fournisseur',
        receivedLines: "Ligne réceptionnée",
        totalHt: 'Total HT',
        differencePrmp:'Ecart PRMP',
        differencePr:'Ecart prix de revient',
        differenceHt:'Ecart HT',
        caddie:'Caddie',
        providedCashFund:'Fond de caisse prévu',
        prevu:'Fond de caisse prévu',
        prevu_session:'Prévu',
        recipient:'Destinataire',
        limitDayPayment:'Date limite de paiement',
        caseLatePayment:'En cas de retard de paiement',
        optionalNoteMsg:'Mentions facultatives à faire apparaître sur le document',
        settleInvoice:'Voulez-vous acquitter cette facture ?',
        cancelLimitDatePaymentMsg:'Cela annulera la date limite de paiement si vous l\'avez renseigné',
        cancelSettleMsg:'Cela annulera l\'acquittement de la facture si vous l\'avez renseigné',
        indicateLimitDateOfPayment:'Voulez-vous indiquer une date limite de paiement ?',
        indicateLimitValidDate:'Voulez-vous indiquer une date limite de validité ?',
        addTextOnTopPart:'Voulez-vous ajouter un texte dans la partie supérieure du document ?',
        addTextOnBottomPart:'Voulez-vous ajouter un texte dans la partie inférieure du document ?',
        topText:'Texte supérieur',
        topTextSize:'Taille du texte supérieur (par défaut 10)',
        bottomText:'Texte inférieur',
        bottomTextSize:'Taille du texte inférieur (par défaut 9)',
        texteDocuments:'Texte documents',
        modeReplaceConfig:'Remplace la configuration par défaut',
        modeAddConfig:'S\'ajoute à la configuration par défaut',
        sortField:'Champ de tri',
        groupField:'Champ de regroupement',
        paidOn:'Payé le',
        generateFreebird:'Généré par Freebird',
        dashboard:'Tableau de bord',
        total:'Total',
        totalWithoutDiscount:'Total non remisé',
        tax:'Taxe',
        openWith:'Ouvert avec',
        binsMovement:'Mouvement de stock',
        stockDeplacement:'Déplacement de stock',
        simpleMove: 'Mouvement simple',
        massMouvement:'Mouvement de stock en masse',
        avlQuantity:'Quantité disponible',
        qteToMove:'Quantité à déplacer',
        qteToTransfer:'Quantité à transférer',
        qteReceived:'Quantité réceptionnée',
        receivedOn:'Réceptionné le',
        qteThinkMove:'Quantité collectée',
        qteIsMove:'Quantité déposée',
        collectedAt:'Collecté le',
        deposedAt:'Déposé le',
        collected:'Collecté',
        converted:'Converti',
        notConverted:'Non converti',
        isFactured:'Facturé',
        isNotFactured:'Non facturé',
        partiallyConverted:'Partiellement converti',
        qteToCollect:'Quantité à collecter',
        inLivraison:'Mis en livraison',
        outLivraison:'Sorti de livraison',
        devisNonConvertis:'Devis non convertis',
        bonDeCommandeNonCollectes:'Bons de commande non collectés',
        bonDeCommandeNonConvertis:'Bons de commande non convertis',
        bonDeLivraisonNonLivres:'Bons de livraison non livrés',
        bonDeLivraisonNonFactures:'Bon de livraison non facturés',
        avoirNonUtilises:'Avoirs non utilisés',
        bonDeRetourNonCollectes:'Bon de retour non collectés',
        factureAcompteNonUtilise:'Factures d\'acompte non utilisés',
        factureAchatNonAcquitte:'Factures d\'achat non acquittées',
        shipmentDelivery:'Expédition et livraison', 
        carriers:'Transporteurs',
        orderPreparationZone:'Zone de préparation de commande',
        matchInternalId:"Associer les ids internes",
        matchingInternalIdImport:"Association des ids internes",
        deposed:'Déposé',
        closed:'Fermé',
        qteReached:'Quantité maximale atteinte',
        qteExceed:'Quantité maximale dépassée',
        qteAvlInsufficient:'La quantité disponible est insuffisante',
        qteAvlInsufficientForItem:'La quantité disponible est insuffisante pour {name}',
        selectStorageDestination:'Sélectionner la zone de stockage',
        cantScanDifferentItem:'Vous ne pouvez pas scanner plusieurs articles en même temps',
        itemNotInThisArea:'Cet article n\'apparaît pas dans cette zone de stockage',
        moveAllArticles:'Tout déplacer',
        scannedArticlesList:'Articles scannés',
        clickToSeeRecommendedDestinations:'Cliquez sur un article pour voir ses destinations conseillées',
        origin:'Provenance',
        destination:'Destination',
        scanTheItemHere:'Scanner l\'article ici',
        binsContent:'Contenu de la bins',
        emptyBins:'Cette bins est vide',
        emptyTrolley:'Votre caddie est vide',
        totalDevise:'Total en devise',
        totalEquivalenceDevise:'Équivalence {devise}',
        equivalenceDeviseOption:"Afficher une équivalence de devise",
        equivalenceDeviseHelp:"Configurez ci-dessous les devises libres pouvant être proposées à l'affichage sur les factures et états de compte. Taux = nombre d'unités de la devise locale pour 1 unité de la devise choisie (le montant affiché est le total divisé par ce taux).",
        equivalenceDeviseCode:'Code devise',
        noEquivalenceDevise:'Aucune',
        addEquivalenceDevise:'Ajouter une devise',
        tauxConversion:'Taux de conversion',
        deviseEquivalenceDuplicate:'Un code de devise est utilisé plusieurs fois',
        deviseEquivalenceRequired:"Équivalence de devise requise",
        deviseEquivalenceInvalid:"Équivalence de devise invalide",
        referencePo:'Référence',
        internetRef:'Référence commande internet',
        seeReceiptVoucher:'Voir le bon de réception',
        voucherNumber:'Numéro du bon',
        receiptDate:'Date de réception',
        boxNumber:'Numéro du carton',
        itemsDetails:'Détails des articles',
        receiptVoucher:'Bon de réception',
        cancelBoxReceipt:'Annulation de la réception d\'un carton',
        cancelItemReceipt:'Annulation de la réception d\'un article',
        cancellationOnReceipt:'Annulation sur ticket',
        cancelAllReceipt:'Annuler toute la réception',
        confirmCancelAllReceipt:'Cette action va annuler TOUTE la réception de ce bon d\'expédition : le stock sera remis à jour et les quantités seront retirées du bon de commande associé. Cette action est irréversible, confirmer ?',
        cancelAllReceiptSuccess:'Toute la réception a été annulée avec succès',
        inactiveStockArticles:'Articles inactifs',
        lastMovementType:'Dernier type de mouvement',
        lastMovementDate:'Date du dernier mouvement',
        someItemsAlreadyScan: "Action impossible, les articles de ce carton sont déjà intégrés au stock",
        cancelItemsEntry:'Annuler l\'entrée en stock des articles',
        itemsReinstate:'Réintégration articles',
        cancellationStockEntry:'Annulation entrée en stock',
        resolveNegative:'Résolution automatique de stock en magasin',
        errorReinstateNotPossible:'Vous ne pouvez pas réintégrer un article non réceptionné',
        selectBlockToReinstate:'Sélectionner le block à réintégrer',
        selectBlocksToReinstate:'Sélectionner les blocks à réintégrer',
        qteInSalesPoint:'Stock dans l\'espace de vente',
        qteInReserve:'Quantité en réserve',
        errorStockReassortMsg:'Il existe actuellement des articles avec des quantités de stock négatives dans votre espace de vente. Les articles concernés sont indiqués ci-dessous. Nous vous conseillons vivement de corriger ces stocks négatifs avant de continuer. Dans le cas contraire, les articles avec des stocks négatifs ne seront pas pris en compte dans le traitement du réassort interne',
        btnReadjustmentAndRestock:'Appliquer le réajustement et générer un réassort',
        btnReadjustmentAndNoRestock:'Continuer sans corriger les stocks négatifs',
        autoRestock:'Réassort automatique',
        autoRestockInternal:'Réassort automatique interne',
        autoRestockSupplier:'Réassort automatique fournisseur',
        reassortInterne:"Réassorts internes",
        resolveNegative:'Correction de stock automatique',
        resolveShopNegative:"Correction stock négatif en magasin",
        internalRestock:'Réassort interne',
        backToInternalRestockList:'Retour à la liste des réassorts internes',
        priorityInternalRestock:'Priorité réassort interne',
        restockList:'Liste des réassorts',
        listSelection:'Choix de la liste',
        actionOnExistingListItem:'Action sur la liste d\'articles existante',
        orderList:'Liste des commandes client',
        underwayRestockMsg:'Un réassort est en cours',
        toCorrectionDeposed:'Correction de stock pour différence entre quantité collectée et quantité livrée',
        reorderPoint: 'Niveau de stock minimum RP',
        referenceTo:'Référence',
        trolley:'Caddie',
        referenceToNoAccent:'Reference',
        transfert_leNoAccent: 'A executer le',
        transfert_le: 'A exécuter le',
        origin_section: 'Commerce d\'origine',
        availableInOriginSection: 'Disponible commerce d\'origine',
        destination_section: 'Commerce de destination',
        rhBarre: 'Code-barre staff',
        preferredStockLevel:'Niveau de stock optimal PSL',
        rppslAutoConfigTitle: 'Configuration réassort automatique RP/PSL',
        rppslAutoGenerationDate: 'Date de génération des RP/PSL automatique',
        rppslPack: 'Pack RP/PSL',
        enableRppslPackFeature: 'Activer la fonctionnalité des packs RP/PSL',
        rppslPackNameAlreadyExists: 'Un pack RP/PSL avec ce nom existe déjà.',
        exportRppslPackMissingArticles: 'Exporter les articles ciblés sans RP/PSL',
        exportRppslPackConfig: 'Exporter la configuration des packs',
        importRppslPack: 'Importer un Pack RP/PSL',
        csvPackName: 'Nom du pack',
        csvPackMatching: 'Correspondance',
        createRppslPack: 'Créer un pack RP/PSL',
        editRppslPack: 'Modifier le pack RP/PSL',
        packType: 'Type de pack',
        typeSpecial: 'Spécial',
        customFieldArticleMatch: 'Champ personnalisé (correspondance article)',
        restrictToSections: 'Restreindre à certaines sections',
        allSections: 'Toutes les sections',
        confirmDeleteRppslPack: 'Supprimer ce pack RP/PSL',
        productNomenclatureFilters: 'Filtres de nomenclature produit',
        addFilterGroup: 'Ajouter une sélection de critères',
        noFilterGroup: 'Aucune sélection de critères ajoutée',
        noFilterFieldConfigured: 'Aucun champ configuré pour les filtres de pack. Configurez-le dans Administration > Personnalisation > RP/PSL > Filtre Pack RP/PSL.',
        rpPslByValueTitle: 'Définir le RP et le PSL pour chaque valeur du champ "{field}"',
        rpPslValuesOptionalHint: 'Vous pouvez laisser des valeurs vides et valider le pack quand même — elles pourront être complétées plus tard via l\'import CSV.',
        and: 'ET',
        filterMode: 'Mode de filtre',
        filterModeInclude: 'Inclusion',
        filterModeExclude: 'Exclusion',
        concernedArticles: 'Articles concernés',
        noMatchingArticleValue: 'Aucun article correspondant trouvé pour les critères sélectionnés',
        rpPslValuesInvalid: 'Veuillez renseigner un RP et un PSL valides (PSL supérieur ou égal au RP) pour chaque valeur',
        excludeFilterSwitch: 'Exclure les produits correspondants au lieu de les inclure',
        excludeFilterHelp: 'Par défaut, seuls les produits correspondant aux sélections ci-dessus sont inclus dans ce pack. Activez cette option pour les exclure à la place : tous les autres produits seront alors inclus. Sans sélection et avec l\'exclusion activée, tous les produits sont inclus.',
        pslGteRp: 'Le PSL doit être supérieur ou égal au RP',
        backToPackList: 'Retour à la liste des packs',
        exportCsvArticles: 'Exporter les articles en CSV',
        creationDate: 'Date de création',
        actualStockDisp:'Stock actuel disponible',
        actualStock:'Stock actuel',
        reassortEnCours:'Réassort à venir',
        recommendedDestination:'Destinations conseillées',
        sameItem:'Même article',
        sameParent:'Même Parent',
        box:'Carton',
        tagSize:'Dimension de l\'étiquette',
        rpInteger:'Le niveau de stock minimum RP de {name} doit être un nombre entier',
        pslInteger:'Le niveau de stock optimal PSL de {name} doit être un nombre entier',
        rppslAllOrNone:'Vous ne pouvez pas renseigner un RP sans PSL (et vice versa) pour {name}',
        detailProvider:'Détails du fournisseur',
        providerCard:'Fiche fournisseur',
        allPo:'Tous les bons de commande',
        generateABarCode:'Générer un code-barre',
        generateMasseBarCode:'Générer les codes barres en masse',
        generateMasseBarCodePdf:'Générer les codes barres pdf en masse',
        generateABarCodePdf:'Générer un code barre pdf',
        quantityManualModification:"Modification manuelle des quantités",
        stockReorganization:'Réorganisation du stock',
        removeFromStock:'Retirer du stock',
        removeOption:'Retirer une option',
        addToStock:'Ajouter au stock',
        chooseAnAction:'Choisir une action',
        choisir:'Choisir',
        selectSection:'Sélectionner un commerce',
        selectType:'Type d\'ajustement',
        stockError:'Erreur de stock',
        transferOrderError:'Erreur de TO',
        stockIntegration:'Intégration au stock',
        stockRemove:'Retrait du stock',
        stockAdjustment:'Ajustement du stock',
        massStockAdjustment:'Ajustement du stock en masse',
        stockAdjustmentConfirmation:'Confirmez-vous les ajustements du stock ?',
        stockAdjustmentResetConfirmation:'La liste des articles sera effacée, confirmez-vous la réinitialisation de l\'ajustement du stock ?',
        attemptedStockAdjustment:"Tentative d'ajustement du stock",
        error_open_checkout:'Erreur sur l\'ouverture de caisse',
        error_close_checkout:'Erreur sur la fermeture de caisse',
        validateAll:'Valider l\'ensemble',
        reinstateAllItems:'Réintégrer tous les articles',
        reinstateOneItem:'Réintégrer un article',
        reinstateSelection:'Réintégrer la sélection',
        confirmReinstateItems:'Souhaitez-vous vraiment réintégrer tous les articles ?',
        noBarcodeFounded:'Aucun code-barre n\'a été trouvé',
        rppsl:'Rppsl',
        allTransferOrders:'Tous les ordres de transferts',
        exceptFinished:'hors finalisé',
        transferOrderNotStarted:"Ordres de transferts non commencés uniquement",
        notStarded:'Non commencé',
        processOfCollecting:'En cours de collecte',
        toEnCours:'Ordres de transferts en cours uniquement',
        processOfDelivery:'En cours de livraison',
        processOfEmptying:'En cours de dépotage',
        transferOrderEdit:'Edition d\'un ordre de transfert',
        errorDeleteTO:'Vous ne pouvez pas supprimer cet ordre de transfert',
        wrongBins:'Vous avez scanné la mauvaise bins',
        wrongItem:'Vous avez scanné le mauvais article',
        stockNegativeAlert:"Alerte stock négatif",
        stockNegativeAlertLabel:"Alerter lors d'une vente si l'article vendu est ou sera en stock négatif",
        stockNegativeAlertMsg:"L'article que vous venez d'ajouter aura un stock négatif si vous finalisez cette vente",
        stockNegativeAlertMsgAutoReassort:"L'article que vous venez d'ajouter aura un stock négatif si vous finalisez cette vente. S'il est disponible dans la zone %zone%, un ajustement de stock sera effectué automatiquement à la finalisation de la vente",
        reassortAutoLabel:"Réassort automatique",
        zoneReassortAutoLabel:"Zone de réserve à utiliser",
        allowTransferOrderWithDifferentValue:"Ordres de transfert et commandes avec des quantités différentes",
        zoneWithoutBins:'Zone sans bins', 
        uncompletedLines:'Lignes inachevées',
        transferTo:'Transférer vers',
        transferOrderCompleted:'Ordre de transfert finalisé',
        errorToStockMissing:"L'ordre de transfert n'a pas pu être finalisé correctement dû à un défaut de stock",
        confirmValidateAsIs:"Êtes-vous sûr de vouloir valider en l'état ?",
        confirmCheckDeposit:"Êtes-vous sûr de vouloir valider votre remise de chèque ?",
        confirmGenerateRestockNoReadjust:"Êtes-vous sûr de vouloir continuer ? Les articles ayant un stock négatif ne seront pas pris en compte dans le réassort",
        transferOrdersToCollect:'Ordres de transfert à collecter',
        transferOrdersToReceive:'Ordres de transfert à réceptionner',
        stockTransfer:'Transfert de stock',
        stockTransferConfirm:"Êtes-vous sûr de vouloir transférer ce stock ?",
        ecomToCollect:'Commande client à collecter',
        transferOrderRelatedPo:'Cet ordre de transfert est lié à une commande client',
        quantityToReceive:'Quantité réceptionnée',
        receiveAllItems:'Réceptionner tous les articles',
        receiveItemsByItems:'Réceptionner article par article',
        collectionAllItems:'Collecter tous les articles',
        collectionItemsByItems:'Collecter article par article',
        validAllArticlePoReceive:'Valider tous les articles à la réception d\'un bon de commande',
        validAllArticleToReceive:'Valider tous les articles à la réception d\'un ordre de transfert',
        validAllArticleToCollecte:'Valider tous les articles à la collecte d\'un ordre de transfert',
        noTransferOrdersToReceive:'Aucun ordres de transfert à réceptionner',
        consultationTransferOrders:'Consultation des ordres de transfert en cours',
        noTransferOrdersInProgress:'Aucun ordre de transfert en cours',
        filterAllStatus:'Tout',
        confirmReceptionWithDifferentQte:'La quantité réceptionnée et différente de la quantité collectée, cela entraînera un réajustement de stock, continuer ?',
        linesNumber:'Nombre de lignes',
        notCollected:'Non collecté',
        lineConverted:'Ligne déjà convertie',
        collectInProgress:'En cours de collecte',
        alertItemsNotCollected:'Tous les articles n\'ont pas été collectés. Si vous continuez, vous aurez probablement des erreurs de stock à l\'avenir. Souhaitez-vous vraiment continuer ?',
        collection:'Collecte',
        depose:'Dépose',
        website:'Site internet',
        previousMonthTurnover:'Chiffre d\'affaires du mois précédent',
        presentMonthTurnover:'Chiffre d\'affaires du mois en cours',
        itemsBase:'Base articles',
        stockInShop:'Stock en magasin',
        stockInOtherShop:'Stock dans autre magasin',
        priority:'Priorité',
        toBeCollectedpriority: 'A réceptionner en priorité',
        restockPriority:'Priorité de réassort',
        collectedOn:'Collecté le',
        collectedBy:'Collecté par',
        rppslNotConfigured:'Le RPPSL de cet article n\'a pas été configuré',
        rppslEdit:'Edition du rppsl',
        nbMaxToInstruction:'Nombre maximum d\'instructions dans un ordre de transfert',
        nbMaxEnumere:'Nombre maximum d\'énumérés de conditionnement',
        allItemsAlreadyScaned:'L\'ensemble des articles a été scanné',
        ecommerce:'E-commerce',
        carrepos:'Carré POS',
        shopLiaison:'Liaison commerce',
        seller:'Vendeur',
        discount:'Remise',
        unitaireDiscount:'Remise unitaire',
        unitairePrice:'Prix unitaire',
        unitaireDiscountPrice:'Prix unitaire remise',
        unitairePriceModif:'Modification prix unitaire',
        priceWithoutDiscount:'Prix non remisé',
        priceEdit:'Edition unitaire du prix',
        priceModification:'Modification du prix',
        newPrice:'Nouveau prix',
        setArticlePrice:"Définir le prix de l'article",
        titleOnReceipt:'Intitulé sur ticket',
        discountPercent:'Remise %',
        cancelDiscount:'Annulation remise manuelle',
        discountNet:'Remise en valeur',
        noDiscount:'Non remisé',
        addNote:'Ajouter une note',
        editToPrepare:'Edition quantité à préparer',
        modifColumnPosition:'Modifier la position des colonnes',
        clickToHideOrShow:'Cliquer pour afficher ou masquer une {param}',
        dragAndDropToChangePosition:'Glisser et déposer pour changer la position d\'une {param}',
        espece:'Espèce',
        check:'Chèque',
        card:'Carte',
        kiosqueCard:'Carte',
        scanCard:'Scanner carte',
        other:'Autre',
        autre:'Autre',
        amount:'Montant',
        amountTtc:'Montant TTC',
        montantDu:'Montant dû',
        montantDisponible:'Montant disponible',
        insertToRecords:'Ajout à un ordre de transfert',
        discountedPrice:'Prix remisé',
        programmedRecurrence:'Récurrences programmées',
        availableTemplate:'Modèles disponibles',
        checkNumber:'Numéro de chèque',
        modePay:'Mode de paiement',
        modePayInvoice:'Mode de paiement factures',
        bank:'Banque',
        checkNum:'Numéro de chèque',
        reason:'Raison',
        numberGiftCard:'Numéro de carte cadeau',
        codeBarreContain:'Dont le code barre contient',
        payment:'Règlement',
        due:'Restant dû',
        promotion:'Promotions',
        percentageException:'Pourcentage exception',
        percentageExceptionFixe:'Montant exception',
        percentageExceptionImport:'Exception de refacturation',
        zoneNameErrorCarac:'Le nom de la zone ne doit pas contenir de caractères spéciaux',
        percent:'Remise en %',
        badgeExceptionPercentage:'Pourcentage commission',
        franche:"Remise nette",
        prixfixe:'Modification du prix',
        xpoury:'Offre X pour Y',
        percentsecond:'Remise en % sur le Nᵉ article',
        xpourfixe:'Prix fixe pour N articles',
        cadeaupourx:'Cadeau pour panier supérieur à',
        suppercent:'Remise supplémentaire en % sur article déjà remisé en %',
        suppercentInstruction:'Cumuler les remises en %, en les séparant par une virgule',
        noPromoPeriodDefined:'Aucune date de fin',
        specifyPaymentMode:'Préciser le mode de paiement',
        createPromo:'Créer une promotion',
        createPercentageException:'Créer une exception de pourcentage',
        createPersonalizedPrice:'Créer un prix personnalisé',
        personalizedPrice:'Prix personnalisé',
        deletePersonalizedPriceConfirm:'Que souhaitez-vous faire avec ce prix personnalisé ?',
        deleteFromLine:'Supprimer de la ligne',
        deleteDefinitive:'Supprimer définitivement',
        qteItems:'Quantité d\'articles',
        qteItemsRetour:'Quantité d\'articles à retourner',
        addImage:'Ajouter une image',
        seeTheList:'Voir la liste',
        reviewAllGols:'Consulter tous les objectifs des vendeurs',
        reviewIndividualGoals:'Consulter les objectifs individuels',
        percentDesc:'Réduction en pourcentage, exemple : -20%',
        francheDesc:"Réduction nette du prix, exemple : -XXX {monnaie}",
        prixfixeDesc:'Attribution d\'un prix fixe à un article',
        xpouryDesc:'Vendez une quantité X d\'articles pour le prix de Y articles, exemple : 2 pour le prix d\'un',
        percentsecondDesc:'Réduction en pourcentage sur le Nᵉ article, exemple : -50% sur le 3e article',
        onPosition:'en position',
        positionArticle:'Position de l\'article (N)',
        positionMin2:'La position doit être supérieure ou égale à 2',
        xpourfixeDesc:'Vendez une quantité X d\'articles pour un prix fixe, exemple : 2 pour XXX {monnaie}',
        cadeaupourxDesc:'Un cadeau offert pour un panier minimum, exemple : un tee-shirt offert à partir de 100$ d\'achat',
        suppercentDesc:'Remise supplémentaire en pourcentage sur un article déjà remisé : -10% en plus sur un article déjà remisé à -30%',
        for:'Pour',
        automaticRestockConfiguration:'Configuration des réassorts automatiques',
        reassortGrouping:'Regroupement d\'articles',
        reassortGroupingFieldsLabel:'Champs de regroupement (l\'ordre est important)',
        reassortGroupingFieldGeneral:'Champ de regroupement d\'articles invalide',
        preparationTicketHeader:'Ticket préparation',
        preparationGroupingField:'Champ de regroupement',
        noPreparationGrouping:'Aucun regroupement',
        preparationGroupOthers:'Autres',
        preparationSentAt:'Heure d\'envoi',
        preparationGroupingOrder:'Sens du tri',
        preparationPrintedItems:'Produits imprimés sur le ticket de préparation',
        preparationPrintAll:'Tous les produits',
        preparationPrintOnlyToPrepare:'Uniquement les produits à préparer',
        preparationGroupOrder:'Ordre d\'impression des groupes',
        preparationGroupOrderHelp:'Les groupes s\'impriment dans cet ordre. Une valeur absente de la liste s\'imprime après, par ordre alphabétique.',
        preparationGroupMoveUp:'Monter',
        preparationGroupMoveDown:'Descendre',
        preparationGroupValuesEmpty:'Aucune valeur trouvée pour ce champ',
        preparationGroupSearch:'Rechercher une valeur à ajouter...',
        preparationGroupRemove:'Retirer de la liste',
        reassortGroupingFieldsRequired:'Sélectionnez au moins un champ de regroupement',
        reassortGroupingFieldDuplicate:'Un champ de regroupement ne peut pas être sélectionné plusieurs fois',
        itemCreation:'Création d\'un article',
        numberPointCumule:'Nombre de points cumulés',
        numberPointsToAccumulate:'Nombre de points à cumuler',
        totalFideliteCumul:'Total de points cumulés',
        totalFideliteSpent:'Total de points dépensés',
        totalFideliteAdjustment:'Total des ajustements manuels',
        mergeWithCustomer:'Fusionner avec un autre client',
        perSliceOf:'Par tranche de',
        beginPromo:'Début de la promotion',
        beginPersonalizedPrice:'Début du prix personnalisé',
        endPromo:'Fin de la promotion',
        endPersonalizedPrice:'Fin du prix personnalisé',
        assignedPoint:'Points attribués',
        editLoyaltyPlan:'Modifier un plan de fidélité',
        createLoyaltyPlan:'Créer un plan de fidélité',
        editPromo:'Modifier une promotion',
        editPercentageException:'Modifier une exception de pourcentage',
        editPersonalizedPrice:'Modifier un prix personnalisé',
        editGeneralInfos:'Modifier les infos générales',
        generalInfos:'Infos générales',
        undefined:'Non défini',
        addPromotion:'Ajouter une promotion',
        currentAndUpcomingPromo: 'Promotions en cours et à venir',
        currentAndUpcomingPersonalizedPrice: 'Prix personnalisés en cours et à venir',
        currentPromo:'Promotion en cours',
        currentPersonalizedPrice:'Prix personnalisé en cours',
        upcomingPromo:'Promotion à venir',
        upcomingPersonalizedPrice:'Prix personnalisé à venir',
        currentLoyaltyPlan:'Plan de fidélité en cours',
        upcomingLoyaltyPlan:'Plan de fidélité à venir',
        noCurrentPromo:'Aucune promotions en cours',
        noUpcomingPromo:'Aucune promotions à venir',
        addToTheSelection:'Ajouter à la liste',
        replaceTheList:'Remplacer la liste',
        addToPromotion:'Ajouter à la promotion',
        additionPromo:'Ajout de la promotion',
        currentAndUpcomingLoyaltyPlan: 'Plans de fidélité en cours et à venir',
        allLoyaltyPlans:'Tous les plans de fidélité',
        dependingItemPrice:'Dépend du prix des articles',
        giftOffered:'Cadeau offert',
        receiptSaved:'Tickets sauvegardés',
        receiptNumber:'Numéro de ticket',
        saleSaved:'Vente sauvegardée',
        favoriteSaved:'Favori sauvegardé',
        noCurrentSale:'Aucune vente en cours',
        noSalesSaved:'Aucune ventes sauvegardées',
        createGiftCard:'Création d\'une carte cadeau',
        createAbonnementCard:'Création d\'une carte d\'abonnement',
        editAbonnementCard:'Edition d\'une carte d\'abonnement',
        prmpOnItemTransform:'PRMP non éditable sur un article transformé',
        deposit:'Montant versé',
        totalDeposit:'Total remise',
        totalDiscountPrice:'Total remisé',
        discountTotal:'Remise totale',
        cashDepositExecutedBy:'Remise d\'espèces effectuée par',
        checkDeposit:'Remise de chèque',
        checkDepositHistorical:'Historique de remise de chèque',
        noCheckDeposit:'Aucune remise de chèque',
        checkAndCash:'Espèces / Chèques',
        qteMoneyIn:'Quantité de monnaie en',
        doneOn:'Fait le',
        changeBack:'Rendu',
        deposited:'Versé',
        giveChange:'A rendre',
        notValidGiftCard:'Cette carte cadeau n\'est pas valide pour ce commerce',
        noFundAvailable:'Aucun fond de disponible sur cette carte cadeau',
        noEnoughFund:'Il n\'y a pas assez de fonds sur cette carte cadeau',
        reminderMsg:'Vous avez programmé un rappel pour les documents suivants',
        recurrenceMsg:'Vous avez programmé une récurrence pour les documents suivants',
        moreDetails:'Plus de détails',
        credit:'Crédit',
        debit:'Débit',
        abonnement:'Abonnement',
        abonnement_article:'Article abonnement',
        abonnement_achat_article:'Article achat abonnement',
        abonnementCredit:'Crédit et abonnement',
        abonnementFrom:'Abonnement du',
        abonnementTo:'au',
        dateExpire:'Date d\'expiration',
        itemReturn:'Retour article',
        dontRemise:'Dont remise',
        scanReceiptHere:'Scanner le ticket ici',
        scanSalesOrderHere:'Scanner le bon de commande ici',
        scanQuotationHere:'Scanner le devis ici',
        scanDocHere:'Scanner le code-barre ici',
        docNum:'Numéro du document',
        document:'Document',
        documents:'Documents',
        searchOneReceipt:'Rechercher un ticket',
        receiptSearch:'Recherche de tickets',
        devisSearch:'Recherche de devis',
        enterRefundMethod:'Renseigner le mode de remboursement',
        ticket:'Ticket',
        tickets:'Tickets',
        vente:'Vente',
        retour:'Retour',
        eatin:'Sur place',
        takeout:"À emporter",
        toDeliver:"À livrer",
        refundEspece:'Remboursement espèce',
        refund:'Remboursement',
        refundGiftcard:'Remboursement carte cadeau',
        refundOther:'Remboursement autre',
        noItemsToReturn:"Aucun article à retourner",
        noItems:"Aucun article",
        paid:'Payé',
        historical:'Historique',
        salesHistorical:'Historique des ventes',
        customerHistorical:'Historique client',
        availableFund:'Fonds disponibles',
        lostFund:'Fonds perdus',
        totalDepot:'Total des dépôts',
        depot:'Dépôt',
        numberDepot:'Nombre de dépôts',
        itemsNumber:'Nombre d\'articles',
        bosexNumber:'Nombre de cartons',
        receiptInProgress:'Ticket en cours',
        messageEndReceipt:'vous remercie de votre visite',
        downloadingPdf:'Téléchargement du pdf',
        downloadInProgress:'Téléchargement en cours, veuillez patienter...',
        lastSale:'Dernière vente',
        noPreviousSale:'Aucune vente effectuée précédemment',
        noPreviousDevis:'Aucun devis effectué précédemment',
        selectConcernedPeriod:'Choisissez la période concernée',
        addNewPayment:'Ajouter un paiement',
        beginningPeriod:'Début de période',
        endPeriod:'Fin de période',
        editPaymentMethod:'Modification du mode de paiement',
        noPaymentMethodToEdit:'Aucun mode de paiement à modifier',
        checkoutState:'État caisse',
        totalWithGiftCard:'Total des ventes avec cartes cadeaux',
        totalWithoutGiftCard:'Total des ventes sans cartes cadeaux',
        averageReceiptWithGiftCard:'Ticket moyen avec cartes cadeaux',
        averageReceiptWithoutGiftCard:'Ticket moyen sans cartes cadeaux',
        wholeShop:'Tout le commerce',
        filterByEmployee:'Filtre par employé',
        filterByCashRegister:'Filtre par caisse',
        allStaff:'Tout le staff',
        thisCashRegister:'Cette caisse',
        concernedShop:'Commerces concernés',
        typePromo:'Type de promotion',
        typePersonalizedPrice:'Type de prix personnalisé',
        statePromo:'État de la promotion',
        statePersonalizedPrice:'État du prix personnalisé',
        messageBienvenue:'Bonjour - Bienvenue',
        acroTel:'Tel',
        postalAdress:'Adresse postale',
        depotGiftCard: 'Dépôts des cartes cadeaux',
        finished:'Terminé',
        poNbr:'Bon de commande n°',
        removeAllArticlesConfirm:"Voulez-vous vraiment vider les articles de cette promotion",
        removeSelectedArticlesConfirm:"Voulez-vous vraiment retirer les articles sélectionnés de cette promotion",
        removeSelectedPromotionsConfirm:"Voulez-vous vraiment supprimer les promotions sélectionnées",
        removeAllArticlesConfirmPricePersonalized:"Voulez-vous vraiment vider les articles de ce prix personnalisé",
        manualDiscountPercent:'Remise manuelle en %',
        manualDiscountNet:'Remise manuelle en valeur',
        manualDeposit:'Remise manuelle',
        autreFrais:'Autres frais',
        ecomConnexion:'Connexion e-commerce',
        caisseIdent:'Identifiant de caisse',
        posName:'Nom de la caisse', 
        actualSumCaisse:'Fond de caisse attendu',
        actualEspeceCaisse:'Sortie d\'espèces attendue',
        sortieEspece:'Sortie d\'espèces',
        cashDepositgroup:'Remise d\'espèces groupée',
        bill:'Billets',
        coin:'Pièces',
        form:'Formulaire',
        preview:'Prévisualisation',
        acutalSession:'Session actuelle',
        cashTotalInCaisse:'Total des espèces',
        checksTotalDeposit:'Total des chèques sur la remise',
        derniersRetraitEspeces: 'Derniers retraits d\'espèces',
        dernierRetraitEspecesSingle: 'Dernier retrait d\'espèces',
        retraitEspeces: 'Retrait d\'espèces',
        exportRetraitEspeces: 'Export retrait espèces',
        remiseEnBanque: 'Remise en banque',
        lastTenRetraitEspeces: '10 derniers retraits d\'espèces',
        thisRetraitEspeces: 'ce retrait d\'espèces',
        generateAutoCashDeposit:'Générer une remise d\'espèces en banque avec le total des espèces, hors fond de caisse',
        newStaff:'Nouveau staff',
        refresh:'Rafraîchir',
        correspondanceItem:'Correspondance sur le détail des articles',
        correspondanceMarque:'Correspondance sur le détail des marques',
        connector:'Connecteur e-commerce',
        personalizedFilter:'Filtre personnalisé',
        periodFilter:'Filtre par période',
        correspondenceDeliveryCost:'Correspondance des frais de livraison',
        correspondenceDatas:'Correspondance des données',
        currentWeek:'Semaine en cours',
        lastWeek:'Semaine dernière',
        nextWeek:'Semaine prochaine',
        month:'Mois',
        currentMonth:'Mois en cours',
        lastMonth:'Mois dernier',
        nextMonth:'Mois prochain',
        currentYear:'Année en cours',
        lastYear:'Année dernière',
        saveSale:'Sauvegarder une vente',
        cancelSaleAndOrder:'Annuler une vente ou une commande',
        paymentDetail:'Détail du paiement',
        receiptDetail:'Détail du ticket',
        depositDetail:'Détail de l\'acompte',
        giftCardCredit:'Crédit carte cadeau',
        giftCardPerimeterTitle:'Périmètre des cartes cadeaux',
        giftCardPerimeterDesc:'Commerces dans lesquels une carte cadeau vendue dans ce commerce peut être utilisée',
        printItemTag:'Imprimer une étiquette',
        printItemTags:'Imprimer des étiquettes',
        includeArchives:'Inclure les archives',
        includeExpiredGiftCard:'Inclure les cartes cadeaux expirées',
        includeExpiredAbonnementCard:'Inclure les cartes d\'abonnement expirées',
        saleOrderDetail:'Détail de la commande',
        devisDetail:'Détail du devis',
        openSaleOrder:'Ouvrir la commande client',
        objectifAndCa:'Objectifs et CA',
        user:'Utilisateur',
        active:'Actif',
        draft:'Brouillon',
        thisDraft:'ce brouillon',
        thisSavedDocument:'cette sauvegarde',
        roughDraftList:'Liste des brouillons',
        templateList:'Liste des modèles',
        archived:'Archivé',
        peripheralDevice:'Périphériques',
        newPeripheralDevice:'Nouveau périphérique',
        model:'Modèle',
        checkoutShortcut:'Raccourci caisse',
        checkoutShortcuts:'Raccourcis caisse',
        newShortcut:'Nouveau raccourci caisse',
        new:'Nouveau',
        allNotifications:'Toutes les notifications',
        noNotifications:'Aucune notification',
        notifTypeSalesOrder:'Commande client B2C',
        markAllAsRead:'Tout marquer comme lu',
        confirmMarkAllAsRead:'Voulez-vous marquer toutes les notifications comme lues ?',
        noNewNotifications:'Aucune nouvelles notifications',
        seeReceipt:'Voir le ticket',
        read:'Lu',
        unread:'Non lu',
        newShipmentToPick:"Nouveau bon d'expédition attribué",
        newTo:'Nouvel ordre de transfert à collecter',
        ipAdress:'Adresse IP ou port COM',
        afficheur:'Afficheur',
        tpe:'TPE',
        ingenico:'Ingenico',
        comPort:'Port COM',
        imprimante_ticket:'Imprimante ticket',
        imprimante_ticket_preparation:'Imprimante ticket préparation',
        imprimante_cheque:'Imprimante chèque',
        matchBarCode:'Associer un code-barre',
        matchBarCodeToItem:'Associer un code-barre à un article',
        imprimante_etiquette:'Imprimante étiquette',
        etiquette:'Etiquette',
        epson_tm_h6000V:'Epson TM-H6000V',
        zebra_zd421:'ZPL (Windows)',
        printCaisseIdent:'Imprimer l\'identifiant de caisse',
        aures_2_l:'Afficheur Aures',
        second_screen_display:'Afficheur second écran',
        notAttributedPeripheral:'Périphériques non attribués',
        noPeripheral:'Aucun périphérique',
        noConfiguredPeripheral:'Aucun périphérique configuré',
        otherSection:'Autre commerce',
        disponibleMini:'Dispo',
        blockedMini:'Bloq',
        workTimeToday:'Indiquer un temps de travail',
        workTimeDetails:'Répartition de votre temps de travail',
        workTime:'Temps de travail',
        chooseProject:"Sélectionner un projet",
        allProject: 'Tous les projets',
        chooseTask:"Sélectionner une tâche",
        work_project:'Projet',
        work_project_detail:"Tâche",
        nbrHours: 'Nombre d\'heures',
        nbrMinutes: 'Nombre de minutes',
        aVenir:"À venir",
        datasRecorded:'Données enregistrées',
        reorganizeColum:'Réorganiser les colonnes',
        changePrinter:'Changer d\'imprimante',
        changeZone:'Changer de zone',
        changeCustomer:'Changer de client',
        qteTag:'Quantité d\'étiquette',
        tagPrint:'Impression étiquette',
        limitTagPrint100:"La limite d'impression est de 100 étiquettes",
        mintTagPrint1:'La quantité minimum d\'étiquette à imprimer est de 1',
        bankDeposit:'Dépôt bancaire',
        salesOrder:'Commandes client',
        addToOrder:'Ajouter à la commande',
        expectedCollectDate:'Date prévue de collecte',
        numberShopifyOrder:'Numéro de commande E-Com',
        collectZone:'Lieu de collecte',
        collectZoneChangeTitle:'Articles déjà collectés',
        collectZoneChangeText:'Cette commande contient déjà des articles collectés. Souhaitez-vous que ces articles soient automatiquement mis en collecté dans le nouveau lieu de collecte, ou souhaitez-vous qu\'ils soient mis à collecter dans le nouveau lieu de collecte ?',
        collectZoneChangeKeepCollected:'Mettre en collecté',
        collectZoneChangeResetToCollect:'Mettre à collecter',
        collectZoneDifferentTitle:'Lieu de collecte différent',
        collectZoneDifferentText:'Le lieu de collecte choisi est différent du magasin actuel. Souhaitez-vous que la marchandise soit collectée immédiatement dans ce lieu, ou qu\'elle reste à collecter ?',
        order:'Commander',
        commandeChangeCollectZone: 'Modification du lieu de collecte',
        commandeOut: 'Sorti de la zone de commerce',
        commandeRemoveOut: 'Sorti de la zone de commande pour mis en ordre de transfert',
        commandePut: 'Mis en zone de commande',
        commandeRemovePut: 'Mis en zone de commerce pour mis en ordre de transfert',
        commandeCancelledOut: 'Annulation commande - Sorti de la zone de commande',
        commandeCancelledPut: 'Annulation commande - Sorti de la zone de commerce',
        orderHistorical:'Historique commande client',
        devisHistorical:'Historique devis',
        preparationHistorical:'Historique préparation',
        searchByCreationDate:'Rechercher par date de création',
        searchByCollectDate:'Rechercher par date prévue de collecte',
        searchASalesOrder:'Rechercher une commande client',
        searchAQuotation:'Rechercher un devis',
        searchSalesOrder:'Recherche de commandes client',
        article:'Article',
        noCheckoutShortcut:'Aucun raccourci caisse',
        validateNewOrder:'Valider le nouvel ordre',
        transferHere:'Transférer ici',
        transferToOtherShop:'Transférer vers un magasin',
        expireSession:'Votre session a expiré ! Vous allez être redirigé.',
        myTime:'Mon temps',
        addQuantityByEnumere:'Ajouter des quantités à partir de l\'énuméré de conditionnement',
        justMinQuantity:'Juste pour quantité minimum',
        changeDocument:'Changement de document',
        bipeurNumber: 'Numéro de bipeur',
        bipeurLabelSetting: 'Terme affiché pour le numéro de commande',
        bipeurLabelBipeur: 'Bipeur',
        /***********Button**************/
        btnAccess: 'Go !',
        btnCancelSalesOrder:'Annuler la commande client',
        cancelPosOnly:'Quitter la commande',
        cancelCommandeOrPosTitle:'Que souhaitez-vous faire ?',
        btnSeeEditDelete : 'Voir / Editer / Supprimer',
        btnValidate: 'Valider',
        btnValidateAndSave:"Valider et sauvegarder",
        btnValidateStockAdjustment: 'Valider l\'ajustement de stock',
        btnDeleteUser: 'Supprimer cet utilisateur',
        btnDeleteGrade: 'Supprimer ce grade',
        btnAddRewardLevel:'Ajouter un palier de récompense',
        btnDeleteRh: 'Supprimer ce staff',
        btnYes: "Oui",
        btnNo: "Non",
        btnDelete: "Supprimer",
        editColor: "Modifier la couleur",
        editName: "Modifier le nom",
        btnAddField: "Ajouter un champ",
        btnRemoveRh: "Retirer du commerce",
        btnRemove: "Retirer",
        btnGoClotureCaisse: 'Clôturer la caisse',
        btnAddAllItems:'Ajouter tous les articles de la base article',
        btnFilterItemsToAdd:'Sélectionner les articles à ajouter',
        btnCancel: 'Annuler',
        btnBackToWelcome: 'Retour à l\'accueil',
        btnPay: 'Payer',
        btnEffacer: 'Effacer',
        btnReset: 'Reset',
        btnClose: 'Fermer',
        closeFolder: 'Fermer le dossier',
        btnImport: 'Importer',
        btnAddClientForm: 'Ajouter le formulaire client',
        btnRemoveClientForm: 'Retirer le formulaire client',
        btnArchiveStaff: 'Archiver ce Staff',
        btnActiveStaff: 'Activer ce Staff',
        btnArchiveProvider: 'Archiver ce fournisseur',
        btnDeleteProvider: 'Supprimer ce fournisseur',
        btnUnarchiveProvider: 'Activer ce fournisseur',
        btnSeeProfil: 'Voir le profil',
        btnDeleteAssociate: 'Supprimer l\'association',
        btnSearchAssociateCustomer: 'Lancer une recherche des possibilités d\'association',
        btnUnarchiveBrand: 'Activer cette marque',
        btnArchiveBrand: 'Archiver cette marque',
        btnDeleteBrand: 'Supprimer cette marque',
        btnAssociate : 'Associer',
        btnCreateNewStaffCustomer: 'Générer un nouveau client associé à ce Staff',
        btnUnarchiveZone: 'Activer cette zone',
        btnArchiveZone: 'Archiver cette zone',
        btnDeleteZone: 'Supprimer cette zone',
        btnShowDetails: 'Voir les détails',
        btnShowReminders:'Voir les rappels',
        btnInsert: 'Insérer',
        btnUpdate: 'Mettre à jour',
        btnBack: 'Retour',
        btnMove:'Déplacer',
        btnReturn:'Retour',
        btnSeeBinsContent:'Voir le contenu de la bins',
        btnSeeParentProfil:'Profil du parent',
        btnValidateAsIs:'Valider en l\'état',
        btnSeeStock:'Voir le stock',
        btnItemProfil:'Profil article',
        btnModifier:'Modifier',
        btnSave:'Sauvegarder',
        btnSeePdf:'Voir le ticket pdf',
        btnPdf:'Voir le pdf',
        btnSeeDevisPdf:'Voir le devis pdf',
        btnPrint:'Imprimer',
        btnSendMailTicket:'Envoyer par e-mail',
        btnPayPrint:'Payer & Imprimer',
        btnGiftPrint:'Ticket Cadeau',
        btnRemoveAllItems:'Retirer tous les articles',
        btnRemoveSelectedItems:'Retirer les articles sélectionnés',
        btnCancelDiscount:'Annuler la remise en cours',
        btnNewDocumentReliquat:'Générer un nouveau document à partir des reliquats',
        btnNextStep:'Etape suivante',
        /***********Menu**************/
        welcome: 'Accueil',
        usersList: 'Liste Utilisateurs',
        usersCreate: 'Créer un Utilisateur',
        rhCreate: 'Créer un Staff',
        newCustomer:'Nouveau client',
        administrationGenerale: 'Administration Générale',
        administrationModePaiement: 'Modes de paiement',
        administrationObjectifPos : 'Objectifs',
        administrationTurnoverPos : 'Chiffre d\'affaires',
        ticketSalesOrder:'Tickets / Commandes Client / Devis',
        administrationCustomForm: 'Formulaires Personnalisés',
        administrationClientForm: 'Client',
        administrationFournisseurForm: 'Fournisseur',
        administrationMarqueForm: 'Marque',
        administrationArticleForm: 'Article',
        administrationStaff: 'Staff',
        administrationStaffList: 'Liste Staff',
        year:'Année',
        shopName:'Nom du magasin',
        allCreate: 'Créer',
        searchStock: 'Recherche stock',
        cashRegister: 'Caisse',
        item:'Article',
        licence_notification: 'Mises à jour',
        addToCart:'Ajouter au panier',
        addItem: 'Ajouter un article',
        addImageLink:"Ajouter le lien de l'image de votre article",
        importItem: 'Importer des articles',
        importFournisseur:'Importer des fournisseurs',
        importPromotion: 'Importer des promotions',
        importPersonalizedPrice: 'Importer des prix personnalisés',
        importPercentageException: 'Importer des exceptions de pourcentages',
        number:'Numéro',
        importInventory:'Importer un inventaire',
        inventaireStaffDelete:"Les comptages seront supprimés pour les staffs supprimés",
        importStockOrInventory:'Importer un stock ou un inventaire',
        importItemLoyaltyPlan: 'Importer des articles au plan de fidélité {name}',
        importItemPercentageException: 'Importer des articles à l\'exception de pourcentage {name}',
        importItemPromotion: 'Importer des articles à la promotion {name}',
        importItemPromotionA: 'Importer des articles dans la liste A, à la promotion {name}',
        importItemPromotionB: 'Importer des articles dans la liste B, à la promotion {name}',
        importItemSupplementList: 'Importer des articles dans la liste de supplément',
        importItemPersonalizedPrice: 'Importer des articles au prix personnalisé {name}',
        listAMsgInfo:'Importez ici les articles qui déclencheront la promotion',
        listBMsgInfo:'Importez ici les articles qui bénéficieront de la promotion',
        listTriggerPromo:'Liste d\'articles qui déclencheront la promotion',
        listBenefitPromo:'Liste d\'articles qui bénéficieront de la promotion',
        noRestockNeeded:"Aucun réassort n'est nécessaire",
        facturation: 'Facturation',
        createBillingQuotation:'Créer facture/devis',
        productOn:'Produit(s) sur',
        formProvider: 'Formulaire fournisseur',
        formSaleOrder: 'Formulaire commande client',
        itemFamily: 'Familles d\'articles',
        brand: 'Marques',
        client: 'Clients',
        customizedInterface: 'Interface personnalisée',
        createRead:'Créer et consulter',
        import: 'Importer',
        allPromotions:'Toutes les promotions',
        allPersonalizedPrice:'Tous les prix personnalisé',
        promoWeight:'Poids de la promotion',
        percentageExceptionWeight:'Poids de l\'exception de pourcentage',
        personalizedPriceWeight:'Poids du prix personnalisé',
        valueBetween:'Valeur entre',
        printingInProgress:'Impression en cours',
        movePeripheralsShop: 'Etes-vous sûr de vouloir déplacer {deviceName} vers {shopName} ?',
        session:'Session',
        byShop:'Par commerce',
        sessionsEnCours:'Sessions en cours',
        sessionsFermees:'Sessions fermées',
        onlyProblemSessions:'Sessions avec écart uniquement',
        neverOpened:'Jamais ouverte',
        closedOn:'Fermée le',
        billingVsCreditNote:'Nbr Factures / Nbr Avoirs',
        etatCompte:'Etat compte',
        donneesLigneArticle:'Données supplémentaires sur ligne article',
        value:'Valeur',
        confirmConvertReliquat:"Êtes-vous sûr de vouloir convertir le reliquat en nouveau {documentType} ? Le présent {documentType} ne contiendra plus que les articles déjà convertis et le nouveau {documentType} contiendra l'ensemble des reliquats",
        created_at:'Créé le',
        exportDataConfiguration:'Export des données',
        bbg_inventory_item:'Articles avec stock',
        bbg_non_inventory_item:'Articles sans stock',
        bbg_item_parent_dates:'Dates articles parents',
        bbg_item_parent_monthly:'Stock parent mensuel',
        bbg_item_monthly:'Articles mensuel',
        bbg_item_parent_weekly:'Stock parent hebdomadaire',
        bbg_item_soh:'Stock articles (SOH)',
        bbg_sales:'Ventes',
        bbg_paiements:'Moyens de paiement',
        bbg_kpis:'KPIs',
        bbg_objectifs:'Objectifs',
        bbg_promotions:'Promotions',
        bbg_pos:'Bons de commande',
        bbg_tos:'Ordres de transfert',
        bbg_shipments:'Expéditions',
        bbg_gift_card:'Cartes cadeaux',
        bbg_failed_stock_adjustment:'Ajustements de stock échoués',
        showReportConfiguration:'Affichage des reports',
        pbi_items:'Articles',
        pbi_stock_items:'Stock',
        pbi_stock_items_monthly:'Stock mensuel',
        pbi_stock_items_weekly:'Stock hebdomadaire',
        pbi_client:'Clients',
        pbi_fournisseur:'Fournisseurs',
        pbi_sales:'Ventes B2C',
        pbi_paiements:'Moyens de paiement sur ventes B2C',
        pbi_promotion:'Promotion',
        pbi_factures:'Ventes B2B',
        pbi_documents_b2b:'Documents B2B',
        pbi_po:'Bon de commande fournisseur',
        pbi_to:'Ordres de transfert',
        pbi_listes:"Listes d'articles",
        pbi_objectifs:'Objectifs',
        pbi_kpis:'KPIs',
        pbi_items_content:'Contenu des articles',
        pbi_passages:'Passages',
        pbiFileName:'Nom du fichier',
        pbiExportActivate:'Activer',
        pbiExportLastExecution:'Dernière fin d\'exécution',
        pbiExportInProgress:'En cours',
        pbiExportRefresh:'Rafraîchir le statut',
        pbiExportGenerate:'Générer maintenant',
        pbiExportNotActivated:'Non activé',
        pbiGenerationInProgress:'Génération en cours',
        alreadyInProgress:'Déjà en cours de génération',
        /***********Table***********/
        dataTable:'Tableau de données',
        tableSearch: 'Rechercher',
        tableName: 'Nom',
        tableFirst: 'Début',
        tableBack: 'Précédent',
        tableNext: 'Suivant',
        tableLast: 'Dernière',
        tableFistTitle: 'Première Page',
        tableBackTitle: 'Page Précédente',
        tableNextTitle: 'Page Suivante',
        tableLastTitle: 'Dernière Page',
        tableNoData: 'Aucune donnée',
        tableNoModePaiement: 'Aucun mode de paiement ajouté',
        tableNoCashOutReason: 'Aucun justificatif de retrait d\'espèces en caisse ajouté',
        tableSex: 'Sexe',
        tableFirstName: 'Prénom',
        tablePhone: 'Téléphone',
        tableRemove: 'Retirer',
        tableBarCode: 'Code-barre',
        tableOtherPhone: 'Autre téléphone',
        tableProviderName: 'Nom du fournisseur',
        tableContactName: 'Nom du contact',
        tableBrandName: 'Nom de la marque',
        tableContraintes: 'Contraintes',
        /*********** Label Form ***********/
        labelSex: 'Sexe',
        labelName: 'Nom',
        labelCsvSeparator: 'Séparateur CSV',
        labelCsvEncode: 'Encodage CSV',
        labelArticleMatching: 'Données de référence possible pour mise à jour article',
        labelMatchingField: 'Donnée de référence pour mise à jour :',
        labelArticleIdentificationField: 'Donnée d\'identification des articles',
        labelPromoImportAction: 'Mode d\'import des articles',
        promoImportActionAdd: 'Ajouter les articles à la promotion',
        promoImportActionReplace: 'Remplacer les articles de la promotion',
        promoImportActionHelp: 'S\'applique uniquement aux promotions déjà existantes. Si vous choisissez le remplacement, chaque liste (1 ou 2) présente dans le fichier est remplacée ; une liste absente du fichier reste inchangée.',
        matchingFieldInvalid: 'Le champ de matching sélectionné est invalide',
        matchingFieldDisabled: 'Le champ de matching sélectionné n’est plus activé',
        matchingFieldNotMapped: 'Le champ de matching sélectionné n’est pas associé à une colonne CSV',
        matchingFieldEmpty: 'La valeur de matching est vide',
        matchingFieldNotFound: 'Aucun article ne correspond à cette valeur',
        matchingFieldAmbiguous: 'Plusieurs articles correspondent à cette valeur',
        matchingFieldCreateOrUpdate: 'Création / Modification',
        matchingFieldUpdateOnly: 'Modification',
        importModeCreateTitle: 'Création',
        importModeUpdateTitle: 'Mise à jour',
        importModeCreateText: 'Les données ci-dessous seront créées car vous n\'avez indiqué aucune correspondance de {field} avec votre fichier CSV.',
        importModeUpdateText: 'Les données ci-dessous seront mises à jour car vous avez indiqué une correspondance de {field} avec votre fichier CSV.',
        labelFirstName: 'Prénom',
        labelPassword: 'Mot de passe',
        labelPasswordConfirmation: 'Confirmer mot de passe',
        labelPhone: 'Téléphone',
        labelMaxusemoisproforma: 'Durée de validité d\'une proforma (en mois)',
        labelRaisonmodifprix: 'Raisons pour lesquelles un vendeur peut justifier de la modification manuelle du prix d\'un article',
        labelInfosTicket:'Les informations renseignées seront affichées telles que vous l\'avez écrit et dans l\'ordre dans lequel vous les avez ajoutées.',
        labelPriorityCollect: 'Définissez l\'ordre dans lequel la collecte d\'un ordre de transfert doit se faire',
        labelPriorityInternalReassort: 'Définissez l\'ordre de priorité des zones de réserve pour les réassorts internes',
        labelDateFormat: 'Format de date',
        labelAdress: 'Adresse',
        labelAdressLivraison: 'Adresse de livraison',
        labelCodePostal: 'Code postal',
        labelVille: 'Ville',
        labelPays: 'Pays',
        labelCodeBank: 'Code banque',
        labelCodeGuichet: 'Code Guichet',
        labelNumeroDeCompte: 'Numéro de compte',
        labelCleRib: 'Clé RIB',
        labelBank: 'Banque',
        labelHoraires: 'Horaires',
        labelProviderName: 'Nom du fournisseur',
        labelContactName: 'Nom du contact',
        labelArchived: 'Archivé',
        labelBankName: 'Nom de la banque',
        labelSelectConfigue: 'Choisissez votre configuration',
        labelReason:'Raison',
        labelMaxReaInterne: "Quantité maximum par article pour un réassort interne",
        labelDelaiReglement: 'Délai de règlement',
        labelModePaiement: 'Mode de paiement',
        labelContact: 'Contact',
        labelMailrelance: 'Mails de relance',
        /********** Success Form Response ************/
        sucessUserCreate: 'Utilisateur créé avec succès !',
        /**********Power BI module ********************/
        reportPbi:'Reporting',
        listOfGroup:'Liste des groupes de report',
        createAGroup:'Créer un groupe report',
        addPbiLink:'Ajouter des liens de report',
        link:'Lien',
        adressRequired:'Le lien est obligatoire',
        adressUrl:'Le lien doit être une adresse valide',
        filterByUser:'Filtrer par utilisateur',
        filterByModule:'Filtrer par module',
        noReportingAvl:'Aucun report disponible',
        /**********Payment methode ********************/
        espece: 'Espèces',
        cheque: 'Chèque',
        emv_touch:'EMV sans contact',
        emv_multiple:'EMV paiement en plusieurs fois',
        amex_touch:'American Express sans contact',
        amex_multiple:'American Express paiement en plusieurs fois',
        cb: 'Carte Bleue/Visa',
        amex: 'American Express',
        mastercard: 'Mastercard', 
        jade: 'Carte Jade',
        jcb: 'Carte Jcb',
        giftcard: 'Carte cadeau',
        giftcardAvoir: 'Carte cadeau (Avoir)',
        recapVenteGiftCard: 'Cartes cadeaux vendues',
        virement: 'Virement bancaire',
        emv:'EMV',
        fidelite: 'Fidélité',
        bonmalistecadeaux: 'Bon "Ma Liste Cadeaux"',
        bonatelierdujouet: 'Bon "Atelier du Jouet"',
        annulCommande: 'Commande client annulée',
        card:'Carte bancaire',
        /********** Week days ************/
        monday: 'Lundi',
        tuesday: 'Mardi',
        wednesday: 'Mercredi',
        thursday: 'Jeudi',
        friday: 'Vendredi',
        saturday: 'Samedi',
        sunday: 'Dimanche',
        /********** Access ************/
        createCreditNote:'Créer un avoir',
        settleInvoiceAccess:'Acquitter une facture',
        assignUser:'Assigner des utilisateurs',
        authorizationRequiredForThisAction:'Une autorisation est nécessaire pour effectuer cette action',
        /********** Global Search ************/
        globalSearchPlaceholder:'Rechercher...',
        globalSearchSearching:'Recherche en cours...',
        globalSearchNoResult:'Aucun résultat trouvé',
        searchCatArticle:'Articles',
        searchCatTo:'Ordres de transfert',
        searchCatShipment:'Expéditions',
        searchCatPo:'Bons de commande',
        searchCatFacture:'Documents B2B',
        searchCatTicket:'Tickets',
        /*********journal comptable (PDF)***********/
        journalComptaVente:'Journal des ventes',
        journalComptaAchat:'Journal des achats',
        journalComptaEclatement:'Avec Eclatement HT & TVA',
        journalComptaEdit:'Editer le journal',
        journalComptaPeriodeFacturation:'Date Facturation : du {begin} au {end}',
        journalComptaEditionDevise:'Edition en {devise} de toutes les factures',
        journalComptaTotaux:'Totaux',
        journalComptaDateEdition:'Date d\'édition',
        journalComptaPage:'Page {current} de {total}',
        journalComptaColDate:'Date',
        journalComptaColPiece:'Pièce',
        journalComptaColTiers:'Tiers',
        journalComptaColTtc:'TTC',
        journalComptaColHt:'HT',
        journalComptaColTva:'TVA',
        journalComptaApercu:'Aperçu du journal',
        journalComptaApercuVide:'Renseignez la période puis éditez le journal pour l\'afficher ici.',
        journalComptaTelecharger:'Télécharger le PDF',
        journalComptaNoDocument:'Aucun document sur la période sélectionnée',
        journalComptaEcartHt:'La somme des ventilations ne correspond pas au HT des documents (écart : {ecart})',
        unvalidDate:'Date invalide',
        unvalidPeriode:'La date de début doit être antérieure à la date de fin',
        journalComptaFiltreCommerce: "Commerces",
        journalComptaFiltreCaisse: "Caisses",
        journalComptaFiltreVendeur: "Vendeurs",
        journalComptaFiltreTous: "Tous",
        journalComptaFiltreToutSelectionner: "Tout sélectionner",
        journalComptaFiltreEffacer: "Effacer",
        journalComptaFiltreAucuneOption: "Aucune option",
        journalComptaFiltreChoisirCommerce: "Sélectionnez d'abord un commerce",
        razCaisseTitle: "RAZ de caisse",
        razCaisseEdit: "Éditer la RAZ",
        razCaisseApercu: "Aperçu de la RAZ",
        razCaisseApercuVide: "Renseignez la période puis éditez la RAZ pour l'afficher ici.",
        razCaisseEmetteur: "Émetteur",
        razCaissePeriode: "Période du {begin} au {end}",
        razCaisseSelectionCentre: "Sélection centre",
        razCaisseSelectionCaisse: "Sélection caisse",
        razCaisseSelectionVendeur: "Sélection vendeur",
        razCaisseSelectionTous: "Tous",
        razCaisseStatistiques: "Statistiques générales",
        razCaisseNbTickets: "Nb tickets",
        razCaisseNbArticles: "Nb articles",
        razCaissePanierMoyenTtc: "Panier moyen TTC",
        razCaissePanierMoyenHt: "Panier moyen HT",
        razCaisseArticleMoyenTtc: "Article moyen TTC",
        razCaisseTotalRemise: "Total remise",
        razCaisseMoyenneRemise: "Moyenne remise",
        razCaisseTotalTtcBrut: "Total TTC brut",
        razCaisseTotalHtBrut: "Total HT brut",
        razCaisseTotalTtcNet: "Total TTC net",
        razCaisseTotalHtNet: "Total HT net",
        razCaisseTotalTva: "Total TVA",
        razCaisseTotalRetour: "Total retour",
        razCaisseCoutAchat: "Coût d'achat",
        razCaisseMargeNette: "Marge nette",
        razCaisseMargePercent: "Marge",
        razCaisseCoefficient: "Coefficient",
        razCaisseVentesParTaux: "Liste des ventes par taux de TVA",
        razCaisseEncaissements: "Liste des encaissements par mode de règlement",
        razCaisseTotaux: "Totaux",
        razCaisseColCode: "Code",
        razCaisseColLibelle: "Libellé",
        razCaisseColCaht: "CAHT",
        razCaisseColCattc: "CATTC",
        razCaisseColNbArticles: "Nb.articles",
        razCaisseColTva: "TVA",
        razCaisseColMode: "Mode de règlement",
        razCaisseColVentes: "Ventes",
        razCaisseColRemboursements: "Remboursements",
        razCaisseColPrelevements: "Prélèvements",
        razCaisseColDepenses: "Dépenses",
        razCaisseColTotal: "Total",
        razCaisseFondCaisse: "Fond de caisse",
        razCaisseNbSessions: "{nb} sessions",
        destinatairesRequired: "Au moins un destinataire est requis",
        destinatairesIsArray: "La liste des destinataires est invalide",
        destinatairesElemRequired: "Un destinataire est vide",
        destinatairesElemMin2: "Chaque destinataire doit contenir au moins 2 caractères",
        destinatairesElemIsEmail: "Chaque destinataire doit être une adresse email valide",
        pdfMustBeAFile: "Le PDF joint n'est pas un fichier valide",
        pdfMustBeAPdf: "Le fichier joint doit être un PDF",
        pdfTooLarge: "Le PDF joint dépasse 50 Mo",
        recurrenceRequired: "Vous devez indiquer une récurrence",
        dateDebutRequired: "Vous devez indiquer une date de première exécution",
        dateDebutIsDate: "La date de première exécution est invalide",
        journalComptaEnvoyerMail: "Envoyer par mail",
        journalComptaCorpsMail: "Message (facultatif)",
        journalComptaMailInfo: "Le PDF affiché est joint au mail, accompagné d'un lien de téléchargement.",
        journalComptaPublicChargement: "Génération du document en cours, veuillez patienter...",
        journalComptaLienInvalide: "Ce lien est invalide ou a expiré.",
        journalAutoExportTitre: "Envoi automatique des journaux / RAZ",
        journalAutoExportRegle: "Chaque exécution envoie la période précédant sa date d'échéance : la veille (quotidien), les 7 jours précédents (hebdomadaire) ou le mois précédent (mensuel). Exemple : une échéance mensuelle au 01/10 envoie du 01/09 au 30/09. Le mail ne contient qu'un lien de téléchargement du document, sans pièce jointe.",
        journalAutoExportSansMail: "Aucun compte mail ou destinataire : l'exécution aura lieu mais aucun mail ne partira",
        journalAutoExportAjouter: "Ajouter une configuration",
        journalAutoExportModifier: "Modifier la configuration",
        journalAutoExportSupprimerConfirm: "Supprimer cet envoi automatique ?",
        journalAutoExportAucune: "Aucun envoi automatique configuré",
        journalAutoExportType: "Document",
        journalAutoExportFiltres: "Filtres",
        journalAutoExportPremiereEcheance: "Première exécution",
        journalAutoExportNbSelection: "{nb} sélectionné(s)",
      }
    },
    es: {
      locale: 'es-ES',
      messages: {
        labelPromoImportAction: "Modo de importación de los artículos",
        promoImportActionAdd: "Añadir los artículos a la promoción",
        promoImportActionReplace: "Reemplazar los artículos de la promoción",
        promoImportActionHelp: "Se aplica únicamente a las promociones ya existentes. En caso de reemplazo, cada lista (1 o 2) presente en el archivo se reemplaza; una lista ausente del archivo permanece sin cambios.",
        stockMinRequired: "El umbral de activación es obligatorio",
        stockGoodRequired: "La cantidad a reabastecer es obligatoria",
        nameRequired: "El campo \"nombre\" es obligatorio",
        firstnameRequired: "El campo \"apellido\" es obligatorio",
        emailRequired: "El campo \"correo electrónico\" es obligatorio",
        mailRelanceRequired: "El campo \"Correos de recordatorio\" es obligatorio",
        passwordRequired: "El campo \"contraseña\" es obligatorio",
        password_confirmationRequired: "El campo \"confirmar contraseña\" es obligatorio",
        companyRequired: "El campo \"empresa\" es obligatorio",
        moduleRequired: "El campo \"módulo\" es obligatorio",
        sectionRequired: "El campo \"comercio\" es obligatorio",
        sexeRequired: "El campo \"sexo\" es obligatorio",
        sizeTagRequired: "Debe indicar una dimensión",
        typefideliteRequired: "El campo \"Tipo de tarjeta de fidelidad\" es obligatorio",
        maxusemoisRequired: "El campo \"Duración de validez\" es obligatorio",
        maxusemoisproformaRequired: "El campo \"Duración de validez de una proforma\" es obligatorio",
        modepaiementRequired: "El campo \"Métodos de pago\" es obligatorio",
        themeRequired: "El campo \"Tema\" es obligatorio",
        donneeclientRequired: "El campo \"Activar la obligación de recopilación de datos del cliente\" es obligatorio",
        objectifvendeurRequired: "El campo \"Activar los objetivos de vendedor\" es obligatorio",
        objectifcommerceRequired: "El campo \"Activar los objetivos de comercio\" es obligatorio",
        dixmilleRequired: "Debe indicar la cantidad de billetes de 10.000 XPF",
        cinqmilleRequired: "Debe indicar la cantidad de billetes de 5.000 XPF",
        milleRequired: "Debe indicar la cantidad de billetes de 1.000 XPF",
        cinqcentRequired: "Debe indicar la cantidad de billetes de 500 XPF",
        deuxcentRequired: "Debe indicar la cantidad de monedas de 200 XPF",
        centRequired: "Debe indicar la cantidad de monedas de 100 XPF",
        cinquanteRequired: "Debe indicar la cantidad de monedas de 50 XPF",
        vingtRequired: "Debe indicar la cantidad de monedas de 20 XPF",
        dixRequired: "Debe indicar la cantidad de monedas de 10 XPF",
        cinqRequired: "Debe indicar la cantidad de monedas de 5 XPF",
        deuxRequired: "Debe indicar la cantidad de monedas de 2 XPF",
        unRequired: "Debe indicar la cantidad de monedas de 1 XPF",
        gradeRequired: "Debe indicar un grado",
        caRequired: "Debe indicar un volumen de negocio sin impuestos",
        cattcRequired: "Debe indicar un volumen de negocio con impuestos",
        pmRequired: "Debe indicar un PM sin impuestos",
        pmttcRequired: "Debe indicar un PM con impuestos",
        tfRequired: "Debe indicar un TF",
        ivRequired: "Debe indicar un IV",
        entreRequired: "Debe indicar un número de visitas de clientes (entrada y salida)",
        beginRequired: "Debe indicar la fecha de inicio",
        endRequired: "Debe indicar la fecha de fin",
        dayRequired: "Debe indicar el día",
        telephoneRequired: "Debe indicar el teléfono",
        adresseRequired: "Debe indicar la dirección física",
        adresseLivraisonRequired: "Debe indicar la dirección de entrega",
        adressepostaleRequired: "Debe indicar la dirección postal",
        newsletterRequired: "Debe marcar la casilla de la newsletter",
        civiliteRequired: "Debe indicar el tratamiento",
        csvEncodeRequired: "Debe indicar la codificación del CSV",
        csvSeparatorRequired: "Debe indicar el separador del CSV",
        csvDateFormatRequired: "Debe indicar el formato de fecha del CSV",
        codeRequired: "Debe indicar un código",
        rcsRequired: "Debe indicar un RCS",
        adressRequired: "Debe indicar la dirección",
        codePostalRequired: "Debe indicar un código postal",
        villeRequired: "Debe indicar una ciudad",
        paysRequired: "Debe indicar un país",
        paysInvalid: "El país seleccionado no es válido",
        codeBanqueRequired: "Debe indicar un código de banco",
        codeGuichetRequired: "Debe indicar un código de sucursal",
        numeroCompteRequired: "Debe indicar un número de cuenta",
        cleRibRequired: "Debe indicar una clave RIB",
        clientTypeRequired: "Debe indicar un tipo",
        quartierRequired: "Debe indicar un barrio",
        typeRequired: "Debe indicar un tipo",
        unspecified: "No especificado",
        dateDeNaissanceRequired: "Debe indicar una fecha de nacimiento",
        providerNameRequired: "Debe indicar un nombre de proveedor",
        contactNameRequired: "Debe indicar un nombre de contacto",
        statusRequired: "Debe indicar un estado",
        itemFamilyNameRequired: "Debe indicar un nombre de familia de artículos",
        brandNameRequired: "Debe indicar un nombre de marca",
        categoryRequired: "Debe indicar una categoría",
        referenceRequired: "Debe indicar un código UPC",
        referenceToRequired: "Debe indicar una referencia",
        skuRequired: "Debe indicar un SKU",
        internalidRequired: "Debe indicar el ID interno del artículo",
        priceRequired: "Debe indicar un precio con impuestos",
        tgcRequired: "Debe indicar una tasa de {taxe}",
        prmpRequired: "Debe indicar un PRMP",
        havestockRequired: "Debe indicar si este artículo debe depender de un stock",
        toPrepareRequired: "Debe indicar si este artículo debe prepararse",
        colorHexaRequired: "Debe indicar un código de color hexadecimal",
        banqueRequired: "Debe indicar el nombre del banco",
        customFieldRequired: "Debe completar el campo \"{name}\"",
        numeroShipmentRequired: "Debe indicar el número de envío",
        cartonRequired: "Debe indicar una referencia de cartón",
        shdeCartonNameRequired: "Debe indicar una referencia de cartón",
        shdeQuotaPrevuRequired: "Debe indicar la cantidad prevista",
        firstStartBinsRequired: "Debe indicar el inicio del primer nivel",
        firstEndBinsRequired: "Debe indicar el fin del primer nivel",
        zoneRequired: "Debe indicar una zona",
        secondEndBinsRequiredWith: "Debe indicar el fin del primer nivel si se ha indicado el inicio del primer nivel",
        thirdEndBinsRequiredWith: "Debe indicar el fin del segundo nivel si se ha indicado el inicio del segundo nivel",
        fourthEndBinsRequiredWith: "Debe indicar el fin del tercer nivel si se ha indicado el inicio del tercer nivel",
        fifthEndBinsRequiredWith: "Debe indicar el fin del cuarto nivel si se ha indicado el inicio del cuarto nivel",
        firstBinsRequired: "Debe indicar el primer nivel",
        quotaRequired: "Debe indicar la cantidad",
        actionRequired: "Debe indicar el campo acción",
        binsRequired: "Debe indicar el bin",
        quantiteRequired: "Debe indicar la cantidad",
        fieldRequired: "Este campo es obligatorio",
        expectedRequired: "La fecha deseada de ejecución es obligatoria",
        rhRequired: "Debe indicar un empleado",
        rhBarreRequired: "Debe indicar el código de barras de un empleado",
        osectionRequired: "Debe indicar un comercio de origen",
        fsectionRequired: "Debe indicar un comercio de destino",
        rpRequired: "Debe indicar el nivel de stock mínimo",
        pslRequired: "Debe indicar el nivel de stock óptimo",
        toMaxRequired: "El número máximo de instrucciones para una orden de transferencia es obligatorio",
        articleRequired: "Debe elegir un artículo",
        promotionRequired: "Debe elegir una promoción",
        allFieldsRequired: "Todos los campos deben completarse",
        promoImport: "Importar promociones",
        codeCaisseRequired: "Debe indicar un código de identificación de la caja",
        caisseIdentRequired: "Debe indicar el identificador de caja",
        hostRequired: "Debe indicar una dirección IP",
        comPortRequired: "Debe indicar un puerto COM",
        modelRequired: "Debe elegir un modelo",
        poRequired: "Debe elegir una orden de compra",
        waitingEpt: "Esperando TPV",
        errorEpt: "Error en la respuesta del TPV",
        newCheckoutShortcutProfil: "Nuevo perfil de acceso rápido",
        newKpiFilter: "Nuevo filtro de KPI",
        checkoutShorcutProfil: "Perfiles de acceso rápido",
        nbrCelluleParLigne: "Número de celdas por línea",
        fromCustomField: "Campo personalizado",
        fullCustom: "Otro grupo",
        customFieldN1: "A partir del campo personalizado",
        valueCustofieldN1: "Valor del campo personalizado",
        niveauCustomField: "Nivel {n} a partir del campo personalizado",
        addLevel: "Añadir un nivel",
        kpiFilter: "Filtro de KPI",
        itemFilter: "Filtro de artículo",
        itemCompareFilter: "Comparar filtro de artículo",
        titreRequired: "Debe indicar un título",
        messageRequired: "Debe indicar un mensaje",
        dateRequired: "Debe indicar una fecha",
        capitalRequired: "Debe indicar el capital",
        exerciceStartRequired: "Debe indicar el inicio del ejercicio",
        montantRequired: "Debe indicar un importe",
        itemsRequiredInTo: "No puede validar una orden de transferencia sin artículos",
        pageNamerequired: "Debe indicar el nombre de la página",
        filtreNamerequired: "Debe indicar el nombre del favorito",
        heureRequired: "Debe indicar el número de horas",
        minuteRequired: "Debe indicar el número de minutos",
        valueRequired: "Debe indicar un valor",
        clientRequired: "Debe indicar un cliente",
        noteRequired: "Debe indicar una nota",
        delaiReglementRequired: "Debe indicar un plazo de pago",
        modeReglementRequired: "Debe indicar un plazo de pago",
        modePaiementRequired: "Debe indicar un método de pago predeterminado",
        modePaiementInvalid: "El valor introducido no es un método de pago válido para esta empresa",
        clientTypeInvalid: "El valor introducido no es un tipo de cliente válido para esta empresa",
        modeReglementInvalid: "El valor introducido no es un plazo de pago válido",
        prefixRequired: "Debe indicar un prefijo",
        articleListRequired: "Debe indicar si desea generar una lista de artículos",
        articleListNameRequired: "Debe indicar un nombre de lista de artículos",
        replaceRequired: "Debe indicar si desea reemplazar el código de barras de los artículos existentes",
        itemReplaceRequired: "Debe indicar si desea reemplazar los artículos existentes",
        sectionAndZoneAdvanceParamsRequired: "Debe configurar un comercio y una zona predeterminados para las listas de artículos en los parámetros avanzados de la empresa",
        cardRequired: "La tarjeta es obligatoria",
        deviseAchatRequired: "La divisa de compra es obligatoria",
        internalIdRequired: "El ID interno es obligatorio",
        capitalMin1: "El capital debe ser de al menos 1 XPF",
        fondCaisseMin1: "El fondo de caja debe ser de al menos 1 XPF",
        poidsMin1: "El peso mínimo es 1",
        exerciceStartMin1: "El inicio del ejercicio debe ser al menos 1 (enero)",
        pageNameMin2: "El nombre de la página debe tener al menos 2 caracteres",
        filtreNameMin2: "El nombre del favorito debe tener al menos 2 caracteres",
        nameMin2: "El campo \"nombre\" debe tener al menos 2 caracteres",
        nameMin5: "El campo \"nombre\" debe tener al menos 3 caracteres",
        skuMin2: "El campo \"sku\" debe tener al menos 2 caracteres",
        firstnameMin2: "El campo \"apellido\" debe tener al menos 2 caracteres",
        passwordMin8: "El campo \"contraseña\" debe tener al menos 8 caracteres",
        phonedMin6: "El campo \"teléfono\" debe tener al menos 6 caracteres",
        phoneMin6: "El campo \"teléfono\" debe tener al menos 6 caracteres",
        maxusemoisdMin1: "El campo \"Duración de validez\" debe ser como mínimo de 1 mes",
        maxusemoisproformaMin1: "El campo \"Duración de validez de una proforma\" debe ser como mínimo de 1 mes",
        dixmilleMin0: "La cantidad de billetes de 10.000 XPF no puede ser inferior a 0",
        cinqmilleMin0: "La cantidad de billetes de 5.000 XPF no puede ser inferior a 0",
        milleMin0: "La cantidad de billetes de 1.000 XPF no puede ser inferior a 0",
        cinqcentMin0: "La cantidad de billetes de 500 XPF no puede ser inferior a 0",
        deuxcentMin0: "La cantidad de monedas de 200 XPF no puede ser inferior a 0",
        centMin0: "La cantidad de monedas de 100 XPF no puede ser inferior a 0",
        cinquanteMin0: "La cantidad de monedas de 50 XPF no puede ser inferior a 0",
        vingtMin0: "La cantidad de monedas de 20 XPF no puede ser inferior a 0",
        dixMin0: "La cantidad de monedas de 10 XPF no puede ser inferior a 0",
        cinqMin0: "La cantidad de monedas de 5 XPF no puede ser inferior a 0",
        deuxMin0: "La cantidad de monedas de 2 XPF no puede ser inferior a 0",
        unMin0: "La cantidad de monedas de 1 XPF no puede ser inferior a 0",
        caMin0: "El volumen de negocio sin impuestos no puede ser inferior a 0",
        cattcMin0: "El volumen de negocio con impuestos no puede ser inferior a 0",
        pmMin0: "El PM sin impuestos no puede ser inferior a 0",
        pmttcMin0: "El PM con impuestos no puede ser inferior a 0",
        tfMin0: "El TF no puede ser inferior a 0",
        ivMin0: "El IV no puede ser inferior a 0",
        entreMin0: "El número de visitas de clientes (entrada y salida) no puede ser inferior a 0",
        codeMin3: "El campo \"código\" debe tener al menos 3 caracteres",
        codeMin2: "El campo \"código\" debe tener al menos 2 caracteres",
        rcsMin5: "El campo \"RCS\" debe tener al menos 5 caracteres",
        codeBanqueMin5: "El campo \"Código de banco\" debe tener al menos 5 caracteres",
        codeGuichetMin5: "El campo \"Código de sucursal\" debe tener al menos 5 caracteres",
        numeroCompteMin11: "El campo \"Número de cuenta\" debe tener al menos 11 caracteres",
        cleRibMin2: "El campo \"Clave RIB\" debe tener al menos 2 caracteres",
        nomContactMin2: "El nombre del contacto debe tener al menos 2 caracteres",
        priceMin: "El precio no puede ser inferior a 0",
        promoPriceMin: "El precio promocional no puede ser inferior a 0",
        tgcMin: "La tasa de TGC no puede ser inferior a 0",
        colorHexaMin: "El código de color hexadecimal debe tener 6 caracteres",
        buyPriceMin: "El precio de compra no puede ser inferior a 0",
        prmpMin: "El PRMP no puede ser inferior a 0",
        prMin: "El precio de costo no puede ser inferior a 0",
        lastBuyPriceMin: "El último precio de compra no puede ser inferior a 0",
        lastBuyePriceDeviseMin: "El último precio de compra en divisa no puede ser inferior a 0",
        indicePrmpMin: "El índice de PRMP no puede ser inferior a 0",
        indicePrMin: "El índice de precio de costo no puede ser inferior a 0",
        deviseAchatMin: "La divisa de compra debe tener 3 caracteres",
        quotaMin: "La cantidad no puede ser inferior a 0",
        quotaCommandeMin: "La cantidad no puede ser inferior a 0",
        numeroShipmentMin2: "El campo \"número de envío\" debe tener al menos 2 caracteres",
        cartonMin1: "La referencia de cartón debe tener al menos 1 carácter",
        shdeCartonNameMin2: "La referencia de cartón debe tener al menos 2 caracteres",
        shdeQuotaPrevuMin: "La cantidad prevista no puede ser inferior a 0",
        firstStartBinsMin0: "El inicio del primer nivel no puede ser inferior a 0",
        firstEndBinsMin0: "El fin del primer nivel no puede ser inferior a 0",
        secondStartBinsMin0: "El inicio del segundo nivel no puede ser inferior a 0",
        secondEndBinsMin0: "El fin del segundo nivel no puede ser inferior a 0",
        thirdStartBinsMin0: "El inicio del tercer nivel no puede ser inferior a 0",
        thirdEndBinsMin0: "El fin del tercer nivel no puede ser inferior a 0",
        fourthStartBinsMin0: "El inicio del cuarto nivel no puede ser inferior a 0",
        fourthEndBinsMin0: "El fin del cuarto nivel no puede ser inferior a 0",
        fifthStartBinsMin0: "El inicio del quinto nivel no puede ser inferior a 0",
        fifthEndBinsMin0: "El fin del quinto nivel no puede ser inferior a 0",
        firstBinsMin0: "El primer nivel no puede ser inferior a 0",
        secondBinsMin0: "El segundo nivel no puede ser inferior a 0",
        thirdBinsMin0: "El tercer nivel no puede ser inferior a 0",
        fourthBinsMin0: "El cuarto nivel no puede ser inferior a 0",
        fifthBinsMin0: "El quinto nivel no puede ser inferior a 0",
        referencePoMin2: "La referencia de la orden de compra debe tener al menos 2 caracteres",
        rpIsMin0: "El nivel de stock mínimo RP de {name} no puede ser inferior a 0",
        pslIsMin0: "El nivel de stock óptimo PSL de {name} no puede ser inferior a 0",
        quantityRequired: "La cantidad es obligatoria",
        quantiteMin0: "La cantidad no puede ser inferior a 0",
        quantiteGreaterThan0: "La cantidad debe ser superior a 0",
        referenceToMin2: "La referencia debe tener al menos 2 caracteres",
        rpMin0: "El nivel de stock mínimo no puede ser inferior a 0",
        pslMin0: "El nivel de stock óptimo no puede ser inferior a 0",
        toMaxMin10: "El número máximo de instrucciones para una orden de transferencia no puede ser inferior a 10",
        giftCardMin1: "La duración de validez de un depósito en una tarjeta regalo no puede ser inferior a 1 mes",
        giftCardMontantMin: "El importe de la tarjeta regalo no puede ser inferior a 1",
        paiementMin: "Las indicaciones de pago deben ser superiores a 0",
        modifManualValueMin0: "El valor debe ser mayor o igual a 0",
        modifManualValueMin1: "No puede introducir un valor inferior a 1",
        codeCaisseMin4: "El identificador de caja debe tener al menos 4 caracteres",
        detailModePaiementMin0: "Los valores no pueden ser inferiores a 0",
        titreMin2: "El título debe tener al menos 2 caracteres",
        messageMin2: "El mensaje debe tener al menos 2 caracteres",
        typeMin2: "El tipo debe tener al menos 2 caracteres",
        ticketNameMin1: "El texto del ticket debe tener al menos un carácter",
        heureMin0: "Las horas no pueden ser inferiores a 0",
        minuteMin0: "Los minutos no pueden ser inferiores a 0",
        prefixMin1Max12: "El prefijo debe tener entre 1 y 12 caracteres",
        articleListNameMin2: "El nombre de la lista de artículos debe tener al menos 2 caracteres",
        creditMin: "El crédito no puede ser inferior a 0",
        abonnementMin: "La suscripción no puede ser inferior a 0",
        weightMin: "El volumen no puede ser inferior a 0",
        minimumCommandeMin: "El pedido mínimo no puede ser inferior a 0",
        valueMin0: "El valor no puede ser inferior a 0",
        exerciceStartMax12: "El inicio del ejercicio no puede ser superior a 12 (diciembre)",
        poidsMax100: "El peso máximo es 100",
        lineLimitationZoneContent: "La visualización está limitada a 1000 líneas",
        quantiteMax8000000: "La cantidad debe ser inferior a 8.000.000",
        quantityMax9999999: "La cantidad debe ser inferior a 9.999.999",
        pageNameMax191: "El nombre de la página debe tener menos de 191 caracteres",
        filtreNameMax191: "El nombre del favorito debe tener menos de 191 caracteres",
        nameMax191: "El campo \"nombre\" debe tener menos de 191 caracteres",
        nameMax250: "El campo \"nombre\" debe tener menos de 250 caracteres",
        nameMax50: "El campo \"nombre\" debe tener menos de 50 caracteres",
        skuMax250: "El campo \"Sku\" debe tener menos de 250 caracteres",
        nbrCelluleMin1: "El número de celdas debe ser como mínimo 1",
        nbrCelluleMax20: "El número de celdas debe ser inferior a 20",
        phoneMax20: "El campo \"teléfono\" debe tener menos de 20 caracteres",
        firstnameMax50: "El campo \"apellido\" debe tener menos de 50 caracteres",
        firstnameMax191: "El campo \"apellido\" debe tener menos de 191 caracteres",
        nameMax20: "El campo \"nombre\" debe tener menos de 20 caracteres",
        logoMax50: "El campo \"logo\" debe tener menos de 50 caracteres",
        gradeMax50: "El campo \"grado\" debe tener menos de 50 caracteres",
        maxusemoisdMax120: "El campo \"Duración de validez\" no puede superar los 120 meses",
        maxusemoisproformaMax120: "El campo \"Duración de validez de una proforma\" no puede superar los 120 meses",
        caMax2000000000: "El volumen de negocio sin impuestos no puede superar los 2.000.000.000 XPF",
        cattcMax2000000000: "El volumen de negocio con impuestos no puede superar los 2.000.000.000 XPF",
        pmMax2000000000: "El PM sin impuestos no puede superar los 2.000.000.000 XPF",
        pmttcMax2000000000: "El PM con impuestos no puede superar los 2.000.000.000 XPF",
        fondCaisseMax1000000: "El fondo de caja no puede superar los 1.000.000 XPF",
        tfMax100: "El TF no puede superar el 100 %",
        ivMax999: "El IV no puede superar los 999 artículos",
        entreMax10000000: "El número de visitas de clientes (entrada y salida) no puede superar 10.000.000",
        codeMax5: "El campo \"código\" debe tener menos de 5 caracteres",
        rcsMax20: "El campo \"RCS\" debe tener menos de 20 caracteres",
        codeBanqueMax5: "El campo \"Código de banco\" debe tener menos de 5 caracteres",
        codeGuichetMax5: "El campo \"Código de sucursal\" debe tener menos de 5 caracteres",
        numeroCompteMax11: "El campo \"Número de cuenta\" debe tener menos de 11 caracteres",
        cleRibMax2: "El campo \"Clave RIB\" debe tener menos de 2 caracteres",
        nomContactMax191: "El nombre del contacto debe tener menos de 191 caracteres",
        priceMax: "El precio no puede ser superior a 999999999.99",
        referenceMax191: "El código UPC debe tener menos de 191 caracteres",
        reference2Max191: "El código UPC 2 debe tener menos de 191 caracteres",
        internalIdMax191: "El ID interno debe tener menos de 191 caracteres",
        referenceToMax191: "La referencia debe tener menos de 191 caracteres",
        skuMax191: "El SKU debe tener menos de 191 caracteres",
        parentNameMax250: "El nombre padre debe tener menos de 250 caracteres",
        promoPriceMax: "El precio promocional no puede ser superior a 999999999.99",
        prmpMax: "El PRMP no puede ser superior a 999999999.99",
        prMax: "El precio de costo no puede ser superior a 999999999.99",
        lastBuyPriceMax: "El último precio de compra no puede ser superior a 999999999.99",
        lastBuyePriceDeviseMax: "El último precio de compra en divisa no puede ser superior a 999999999.99",
        tgcMax: "La tasa de TGC no puede ser superior a 100",
        imageMax250: "El enlace de la imagen del artículo debe tener menos de 250 caracteres",
        colorHexaMax: "El código de color hexadecimal debe tener 6 caracteres",
        buyPriceMax: "El precio de compra no puede ser superior a 999999999.99",
        indicePrmpMax: "El índice de PRMP no puede ser superior a 999999999.99",
        indicePrMax: "El índice de precio de costo no puede ser superior a 999999999.99",
        deviseAchatMax: "La divisa de compra debe tener 3 caracteres",
        maxPhoneLength6: "El número de teléfono debe tener como máximo 6 cifras",
        quotaCommandeMax: "La cantidad no puede ser superior a 8000000",
        quotaMax: "La cantidad no puede ser superior a 8000000",
        quotaMax10000: "La cantidad no puede ser superior a 10000",
        numeroShipmentMax190: "El número de envío debe tener menos de 190 caracteres",
        cartonMax250: "La referencia de cartón debe tener menos de 250 caracteres",
        shdeCartonNameMax250: "La referencia de cartón debe tener menos de 250 caracteres",
        shdeQuotaPrevuMax: "La cantidad prevista no puede ser superior a 8000000",
        firstStartBinsMax32000: "El inicio del primer nivel no puede ser superior a 32000",
        firstEndBinsMax32000: "El fin del primer nivel no puede ser superior a 32000",
        secondStartBinsMax32000: "El inicio del segundo nivel no puede ser superior a 32000",
        secondEndBinsMax32000: "El fin del segundo nivel no puede ser superior a 32000",
        thirdStartBinsMax32000: "El inicio del tercer nivel no puede ser superior a 32000",
        thirdEndBinsMax32000: "El fin del tercer nivel no puede ser superior a 32000",
        fourthStartBinsMax32000: "El inicio del cuarto nivel no puede ser superior a 32000",
        fourthEndBinsMax32000: "El fin del cuarto nivel no puede ser superior a 32000",
        fifthStartBinsMax32000: "El inicio del quinto nivel no puede ser superior a 32000",
        fifthEndBinsMax32000: "El fin del quinto nivel no puede ser superior a 32000",
        firstBinsMax32000: "El primer nivel no puede ser superior a 32000",
        secondBinsMax32000: "El segundo nivel no puede ser superior a 32000",
        thirdBinsMax32000: "El tercer nivel no puede ser superior a 32000",
        fourthBinsMax32000: "El cuarto nivel no puede ser superior a 32000",
        fifthBinsMax32000: "El quinto nivel no puede ser superior a 32000",
        referencePoMax190: "La referencia de la orden de compra debe ser inferior a 190 caracteres",
        rpIsMax8000000: "El nivel de stock mínimo RP de {name} no puede ser superior a 8000000",
        pslIsMax8000000: "El nivel de stock óptimo PSL de {name} no puede ser superior a 8000000",
        generateBarcodeMax1000: "No puede generar más de 1000 códigos de barras",
        rpMax8000000: "El nivel de stock mínimo no puede ser superior a 8000000",
        pslMax8000000: "El nivel de stock óptimo no puede ser superior a 8000000",
        toMaxMax1000: "El número máximo de instrucciones para una orden de transferencia no puede ser superior a 1.000",
        giftCardMax120: "La duración de validez de un depósito en una tarjeta regalo no puede ser superior a 120 meses",
        giftCardMontantMax: "El importe de la tarjeta regalo no puede ser superior a 100.000.000",
        paiementMax: "Las indicaciones de pago deben ser inferiores a 1.000.000.000",
        codeCaisseMax30: "El identificador de caja debe tener menos de 30 caracteres",
        cashOutReasonMax100: "El motivo de una salida de efectivo debe tener menos de 100 caracteres",
        titreMax250: "El título debe tener menos de 250 caracteres",
        typeMax50: "El tipo debe tener menos de 50 caracteres",
        ticketNameMax15: "El texto del ticket debe tener menos de 15 caracteres",
        heureMax23: "Las horas deben ser inferiores a 23",
        minuteMax59: "Los minutos deben ser inferiores a 59",
        articleListNameMax191: "El nombre de la lista de artículos debe tener menos de 191 caracteres",
        creditMax: "El crédito no puede ser superior a 999999",
        abonnementMax: "La suscripción no puede ser superior a 999999",
        unitMax191: "La unidad debe ser inferior a 191",
        weightMax: "El volumen debe ser inferior a 999999",
        minimumCommandeMax: "El pedido mínimo debe ser inferior a 999999999",
        defaultConditionnementNameMax250: "El nombre del formato predeterminado debe tener menos de 250 caracteres",
        valueMax100: "El valor no puede ser superior a 100",
        emailEmail: "El campo \"correo electrónico\" debe ser un correo electrónico válido",
        emailUnique: "Ya existe una cuenta registrada con esta dirección de correo electrónico",
        emailExists: "Ya existe un cliente con esta dirección de correo electrónico",
        nameUnique: "Este nombre ya existe",
        skuUnique: "Otro artículo ya tiene el mismo SKU",
        referenceUnique: "El código UPC ya está siendo utilizado por otro artículo",
        referenceEnumereUnique: "El código de barras del formato ya está siendo utilizado por otro formato",
        reference2Unique: "El código UPC 2 ya está siendo utilizado por otro artículo",
        skuUnique: "El SKU ya está siendo utilizado por otro artículo",
        alreadyExist: "ya ha sido asignado",
        sectionUnique: "Esta rúbrica ya existe",
        zoneInventaireAlreadyExists: "Ya tiene una zona de inventario con el mismo nombre",
        alreadyAvoirAndCantBeCancelled: "Esta factura ya está vinculada a una nota de crédito y no se puede anular",
        passwordConfirmed: "La contraseña se confirmó incorrectamente",
        confirmDifferentQuantityCollected: "La cantidad recogida no coincide con la cantidad solicitada, ¿confirmar?",
        confirmDifferentQuantityReceipt: "La cantidad recibida no coincide con la cantidad recogida, ¿confirmar?",
        confirmCancelSaleOrder: "¿Está seguro de que desea anular este pedido de cliente?",
        confirmValidateDocument: "¿Está seguro de que desea validar este documento?",
        confirmCancelDocument: "¿Está seguro de que desea anular este documento?",
        confirmValidateDeliveryNote: "¿Está seguro de que desea validar este albarán de entrega? Esto retirará del stock los artículos de este albarán",
        confirmConvertDeliveryNoteToInvoice: "¿Está seguro de que desea convertir este albarán de entrega en factura?",
        roleIn: "El rol asignado no es aceptado",
        sexeIn: "El sexo asignado no es aceptado",
        themeIn: "El tema asignado no es aceptado",
        modepaiementIn: "Uno de los métodos de pago indicados no es aceptado",
        priorityIn: "El valor de \"Prioridad\" debe ser Sí o No",
        customFieldIn: "El campo \"{name}\" tiene un valor no válido",
        encryptionIn: "El valor de encriptación debe ser ssl o tls",
        incorrectRemiseType: "Tipo de descuento incorrecto",
        fileDoesntExists: "El archivo no existe",
        companyExists: "Esta empresa no existe",
        moduleExists: "Este módulo no existe",
        sectionExists: "Este comercio no existe",
        rhExists: "Este empleado no existe",
        gradeExists: "Este grado no existe",
        typefideliteExists: "Este tipo de tarjeta de fidelidad no existe",
        programfideliteExists: "Este programa de fidelidad no existe",
        programgiftcardExists: "Este programa de tarjetas regalo no existe",
        clientExists: "Ya existe un cliente registrado con este nombre y apellido",
        clientIdNotExists: "Este ID de cliente no existe",
        fournisseurIdNotExists: "Este ID de proveedor no existe",
        giftCardExists: "Ya existe una tarjeta regalo con esta referencia",
        internalIdExists: "El ID interno es incorrecto",
        expectedInternalIdAlreadyExists: "El ID interno deseado ya existe",
        internalNotIdExists: "El ID interno ya existe",
        firstlevelcatExists: "No se ha encontrado ninguna coincidencia con el campo \"Clasificación\"",
        secondlevelcatExists: "No se ha encontrado ninguna coincidencia con el campo \"Familia\"",
        thirdlevelcatExists: "No se ha encontrado ninguna coincidencia con el campo \"Subfamilia\"",
        fourthlevelcatExists: "No se ha encontrado ninguna coincidencia con el campo \"Categoría\"",
        fifthlevelcatExists: "No se ha encontrado ninguna coincidencia con el campo \"Subcategoría\"",
        fournisseurExists: "No se ha encontrado ninguna coincidencia con el campo \"Proveedor\"",
        fournisseurExistsImport: "Este proveedor ya existe",
        marqueExists: "No se ha encontrado ninguna coincidencia con el campo \"Marca\"",
        nameExists: "Este nombre ya está en uso",
        referenceExists: "Esta referencia ya está en uso",
        articleNameExists: "Ningún artículo coincide con este nombre de artículo",
        articleNameAlreadyExists: "El nombre de este artículo ya está siendo utilizado por otro artículo",
        supplementListNameAlreadyExists: "El nombre de esta lista de suplementos ya está siendo utilizado por otra lista",
        articleSkuExists: "Ningún artículo corresponde a este Sku",
        poNameExists: "Este pedido de compra no existe",
        devisNotExists: "Este presupuesto no existe",
        sectionCodeExists: "Este código de comercio no existe",
        numeroShipmentExists: "Este número de albarán de envío ya está en uso",
        shipmentNameExists: "Este número de albarán de envío no existe",
        idsExists: "El ID es incorrecto",
        binsExists: "Ya existe una ubicación con la misma dirección para esta zona de almacenamiento",
        shdeCartonNameExists: "Este cartón no existe en este albarán de envío",
        binsAlreadyExistsInSection: "Ya existe una ubicación con la misma dirección para este comercio",
        binsNotInThisSection: "Esta ubicación no existe en este comercio",
        binsNotInThisZone: "Esta ubicación no existe en esta zona",
        zoneNotInThisSection: "Esta zona no existe en este comercio",
        binsNotExist: "Esta ubicación no existe",
        binsNotExistInToList: "Esta ubicación no figura en su orden de transferencia",
        binsNotExistInInventory: "Esta ubicación no forma parte de su zona de inventario",
        itemNotExistInInventory: "Este artículo no forma parte de su zona de inventario",
        codeCaisseExists: "Este identificador de caja ya está en uso",
        caisseIdentExists: "Este identificador de caja no existe",
        namePeripheriqueExists: "Este nombre de periférico ya está en uso",
        articleAlreadyInTo: "Este artículo ya está presente en esta orden de transferencia",
        defaultConditionnementExists: "Este acondicionamiento no existe",
        moduleArray: "Se ha producido un error inesperado",
        sectionArray: "Se ha producido un error inesperado",
        rhArray: "Se ha producido un error inesperado",
        modepaiementArray: "Se ha producido un error inesperado",
        raisonmodifprixArray: "Se ha producido un error inesperado",
        componentsIsArray: "Se ha producido un error inesperado",
        articlesArray: "Se ha producido un error inesperado",
        cartonArray: "Se ha producido un error inesperado",
        sectionGeneral: "Se ha producido un error inesperado",
        rhGeneral: "Se ha producido un error inesperado",
        programfideliteGeneral: "Se ha producido un error inesperado",
        programgiftcardGeneral: "Se ha producido un error inesperado",
        forbiddenGeneral: "No está autorizado a realizar esta acción",
        maxusemoisNumeric: "El campo \"Duración de validez\" debe ser un valor numérico",
        maxusemoisproformaNumeric: "El campo \"Duración de validez de una proforma\" debe ser un valor numérico",
        dixmilleNumeric: "El número de billetes de 10 000 XPF debe ser un valor numérico",
        cinqmilleNumeric: "El número de billetes de 5 000 XPF debe ser un valor numérico",
        milleNumeric: "El número de billetes de 1 000 XPF debe ser un valor numérico",
        cinqcentNumeric: "El número de billetes de 500 XPF debe ser un valor numérico",
        deuxcentNumeric: "El número de monedas de 200 XPF debe ser un valor numérico",
        centNumeric: "El número de monedas de 100 XPF debe ser un valor numérico",
        cinquanteNumeric: "El número de monedas de 50 XPF debe ser un valor numérico",
        vingtNumeric: "El número de monedas de 20 XPF debe ser un valor numérico",
        dixNumeric: "El número de monedas de 10 XPF debe ser un valor numérico",
        cinqNumeric: "El número de monedas de 5 XPF debe ser un valor numérico",
        deuxNumeric: "El número de monedas de 2 XPF debe ser un valor numérico",
        unNumeric: "El número de monedas de 1 XPF debe ser un valor numérico",
        caNumeric: "La facturación sin impuestos debe ser un valor numérico",
        cattcNumeric: "La facturación con impuestos debe ser un valor numérico",
        pmNumeric: "El PM sin impuestos debe ser un valor numérico",
        pmttcNumeric: "El PM con impuestos debe ser un valor numérico",
        tfNumeric: "El TF debe ser un valor numérico",
        ivNumeric: "El IV debe ser un valor numérico",
        capitalNumeric: "El capital debe ser un valor numérico",
        exerciceStartNumeric: "El inicio del ejercicio debe ser un valor numérico",
        entreNumeric: "El número de visitas de clientes (entrada y salida) debe ser un valor numérico",
        codeBanqueNumeric: "El campo \"Código Banco\" debe ser un valor numérico",
        codeGuichetNumeric: "El campo \"Código Oficina\" debe ser un valor numérico",
        numeroCompteNumeric: "El campo \"Número de Cuenta\" debe ser un valor numérico",
        cleRibNumeric: "El campo \"Clave RIB\" debe ser un valor numérico",
        priceNumeric: "El precio debe ser un valor numérico",
        promoPriceNumeric: "El precio promocional debe ser un valor numérico",
        prmpNumeric: "El PRMP debe ser un valor numérico",
        prNumeric: "El precio de coste debe ser un valor numérico",
        lastBuyPriceNumeric: "El último precio de compra debe ser un valor numérico",
        lastBuyePriceDeviseNumeric: "El último precio de compra en divisa debe ser un valor numérico",
        tgcNumeric: "La tasa de TGC debe ser un valor numérico",
        invalidTauxTgc: "Tasa de TGC inválida",
        invalidTauxTva: "Tasa de IVA inválida",
        buyPriceNumeric: "El precio de compra debe ser un valor numérico",
        indicePrmpNumeric: "El índice PRMP debe ser un valor numérico",
        indicePrNumeric: "El índice del precio de coste debe ser un valor numérico",
        internalIdNumeric: "El ID interno debe ser un valor numérico",
        componentInternalIdNumeric: "El ID interno del componente debe ser un valor numérico",
        expectedInternalIdNumeric: "El ID interno deseado debe ser un valor numérico",
        referenceNumeric: "El código UPC debe ser un valor numérico",
        quotaNumeric: "La cantidad debe ser un valor numérico",
        quotaCommandeNumeric: "La cantidad debe ser un valor numérico",
        shdeQuotaPrevuNumeric: "La cantidad prevista debe ser un valor numérico",
        firstStartBinsNumeric: "El inicio del primer nivel debe ser un valor numérico",
        firstEndBinsNumeric: "El fin del primer nivel debe ser un valor numérico",
        secondStartBinsNumeric: "El inicio del segundo nivel debe ser un valor numérico",
        secondEndBinsNumeric: "El fin del segundo nivel debe ser un valor numérico",
        thirdStartBinsNumeric: "El inicio del tercer nivel debe ser un valor numérico",
        thirdEndBinsNumeric: "El fin del tercer nivel debe ser un valor numérico",
        fourthStartBinsNumeric: "El inicio del cuarto nivel debe ser un valor numérico",
        fourthEndBinsNumeric: "El fin del cuarto nivel debe ser un valor numérico",
        fifthStartBinsNumeric: "El inicio del quinto nivel debe ser un valor numérico",
        fifthEndBinsNumeric: "El fin del quinto nivel debe ser un valor numérico",
        firstBinsNumeric: "El primer nivel debe ser un valor numérico",
        secondBinsNumeric: "El segundo nivel debe ser un valor numérico",
        thirdBinsNumeric: "El tercer nivel debe ser un valor numérico",
        fourthBinsNumeric: "El cuarto nivel debe ser un valor numérico",
        fifthBinsNumeric: "El quinto nivel debe ser un valor numérico",
        rpIsNumeric: "El nivel de stock mínimo RP de {name} debe ser un valor numérico",
        pslIsNumeric: "El nivel de stock óptimo PSL de {name} debe ser un valor numérico",
        quantiteNumeric: "La cantidad debe ser un valor numérico",
        rpNumeric: "El nivel de stock mínimo debe ser un valor numérico",
        pslNumeric: "El nivel de stock óptimo debe ser un valor numérico",
        toMaxNumeric: "El número máximo de instrucciones para una orden de transferencia debe ser un valor numérico",
        giftCardNumeric: "La duración de validez de un depósito en una tarjeta regalo debe ser un valor numérico",
        giftCardMontantNumeric: "El importe de la tarjeta regalo debe ser un valor numérico",
        paiementNumeric: "Las indicaciones de pago deben ser valores numéricos",
        modifManualValueNumeric: "El valor debe ser numérico",
        detailModePaiementNumeric: "Todos los valores deben ser numéricos",
        maxArticleInventaire: "Su inventario no puede contener más de 500 referencias",
        maxZoneInventaire: "Su inventario no puede contener más de 500 zonas de inventario",
        prefixNumeric: "El prefijo debe ser un valor numérico",
        weightNumeric: "El volumen debe ser un valor numérico",
        minimumCommandeNumeric: "El pedido mínimo debe ser un valor numérico",
        pourcentageRefacturationNumeric: "La comisión en porcentaje debe ser un valor numérico",
        valueNumeric: "El valor debe ser un valor numérico",
        creditInteger: "El crédito debe ser un número entero",
        abonnementInteger: "El abono debe ser un número entero",
        nbrCelluleInteger: "El número de celdas debe ser un número entero",
        noNoteForArticleRetour: "Debe indicar una nota sobre los artículos devueltos",
        donneeclientBoolean: "Se ha producido un error inesperado",
        objectifvendeurBoolean: "Se ha producido un error inesperado",
        objectifcommerceBoolean: "Se ha producido un error inesperado",
        replaceBoolean: "Se ha producido un error inesperado",
        articleListBoolean: "Se ha producido un error inesperado",
        lockLineIsBoolean: "Se ha producido un error inesperado",
        unknowError: "Se ha producido un error inesperado",
        /*********Asistente IA***********/
        chatbotIaTitle: 'Asistente IA',
        chatbotIaOpen: 'Abrir el asistente IA',
        chatbotIaClose: 'Cerrar',
        chatbotIaExpand: 'Ampliar',
        chatbotIaReduce: 'Reducir',
        chatbotIaNewChat: 'Nueva conversación',
        chatbotIaPlaceholder: 'Escriba su pregunta...',
        chatbotIaSend: 'Enviar',
        chatbotIaMicStart: 'Dictar su mensaje',
        chatbotIaMicStop: 'Detener el dictado',
        chatbotIaMicDenied: 'El acceso al micrófono está bloqueado. Autorícelo en los ajustes del navegador (y, en iPhone, active el dictado en Ajustes > General > Teclado).',
        chatbotIaMicError: 'El dictado por voz no está disponible en este momento.',
        chatbotIaAttach: 'Adjuntar un documento (PDF o imagen)',
        chatbotIaAttachRemove: 'Quitar este archivo adjunto',
        chatbotIaFileDefaultText: 'Aquí tiene un documento.',
        chatbotIaFileTooMany: 'Máximo 5 documentos por conversación. Inicie una nueva conversación para adjuntar otros.',
        chatbotIaFileTooLarge: 'Este documento es demasiado grande (5 MB como máximo).',
        chatbotIaFileInvalid: 'No se ha podido leer este documento.',
        chatbotIaFileUnsupported: 'Formato no admitido: solo PDF, JPEG, PNG, GIF o WebP.',
        chatbotIaFilePdfTooLong: 'Este PDF tiene demasiadas páginas (100 como máximo).',
        chatbotIaFileDownload: 'Descargar',
        chatbotIaFileLines: '{nb} artículo(s), para revisar antes de importar',
        chatbotIaMemory: 'Memoria del asistente',
        chatbotIaMemoryHint: 'Para añadir una instrucción, diga por ejemplo «recuerda que...» en el chat. Estas instrucciones solo se aplican a usted.',
        chatbotIaMemoryEmpty: 'Ninguna instrucción memorizada por el momento.',
        chatbotIaMemoryCount: '{nb} / {max} instrucciones',
        chatbotIaMemoryDelete: 'Olvidar esta instrucción',
        chatbotIaMemoryBack: 'Volver a la conversación',
        chatbotIaMemorySaved: 'Instrucción memorizada',
        chatbotIaMemoryReplaced: 'Instrucción reemplazada',
        chatbotIaMemoryForgotten: 'Instrucción olvidada',
        chatbotIaRecording: 'Grabando...',
        chatbotIaSpeakOn: 'Leer las respuestas en voz alta',
        chatbotIaSpeakOff: 'Dejar de leer las respuestas en voz alta',
        chatbotIaSpeakStop: 'Detener la lectura',
        chatbotIaWelcome: 'Hola, ¿en qué puedo ayudarte?',
        chatbotIaUsage: 'Consumo del mes',
        chatbotIaConfirm: 'Confirmar',
        chatbotIaCancel: 'Cancelar',
        chatbotIaCancelled: 'Acción cancelada',
        chatbotIaNotAllowed: 'No está autorizado a usar el asistente IA. Póngase en contacto con su administrador.',
        chatbotIaBusy: 'El asistente está muy solicitado, inténtalo de nuevo en un momento.',
        chatbotIaUnavailable: 'El asistente no está disponible por el momento.',
        chatbotIaNoAnswer: 'No pude responder a esta pregunta. ¿Puedes reformularla?',
        chatbotIaNoPack: "El asistente IA no está disponible: no hay ningún pack IA activo para su empresa.",
        chatbotIaQuotaGlobal: "Se ha alcanzado la cuota IA de su empresa para este mes.",
        chatbotIaQuotaUser: "Se ha alcanzado su cuota IA personal para este mes. Póngase en contacto con su administrador.",
        chatbotIaUsagePersonal: "Su consumo",
        chatbotIaUsagePackEnd: "Fin del pack",
        chatbotIaUnlockLabel: "Desbloquear un excedente para este mes",
        chatbotIaUnlockButton: "Desbloquear",
        chatbotIaUnlocked: "Excedente desbloqueado. Puede volver a hacer su pregunta.",
        chatbotIaAmountInvalid: "Importe no válido.",
        chatbotIaQuotaPercentInvalid: "El porcentaje debe estar entre 0 y 100.",
        chatbotIaQuotaTab: "Consumo IA",
        chatbotIaQuotaMonth: "Mes",
        chatbotIaQuotaPack: "Pack mensual",
        chatbotIaQuotaCompanyUsage: "Consumo de la empresa",
        chatbotIaQuotaCap: "Límite mensual de excedente",
        chatbotIaQuotaCapHelp: "Además del pack, renovado cada mes. Vacío = ningún excedente automático.",
        chatbotIaQuotaUnlocked: "Desbloqueado este mes",
        chatbotIaQuotaOverageUsed: "Excedente consumido",
        chatbotIaQuotaLimit: "Límite (% del total autorizado)",
        chatbotIaQuotaNoLimit: "Sin límite",
        chatbotIaQuotaShare: "Parte del consumo autorizado",
        chatbotIaQuotaOwnProgress: "Avance sobre su límite",
        chatbotIaQuotaAccess: "Acceso al asistente IA",
        chatbotIaQuotaAccessHelp: "Desmarcado: el usuario deja de ver el asistente, en su próxima carga de la aplicación.",
        chatbotIaQuotaLimitHelp: "Un límite es un tope, no una reserva: la suma puede superar el 100 %. Vacío = sin límite.",
        chatbotIaConversationTooLong: 'La conversación es demasiado larga, empieza una nueva.',
        chatbotIaMessageTooLong: 'Tu mensaje es demasiado largo.',
        chatbotIaChartReopen: 'Volver a abrir el gráfico',
        chatbotIaChartView: 'Gráfico',
        chatbotIaChartRendering: 'Representación',
        chatbotIaChartLabels: 'Etiquetas',
        chatbotIaChartLabelsNone: 'Ninguna',
        chatbotIaChartLabelsPercent: 'Porcentaje',
        chatbotIaChartReset: 'Restablecer',
        chatbotIaChartPieOnePeriod: 'Un gráfico circular representa un solo periodo',
        chatbotIaChartTypeBar: 'Barras agrupadas',
        chatbotIaChartTypeBarEmpile: 'Barras apiladas',
        chatbotIaChartTypeBarHorizontal: 'Barras horizontales',
        chatbotIaChartTypeLine: 'Líneas',
        chatbotIaChartTypeArea: 'Áreas',
        chatbotIaChartTypeAreaEmpile: 'Áreas apiladas',
        chatbotIaChartTypeCamembert: 'Gráfico circular',
        chatbotIaPageRead: 'Página consultada',
        chatbotIaHighlighted: 'Elemento resaltado en la página',
        chatbotIaSearchProposed: 'Propongo una búsqueda en internet:',
        chatbotIaSearchAllow: 'Autorizar la búsqueda',
        chatbotIaSearchRefuse: 'Rechazar',
        chatbotIaSearchAllowed: 'Búsqueda autorizada',
        chatbotIaSearchRefused: 'Búsqueda rechazada',
        chatbotIaWriteProposed: 'Voy a guardar esta modificación:',
        chatbotIaWriteProposedMany: 'Voy a guardar estas modificaciones en {nb} artículos:',
        chatbotIaWriteEmpty: '(vacío)',
        chatbotIaWriteConfirmed: 'Modificación guardada',
        chatbotIaWriteRefused: 'No se pudo guardar la modificación:',
        chatbotIaWriteBulk: 'Atención: las reglas de actualización de la empresa aplicarán también este valor a los demás artículos que comparten el mismo {critere}.',
        chatbotIaWriteBulkCount: 'Atención: este valor se aplicará también a {nb} artículos que comparten el mismo {critere}.',
        chatbotIaExportProposed: 'Voy a iniciar esta exportación CSV:',
        chatbotIaExportTotal: '{nb} artículo(s) correspondiente(s)',
        chatbotIaExportColumnsAll: 'todas las columnas que puedes ver',
        chatbotIaExportColumnsSome: '{nb} columna(s) seleccionada(s)',
        chatbotIaExportApostrophe: 'con un apóstrofo al principio de cada celda',
        chatbotIaFamilleProposedCreer: 'Voy a crear estos valores de {niveau}:',
        chatbotIaFamilleProposedRenommer: 'Voy a renombrar este valor de {niveau}:',
        chatbotIaFamilleProposedArchiver: 'Voy a archivar estos valores de {niveau}:',
        chatbotIaFamilleProposedDesarchiver: 'Voy a restaurar estos valores de {niveau}:',
        chatbotIaFamilleConfirmed: 'Catálogo de clasificación actualizado',
        chatbotIaOutdated: 'Esta página ejecuta una versión anterior del asistente. Recarga la página (Ctrl+F5) y vuelve a preguntar.',
        chatbotIaSources: 'Fuentes',
        unknowKiosqueError: "Se ha producido un error inesperado, póngase en contacto con un responsable",
        identFailed: "Las credenciales de conexión son incorrectas",
        originArticleCannotBeTransformArticle: "Un artículo transformado no puede transformarse a partir de un artículo ya transformado",
        allKpiCompareMustBeSelected: "Debe seleccionar un valor para los dos campos",
        noreplace_item_by_itself: "No puede reemplazar un artículo por sí mismo",
        dlThePdf: "Descargar el PDF",
        loyaltyPoints: "Puntos de fidelidad",
        importLoyaltyPoints: "Importar puntos de fidelidad",
        pinrtStartPosition: "Iniciar la impresión de etiquetas en la posición",
        loadingTagsMsg: "Generación de etiquetas en curso, esta acción puede tardar...",
        generateAndDownLoad: "Generar y descargar",
        margeTopPdf: "Margen superior de página",
        margeBottomPdf: "Margen inferior de página",
        margeLeftPdf: "Margen izquierdo de página",
        margeRightPdf: "Margen derecho de página",
        downloadListPdf: "Descargar la lista en PDF",
        margeParDefautA4: "Márgenes predeterminados A4",
        mustBeOneLineConverted: "Debe tener al menos un artículo convertido para realizar esta acción",
        noReliquatInDocument: "No hay ningún saldo pendiente en este documento",
        importCustomer: "Importar clientes",
        cliendtId: "ID del cliente",
        createCustomer: "Crear un cliente",
        last_purchase_price: "Último precio de compra",
        last_purchase_price_devise: "Último precio de compra en divisa",
        convertedIntoInvoice: "Convertido en factura",
        addItemsMass: "Añadir artículos en masa",
        massAssociateSupplementList: "Asignar esta lista de suplementos a artículos",
        filterArticlesMode: "Filtrar artículos",
        existingArticleListMode: "Usar una lista de artículos existente",
        existingArticleList: "Lista de artículos",
        duplicateSupplementConfig: "Duplicar esta configuración de suplementos",
        duplicateSupplementConfigBtn: "Duplicar esta configuración en otros artículos",
        importItemSupplementListAssign: "Importar asignaciones de listas de suplementos",
        validateModif: "Validar las modificaciones",
        defaultQteItems: "Cantidad de artículo por defecto",
        codeComptableGeneral: "Código contable general",
        codeComptable: "Código contable",
        libelleComptableGeneral: "Descripción contable general",
        libelleAttribueAcompte: "La descripción asignada durante la configuración de los códigos de los modos de pago se asignará a los modos de pago siguientes",
        cantDuplicateAcompteOnSelectedType: "La correspondencia no puede duplicarse para el tipo indicado",
        cantDuplicatePaiementOnDifferentType: "La correspondencia de los pagos no puede realizarse en un tipo diferente",
        unavailableConfigForDuplicate: "No es posible duplicar esta configuración",
        configType: "La configuración indicada no tiene el tipo correcto",
        unvalidConfig: "Hay un error en la configuración",
        unavailableVentilation: "Una de las distribuciones seleccionadas no es aplicable",
        acompteDebitMissing: "Falta el código débito para la configuración de los anticipos",
        acompteCreditMissing: "Falta el código crédito para la configuración de los anticipos",
        paiementModeMissingAcompte: "Faltan los códigos de correspondencia para uno o varios modos de pago",
        selectBreakdownField: "Seleccione el campo de distribución",
        codeJournalMissing: "No hay ningún código de diario configurado",
        emailAccountSend: "Cuenta de correo electrónico de envío",
        firstDateOfExport: "Primera fecha de exportación",
        autoExportConfMsgDestinataire: "Añada varios destinatarios separándolos con \";\", pulse la tecla \"Enter\" para añadirlos",
        quotidien: "Diario",
        hebdomadaire: "Semanal",
        mensuel: "Mensual",
        facturation_auto: "Facturación automática",
        facturationFrequenceRequired: "La frecuencia de facturación automática es obligatoria",
        facturation_frequence: "Frecuencia de facturación automática",
        interface_goot: "Interfaz GOOT",
        interfaceGootUndefined: "No definido (según el tipo de cliente)",
        facturationMensuelle: "Facturación mensual",
        facturationBL: "Facturación de albaranes de entrega",
        noBlToBilling: "Ningún albarán de entrega para facturar",
        infosConversionBcBl: "Solo los artículos recogidos pueden convertirse en albarán de entrega. Los artículos no recogidos no figuran, por tanto, en esta lista.",
        convertThePurchaseOrder: "Conversión del pedido de compra",
        convertTheQuotation: "Conversión del presupuesto",
        convertTheCreditNote: "Conversión del abono",
        convertTheInvoice: "Conversión de la factura",
        inBl: "en albarán de entrega",
        inPo: "en pedido de compra",
        inRn: "en albarán de devolución",
        inCn: "en abono",
        returnToPurachaseOrder: "Volver al pedido de compra",
        returnToQuotation: "Volver al presupuesto",
        returnToCreditNote: "Volver al abono",
        returnToInvoice: "Volver a la factura",
        autoFacturationMensuelle: "Facturación automática",
        autoFacturationMensuelleFrequency: "Frecuencia de facturación automática",
        allDeliveryNote: "Todos los albaranes de entrega",
        autoExportConf: "Configuración de las exportaciones automáticas",
        total_remise_ht: "Total del descuento sin impuestos",
        ht_remise: "Importe del descuento sin impuestos",
        supplierInvoiceRef: "Referencia de la factura del proveedor",
        franchise_en_base: "Franquicia en base",
        byItem: "Por artículo",
        exportConfRequiredVentilation: "Se necesita una configuración del archivo de exportación para poder distribuir por artículo",
        selectConf: "Seleccionar la(s) configuración(es)",
        duplicateBreakdown: "Duplicar la distribución",
        AddNewBreakdownLine: "Añadir una nueva línea de distribución",
        exportHeaderOnFlatFile: "Exportar los encabezados en los archivos planos",
        ventilationItem: "Distribución por artículo",
        breakdownTgcByItem: "Distribución por artículo de la {taxe}",
        correspondanceMissing: "No existe ninguna configuración de código",
        configMissing: "Existe un error en la configuración de su archivo de exportación",
        codeClientConfigMissing: "No existe ninguna configuración de código de cliente",
        paiementModeMissing: "Existe un error en la configuración del archivo de exportación de los modos de pago",
        taxeMissing: "Existe un error en la configuración del archivo de exportación de los impuestos",
        caisseIdentMissing: "Existe un error en la configuración del archivo de exportación de las cajas",
        commerceMissing: "Existe un error en la configuración del archivo de exportación de los comercios",
        codeFournisseurConfigMissing: "No existe ninguna configuración de código de proveedor",
        cantDuplicatePaiementOnDifferentType: "No es posible duplicar estos modos de pago",
        duplicateComptaConfig: "Duplicar una configuración",
        duplicateExistingComptaConfig: "Duplicar una configuración existente",
        duplicateComptaConfigFrom: "Duplicar una configuración a partir de",
        receiptRef: "Referencia del ticket",
        paymentNumber: "Código contable del pago",
        paymentWording: "Descripción del pago",
        taxeWording: "Descripción de {taxe}",
        taxeNumber: "Código contable de {taxe}",
        acompteWording: "Descripción del anticipo",
        acompteNumber: "Código contable del anticipo",
        shopTel: "Número de teléfono del comercio",
        shopEmail: "Correo electrónico del comercio",
        shopHoraire: "Horario del comercio",
        shopType: "Tipo de comercio",
        shopItemPrice: "Precio de los artículos en comercio",
        shopEcomType: "Tipo de comercio electrónico",
        shopAccountingCode: "Código contable del comercio",
        customerAccountingCode: "Código contable del cliente",
        providerAccountingCode: "Código contable del proveedor",
        custmomerIcrementNum: "Número de incremento del cliente",
        providerIncrementNum: "Número de incremento del proveedor",
        oldAccountingClientCode: "Antiguo código contable del cliente",
        oldAccountingProviderCode: "Antiguo código contable del proveedor",
        customerTel: "Número de teléfono del cliente",
        customerEmail: "Correo electrónico del cliente",
        customerType: "Tipo de cliente",
        customerName: "Apellido del cliente",
        customerFirstName: "Nombre del cliente",
        cashRegisterAccountingCode: "Código contable de la caja",
        cashRegisterCode: "Código de caja",
        ticketDate: "Fecha del ticket",
        receiptType: "Tipo de ticket",
        selectionOfTheDataTypeToAssociate: "Selección del tipo de dato a asociar",
        exportConfigurationB2b: "Exportaciones contables de las ventas B2B",
        exportConfigurationB2c: "Exportaciones contables de las ventas B2C",
        exportConfigurationPurchase: "Exportaciones contables de las compras",
        purchase: "Compra",
        b2cSale: "Venta B2C",
        b2bSale: "Venta B2B",
        configurationTypeSelection: "Selección del tipo de configuración",
        noExistingShopForThisCompany: "No existe ningún comercio para esta empresa",
        noExistingCashRegisterForThisCompany: "No existe ninguna caja para esta empresa",
        receipts: "Ingresos",
        wording: "Descripción",
        accountingCodeConfiguration: "Configuración de los códigos contables",
        accountingFileConfiguration: "Configuración de los archivos contables",
        salesJournalCode: "Código del diario de ventas",
        salesJournalConfigurationB2c: "Configuración del diario de ventas B2C",
        salesJournalConfigurationB2b: "Configuración del diario de ventas B2B",
        flatFile: "Archivo plano",
        csvFile: "Archivo CSV",
        purchasesExport: "Exportación de las compras",
        noExistingExportConfiguration: "No existe ninguna configuración de exportación",
        selectCompany: "Seleccionar una empresa",
        exportTiersClient: "Exportación de terceros clientes",
        exportTiersFournisseur: "Exportación de terceros proveedores",
        exportTiersClientFournisseur: "Exportación de terceros cliente/proveedor",
        addColumn: "Añadir una columna",
        exportHeader: "Encabezado de exportación",
        associatedData: "Dato asociado",
        defaultValue: "Valor por defecto",
        correspondenceField: "Campo de correspondencia",
        numberOfDigitsToIncrement: "Longitud de la sección de incremento",
        numberOfSection: "Número de secciones",
        codeFournisseur: "Código de proveedor",
        codeClient: "Código de cliente",
        codeClientDefault: "Código de cliente por defecto",
        codeFournisseurDefault: "Código de proveedor por defecto",
        codeConfigurationFournisseur: "Configuración de los códigos de proveedor",
        codeConfigurationClient: "Configuración de los códigos de cliente",
        codeConfigurationModePay: "Configuración de los códigos de los modos de pago",
        codeConfigurationDeposit: "Configuración de los códigos de anticipo",
        codeConfigurationTaxe: "Configuración de los códigos de {taxe}",
        codeConfigurationTaxeArticles: "Configuración de los códigos de {taxe} por artículo",
        codeConfigurationShop: "Configuración de los códigos de comercio",
        codeConfigurationCaisse: "Configuración de los códigos de caja",
        codeConfigurationJournal: "Configuración de los códigos de diario",
        exportConfigurationClient: "Exportaciones contables de clientes",
        exportConfigurationFournisseur: "Exportaciones contables de proveedores",
        syncInProgres: "Sincronización de artículos en curso...",
        synchronizeItemsList: "Sincronizar la lista de artículos",
        additionToList: "Adición a la lista",
        replacementOfTheList: "Reemplazo de la lista",
        dynamicFilter: "Filtro dinámico",
        existingDynamicFilter: "Filtro dinámico existente",
        dynamicUpdateByFilter: "Actualización de artículos por filtrado dinámico",
        actionOnDynamicFilter: "Acción sobre los artículos afectados por el filtrado dinámico",
        itemsWillReplaceItemPromo: "Los artículos afectados por la selección de filtro reemplazarán a los de la promoción",
        firstValue: "Primer valor",
        secondValue: "Segundo valor",
        thirdValue: "Tercer valor",
        numeroTgc: "Número de {taxe}",
        siren: "SIREN",
        siret: "SIRET",
        labelAssujettiTva: "Sujeto al IVA",
        notSpecified: "No especificado",
        sirenInvalid: "El SIREN debe contener 9 dígitos válidos",
        siretInvalid: "El SIRET debe contener 14 dígitos válidos",
        siretSirenMismatch: "El SIRET no corresponde al SIREN",
        sirenRequired: "El SIREN es obligatorio",
        siretRequired: "El SIRET es obligatorio",
        assujettiTvaRequired: "Debe indicar la sujeción al IVA",
        paysLegacyValue: "Valor actual no reconocido: «{pays}». Seleccione un país de la lista.",
        factureNoPaymentM: "No hay ningún {documentType} disponible para este cliente",
        factureNoPaymentF: "No hay ninguna {documentType} disponible para este proveedor",
        column: "Columna",
        noPaymentModeAvailable: "Ningún modo de pago disponible",
        availableStock: "Stock disponible",
        unavailableStock: "Stock no disponible",
        totalStock: "Stock total",
        usedOnDoc: "Utilizado en el(los) siguiente(s) documento(s)",
        amountLeft: "Importe restante",
        used: "Utilizado",
        unUsed: "No utilizado",
        partiallyUsed: "Parcialmente utilizado",
        unUsedF: "No utilizada",
        surDocument: "Sobre documento",
        tousDocTitle: "Todos los {documentType}",
        toutesDocTitle: "Todas las {documentType}",
        tgcDefault: "{taxe} por defecto",
        sectionArticleListDefault: "Comercio por defecto para lista de artículos",
        zoneArticleListDefault: "Zona por defecto para lista de artículos",
        defaultReservationTime: "Duración de reserva por defecto",
        minutes: "minutos",
        kpiFilterDefault: "Filtro de KPI por defecto",
        kpiFilterDefaultCompare: "Comparación de filtro por defecto",
        generateUpc: "Generación de código UPC",
        itemsTransform: "Artículos transformados",
        editItemsTransform: "Edición de artículo transformado",
        notItemTransform: "Este artículo no es un artículo transformado",
        convertToItemTransform: "Convertir en artículo transformado",
        prefix: "Indicar el prefijo",
        replace: "Reemplazar los códigos de barras existentes",
        article_list: "Generar una lista de artículos",
        article_list_name: "Indicar un nombre para la lista de artículos",
        generateUpcStart: "Inicio de la generación de códigos de barras",
        generateUpcSuccess: "Los códigos de barras han sido generados",
        generateUpcSuccessList: "Los códigos de barras y la lista de artículos han sido generados",
        generateUpcInProgress: "Generación de códigos de barras en curso. Esta tarea puede tardar algunos minutos, no salga de la página...",
        prefixConfigError: "No se han podido generar los códigos de barras, verifique la configuración del prefijo",
        errorInvoicingRecordsMsg: "Existen errores en los siguientes tickets",
        reviewOfAccountingRecords: "Control de los asientos contables",
        allAccountingEntriesAreCorrect: "Todos los asientos contables son correctos",
        refundOnEspecePay: "Realizar un reembolso en efectivo",
        refundOnOtherPay: "Realizar otro tipo de reembolso",
        selectedRows: "Líneas seleccionadas",
        noDiscounts: "Precio normal",
        confirmArticleEdition: "¿Está seguro de que desea editar el campo {articleField}?",
        editConfirmation: "Confirmación de edición",
        refundMode: "Modo de reembolso",
        errorMsgTotalPay: "El importe total de los pagos no corresponde al total del carrito",
        cartTotal: "Total del carrito",
        deleteAnItemsList: "Eliminar una lista de artículos",
        createdFromItemsList: "Creado a partir de la lista de artículos",
        noExistingCurrency: "No existe ninguna moneda",
        addACurrency: "Añadir una moneda",
        roundNumberValue: "Valor del importe del redondeo",
        roundNumberMsg: "Deje este campo vacío si no gestiona redondeo",
        currency: "Moneda",
        addARateOf: "Añadir una tasa de {taxe}",
        tvaPo: "Tasa de {taxe} proveedor",
        infoOnItemLine: "Información sobre la línea de artículo",
        organizeInAlphabeticalOrder: "Organizar por orden alfabético",
        organizeByFolderNumberCroissant: "Organizar por número de expediente (orden ascendente)",
        organizeByFolderNumberDecroissant: "Organizar por número de expediente (orden descendente)",
        nextFolder: "Expediente siguiente",
        previousFolder: "Expediente anterior",
        ascending: "Ascendente",
        descending: "Descendente",
        sortAndGroup: "Ordenar y agrupar",
        dragAndDropItemsOrder: "Arrastre y suelte los artículos en el orden deseado.",
        reorderSortGroupPriority: "Hay una ordenación y/o agrupación configurada en este documento: tiene prioridad, el orden manual solo se aplica entre los artículos que deja empatados.",
        editManualEntry: "Modificar la entrada manual",
        prmpLine: "PMP de la línea",
        receptionSuccess: "Recepción finalizada con éxito",
        collectionSuccess: "Recogida finalizada con éxito",
        confirmCollectAll: "¿Está seguro de que desea recoger todos los artículos?",
        confirmReceiveAll: "¿Está seguro de que desea recepcionar todos los artículos?",
        urlFichierCommande: "URL del archivo de pedidos",
        urlApi: "URL API",
        commerceRetraitStock: "Comercio de retiro de stock",
        startDateOrderProcessing: "Inicio del procesamiento de pedidos en la aplicación",
        uncertainty: "Incertidumbre",
        code_barre: "Código UPC",
        sku_vendeur: "SKU",
        famille: "Familia",
        sous_famille: "Subfamilia",
        images: "Imágenes",
        longueur: "Longitud",
        largeur: "Anchura",
        hauteur: "Altura",
        weight: "Peso",
        weight_unit: "Unidad de peso",
        short_description: "Descripción corta",
        actionOnOtherModePay: "Acción realizada si el importe del carrito es inferior al importe del modo de pago",
        item_price_zero: "Añadir un artículo",
        historicalExportSales: "Historial de exportaciones de ventas",
        thirdPartyExport: "Exportación de terceros",
        saleExport: "Exportación de ventas",
        accounting: "Contabilidad",
        paymentInterface: "Interfaz de pago",
        default: "Por defecto",
        checkoutInterface: "Interfaz de caja",
        lastCloseCaisse: "Último cierre de caja",
        errorDeclarationEsp: "Error de declaración en la línea {monnaie}, el número máximo es {maxNbr}",
        filter: "Filtrar",
        itemsWillBe: "Los artículos serán",
        includedToPromo: "Incluido en la promoción",
        includedToPercentageException: "Incluido en la excepción de porcentaje",
        includedToPersonalizedPrice: "Incluido en el precio personalizado",
        excludedToPromo: "Excluido de la promoción",
        excludedToPercentageException: "Excluido de la excepción de porcentaje",
        excludedToPersonalizedPrice: "Excluido del precio personalizado",
        excludeItemToPromo: "Excluir los artículos de la promoción",
        excludeItemToKpi: "Excluir los artículos del filtro de KPI",
        includedToFidelite: "Incluido en el plan de fidelidad",
        excludedToFidelite: "Excluido del plan de fidelidad",
        confFondCaisseMsg: "Si no hay ningún fondo de caja configurado, se utilizará por defecto el indicado en el cierre de caja",
        autoDistributionCashFund: "Distribución automática del fondo de caja",
        automaticReminderPayment: "Creación automática de un recordatorio de pago después de xx día(s)",
        defaultRefacturationPercentage: "Comisión de refacturación en porcentaje",
        defaultRefacturationCategorieTarif: "Categoría tarifaria de refacturación",
        defaultRefacturationCategorieTarifHelp: "Nombre de la categoría tarifaria (ArticlePrice) utilizada al refacturar por esta empresa. Si se indica, este campo prevalece sobre las excepciones por artículo y sobre el porcentaje de refacturación. Si no se encuentra, se utiliza article.price_b2b, en su defecto 0.",
        defaultRefacturationDate: "Primera fecha de aplicación de la refacturación",
        defaultShopStock: "Stock por defecto",
        associatedClientFournisseur: "Cliente y proveedor asociados a la empresa para la refacturación",
        facturationCompteMail: "Cuenta de correo por defecto para los correos automáticos de facturación",
        clientAlreadyUsed: "Cliente ya utilizado",
        fournisseurAlreadyUsed: "Proveedor ya utilizado",
        selectionOfCustomers: "Selección de clientes",
        selectionOfClientType: "Selección del tipo de cliente",
        extraCustomFieldsExposed: "Campos personalizados adicionales expuestos",
        noArticleCustomFieldConfigured: "Ningún campo personalizado de artículo configurado",
        unknownCustomField: "Campo personalizado desconocido",
        itemsFromWillBeExcluded: "Los artículos de su selección serán excluidos de la promoción",
        itemsFromPercentageExceptionWillBeExcluded: "Los artículos de su selección serán excluidos de la excepción de porcentaje",
        itemsFromPersonalizedPriceWillBeExcluded: "Los artículos de su selección serán excluidos del precio personalizado",
        itemsFromFideliteWillBeExcluded: "Los artículos de su selección serán excluidos del plan de fidelización",
        keepAfterCopnversion: "Conservar después de la conversión",
        cashPayment: "Pago al contado",
        days7Payment: "7 días",
        days15Payment: "15 días",
        days30PaymentFixed: "30 días",
        days30Payment: "30 días fin de mes",
        days45Payment: "45 días fin de mes",
        days60Payment: "60 días fin de mes",
        days90Payment: "90 días fin de mes",
        nbTickets: "Número de tickets",
        nbFactures: "Número de facturas",
        unassigned: "Sin asignar",
        passages: "Visitas",
        bestTicket: "Mejor ticket",
        apostropheBeginningCell: "Apóstrofo al inicio de la celda",
        compare_date: "Comparar la fecha en lugar del día",
        justificatif: "Descargar el justificante",
        documentSaved: "Documentos guardados",
        confirmReinstateItemsInStock: "¿Está seguro de que desea reintegrar los artículos a su stock?",
        confirmCollectItem: "¿Está seguro de que desea recolectar los artículos no recolectados?",
        confirmRemoveItemsFromStock: "¿Está seguro de que desea sacar los artículos de su stock?",
        removeItemFromStock: "Sacar los artículos del stock",
        collectAllItem: "Recolectar todos los artículos no recolectados desde",
        warninStockMsgFacture: "Todos o parte de los artículos de esta factura no están presentes en un albarán de entrega. Complete el formulario a continuación para realizar la salida de stock de los artículos correspondientes",
        dupliquer: "Duplicar este documento",
        noteRequiredMsg: "Se requiere una nota",
        noteRequiredReturnItem: "Nota obligatoria en los artículos devueltos",
        returnItems: "Realizar devoluciones de artículos",
        wmsAuthentication: "Autenticación WMS",
        wmsAuthRequired: "Requerida",
        wmsAuthRequiredRequired: "El campo \"autenticación WMS requerida\" es obligatorio",
        wmsAuthRequiredBoolean: "El campo \"autenticación WMS requerida\" debe ser verdadero o falso",
        binsCollectOrder: "Orden de recolección de BINS",
        binsCollectOrderAsc: "Ascendente",
        binsCollectOrderDesc: "Descendente",
        binsCollectOrderRequired: "El campo \"orden de recolección de BINS\" es obligatorio",
        binsCollectOrderIn: "El campo \"orden de recolección de BINS\" debe ser \"asc\" o \"desc\"",
        displayOtherSectionsTo: "Órdenes de transferencia de los otros comercios",
        displayOtherSectionsToLabel: "Mostrar las órdenes de transferencia en curso de los otros comercios en el WMS",
        displayOtherSectionsToRequired: "El campo \"mostrar las órdenes de transferencia de los otros comercios\" es obligatorio",
        displayOtherSectionsToBoolean: "El campo \"mostrar las órdenes de transferencia de los otros comercios\" debe ser verdadero o falso",
        dontApplyDiscountedItem: "No aplicar en los artículos con descuento",
        totalPriceEdition: "Edición del precio total",
        selectTheTransferArea: "Elegir la zona de transferencia",
        noPrice: "Ningún precio configurado para este artículo",
        zoneAlreadyHaveCommandeB2b: "Ya existe una zona de pedido B2B",
        noZoneCommandeB2b: "No existe ninguna zona de pedido B2B",
        factureAlreadyReceptione: "Este documento ya ha sido recepcionado",
        factureArticleAlreadyReceptione: "Este artículo ya ha sido recepcionado en este documento",
        itemAdditionFrom: "Adición de artículos desde",
        signHere: "Firmar aquí",
        leaveBox: "Sacar de la caja",
        noDeliveryNote: "Ningún albarán de entrega",
        confirmFianlizeDeliveryNote: "¿Realmente desea finalizar este albarán de entrega?",
        voucherInProgress: "Bonos en curso",
        nbItemsCantBeHigherThanOrdered: "La cantidad de artículos escaneados no puede ser superior a la cantidad pedida",
        itemNotInOrderedList: "Este artículo no está presente en la lista de artículos pedidos",
        addItemsInDeliveryNote: "Añadir artículos al albarán de entrega",
        selectionPoWms: "Selección de las órdenes de compra",
        delivery: "Entrega",
        createDeliveryVoucher: "Crear un bono",
        validationDelivery: "Entrega de los bonos",
        returnNotes: "Bonos de devolución",
        shipmentVouchers: "Bonos de expedición",
        poB2bWms: "Pedidos de cliente B2B",
        poB2cWms: "Pedidos de cliente B2C",
        createListItem: "Crear una lista de artículos",
        customizeTag: "Personalizar la etiqueta",
        generatedByPurchaseOrder: "Generado por la orden de compra",
        gestionReliquats: "Gestión de los remanentes",
        reliquat: "Remanente",
        convertedValue: "Valor convertido",
        reliquatValue: "Valor del remanente",
        billingInvoireGeneratedMsg: "Se ha generado una factura de compra a partir de esta orden de compra",
        selectAPrinter: "Seleccionar una impresora",
        printerNameRegistered: "Nombre de la impresora registrada en Windows",
        image_file: "Archivo de imagen (Windows)",
        defaultCustomer: "Cliente por defecto",
        default_conditionnement: "Embalaje por defecto",
        lessThanMOQ: "Uno o varios artículos no respetan la cantidad mínima de pedido. ¿Desea continuar?",
        deletePersonalizedPrice: "¿Desea eliminar el precio personalizado de la línea?",
        minimum_commande: "Pedido mínimo",
        personalized_price: "Precio personalizado",
        personalized_price_delete: "el precio personalizado para",
        personalized_price_percent: "Precio personalizado descuento porcentaje",
        personalized_price_franche: "Precio personalizado descuento fijo",
        personalized_price_prixfixe: "Precio personalizado precio fijo",
        permanent: "Permanente",
        noFolderLinked: "Ningún expediente vinculado",
        convertPoBillinBuyErr: "Esta orden de compra no se puede convertir porque contiene varias divisas",
        convertIntoBillingBuy: "Convertir en factura de compra",
        dont: "De los cuales",
        last_pr: "Último precio de costo",
        last_date_buy: "Última fecha de compra",
        first_stock_entry_date: "Fecha de primera entrada en stock",
        ecotaxe: "Ecotasa",
        quotaIsOverArticleQuantity: "La cantidad indicada es superior a la cantidad esperada",
        qteToReceive: "Cantidad a recepcionar",
        docCompletelyReceived: "Documento totalmente recepcionado",
        noMoreItemReceive: "Ya no hay artículos por recepcionar",
        noReturnNote: "Ningún bono de devolución",
        receiptReturnNote: "Recepción de los bonos de devolución",
        returnNote: "Bono de devolución",
        addToBoxMsg: "¿Desea añadir la selección a una caja?",
        poB2b: "Orden de compra de cliente",
        collectPoClient: "Recolección de las órdenes de compra de cliente",
        cancelFiltre: "Cancelar el filtro",
        showOnlyLineToBeConverted: "Mostrar únicamente las líneas por convertir",
        allItemsConverted: "Todos los artículos han sido convertidos",
        notemsToConvert: "Ningún artículo por convertir",
        cancelledDocu: "Documento anulado",
        documentClosedAt: "Documento finalizado el",
        confirmCancelpo: "¿Está seguro de que desea anular esta orden de compra?",
        cancelDocument: "Anular {document}",
        quantityAlreadyPo: "Cantidad ya convertida",
        quantityToConvert: "Cantidad a convertir",
        convertToPo: "Convertir en orden de compra",
        convertFolderPo: "Convertir las órdenes de compra",
        convertFolderPoSwal: "¿Convertir todas las órdenes de compra del expediente en albarán de entrega? Atención: solo se tendrán en cuenta los artículos recolectados.",
        convertToCreditNote: "Convertir en nota de crédito",
        convertToCreditNoteBuy: "Convertir en nota de crédito de proveedor",
        convertToDeliveryNote: "Convertir en albarán de entrega",
        convertFolderDeliveryNote: "Convertir los albaranes de entrega",
        convertFolderDeliveryNoteSwal: "¿Convertir todos los albaranes de entrega del expediente en factura?",
        deliveryNote: "Albarán de entrega",
        validateDeliveryNote: "Validar la entrega",
        convertToReturnOrder: "Convertir en bono de devolución",
        returned_in: "Artículo devuelto en el ticket",
        mustHave1Bouton: "La etiqueta de botón de descarga es obligatoria ([bouton]) y solo puede estar presente una vez",
        documentClosedFieldLocked: "Este documento ha sido emitido: su contenido impreso ya no puede modificarse (solo la nota interna, las alertas y los pagos siguen siendo editables)",
        pennylaneStatusTitle:"Transmisión Pennylane",
        pennylaneSelectAllOnPage:"Seleccionar todo en esta página",
        pennylaneBulkSend:"Enviar a Pennylane",
        pennylaneBulkConfirm:"¿Transmitir {count} ticket(s) a Pennylane, con el cliente ya vinculado a cada uno?",
        pennylaneTicketButton:"Factura Pennylane",
        pennylaneTicketTitle:"Factura Pennylane del ticket",
        pennylaneTicketCustomer:"Cliente facturado",
        pennylaneTicketCustomerLocked:"El cliente ya vinculado es una empresa identificada: no se puede reemplazar.",
        pennylaneTicketNotTransmittable:"Este ticket no se puede transmitir:",
        pennylaneTicketModeImportOnly:"La factura se importará en Pennylane para la contabilidad, sin facturación electrónica.",
        pennylaneTicketModeEInvoice:"La factura se transmitirá como factura electrónica.",
        pennylaneTicketModeDisabled:"La transmisión de las facturas de caja está desactivada para este emisor.",
        pennylaneTicketSend:"Enviar a Pennylane",
        pennylaneTicketBlockedOutro:"Puede completar la ficha del cliente antes del envío, o enviar ahora: la transmisión quedará en espera hasta la corrección.",
        pennylaneTicketMixedNotSupported:"Ticket que mezcla venta y devolución (cambio): no transmisible",
        pennylaneTicketGiftCardLine:"Ticket con una tarjeta regalo: no transmisible",
        pennylaneTicketRefundOriginAmbiguous:"Reembolso sobre varios tickets: no transmisible",
        pennylaneTicketRefundOriginNotTransmitted:"El ticket reembolsado no se transmitió a Pennylane",
        pennylaneTicketAlreadyRequested:"Ya se ha solicitado una factura Pennylane para este ticket",
        pennylaneTicketClientLocked:"Este ticket se transmitió a Pennylane: su cliente ya no se puede modificar",
        pennylaneConnections:"Conexiones Pennylane",
        pennylaneConnectionsHelp:"Una conexión por empresa emisora. El token API se genera en Pennylane (cuenta de administrador); nunca se vuelve a mostrar.",
        pennylaneIssuer:"Emisor",
        pennylaneAccount:"Empresa Pennylane",
        pennylaneEnvironment:"Entorno",
        pennylaneEnvironment_sandbox:"Entorno de pruebas",
        pennylaneEnvironment_production:"Producción",
        pennylaneOptions:"Opciones",
        pennylaneActiveFrom:"Desde",
        pennylaneState:"Estado",
        pennylaneB2b:"Facturas del módulo de facturación",
        pennylaneB2c:"Facturas de caja",
        pennylaneConvert:"Factura electrónica",
        pennylaneNotConnected:"No conectado",
        pennylaneActive:"Activa",
        pennylaneInactive:"Inactiva",
        pennylaneConfigure:"Configurar",
        pennylaneDeactivate:"Desactivar",
        pennylaneDeactivateConfirm:"Desactivar la conexión Pennylane de",
        pennylaneConnectionOf:"Conexión Pennylane de",
        pennylaneToken:"Token API Pennylane",
        pennylaneTokenKeep:"Dejar vacío para conservar el token guardado",
        pennylaneB2bHelp:"Transmitir las facturas y abonos del módulo de facturación",
        pennylaneB2cHelp:"Transmitir las facturas solicitadas en caja",
        pennylaneConvertHelp:"Convertir en factura electrónica (Factur-X) las facturas elegibles",
        pennylaneActiveHelp:"Conexión activa",
        pennylaneActiveFromHelp:"Transmitir los documentos cerrados a partir del",
        pennylaneReplaceConnection:"Reemplazar la conexión",
        pennylaneMissingScopes:"Conexión guardada, pero al token le faltan permisos",
        pennylaneClassification:"Clasificación de las líneas en Pennylane",
        pennylaneClassificationHelp:"Los números de cuenta los decide el contable en Pennylane. Elija los campos personalizados de artículo (listas) que indican la naturaleza de las ventas y su categoría analítica.",
        pennylaneNature:"Naturaleza",
        pennylaneNatureField:"Campo personalizado de artículo que indica la naturaleza",
        pennylaneNoField:"Ninguno",
        pennylaneFieldValue:"Valor del campo",
        pennylaneNature_none:"No indicada (cuenta por defecto de Pennylane)",
        pennylaneNature_goods:"Mercancías",
        pennylaneNature_services:"Prestaciones de servicios",
        pennylaneCategory:"Categoría analítica",
        pennylaneCategoryField:"Campo personalizado de artículo que indica la categoría analítica",
        pennylaneCategoryGroups:"Grupos de categorías Pennylane a sincronizar",
        pennylaneNoCategoryGroup:"Ningún grupo encontrado: compruebe que una conexión está activa",
        pennylaneSyncCategories:"Sincronizar las categorías Pennylane",
        pennylaneLastSync:"Última sincronización",
        pennylaneCategoriesFound:"categorías",
        pennylaneCategoriesAdded:"Añadidas a la lista",
        pennylaneCategoriesMissing:"Valores de la lista ausentes en Pennylane (conservados):",
        pennylaneArticles:"artículos",
        pennylaneEnvironmentInvalid:"Entorno no válido",
        pennylaneActiveFromInvalid:"Fecha de inicio no válida",
        pennylaneTokenRequired:"El token API es obligatorio para una primera conexión",
        pennylaneTokenRequiredForEnvironmentChange:"Cambiar de entorno requiere introducir un token",
        pennylaneConnectionAccountChanged:"Este token corresponde a otra empresa Pennylane o a otro entorno. ¿Reemplazar la conexión existente?",
        pennylaneTokenInvalid:"Token Pennylane no válido o revocado",
        pennylaneTokenVerificationFailed:"No se pudo verificar el token, inténtelo más tarde",
        pennylaneSandboxTokenForProduction:"Este token corresponde a un entorno de pruebas: no se puede usar en producción",
        pennylaneProductionTokenForSandbox:"Este token no corresponde a un entorno de pruebas",
        pennylaneCustomFieldNotEligible:"Solo se pueden usar campos personalizados de artículo de tipo lista",
        pennylaneCustomFieldsMustDiffer:"La naturaleza y la categoría deben usar dos campos distintos",
        pennylaneNatureInvalid:"Naturaleza no válida",
        pennylaneCategoryGroupsNotSelected:"Elija al menos un grupo de categorías a sincronizar",
        pennylaneCategoryNotFound:"Categoría analítica ausente en Pennylane",
        pennylaneCategoriesNotAssigned:"No se pudieron asignar las categorías analíticas",
        pennylaneStatus_pending:"pendiente",
        pennylaneStatus_pdf_ready:"PDF generado, envío en curso",
        pennylaneStatus_importing:"importación en curso",
        pennylaneStatus_import_unknown:"resultado de importación en verificación automática",
        pennylaneStatus_imported:"importada",
        pennylaneStatus_awaiting_conversion:"conversión a factura electrónica en curso",
        pennylaneStatus_retry_wait:"nuevo intento programado",
        pennylaneStatus_waiting_origin:"a la espera de la transmisión de la factura de origen",
        pennylaneStatus_blocked:"bloqueada, condiciones no cumplidas",
        pennylaneStatus_validation_error:"rechazada por Pennylane",
        pennylaneStatus_skipped:"no transmitida",
        pennylaneStatus_error:"error de conexión o de permisos Pennylane",
        pennylaneImportedWithoutEInvoice:"Importada para la contabilidad, sin facturación electrónica",
        pennylaneRetry:"Relanzar la transmisión",
        pennylaneRetryLaunched:"Transmisión relanzada",
        pennylaneRetryNotAllowed:"Esta transmisión no se puede relanzar",
        pennylaneConfirmTitle:"Condiciones de importación Pennylane no cumplidas",
        pennylaneConfirmBlockedIntro:"Este documento no podrá importarse en Pennylane:",
        pennylaneConfirmBlockedOutro:"Puede corregir la ficha del cliente antes de validar, o validar ahora: la transmisión quedará en espera hasta la corrección. Atención, los datos del cliente figuran en el documento emitido.",
        pennylaneValidateAnyway:"Validar de todos modos",
        eInvoiceDocumentTypeNotCovered:"Tipo de documento no afectado",
        eInvoiceCreditNoteWithoutOrigin:"Abono sin factura de origen",
        eInvoiceCreditNoteEmitterMismatch:"El abono y su factura de origen no tienen el mismo emisor",
        eInvoiceCreditNoteRecipientMismatch:"El abono y su factura de origen no tienen el mismo cliente",
        eInvoiceRecipientMissing:"Cliente ausente del documento",
        eInvoiceCurrencyNotInPilot:"Moneda no admitida (solo EUR)",
        eInvoiceB2cFlagWithProfessionalRecipient:"Documento marcado B2C para un cliente profesional",
        eInvoiceEmitterCountryMissing:"País de la empresa emisora no informado",
        eInvoiceEmitterCountryNotCoded:"País de la empresa emisora no reconocido (se espera un código de país)",
        eInvoiceEmitterTerritoryExcluded:"Empresa emisora fuera del territorio de la facturación electrónica",
        eInvoiceEmitterTerritoryToReview:"Territorio de la empresa emisora por confirmar",
        eInvoiceEmitterNotInFrance:"Empresa emisora no establecida en Francia",
        eInvoiceEmitterVatStatusUnknown:"Sujeción al IVA de la empresa emisora no informada",
        eInvoiceEmitterNotVatLiable:"Empresa emisora no sujeta al IVA",
        eInvoiceEmitterSirenMissing:"Falta el SIREN de la empresa emisora",
        eInvoiceEmitterSirenInvalid:"SIREN de la empresa emisora no válido",
        eInvoiceRecipientCountryMissing:"País del cliente no informado",
        eInvoiceRecipientCountryNotCoded:"País del cliente no reconocido (se espera un código de país)",
        eInvoiceRecipientTerritoryExcluded:"Cliente fuera del territorio de la facturación electrónica",
        eInvoiceRecipientTerritoryToReview:"Territorio del cliente por confirmar",
        eInvoiceRecipientNotInFrance:"Cliente no establecido en Francia",
        eInvoiceRecipientVatStatusUnknown:"Sujeción al IVA del cliente no informada",
        eInvoiceRecipientNotVatLiable:"Cliente no sujeto al IVA",
        eInvoiceRecipientSirenMissing:"Falta el SIREN del cliente",
        eInvoiceRecipientSirenInvalid:"SIREN del cliente no válido",
        pennylaneQualificationNeedsReview:"Datos por completar antes de la transmisión",
        pennylaneChannelDisabled:"Transmisión desactivada para este tipo de documento",
        pennylaneCreditNoteOriginNotTransmitted:"La factura de origen del abono no se transmitió a Pennylane",
        pennylaneCreditNoteOriginFailed:"La transmisión de la factura de origen falló",
        pennylaneFacturXDocumentTypeNotSupported:"Este tipo de documento no puede convertirse en factura electrónica",
        pennylaneFacturXCreditNoteOriginMissing:"Falta la factura de origen del abono o no tiene número",
        pennylaneFacturXIdentifierMissing:"Falta un SIREN en el emisor o en el cliente",
        pennylaneFacturXExemptNotSupported:"Las líneas exentas de IVA aún no se admiten en factura electrónica",
        pennylaneFacturXVatRateNotMapped:"Este tipo de IVA no tiene equivalente en factura electrónica",
        pennylaneSendToPaFailed:"La factura electrónica no pudo enviarse a la plataforma autorizada",
        pennylaneAttachmentUsedByAnotherDocument:"El PDF ya está vinculado a otro documento Pennylane",
        pennylaneSchematronInvalid:"La factura electrónica generada por Pennylane no es válida",
        pennylaneConversionTimeout:"Conversión a factura electrónica demasiado larga",
        pennylaneMaxAttemptsReached:"Número máximo de intentos alcanzado",
        pennylaneAlreadyTransmitted:"Este documento ya ha sido enviado a Pennylane",
        pennylaneFactureNeverSent:"Este documento nunca ha sido enviado a Pennylane",
        pennylaneFactureBulkConfirm:"¿Enviar {count} documento(s) pendiente(s) a Pennylane?",
        pennylaneDocumentNotClosed:"Documento no cerrado",
        pennylaneDocumentTypeNotCovered:"Tipo de documento no transmisible",
        pennylaneInvoiceNumberNotConvertible:"Número de factura incompatible con la factura electrónica (35 caracteres, letras, cifras y -+_/)",
        pennylaneCurrencyNotSupported:"Moneda no admitida (solo EUR)",
        pennylaneAmountsMismatch:"Los importes de las líneas no corresponden a los totales del documento",
        pennylaneNegativeInvoice:"Factura de importe negativo",
        pennylaneZeroRateWithoutExemption:"Línea con IVA al 0 % sin exención",
        pennylaneVatRateNotMapped:"Tipo de IVA no admitido por Pennylane",
        pennylaneNoBillableLine:"Ninguna línea facturable",
        pennylaneVatGroupMissing:"Desglose de IVA incompleto",
        pennylaneExemptDocumentWithTax:"Documento exento con IVA",
        pennylaneRecipientMissing:"Cliente ausente del documento",
        mustHaveTicketAndFactureBouton: "Las etiquetas [bouton ticket] y [bouton facture] son obligatorias y cada una solo puede estar presente una vez",
        linkToDouaneCat: "Vincular a una categoría aduanera",
        noPurchaseOrderFound: "No hay ninguna orden de compra por convertir",
        allPurchaseOrdersAlreadyConverted: "Todas las órdenes de compra ya están convertidas",
        noDeliveryNoteFound: "No hay ningún albarán de entrega por convertir",
        allDeliveryNotesAlreadyInvoiced: "Todos los albaranes de entrega ya están convertidos",
        noSupplierProvided: "Ningún proveedor indicado",
        noCurrencyProvided: "Ninguna divisa indicada",
        exchangeRate: "Tipo de cambio",
        indiceCalcul: "Cálculo de los índices PMP",
        categorie_douane: "Categoría aduanera",
        position: "Posición",
        unit: "Unidad",
        qtyUnit: "Cant. unidad",
        price_unit: "Precio por unidad",
        price_unit_b2b: "Precio por unidad B2B",
        confirmCancelFactureAchat: "¿Está seguro de que desea anular esta factura?",
        billingBuy: "Factura de compra",
        creditNoteBuy: "Nota de crédito de proveedor",
        creditNoteBuyCreate: "Creación de nota de crédito de proveedor",
        mustDeletePaymentBeforeCancel: "Debe anular todos los pagos o completar los pagos faltantes antes de anular la factura",
        linkToFolder: "Asociado al expediente",
        linkTo: "Asociado a",
        billingDeposit: "Factura de anticipo",
        depositLabel: "Anticipo",
        quotationExpireAt: "Este presupuesto expiró el",
        quotationNotConverted: "Este presupuesto no ha generado ni orden de compra ni factura",
        quotationConverted: "Este presupuesto ha generado uno o varios documentos asociados",
        billingDepositUnUsed: "Esta factura de anticipo no se ha utilizado",
        billingDepositPartiallyUsed: "Esta factura de anticipo se ha utilizado parcialmente",
        billingDepositUsed: "Esta factura de anticipo no se ha utilizado por completo",
        purchaseOrderB2bNotCollected: "La recolección de esta orden de compra no ha comenzado",
        purchaseOrderB2bPartialCollected: "La recolección de esta orden de compra está en curso",
        purchaseOrderB2bCollected: "La recolección de esta orden de compra ha finalizado",
        purchaseOrderB2bNotConverted: "Esta orden de compra no ha generado ningún albarán de entrega",
        purchaseOrderB2bPartialConverted: "Esta orden de compra ya ha generado al menos un albarán de entrega; sin embargo, algunos artículos aún no se han convertido",
        purchaseOrderB2bConverted: "Todos los artículos de esta orden de compra se han convertido en albarán de entrega",
        deliveryNoteNotDelivery: "Este albarán de entrega aún no ha sido entregado",
        deliveryNoteDelivery: "Este albarán de entrega ha sido entregado",
        deliveryNoteNotConverted: "Este albarán de entrega no ha generado ninguna factura",
        deliveryNoteConverted: "Todos los artículos de este albarán de entrega se han convertido en factura",
        invoiceNotAcquitte: "Esta factura no ha sido saldada",
        invoicePartiallyAcquitte: "Esta factura solo ha sido saldada parcialmente",
        invoiceAcquitte: "Esta factura ha sido saldada",
        avoirUnUsed: "Esta nota de crédito no se ha utilizado",
        avoirPartiallyUsed: "Esta nota de crédito se ha utilizado parcialmente",
        avoirUsed: "Esta nota de crédito se ha utilizado por completo",
        avoirNotConverted: "Esta nota de crédito no ha generado ningún bono de devolución",
        avoirPartialConverted: "Esta nota de crédito ya ha generado al menos un bono de devolución; sin embargo, algunos artículos no se han convertido en bono de devolución",
        avoirConverted: "Todos los artículos de esta nota de crédito se han convertido en bono de devolución",
        returnNoteNotCollected: "La recolección de este bono de devolución no ha comenzado",
        returnNotePartialCollected: "La recolección de este bono de devolución está en curso",
        returnNoteCollected: "La recolección de este bono de devolución ha finalizado",
        error404Msg: "Lo sentimos, la página que busca no existe",
        retourAccuil: "Volver al inicio",
        noEmailAdressConfigured: "Ninguna dirección de correo electrónico configurada",
        errDestinataireEmail: "Incluya \"@\" en la dirección de correo electrónico",
        addMoreRecipientsMsg: "Añada varios destinatarios separándolos con una \",\"",
        destinatairesRequired: "Se requiere al menos un destinatario",
        destinatairesIsArray: "Los destinatarios deben ser una lista",
        destinatairesElemRequired: "Un destinatario no puede estar vacío",
        urlRequired: "El enlace de consulta es obligatorio",
        urlMin2: "El enlace de consulta no es válido",
        documentAlreadyUseForPaiement: "Este documento ya se ha utilizado para el pago de otra factura",
        montantIsOver: "El importe indicado es superior al saldo restante por pagar",
        changeFolder: "Cambiar de expediente",
        allInfosCorrect: "¿Es correcta toda la información?",
        allDocuments: "Todos los documentos",
        noPriorityPricing: "Ningún precio prioritario",
        priorityPricingCat: "Categoría tarifaria prioritaria",
        priorityPricingCatB2C: "Categoría tarifaria prioritaria B2C",
        priorityPricingCatB2B: "Categoría tarifaria prioritaria B2B",
        defaultCategorieTva: "Categoría de {taxe} especial",
        noDefaultCategorieTva: "Ninguna categoría por defecto",
        associatedCategorieTva: "Categoría de {taxe} asociada",
        noCategorieTvaAssociated: "Ninguna categoría asociada",
        selectArticlePrice: "Elegir una categoría tarifaria",
        noPricingCat: "Ninguna categoría tarifaria",
        articlePriceNotFound: "No se ha encontrado ningún precio para este artículo y esta categoría tarifaria",
        noB2cPrice: "Ningún precio B2C indicado para este artículo",
        noTvaRate: "La tasa de IVA no está configurada para este artículo en la categoría de IVA de la caja",
        searchForExistingFolder: "Buscar un expediente existente",
        folderNotExist: "El expediente n.º {numeroDossier} no existe",
        folder: "Expediente",
        folders: "Expedientes",
        ongoingFiles: "Expedientes en curso",
        linkToOtherCompany: "Vincular a otra empresa",
        docName: "Nombre del expediente",
        linkToDoc: "Vincular a un expediente",
        createFolder: "Crear un expediente",
        newFolder: "Nuevo expediente",
        createDocument: "Crear un documento",
        createTemplate: "Crear una plantilla",
        editTemplate: "Editar una plantilla",
        deleteEmailAccount: "Eliminar la cuenta de correo electrónico",
        send: "Enviar",
        sendTestEmail: "Enviar un correo electrónico de prueba",
        smtpConfigError: "No se pudo enviar el correo: la configuración SMTP de esta cuenta parece incorrecta (host, puerto o credenciales). Verifique la configuración de la cuenta.",
        addEmailAccount: "Añadir una cuenta de correo electrónico",
        emailAccount: "Cuentas de correo electrónico",
        emailLayout: "Plantillas de correo electrónico",
        miseEnPage: "Diseño",
        emetteurClient: "Datos Emisor / Cliente",
        dataEmitterPdf: "Datos del emisor",
        dataClientPdf: "Datos del cliente",
        capital: "Capital",
        logoField: "Logo",
        balisesPossibles: "Etiquetas disponibles",
        newEmailAccount: "Nueva cuenta de correo electrónico",
        accountName: "Nombre de la cuenta",
        emailAdress: "Dirección de correo electrónico",
        hostOutgoing: "Servidor de correo saliente",
        username: "Nombre de usuario",
        allFieldRequiredForEnumere: "Todos los campos de la enumeración de embalaje deben completarse (nombre, código de barras, cantidad)",
        price: "Precio",
        prixAchat: "Precio de compra",
        addAdditionalPrice: "Añadir un precio adicional",
        portrait: "Vertical",
        landscape: "Horizontal",
        generateExport: "Generar una exportación",
        referedToQuotation: "En referencia al presupuesto n.º",
        referedToDocument: "En referencia al documento n.º",
        parentToDocument: "Padre de los documentos",
        childToDocument: "Hijo de los documentos",
        priceTtcB2c: "Precio con IVA B2C",
        priceTtcB2b: "Precio con IVA B2B",
        priceHtB2b: "Precio sin IVA B2B",
        priceHtB2c: "Precio sin IVA B2C",
        margeNB2b: "Margen bruto B2B",
        margePB2b: "Margen % B2B",
        margeB2c: "Margen bruto B2C",
        margePB2c: "Margen % B2C",
        b2bPrice: "Precio B2B",
        b2cPrice: "Precio B2C",
        mustIndicateAPrice: "Debe indicar al menos un precio",
        additionalPriceName: "Nombre del precio adicional",
        additionalPrice: "Precio adicional",
        includedTaxe: "Impuestos incluidos",
        useB2bPrice: "Usar el precio B2B",
        useB2cPrice: "Usar el precio B2C",
        itemPrice: "Precio del artículo",
        usedArticlePrice: "Precio de artículo en uso, elimínelo de todas las configuraciones antes de suprimirlo",
        productPriceMaxNumber: "Número máximo de precios adicionales para un artículo",
        categorieTva: "Categorías de {taxe} adicionales",
        categorieTvaName: "Nombre de la categoría",
        addCategorieTva: "Añadir una categoría de {taxe}",
        categorieTvaArray: "Las categorías de impuesto deben ser una lista",
        categorieTvaRequired: "El nombre de la categoría de impuesto es obligatorio",
        categorieTvaNameRequired: "El nombre de la categoría de impuesto es obligatorio",
        categorieTvaNameString: "El nombre de la categoría de impuesto debe ser texto",
        categorieTvaNameMax191: "El nombre de la categoría de impuesto no debe superar los 191 caracteres",
        categorieTvaTauxRequired: "Se requiere al menos una tasa para esta categoría de impuesto",
        categorieTvaTauxArray: "Las tasas de la categoría de impuesto deben ser una lista",
        categorieTvaTauxNumeric: "Las tasas de la categoría de impuesto deben ser numéricas",
        categorieTvaTauxMin0: "Las tasas de la categoría de impuesto deben ser superiores o iguales a 0",
        categorieTvaTauxMax100: "Las tasas de la categoría de impuesto no deben superar el 100",
        CategorieTvaIsNotValid: "La categoría de IVA no es válida",
        categorieTvaDefaultMax191: "La categoría de IVA por defecto no debe superar los 191 caracteres",
        noDefaultTaux: "Ninguno",
        paysExonereTva: "Países exentos de {taxe}",
        paysExonereTvaDescription: "Los clientes o proveedores situados en estos países quedarán automáticamente exentos de {taxe} en las facturas emitidas por esta entidad.",
        paysExonereTvaArray: "Los países exentos deben ser una lista",
        paysExonereTvaInvalid: "Uno de los países seleccionados no es válido",
        categorieTvaDefaultTauxIn: "La tasa por defecto debe formar parte de las tasas definidas para esta categoría",
        taux_categorie_tva: "Tasa {taxe}",
        noUserRestricted: "Ningún usuario está restringido",
        unauthorized: "No autorizado",
        fieldReading: "Lectura del campo",
        fieldEditing: "Edición del campo",
        fieldReadingNotAvl: "Lectura no disponible en",
        fieldEditingNotAvl: "Edición no disponible en",
        fieldEditingAlertNotAvl: "Alerta de confirmación en",
        designation: "Designación",
        accessMenu: "Acceso",
        usersListing: 'Listado de usuarios',
        email: 'Correo electrónico',
        modules: 'Módulos',
        emailAccess: 'Acceso a correo',
        access: 'Acceso',
        noModuleAssigned: 'Ningún módulo asignado',
        noEmailAccountAssigned: 'Ninguna cuenta de correo asignada',
        stockInZoneNotSufficient: "El stock de su zona o ubicaciones no es suficiente para realizar esta acción",
        padFormat: "Formato del PAD",
        clotureFormatPdf: "Formato del PDF de cierre de caja",
        clotureFormatA5: "A5 estándar",
        clotureFormatSlip: "Slip (impresora slip Epson)",
        smallPad: "PAD pequeño",
        bigPad: "PAD grande",
        seuilMiniCashBack: "Umbral mínimo de uso del cashback",
        plafondCashBack: "Límite de acumulación del cashback",
        reliquatCashBack: "Obligación de utilizar todo su cashback",
        reliquatFidelite: "Obligación de utilizar todos sus puntos de fidelidad",
        hostname: "Nombre del host",
        hostnameOrIpAdress: "Nombre o dirección IP del host",
        noHostnameAssigned: "Ningún nombre de host asignado",
        clientAlreadyAssigned: "Este cliente ya ha sido asociado o está en proceso de asociación",
        relatedCompanies: "Empresas relacionadas",
        poids: "Peso",
        companyOrOtherCompany: "Empresa u otra empresa",
        noAssignablePromo: "Ninguna promoción asignable",
        noAssignedPromo: "Ninguna promoción asignada",
        assignablePromo: "Promociones asignables",
        assignedPromo: "Promociones asignadas",
        assignPromoClient: "Asignar promociones",
        addCustomer: "Añadir clientes",
        allModificationWillBeLost: "Todas las modificaciones se perderán, ¿continuar?",
        allCustomer: "Todos los clientes",
        listOfCustomer: "Lista de clientes",
        selectionOfCustomer: "Selección de cliente",
        selectionTemplate: "Seleccionar una plantilla",
        voucherManagement: "Gestión de bonos",
        itemListWillBeDelete: "Su selección de artículos será eliminada, ¿desea continuar?",
        convertIntoToCollected: "Orden de transferencia ya recolectada",
        convertThisList: "Convertir esta lista",
        quantityManualModificationListeArticle: "Modificación manual de las cantidades en las listas de artículos",
        noList: "Ninguna lista",
        listName: "Nombre de la lista",
        listOfItems: "Lista de artículos",
        supplementList: "Lista de suplementos de artículos",
        multiple_choice: "Selección múltiple",
        required_choice: "Selección obligatoria",
        max_choices: "Límite de opciones",
        max_choices_unlimited: "Ilimitado si está vacío",
        max_choices_reached: "Número máximo de opciones alcanzado",
        packaging: "Embalaje",
        packagedQuantity: "Cantidad embalada",
        packagingName: "Nombre del embalaje",
        enumere: "Enumeración de embalaje",
        packagingList: "Enumeración de embalaje",
        pricingHt: "Tarificación sin impuestos",
        nbSales: "Número de ventas",
        qteSold: "Cantidad vendida",
        salesStatistics: "Estadísticas de venta",
        copy: "Copiar",
        copied: "Copiado",
        infoZoneAffectedByRestock: "Por defecto, freebird utiliza todas las zonas de almacenamiento si no existe ninguna configuración",
        zoneAffectedByARestock: "Zona afectada por un reabastecimiento interno",
        triggerThresholdInternalRestock: "Umbral de activación de un reabastecimiento interno",
        seuilDeclenchement: "Umbral de activación",
        seuilTypeCA: "Configurar un umbral de activación por volumen de ventas",
        seuilTypeQuantity: "Configurar un umbral de activación por cantidad",
        seuilQuantityValue: "Umbral de activación (cantidad)",
        seuilQuantityType: "Tipo de umbral de cantidad",
        seuilQuantitySameArticle: "El mismo artículo",
        seuilQuantityDistinctArticles: "Artículos de la lista",
        seuilQuantitySameArticleHelp: "Hay que comprar al menos N veces exactamente el mismo artículo de la lista de esta promoción.",
        seuilQuantityDistinctArticlesHelp: "Hay que comprar al menos N artículos en total (cantidades acumuladas, mezcla permitida) de la lista de esta promoción.",
        seuilExclusive: "El umbral de volumen de ventas y el umbral de cantidad no se pueden configurar al mismo tiempo",
        seuilQuantityNumeric: "El umbral de cantidad debe ser un número entero",
        seuilQuantityMin: "El umbral de cantidad debe ser al menos 1",
        seuilQuantityMax: "El umbral de cantidad es demasiado alto",
        seuilQuantityTypeIn: "Por favor, elija un tipo de umbral de cantidad",
        quantityToRestock: "Stock óptimo",
        internalRestockException: "Excepción de reabastecimiento interno",
        noZoneOfStock: "Ninguna zona de stock",
        rppslMenuName: "RP/PSL",
        rppslFournisseurMenuName: "RP/PSL Proveedor",
        emptyValue: "Valor vacío",
        reopenQuotation: "Reabrir presupuesto",
        devisValidite: "Duración de validez del presupuesto",
        quotationGenerated: "Su presupuesto ha sido generado",
        continueWithoutIdentification: "Continuar sin identificarse",
        expired: "Caducado",
        notExpired: "No caducado",
        notAvailable: "No disponible",
        tablePlan: "Plano de mesas",
        openTablePlan: "Configurar el plano de mesas",
        tables: "mesas",
        reservations: "Reservas",
        addReservation: "Añadir una reserva",
        createTicketForTable: "Crear ticket",
        openTicketForTable: "Abrir ticket",
        ticketEnCours: "Ticket en curso",
        tableAlreadyHasOpenTicket: "Esta mesa ya tiene un ticket abierto",
        reservationName: "Nombre",
        reservationDate: "Fecha",
        reservationDateDebut: "Fecha de inicio",
        reservationDateFin: "Fecha de fin (opcional)",
        reservationTime: "Hora",
        reservationNote: "Nota",
        noReservationToday: "Ninguna reserva para hoy",
        kpiNbReservations: "Reservas",
        kpiNbPersons: "Personas",
        kpiAvgPersons: "Prom. por reserva",
        allZones: "Todas las zonas",
        tableStatusAvailable: "Disponible",
        tableStatusUpcoming: "Reserva próxima",
        tableStatusOngoing: "Reserva en curso",
        tableStatusPast: "Pasada",
        phone: "Teléfono",
        obstacle: "Obstáculo",
        addObstacle: "Añadir un obstáculo",
        color: "Color",
        posDefaultClient: "Cliente POS",
        editReservation: "Modificar la reserva",
        reservationOverlap: "Este horario se superpone con una reserva existente",
        planningView: "Planificación",
        planningFullDay: "Día completo",
        confirmDeleteReservation: "¿Está seguro de que desea eliminar esta reserva?",
        searchAvailability: "Buscar",
        noAvailableTable: "Ninguna mesa disponible en este horario",
        addPlan: "Añadir un plano",
        planName: "Nombre del plano",
        editPlan: "Modificar el plano",
        planDimensions: "Dimensiones (px)",
        uploadBackground: "Imagen de fondo",
        removeBackground: "Eliminar el fondo",
        deletePlan: "Eliminar el plano",
        confirmDeletePlan: "¿Está seguro de que desea eliminar este plano? Se eliminarán todas las mesas.",
        noPlanYet: "Ningún plano de mesas configurado.",
        services: "Servicios",
        addService: "Añadir un servicio",
        serviceName: "Nombre del servicio",
        serviceHeureDebut: "Hora de inicio",
        serviceHeureFin: "Hora de fin",
        noServiceYet: "Ningún servicio configurado.",
        editService: "Modificar el servicio",
        confirmDeleteService: "¿Está seguro de que desea eliminar este servicio?",
        table: "Mesa",
        addTable: "Añadir una mesa",
        editTable: "Modificar la mesa",
        tableNumber: "Número de mesa",
        nbPersons: "personas",
        confirmDeleteTable: "¿Está seguro de que desea eliminar esta mesa?",
        tableShape: "Forma",
        tableShapeSquare: "Cuadrada",
        tableShapeCircle: "Redonda",
        tableWidth: "Ancho (px)",
        tableHeight: "Alto (px)",
        tableDiameter: "Diámetro (px)",
        infosOnReceipt: "Información a mostrar en el ticket",
        infosOnTopReceipt: "Información a mostrar en la parte superior del ticket",
        infosOnBottomReceipt: "Texto a mostrar en la parte inferior del ticket",
        noteAutomatiqueHeader: "Nota automática sobre el artículo",
        noteAutomatiqueLabel: "Campo personalizado a usar como nota automática",
        noteAutomatiqueHelp: "Al añadir un artículo a un ticket de esta sección, si este campo personalizado está completado en el artículo, su valor rellena automáticamente la nota del artículo.",
        selectNone: "Ninguno",
        customFieldUsedAsAutomaticNote: "Este campo personalizado no se puede renombrar ni eliminar mientras se utilice como nota automática de artículo.",
        buffaloPreparationTrigger: "Preparación tabla de pizza",
        buffaloPreparationValue: "Valor esperado",
        buffaloPreparationAnyValue: "Cualquier valor",
        buffaloPreparationHelp: "Los artículos cuyo campo personalizado coincide con el valor esperado activan la preparación en la tabla de pizza. Sin valor esperado, cualquier artículo con este campo completado la activa.",
        buffaloPreparationValueMax191: "El valor esperado no debe superar los 191 caracteres",
        customFieldUsedAsBuffaloPreparation: "Este campo personalizado no se puede renombrar ni eliminar mientras se utilice para la preparación de la tabla de pizza.",
        excludeArticlesFromSearch: "Excluir artículos de la búsqueda:",
        searchExclusionNone: "No excluir nada",
        searchExclusionValue: "Valor que excluye el artículo",
        searchExclusionHelp: "En el TPV, los artículos cuyo campo personalizado tenga exactamente este valor (sin distinguir mayúsculas) ya no aparecen en la barra de búsqueda de artículos.",
        searchExclusionValueMax191: "El valor de exclusión no debe superar los 191 caracteres",
        customFieldUsedAsSearchExclusion: "Este campo personalizado no se puede renombrar ni eliminar mientras se utilice para excluir artículos de la búsqueda del TPV.",
        listedUserWillBeNotified: "Los usuarios enumerados serán notificados",
        cancellationOfInvoice: "Anulación de la factura n.º",
        cancelledByCreditNote: "Anulada por la nota de crédito n.º",
        assignCountZeroEmptyBins: "Asignar un conteo en cero a todas las ubicaciones restantes",
        confirmAssignCountZeroEmptyBins: "¿Realmente desea asignar un conteo en cero a todas las ubicaciones restantes?",
        confirmDeleteTemplate: "¿Realmente desea eliminar esta plantilla?",
        assignPointsManually: "Asignar puntos manualmente",
        exclureFidelite: "Excluir del programa de fidelización",
        confirmInnerFidelite: "¿Incluir a este cliente en el programa de fidelización?",
        confirmExcluFidelite: "¿Excluir a este cliente del programa de fidelización?",
        unauthorizedMovement: "La transferencia de stock en esta zona no está autorizada",
        nbPointsToAssign: "Número de puntos a asignar",
        priceCalculationMethod: "Fórmula de cálculo del precio de un artículo a medida",
        calculationValue: "Valor de cálculo",
        customMadeItem: "Artículo a medida",
        itemWithoutUpcCode: "Artículos sin código UPC",
        showCustomMadeItem: "Mostrar únicamente los artículos a medida",
        typePercent: "Porcentaje",
        subtraction: "Resta",
        reminder: "Recordatorio",
        programedReminder: "Recordatorio programado",
        reminders: "Recordatorios",
        fromDocument: "A partir del documento",
        a: "A",
        list: "Lista",
        listMin1: "El valor de la lista debe ser 1 o 2",
        listMax2: "El valor de la lista debe ser 1 o 2",
        title: "Título",
        addSettle: "Liquidar el documento",
        bulkSettle: "Liquidar en masa",
        bulkSettleSelectedCount: "Facturas seleccionadas",
        bulkSettleSelectedInvoices: "Facturas seleccionadas",
        bulkSettleResultSuccess: "{count} factura(s) liquidada(s) con éxito",
        bulkSettleResultError: "{count} factura(s) no pudieron ser liquidada(s)",
        bulkSendEmail: "Enviar por correo electrónico",
        bulkSendEmailSelectedDocuments: "Documentos seleccionados",
        bulkSendEmailResultSuccess: "{count} documento(s) enviado(s) con éxito",
        bulkSendEmailResultError: "{count} documento(s) no pudieron ser enviados",
        bulkSendEmailFillMain: "Añadir la dirección principal de cada cliente",
        bulkSendEmailFillAll: "Añadir todas las direcciones de cada cliente",
        bulkSendEmailFillRelance: "Añadir solo las direcciones de recordatorio",
        noCommonPaymentMode: "Las facturas seleccionadas no tienen ningún método de pago común disponible",
        modePaiementNotAvailable: "Método de pago no disponible para esta factura",
        factureAlreadyAcquitte: "Esta factura ya está liquidada",
        invalidDocumentType: "Este documento no es una factura",
        factureNotFinalized: "Esta factura aún no está finalizada",
        addLimitDate: "Añadir una fecha límite de pago",
        addLimitDateValidity: "Añadir una fecha límite de validez",
        addFund: "Añadir fondos a la tarjeta de regalo",
        addUsers: "Añadir usuarios",
        addItems: "Añadir artículos",
        addingItemsToPromo: "Añadiendo artículos a la promoción",
        addTopText: "Añadir texto en la parte superior",
        addBottomText: "Añadir texto en la parte inferior",
        specifyASeller: "Indicar un vendedor",
        message: "Mensaje",
        retraitZone: "Zona de retiro",
        transferAllProducts: "Transferir todos los productos",
        toMomentarilyFiniched: "La recogida de esta orden de transferencia está momentáneamente terminada",
        toFiniched: "La recogida de esta orden de transferencia ha terminado",
        collectOrderFinish: "La recogida de artículos para este pedido ha terminado",
        toReceiptMomentarilyFiniched: "La recepción de esta orden de transferencia está momentáneamente terminada",
        toReceiptFiniched: "La recepción de esta orden de transferencia ha terminado",
        reassortInterneCollectFinish: "La recogida de este reabastecimiento interno ha terminado",
        toItemCollectMessage: "Este artículo no tiene stock o ya ha sido totalmente recogido",
        assignedTo: "Asignado a",
        assignedToAllClient: "Asignar a todos los clientes",
        finalize: "Finalizar",
        finalized: "Finalizado",
        getToItemsSelection: "Ir a la selección de artículos",
        selectCustomer: "Seleccionar un cliente",
        orderedInThisShop: "Pedido en este comercio",
        toBeCollectedInThisShop: "Por recoger en este comercio",
        informPaymentLate: "Informar al cliente de las consecuencias de un retraso en el pago",
        toCollect: "Por recoger",
        toCollectWms: "Por recoger desde su WMS",
        enCoursTo: "Objeto de una orden de transferencia",
        necessaryActionOrder: "Se requiere una acción manual para finalizar la recogida de este artículo",
        createATransferOrder: "Crear una orden de transferencia",
        generateAnTransferOrder: "Generar una orden de transferencia",
        dontIndicate: "No indicar",
        itemManagement: "Gestión de artículos",
        autoCreationItemInfos: "Creación automática de clasificaciones, familias, subfamilias, categorías, subcategorías, marcas y proveedores",
        skuObligation: "Obligación de crear un SKU",
        barCodeObligation: "Obligación de crear un código de barras",
        temporary: "Provisional",
        ecomTemporaryMsg: "Este artículo no se puede publicar en línea porque actualmente es provisional",
        showOnlyTemporaryItem: "Mostrar solo los artículos provisionales",
        temporaryItem: "Artículo provisional",
        addThisItemToItemBase: "Añadir definitivamente este artículo a la base de artículos",
        hour: "Hora",
        ordered: "Pedido",
        noteInterne: "Nota interna",
        seeOriginalDocument: "Ver el documento original",
        errorDifferenceQteValidate: "Existe una diferencia de valor en los siguientes artículos",
        paiementFideliteButNoFideliteArticle: "El pago por fidelidad no se acepta en este carrito",
        closeWithDifference: "El recuento de su caja no parece correcto. ¿Desea cerrar de todos modos?",
        changePaiement: "El cambio se perderá y el pago se recalculará. ¿Desea continuar?",
        onReceipt: "En el ticket",
        articleNoReferenceFind: "Ningún artículo corresponde a esta referencia",
        mustIndicateReasonRetrait: "Debe indicar el motivo por el que retira efectivo",
        gradeHasUser: "No puede eliminar este grado porque algunos miembros del personal tienen actualmente este grado. Para eliminar este grado, primero debe retirarlo de todos los miembros del personal a quienes se les ha asignado.",
        modepaiementRemove: "No puede eliminar este método de pago porque está asignado a algunos de sus comercios. Si realmente desea eliminarlo, primero debe retirarlo de los comercios a los que está asignado.",
        adminOverQuota: "No puede añadir el módulo \"Configuración\" a este usuario porque su cuota de usuarios para este módulo ya ha sido alcanzada. Por favor, contacte con Ciweb si desea modificar esta cuota.",
        erpOverQuota: "No puede añadir el módulo \"ERP\" a este usuario porque su cuota de usuarios para este módulo ya ha sido alcanzada. Por favor, contacte con Ciweb si desea modificar esta cuota.",
        usersOverQuota: "No puede añadir el módulo \"Usuarios\" a este usuario porque su cuota de usuarios para este módulo ya ha sido alcanzada. Por favor, contacte con Ciweb si desea modificar esta cuota.",
        wmsOverQuota: "No puede añadir el módulo \"WMS\" a este usuario porque su cuota de usuarios para este módulo ya ha sido alcanzada. Por favor, contacte con Ciweb si desea modificar esta cuota.",
        posOverQuota: "No puede añadir el módulo \"POS\" a este usuario porque su cuota de usuarios para este módulo ya ha sido alcanzada. Por favor, contacte con Ciweb si desea modificar esta cuota.",
        endUnderrBegin: "La fecha de fin del período no puede ser anterior a la fecha de inicio del período",
        perdioExceedAYear: "El período no puede ser superior a un año",
        dayDateFormat: "La fecha de esta línea del archivo CSV no tiene un formato correcto. El formato correcto es el que se indica en los parámetros avanzados de su empresa.",
        commandeDateFormat: "La fecha del pedido no tiene un formato correcto. El formato correcto es el que se indica en los parámetros avanzados de su empresa.",
        expectedDateFormat: "La fecha de transferencia no tiene un formato correcto. El formato correcto es el que se indica en los parámetros avanzados de su empresa.",
        expeditionDateFormat: "La fecha de expedición no tiene un formato correcto. El formato correcto es el que se indica en los parámetros avanzados de su empresa.",
        expectedReceptionDateFormat: "La fecha prevista de recepción no tiene un formato correcto. El formato correcto es el que se indica en los parámetros avanzados de su empresa.",
        realExpeditionDateFormat: "La fecha real de expedición no tiene un formato correcto. El formato correcto es el que se indica en los parámetros avanzados de su empresa.",
        receptionDateFormat: "La fecha prevista de recepción no tiene un formato correcto. El formato correcto es el que se indica en los parámetros avanzados de su empresa.",
        beginDateFormat: "La fecha de inicio no tiene un formato correcto. El formato correcto es el que se indica en los parámetros avanzados de su empresa.",
        endDateFormat: "La fecha de fin no tiene un formato correcto. El formato correcto es el que se indica en los parámetros avanzados de su empresa.",
        dateDepartDateFormat: "La fecha de salida no tiene un formato correcto. El formato correcto es el que se indica en los parámetros avanzados de su empresa.",
        dateArriveDateFormat: "La fecha de llegada no tiene un formato correcto. El formato correcto es el que se indica en los parámetros avanzados de su empresa.",
        lastDateBuyDateFormat: "La última fecha de compra no tiene un formato correcto. El formato correcto es el que se indica en los parámetros avanzados de su empresa.",
        dateFormat: "La fecha no tiene el formato correcto. El formato correcto es el que se indica en los parámetros avanzados de su empresa.",
        beginRequiredWithEnd: "Debe indicar una fecha de inicio ya que ha indicado una fecha de fin",
        endRequiredWithBegin: "Debe indicar una fecha de fin ya que ha indicado una fecha de inicio",
        sizeLineCsv: "Esta línea del archivo CSV no contiene el número correcto de columnas",
        row: "Línea",
        lines: "Líneas",
        noRhOrNoAuth: "Personal inexistente o no autorizado a acceder a esta sección",
        rhNoAuth: "Personal no autorizado a realizar esta acción",
        staffNotAttributeToInventory: "Este personal no está asignado a este inventario",
        noRhOrNoAttributed: "Personal inexistente o no asignado a este inventario",
        noRhTos: "No tiene órdenes de transferencia pendientes",
        noInternetTos: "No tiene ningún pedido pendiente",
        imageUrl: "El enlace de la imagen del artículo debe ser una URL válida",
        havestockIn: "Debe indicar si este artículo debe depender de un stock",
        zoneAlreadyHaveCommercial: "Este comercio ya tiene una zona de stock de tipo punto de venta",
        zoneAlreadyHaveCommande: "Este comercio ya tiene una zona de stock de tipo pedido",
        archiveZoneAddArticle: "Esta zona de stock contiene artículos y, por lo tanto, no puede archivarse",
        deleteZoneAddArticle: "Esta zona de stock contiene artículos y, por lo tanto, no puede eliminarse",
        customFieldsAlreadyExists: "Ya existe un campo personalizado con el mismo nombre",
        youMustIndicateField: "Debe completar el campo",
        ecomMustBeConfigured: "Este e-commerce no está configurado",
        limitCsv: "El archivo CSV debe contener menos de {limit} líneas",
        filename: "Nombre del archivo",
        name: "Nombre",
        description: "Descripción",
        categorization: "Categorización",
        ptype: "Tipo de producto",
        pcat: "Categoría de producto",
        image: "Imagen",
        couleur: "Color",
        couleurs: "Colores",
        headerColor: "Color del encabezado",
        cardHeaderColor: "Color de los encabezados de tarjeta",
        tabsColor: "Color de las pestañas",
        taille: "Talla",
        notANameForCustomFields: "Este nombre no se puede asignar a un campo personalizado",
        quotaCommandeInteger: "La cantidad debe ser un número entero",
        quotaInteger: "La cantidad debe ser un número entero",
        selectBinsOrZone: "Debe escanear un bin o seleccionar una zona",
        shipmentLineAlreadyReceptione: "Este bloque ya ha sido validado",
        shipmentCartonAlreadyReceptione: "Esta caja ya ha sido recepcionada",
        changHaveBinsMustEqualZero: "No puede modificar la opción de bins para una zona que ya contiene artículos. Esta zona contiene actualmente: {quota} artículos",
        toIsClosed: "Esta orden de transferencia ha sido cerrada",
        rhNotInSection: "Este miembro del personal no existe o no trabaja en el comercio de origen",
        communToLineNotTheSame: "Algunos datos que deben ser comunes a todas las líneas de una misma orden de transferencia no lo son",
        noDoubleArticleTo: "Este artículo ya está presente en otra línea de esta orden de transferencia",
        noAutorizedUpdateTo: "No puede actualizar una orden de transferencia que ya ha superado la etapa de recogida",
        cantDeleteLine: "No puede eliminar esta línea",
        newLine: "Añadir una línea",
        newSupplementList: "Añadir una lista de suplementos",
        configArticleSupplementList: "Configurar una lista de suplementos para un nuevo artículo",
        configArticleAbonnement: "Configurar una gestión de suscripción en un nuevo artículo",
        pslGte: "El nivel de stock óptimo no puede ser inferior al nivel de stock mínimo",
        noDockForReassort: "No tiene ningún dock definido",
        noArticleForReassort: "No hay ningún artículo en su selección",
        noToMaxForReassort: "Primero debe definir el número máximo de instrucciones que puede contener una orden de transferencia en los parámetros de su empresa",
        valuePromotionNotOk: "Los valores de la promoción son incorrectos",
        amountOverDue: "El importe pagado no puede ser superior al saldo pendiente",
        hasBillingDeposit: "Hay facturas de anticipo disponibles para el pago del documento",
        hasCreditNote: "Hay notas de crédito disponibles para el pago del documento",
        resteIsOverTicket: "El importe pagado es superior al saldo pendiente del ticket",
        majorPaiementError: "Error de pago grave, el cliente ha pagado más del precio solicitado",
        paiementIsNegative: "El importe a pagar no puede ser negativo",
        paiementIsPositive: "El saldo pendiente debe ser 0",
        noCommercialZone: "No hay ninguna zona comercial definida para este comercio",
        noGiftCardFound: "Ninguna tarjeta de regalo corresponde a esta referencia",
        noFactureFound: "No se ha encontrado ningún documento",
        noTicketFound: "Ningún ticket corresponde a esta referencia",
        noCommandeFound: "Ningún pedido corresponde a esta referencia",
        noPossibilityToReturnArticle: "Un error impide la devolución del artículo",
        articleAlreadyReturn: "Este artículo ya ha sido devuelto",
        hostIp: "Esta no es una dirección IP válida",
        optional: "Opcional",
        orderTitle: "Pedido",
        sectionDontHaveCommandeZone: "Las secciones afectadas por este pedido no tienen zona de pedido",
        commandeAlreayCancel: "Este pedido de cliente ya ha sido cancelado",
        mustSpecifyRemboursement: "Debe especificar el método de reembolso",
        mustSpecifyGiftCardReference: "Debe indicar el código de barras de la tarjeta de regalo",
        mustChooseOneRaccourci: "Debe elegir un acceso directo",
        someItemsNotPresentInPo: "Algunos artículos no están presentes en la orden de compra asociada",
        thisItemsNotPresentInPo: "Este artículo no está presente en la orden de compra asociada ({name})",
        lineCannotBeDelated: "Esta línea no se puede eliminar",
        thisArticleNotLinkToStock: "Este artículo no está vinculado a un stock",
        articleIsNotInPo: "Este artículo no está presente en esta orden de compra",
        articleIsNotInTo: "Este artículo no está presente en esta orden de transferencia",
        articleIsNotInRestock: "Este artículo no está presente en este reabastecimiento interno",
        toQuantityCantBeEdit: "El estado de esta orden de transferencia no le permite editar las cantidades a recoger",
        tooManyOrTooLongTags: "Hay demasiadas etiquetas (250 máx.) o alguna de ellas es demasiado larga (255 caracteres máx.)",
        ecommerceSendError: "El e-commerce devuelve el error {erreur}",
        variantAreTheSame: "Los artículos secundarios no están detallados correctamente y, por lo tanto, Shopify los interpreta como los mismos artículos. Verifique las opciones que ha indicado.",
        noUserToSendAlert: "Ningún usuario está configurado para recibir este tipo de alerta",
        noUser: "No se ha asignado ningún usuario",
        indicateBinsInZoneThatHaveNoBins: "Ha indicado un bin para una zona que no contiene ninguno",
        binsOrZone: "Debe indicar un bin o una zona",
        reassortInterneAlreadyOpen: "Ya hay un reabastecimiento interno abierto. Por favor, ciérrelo antes de generar uno nuevo",
        noZoneReassortInterneConfig: "No hay ninguna configuración de zona de reabastecimiento interno",
        negativeShopStockAndNoAutoPossibilities: "Los siguientes artículos tienen un stock negativo en su zona de comercio. Debe reajustar su stock antes de poder generar un reabastecimiento.",
        reassortCantDeleteAlreadyMove: "No puede eliminar una línea cuya recogida ya ha comenzado",
        clientNotMatchWithDossier: "El cliente no corresponde a este expediente",
        exportEtatCompte: "Exportar estado de cuenta",
        mailEtatCompte: "Enviar por correo el estado de cuenta",
        etatCompteOnlyOngoing: "Exportar: solo documentos en curso (facturas no saldadas y notas de crédito no utilizadas)",
        exportZCaisse: "Exportar cierre Z de caja",
        exportZCaisseWarning: "Las sesiones de caja tenidas en cuenta en este informe son únicamente las que se abrieron durante el período indicado anteriormente y luego se cerraron. Atención: si el cierre de una o varias de estas sesiones tuvo lugar después de la fecha de fin del período indicado anteriormente, la totalidad de cada sesión se tiene en cuenta de todos modos. Por el contrario, si una sesión de caja se abrió antes de la fecha de inicio del período indicado anteriormente, no se tendrá en cuenta, aunque su cierre se haya realizado durante dicho período.",
        jourCloture: "día de cierre",
        du: "del",
        au: "al",
        sessionCaisse: "sesión de caja",
        baseHt: "Base sin IVA",
        montant: "Importe",
        delete_current_to_pos: "¿Desea realmente cancelar la creación de la orden de transferencia? La selección en curso se perderá definitivamente.",
        moduleadmin: "Configuración",
        moduleerp: "ERP",
        modulewms: "WMS",
        moduleposs: "CAJAS",
        modulepos: "CAJA",
        moduleusers: "Usuarios",
        moduleinvoice: "Facturación",
        modulegeneral: "General",
        chatbotIa: "Asistente IA",
        modulerhtime: "Gestión del tiempo de trabajo",
        noDeliveryNoteToConvert: "No hay ningún albarán de entrega para facturar",
        noSelection: "Sin selección",
        resetQuantity: "Restablecer la cantidad",
        resetDefault: "Restablecer valores predeterminados",
        pointFideliteIsOverClientPointFidelite: "El cliente no dispone de suficientes puntos de fidelidad",
        stockAdjustmentSupportingDocument: "Justificante de ajuste de stock",
        addDiscountSelection: "Aplicar un descuento a la selección",
        addDiscountAll: "Aplicar un descuento a todos los artículos",
        documentCantBeDeleteBecauseLinesAlreadyProcessed: "El documento no puede cancelarse porque algunas líneas de este documento ya han sido procesadas",
        convert: "Convertir",
        chat: "Mensaje",
        thisLine: "Esta línea",
        manualCounting: "Conteo manual",
        cetteLigne: "esta línea",
        emisLe: "Emitido el",
        acquittee: "Liquidada",
        cancelInvoice: "Cancelar esta factura",
        acquitterFacture: "Liquidar esta factura",
        generateNewFrom: "Generar un nuevo documento a partir de este",
        sendDocEmail: "Enviar este documento por correo electrónico",
        sendTicketEmail: "Enviar este ticket por correo electrónico",
        mailTicketBodyHeader: "Cuerpo del correo electrónico del ticket",
        factureA4FooterHeader: "Texto de pie de página de la Factura A4",
        factureA4FooterTextLabel: "Texto que se muestra en la parte inferior de la Factura A4 generada desde la caja",
        factureA4FooterSizeLabel: "Tamaño de fuente",
        defaultMail: "Hola,<br /><br />Haga clic en el botón de abajo para descargar su [type]<br /><br />[bouton]<br /><br />Atentamente,<br />",
        saveDocTemplate: "Guardar este documento como plantilla",
        createReminderFromDoc: "Programar un recordatorio para este documento",
        editReminderDoc: "Modificar el recordatorio para este documento",
        convertToInvoice: "Convertir en factura",
        notConvertToInvoice: "No convertir en factura",
        allLocalisations: "Todas las ubicaciones",
        filterTheSelection: "Filtrar la selección",
        exludeConvertedLines: "Quitar las líneas completamente convertidas",
        filterBysection: "Filtrar por comercio",
        referenceItem: "Artículo de referencia",
        complementaryItem: "Artículo complementario",
        supplierOrder: "Pedido a proveedor",
        addSupplierItem: "Añadir un artículo de proveedor",
        addItemFromBase: "Añadir un artículo de la base",
        yes: "Sí",
        no: "No",
        signIn: "Iniciar sesión",
        password: "Contraseña",
        newPassword: "Nueva contraseña",
        signOut: "Cerrar sesión",
        administration: "Configuración",
        users: "Licencias",
        gestionStockCommandes: "ERP",
        shops: "Comercios",
        shop: "Comercio",
        showedStock: "Stock mostrado",
        delete: "Eliminar",
        cancelCollect: "Cancelar la recogida",
        remove: "Retirar",
        update: "Actualizar",
        upload: "Publicar",
        online: "En línea",
        optional: "Opcional",
        offline: "Fuera de línea",
        calculationMethod: "Método de cálculo",
        activeOnPromotion: "Activo en las promociones",
        forAmountOf: "Por un importe de",
        perSlice: "Por tramo",
        inProportion: "A prorrata",
        activateOnPromotion: "Activar en las promociones",
        totalCumulLoyaltyPoint: "Total de puntos de fidelidad acumulados",
        fusionClientInfo: "El cliente seleccionado desaparecerá de su base de clientes y toda su información se fusionará con la de {clientName}",
        earnedLoyaltyPoint: "Puntos de fidelidad obtenidos",
        confirmDeleteAllPage: "¿Desea realmente eliminar todas las líneas de la página",
        confirmDeleteUser: "¿Desea realmente eliminar al usuario",
        confirmDeleteGrade: "¿Desea realmente eliminar el grado",
        typeDeleteX: "¿Desea realmente eliminar ",
        typeCancelCollectX: "¿Desea realmente cancelar la recogida de",
        typeDeleteReminderX: "¿Desea realmente eliminar el recordatorio para ",
        confirmDeleteCheckDeposit: "¿Desea realmente eliminar esta remesa de cheque?",
        typeRemoveX: "¿Desea realmente retirar ",
        confirmArchiveX: "¿Desea realmente archivar ",
        confirmActiveX: "¿Desea realmente activar ",
        confirmDeleteGoals: "¿Desea realmente eliminar los objetivos de este período?",
        confirmRemoveRh: "¿Desea realmente retirar",
        confirmOpenFonCaisse: "¿Está seguro de que desea abrir esta caja con ",
        confirmAddClientForm: "¿Desea realmente añadir un formulario de cliente",
        confirmRemoveClientForm: "¿Desea realmente retirar el formulario de cliente",
        loyaltyRewardConfig: "Configuración de las recompensas de fidelidad",
        selectLoyaltyRewardMode: "Seleccionar el modo de recompensa de la fidelidad de clientes",
        noRewardModeSelected: "Ningún modo de recompensa seleccionado",
        cashback: "Cashback",
        availableCashBack: "Cashback disponible",
        toApplyTo: "Aplicar a",
        recompense: "Artículo de regalo",
        ofFondCaisse: "de fondo de caja",
        confirmUnarchiveX: "¿Desea realmente activar ",
        confirmClockingX: "¿Desea realmente fichar ",
        confirmValidateLine: "¿Está seguro de que desea validar este bloque",
        confirmValidateAll: "¿Está seguro de que desea validar todo",
        confirmCancelReceiptTo: "¿Está seguro de que desea cancelar la recepción de este artículo",
        confirmCancelSaleOrder: "¿Está seguro de que desea cancelar este pedido",
        warningToCancelSaleOrder: "Hay órdenes de transferencia asociadas a este pedido de cliente, se recomienda encarecidamente cancelarlas",
        confirmClosefondCaisse: "¿Está seguro de que desea cerrar esta caja con ",
        confirmDifferenceFondCaisse: "¿Está seguro de que desea abrir esta caja con una diferencia de ",
        confirmValidateInventory: "¿Está seguro de que desea validar este inventario? Esta acción será irreversible",
        clotureDetailPdf: "Detalle del cierre de caja",
        returnToItemReceipt: "Volver a la recepción de artículos",
        associateToAnItem: "Reemplazar por un artículo existente",
        addPermanentlyMsg: "Atención, esta acción es irreversible",
        de: "de",
        exerciseStart: "Inicio de ejercicio",
        ecart: "Diferencia",
        closeNote: "Nota",
        irreversibleAction: "Atención: esta acción será irreversible",
        company: "Empresa",
        allCompany: "Todas las empresas",
        canceled: "Cancelado",
        noLogoActualy: "Ningún logo actualmente",
        noPhotoActualy: "Ninguna foto actualmente",
        man: "Hombre",
        woman: "Mujer",
        rh: "Personal",
        modePaiement: "Método de pago",
        loyaltyMode: "Modo de fidelidad",
        general: "General",
        genere: "Generar",
        proposal: "Propuestas",
        newTotalValueStock: "Valor total del nuevo stock",
        oldTotalValueStock: "Valor total del stock anterior",
        totalValueSaleOrder: "Valor total de los pedidos de cliente",
        totalPaiementSaleOrder: "Valor total de los anticipos pagados",
        tarifSellerModification: "Modificación manual de un precio",
        width: "Ancho",
        height: "Alto",
        openFondCaisse: "Apertura de caja - Fondo de caja",
        fond_caisse: "Fondo de caja",
        closeFondCaisse: "Cierre de caja",
        closeCaisse: "Cierre de caja",
        repartGoals: "Distribución de objetivos",
        openCaisse: "Apertura de caja",
        openTiroir: "Apertura del cajón",
        loyalty: "Fidelidad",
        customerLoyalty: "Fidelidad del cliente",
        loyaltyPlan: "Plan de fidelidad",
        accumulatedPoints: "Puntos acumulados",
        spentPoints: "Puntos gastados",
        open: "Abrir",
        opened: "Abierto",
        closeWith: "Cerrado con",
        a: "a",
        allShops: "Todos los comercios",
        allUsers: "Todos los usuarios",
        searchArticle: "Buscar artículo...",
        searchInWait: "Búsqueda en curso",
        cashier: "Cajero",
        inventory: "Inventario",
        clickOnZoneWithoutBins: "Haga clic en una zona sin bins",
        mustCompleteOrCancelReceipt: "Primero debe finalizar o cancelar su ticket en curso",
        inventaireZone: "Inventario de tipo zona",
        inventaireBins: "Inventario de tipo bins",
        inventaireCategorie: "Inventario de tipo categoría",
        finalizedInventory: "Inventario finalizado",
        inventoryType: "Tipo de inventario",
        inventaireImport: "Importación de inventario",
        loyaltyPlanImport: "Importación de fidelidad",
        ajustImport: "Ajuste de stock importado",
        returnInventory: "Volver al inventario",
        returnInventoryHome: "Volver al inicio de inventarios",
        startCounting: "Iniciar el conteo",
        seeInventoryReport: "Ver el balance del inventario",
        validateInventory: "Validar el inventario",
        addSelection: "Añadir la selección",
        validateCount: "Validar el conteo",
        addToInventoryList: "Añadir a la lista de inventario",
        cancelCount: "Cancelar conteo",
        cancelAllCount: "Cancelar todos los conteos",
        cancelComparisonwithStok: "Cancelar la comparación con el stock",
        allInventories: "Todos los inventarios",
        readInventoryDetail: "Consultar el detalle de un inventario",
        compareInventoryToStock: "Comparar el inventario con el stock",
        inventoryComparison: "Comparación del inventario",
        allCounts: "Todos los conteos",
        selectCancellationOption: "Seleccionar la opción de cancelación",
        countNotFinished: "Conteo no terminado",
        wrongCount: "Conteo erróneo",
        inventoryBinsMsg: "El sistema creará varios inventarios si el número de bins de la zona es demasiado elevado",
        confirmSecondCount: "Ya ha realizado este conteo, ¿desea realmente realizar uno nuevo?",
        zoneName: "Nombre de la zona",
        customerPlacehlder: "Cliente...",
        refineSearchResults: "Precise su búsqueda para ver más resultados",
        supplementListPlaceholder: "Lista de suplementos...",
        noRhForSection: "No se ha asignado ningún personal a este punto de venta",
        consultPriceItem: "Ver precio del artículo...",
        seeSaleOrder: "Ver el pedido de cliente",
        selectColumnFileToMatch: "Seleccionar la columna del archivo a asociar",
        selectColumnBaseToMatch: "Seleccionar la columna de la base de artículos a asociar",
        stockArea: "Zona de stock",
        createStockArea: "Crear una zona de stock",
        creerGiftCard: "Crear una tarjeta de regalo",
        creerAbonnementCard: "Crear una tarjeta de suscripción",
        stockHaveBins: "Esta zona de stock debe tener bins",
        stockZoneEmpty: "Esta zona está vacía",
        errorEcomOrderTraitement: "Error en un pedido de cliente",
        newEcomOrder: "Nuevo pedido de cliente",
        itemReference: "Referencia del artículo...",
        cashOut: "Retiro de efectivo",
        consulter: "Consultar",
        attribuer: "Asignar",
        attribuerA: "Asignar a",
        synchronized: "Sincronizado",
        notSynchronized: "No sincronizado",
        synchronizeItems: "Sincronizar los artículos",
        itemMustHaveParentToBeOnline: "Este artículo debe tener un nombre de padre para estar en línea",
        attribuerSelection: "Asignar la selección",
        generateReassort: "Generar una propuesta de reabastecimiento",
        validateProposalReassortFournisseur: "¿Está seguro de que desea convertir esta propuesta de reabastecimiento en órdenes de compra a proveedor?",
        waitConvertInPo: "Orden(es) de compra en proceso de creación. Será redirigido en breve. Esta tarea puede tardar unos minutos...",
        qteToOrder: "Cant. a pedir",
        reassortGenerate: "Generar un reabastecimiento",
        addToFavorite: "Añadir a favoritos",
        editFavorite: "Modificar favorito",
        listOfFavorite: "Lista de favoritos",
        favoriteName: "Nombre del favorito",
        generateReadjustment: "Generar un reajuste",
        proposalReassortList: "Propuesta de reabastecimiento",
        forDepotBanque: "Este retiro es para un depósito bancario",
        depotEnBanque: "Depósito bancario",
        typeRetrait: "Tipo",
        retraitForOtherReason: "Este retiro es por otro motivo",
        retraitOtherLabel: "Indique el motivo por el cual retira efectivo",
        confirmRetraitOtherReason: "¿Realmente desea retirar efectivo por un importe de",
        confirmRetraitBanqueReason: " ¿Realmente desea depositar en el banco un importe de",
        confirmDeleteCustomerAssociate: "¿Realmente desea eliminar la asociación con este cliente",
        confirmDeleteDivers: "¿Realmente desea eliminar",
        confirmDelete: "¿Desea confirmar la eliminación",
        confirmGenerateTo: "¿Está seguro de que desea generar una orden de transferencia a partir de este albarán de expedición",
        successOperation: "Operación realizada con éxito",
        deleteSelection: "Eliminar la selección",
        draftsSelected: "borrador(es) seleccionado(s)",
        bulkDeleteResult: "{deleted} borrador(es) eliminado(s), {skipped} omitido(s)",
        successInHistorique: "Importación iniciada con éxito. Puede seguir el estado de la importación en su historial de importaciones.",
        ruleUpDateAlreadyAssigned: "Este campo ya ha sido asignado a una regla de actualización",
        addClient: "Añadir un cliente",
        editColumnPdf: "Edición de columnas",
        editRecapPdf: "Edición de líneas de resumen",
        addLogo: "Añadir un logotipo",
        cattc: "CA IVI",
        caht: "CA sin IVI",
        taxesExcluded: "Sin IVI",
        taxesIncluded: "IVI",
        totalTTC: "Total IVI",
        goalsttc: "Objetivos IVI",
        goalsht: "Objetivos sin IVI",
        grossMargin: "Margen bruto",
        grossMarginPercent: "Margen bruto en %",
        beginIsGreaterThanEnd: "El inicio del período no puede ser posterior al fin del período",
        periodIsGreaterThanAYear: "El período seleccionado debe ser inferior a un año",
        importGoals: "Importar objetivos",
        createGrade: "Crear un grado",
        createModePaiement: "Añadir un método de pago",
        createCashOutReason: "Añadir un justificante de retiro de efectivo en caja",
        cashOutMore: "Sus justificantes de retiro de efectivo en caja",
        modePaiementForced: "Métodos de pago básicos",
        modePaiementMore: "Sus métodos de pago añadidos",
        items: "Artículos",
        today: "Hoy",
        hier: "Ayer",
        demain: "Mañana",
        noObjectif: "No hay ningún objetivo POS para este período",
        objectifs: "Objetivos",
        realise: "Realizado",
        nbrEntreClient: "Número de pasos de clientes (entrada y salida)",
        edit: "Editar",
        period: "Período",
        oneDay: "Un día",
        manyDays: "Varios días",
        searchBy: "Buscar por",
        day: "Día",
        de: "De",
        vers: "Hacia",
        toA: "A",
        seeAll: "Ver todo",
        seeMore: "Ver más",
        createNotification: "Crear una notificación",
        disponible: "Disponible",
        addCashOut: "Retiro de efectivo",
        noEnougthForReassort: "{name} no dispone de suficiente stock para satisfacer esta modificación",
        confirmAddItemPromo: "Confirmar la selección de {quantity} artículos",
        needEntre: "Este gráfico estará disponible cuando se indique el número de entradas de clientes",
        createGoals: "Crear objetivos de comercio",
        attributeStaffGoals: "Asignar objetivos al personal",
        deleteGoals: "Eliminar objetivos",
        createOneDayGoals: "Crear los objetivos de un día",
        report: "Reportes",
        datas: "Datos",
        dropCsv: "Suelte el archivo CSV aquí o haga clic para cargarlo.",
        noDataInCsv: "No se ha encontrado ningún dato en este archivo csv",
        zoneCsvImportBtn: "Importar zonas desde CSV",
        zoneCsvImportSuccess: "{inserted} zona(s) importada(s) con éxito",
        zoneCsvImportPartial: "{inserted} de {total} zona(s) importada(s). Ver detalles a continuación.",
        zoneCsvNoHeaderHelp: "El archivo no debe contener una fila de encabezado.",
        csvLineError: "Línea {line} ({value}): {errors}",
        fileCsvToLarge: "El archivo supera el tamaño máximo permitido de 7 megabytes",
        objectifCsvFileToLong: "El archivo csv debe tener como máximo 1000 líneas",
        doublonCsv: "Algunas columnas del archivo csv se utilizan en varios datos diferentes",
        indicateRecurrence: "Indicar una recurrencia",
        indicateRecurrenceMsg: "Indique el día del mes en el que desea que se aplique esta recurrencia para el modelo {modeleName}",
        deleteRecurrence: "Eliminar la recurrencia",
        exonerateFromTaxes: "Exonerar de {taxe}",
        every: "Todos los",
        ofMonth: " del mes",
        template: "Modelo",
        recurrence: "Recurrencia",
        reprogramRecurrenceOnNextMonth: "Reprogramar la recurrencia para el mes siguiente",
        templateConfiguration: "Configuración del modelo",
        templateEmailConfiguration: "Configuración del modelo de correo electrónico",
        emailBodyQuotation: "Cuerpo predeterminado del correo electrónico de un presupuesto",
        emailBodyInvoice: "Cuerpo predeterminado del correo electrónico de una factura",
        emailBodyCreditNote: "Cuerpo predeterminado del correo electrónico de un abono",
        msgInfoContenuMail: "Los elementos indicados entre corchetes [] se recuperarán a partir de la información del documento. Aquí está el conjunto de elementos que puede escribir entre corchetes:",
        msgInfoContenuMailClient: "será reemplazado por el nombre del cliente",
        msgInfoContenuMailNumero: "será reemplazado por el número del documento",
        msgInfoContenuMailMontant: "será reemplazado por el importe con impuestos del documento",
        msgInfoContenuClient: "[cliente]",
        msgInfoContenuNumero: "[numero]",
        msgInfoContenuMontant: "[importe]",
        msgEmailConfigure: "Cuando crea una factura, un presupuesto o un abono, se le propone enviarlo directamente por correo electrónico a su cliente. El cuerpo del correo electrónico que se le propondrá para este envío será el que haya indicado previamente aquí.",
        seeMyTemplate: "Ver el modelo",
        importedRows: "Líneas importadas: ",
        infoModePaiement: "Aquí se trata de enumerar los métodos de pago posibles para su empresa. Atención: cada uno de sus comercios puede utilizar métodos de pago diferentes. Por ello, debe acceder a las opciones de cada uno de sus comercios para indicar los métodos de pago aceptados en ellos.",
        restrictionStaff: "Restricciones de personal",
        reassortWait: "Propuesta de reabastecimiento en curso de cálculo. Esta tarea puede tardar unos minutos...",
        rebillingWait: "Refacturación entre empresas en curso. Esta tarea puede tardar unos minutos...",
        interSocieteGenerationDone: "Generación finalizada con errores",
        interSocieteGenerationErrorFile: "Se produjo al menos un error durante la generación. Se ha generado un archivo:",
        inventoryCompareWait: "Comparación del inventario con el stock en curso de cálculo. Esta tarea puede tardar unos minutos...",
        inventoryValidateWait: "El inventario se está validando. Esta tarea puede tardar unos minutos...",
        waitReassortTo: "Orden(es) de transferencia en curso de creación. Pronto será redirigido. Esta tarea puede tardar unos minutos...",
        authorized: "Autorizados",
        noRestriction: "Sin restricción",
        scanBadge: "Escanee su credencial aquí...",
        scanSellerBadge: "Escanee su credencial de vendedor aquí...",
        scanBadgeOrSearch: "Escanee su credencial aquí o busque un miembro del personal",
        formclient: "Formulario de cliente",
        explicationFormClient: "Indique los campos que desea que aparezcan en el formulario de creación de un cliente",
        noFilter: "Sin filtro",
        field: "Campo",
        obligatoire: "Obligatorio",
        requiredField: "Campo obligatorio",
        notRequiredField: "Campo no obligatorio",
        uniqueField: "Valor único",
        notUniqueField: "Valor no único",
        freeField: "Valor libre",
        fieldListData: "Sujeto a una lista de datos",
        civilite: "Tratamiento",
        activer: "Activar",
        adressePhysique: "Dirección física",
        adressePostale: "Dirección postal",
        communeVille: "Municipio/Ciudad",
        inscriptionNewsletter: "Suscripción al boletín",
        noFormClient: "El formulario de cliente de su empresa no está configurado",
        customerReward: "Recompensas del cliente",
        homme: "Hombre",
        femme: "Mujer",
        noClientToEdit: "Primero debe indicar un cliente",
        noCashierIndicated: "Primero debe indicar un cajero",
        periodHigherOneMonth: "El período seleccionado debe ser inferior a 1 mes",
        newItem: "Nuevo artículo",
        stamp: "Sello",
        parameterName: "Parámetros avanzados",
        otherCompany: "Otras empresas",
        interSociete: "Refacturación entre empresas",
        executeInterSociete: "¿Lanzar la refacturación entre empresas?",
        refacturation: "Refacturación",
        exceptionRefacturation: "Excepción de refacturación",
        mailSent: "Correo enviado",
        mailOpened: "Correo abierto",
        clientType: "Tipo de cliente",
        quartier: "Barrio",
        dateDeNaissance: "Fecha de nacimiento",
        selectAType: "Por favor, elija un tipo",
        customField: "Campo personalizado",
        customFields: "Campos personalizados",
        category: "Categorías",
        providerName: "Nombre del proveedor",
        contactName: "Nombre del contacto",
        categoryName: "Nombre de la categoría",
        companyName: "Nombre de la empresa",
        legalForm: "Forma jurídica",
        documentType: "Tipo de documento",
        documentDeleted: "Documento eliminado",
        allType: "Todos los tipos",
        draftListMsgInfo: "Solo se conservan los borradores de menos de 48 horas",
        fieldName: "Nombre del campo",
        defaultFields: "Campos predeterminados",
        providers: "Proveedores",
        nouveauFournisseur: "Nuevo proveedor",
        editFournisseur: "Editar un proveedor",
        CDD: "Contrato temporal",
        CDIE: "Contrato indefinido - Período de prueba",
        CDI: "Contrato indefinido",
        archive: "Archivar",
        archiveSelection: "Archivar la selección",
        activateSelection: "Activar la selección",
        confirmArchiveSelection: "¿Desea realmente archivar los artículos seleccionados:",
        confirmActivateSelection: "¿Desea realmente activar los artículos seleccionados:",
        noItemSelected: "Ningún artículo seleccionado",
        itemsArchived: "Artículos archivados correctamente",
        itemsActivated: "Artículos activados correctamente",
        itemsRemovedFromList: "Artículos retirados correctamente",
        thisStaffIsArchive: "Atención: este miembro del personal está archivado",
        includeArchiveStaff: "Incluir el personal archivado",
        includeArchiveProvider: "Incluir los proveedores archivados",
        includeArchiveData: "Incluir los datos archivados",
        includeArchivetem: "Incluir los artículos archivados",
        clientAssocie: "Cliente asociado",
        clientArchiveAccocie: "Este miembro del personal está archivado y, por lo tanto, no puede asociarse a un cliente",
        clientArchiveBadge: "Este miembro del personal está archivado y, por lo tanto, no es posible generar una credencial",
        deleteCheckDeposit: "Eliminar remesas de cheques",
        makeSale: "Realizar una venta",
        downloadCSV: "Exportar en csv",
        downloadZone: "Exportar el contenido de la zona",
        downloadBins: "Exportar el contenido de los bins",
        downloadQuickCSVSelection: "Exportar una versión rápida de las líneas seleccionadas en csv",
        downloadCSVSelection: "Exportar únicamente las columnas seleccionadas en csv",
        downloadCSVPeriod: "Exportar el período seleccionado en csv",
        downloadCSVThisSelection: "Exportar la selección en csv",
        downloadCSVThisSalesSelection: "Exportar las ventas de la selección en csv",
        downloadCSVThisTicketsSelection: "Exportar los tickets de la selección en csv",
        downloadCSVThisDocumentsSelection: "Exportar los documentos de la selección en csv",
        downloadCSVThisPaiementSelection: "Exportar los métodos de pago de la selección en csv",
        downloadCSVAll: "Exportar todas las columnas en csv",
        downloadAllPoCsv: "Exportar el contenido de los pedidos de compra seleccionados en csv",
        downloadSelectedPoCsv: "Exportar los encabezados de los pedidos de compra seleccionados en csv",
        downloadAllToCsv: "Exportar el contenido de las órdenes de transferencia seleccionadas en csv",
        downloadAllToWithoutDetailsCsv: "Exportar los encabezados de las órdenes de transferencia seleccionadas en csv",
        exportTransferOrdersInProgress: "Exportar las órdenes de transferencia en curso en csv",
        downloadAllShipmentCsv: "Exportar todos los albaranes de expedición en csv",
        downloadAllGiftCardCsv: "Exportar todas las tarjetas de regalo en csv",
        downloadAllAbonnementCardCsv: "Exportar todas las tarjetas de suscripción en csv",
        downloadSelectGiftCardCsv: "Exportar únicamente la selección en csv",
        downloadSelectAbonnementCardCsv: "Exportar únicamente la selección en csv",
        downloadStockGap: "Exportar las diferencias de stock",
        downloadExcel: "Exportar en excel",
        downloadArticlesCSV: "Exportar los artículos en csv",
        downloadCSVecotaxe: "Exportar la ecotasa en csv",
        downloadCSVecotaxeDetail: "Exportar la ecotasa y su detalle en csv",
        downloadCSVThisPreparationsSelection: "Exportar las preparaciones de la selección en csv",
        downloadCSVThisPreparationsDetailsSelection: "Exportar las preparaciones de la selección y sus detalles en csv",
        listDonnéesCsv: "Exportar la lista de datos posibles",
        firstlevelcat: "Clasificación",
        secondlevelcat: "Familia",
        thirdlevelcat: "Subfamilia",
        fourthlevelcat: "Categoría",
        fifthlevelcat: "Subcategoría",
        imageLink: "Enlace de imagen del artículo",
        categorysingular: "Categoría",
        addone: "Añadir una",
        addOption: "Añadir una opción",
        tagsMsg: "Puede acumular varias etiquetas separándolas con una coma",
        emailsCumul: "Puede acumular varios correos electrónicos separándolos con una coma",
        tagsMax: "Puede acumular hasta 250 etiquetas",
        staffIsAssociate: "Este miembro del personal está asociado al cliente",
        staffIsNotAssociate: "Este miembro del personal no está asociado a ningún cliente",
        newbrand: "Nueva marca",
        includeArchiveBrands: "Incluir las marcas archivadas",
        formBrand: "Formulario de marca",
        archivedBrand: "Esta marca está archivada",
        archivedProvider: "Este proveedor está archivado",
        associationStaffCustomer: "Asociación de un miembro del personal y un cliente",
        transferOrderPriority: "Prioridad de recogida de una orden de transferencia",
        transferOrderAssociation: "Asociación de órdenes de transferencia",
        saleOrderAssociation: "Asociación de pedido de cliente",
        noAssociateCustomerResult: "No se han encontrado posibilidades de asociación",
        impossibleDeletingFamily: "¡La eliminación es imposible!",
        familyContainItems: "Esta categoría contiene artículos",
        impossibleArchivingFamily: "¡El archivado es imposible!",
        formItem: "Formulario de artículo",
        internalId: "ID interno",
        internalid: "ID interno",
        componentInternalId: "ID interno del componente",
        expectedInternalId: "ID interno deseado",
        fournisseur: "Proveedor",
        notConnectedToFreebird: "No conectado a Freebird",
        otherItemWithSameRefName: "Otros artículos con el mismo nombre de referencia",
        marque: "Marca",
        reference: "Código UPC",
        reference2: "Código UPC 2",
        arrowUp: "Flecha hacia arriba",
        arrowDown: "Flecha hacia abajo",
        ecoTaxe: "Ecoparticipación",
        barcode: "Código de barras",
        barcodePackaginglist: "Código de barras del embalaje",
        shopCode: "Código del comercio",
        itemName: "Nombre del artículo",
        priceTtc: "Precio con impuestos",
        priceHt: "Precio sin impuestos",
        supplierPrice: "Precio de proveedor",
        priceHtWithoutDiscount: "Precio sin impuestos sin descuento",
        marge: "Margen",
        margeNet: "Margen neto",
        totalMargeNet: "Total margen bruto",
        differenceMargeNet: "Diferencia de margen neto",
        totalBuyPrice: "Total precio de compra en divisa",
        margePercent: "Margen %",
        discountPrice: "Precio promocional",
        discountProfil: "Perfil de promoción",
        percentageExceptionProfil: "Perfil de excepción de porcentaje",
        discountProfilPersonalizedPrice: "Perfil de precio personalizado",
        unitDiscount: "Descuento unitario",
        discountType: "Tipo de descuento",
        editionPrix: "Edición del precio",
        buy_price: "Precio de compra en divisa",
        devise_achat: "Divisa de compra",
        last_devise_achat: "Última divisa de compra",
        stores: "Comercios",
        tgc: "Tasa {taxe}",
        downloadBadge: "Descargar la credencial",
        generateBadge: "Generar la credencial",
        thisItemMustHaveStock: "Este artículo dependerá de un stock",
        thisItemMustBePrepare: "Este artículo deberá prepararse",
        thisItemIsArchived: "Este artículo está archivado",
        itemHaveStock: "Vinculación al stock",
        itemToPrepare: "A preparar",
        btnPrepare: "Preparación",
        buffaloPreparationFtpError: "No se pudo enviar el ticket de preparación al servidor FTP",
        buffaloPreparationOrigin: "Preparación procedente de Buffalo",
        preparations: "Preparaciones",
        sendTicketToPreparation: "Enviar el contenido del ticket a preparación",
        ticketPrintDestination: "¿Dónde se debe imprimir el ticket?",
        preparationPrinter: "Preparación",
        invalidItemForPreparation: "Hay artículos no válidos para la preparación en el ticket",
        noPreparationFound: "No se encontró ninguna preparación",
        customizationBadge: "Personalización de la credencial",
        addIdPicture: "Añadir una foto en la credencial",
        addGrade: "Añadir el grado",
        addShopName: "Añadir el nombre de la entidad",
        addLastname: "Añadir el apellido",
        addShopLogo: "Añadir el logotipo del comercio",
        chooseYouCompany: "Seleccione la entidad",
        chooseYourBgColor: "Elija un color de fondo",
        chooseYourTextEntityColor: "Elija el color del texto de la entidad",
        chooseRefundMethod: "Elija el método de reembolso",
        enterYourCustomColor: "Añadir un color en hexadecimal",
        addCustomColor: "Añadir un color de fondo personalizado",
        fieldToUpdate: "Campo a actualizar",
        fieldAutoUpdateItemRule: "Todos los artículos que tengan este campo informado de la misma manera se actualizarán automáticamente",
        noUpdateRule: "Ninguna regla de actualización",
        noEntity: "Ninguna entidad",
        red: "Rojo",
        blue: "Azul",
        yellow: "Amarillo",
        pink: "Rosa",
        green: "Verde",
        black: "Negro",
        white: "Blanco",
        pr: "Precio de costo",
        prmp: "PMP",
        beneficiary: "Beneficiario",
        selectABeneficiary: "Seleccionar un beneficiario",
        muststock: "El artículo tiene stock",
        mobil: "Zona de transición",
        collect: "Recoger",
        receive: "Recepcionar",
        chosseMobile: "Elegir el vehículo de entrega",
        choseReceptionZone: "Elegir la zona de recepción",
        receiptPoDefaultZone: "Zona de recepción predeterminada de un pedido de compra",
        receiptToDefaultZone: "Zona de recepción predeterminada de una orden de transferencia",
        collectToDefaultZone: "Zona de recogida predeterminada de una orden de transferencia",
        receiptAndCollectDefaultZone: "Zona de recepción y recogida predeterminada",
        choseAReceptionZoneToReceive: "Elegir una zona para recepcionar la orden de transferencia",
        choseAReceptionZoneToCollect: "Elegir una zona para recoger la orden de transferencia",
        choseAReceptionZoneToReceivePo: "Elegir una zona para recepcionar el pedido de compra",
        unauthorizedActionOnZoneBins: "La zona seleccionada contiene bins, utilice su WMS para la recepción de esta orden de transferencia",
        duplicatePoReliquat: "Duplicar la línea en función del saldo pendiente",
        duplicatePoReliquatConfirm: "¿Está seguro de que desea duplicar la línea en función del saldo pendiente",
        duplicate: "Duplicar",
        reception: "Zona de recepción",
        commerciale: "Punto de venta",
        prive: "Zona no accesible para la venta ni los movimientos de stock",
        unpaidInvoice: "Facturas no saldadas",
        nonAcquitte: "No saldada",
        stockage: "Zona tradicional de almacenamiento",
        commande: "Almacenamiento de pedidos B2C",
        commandeB2b: "Almacenamiento de pedidos B2B",
        zoneArchived: "Atención: esta zona está archivada",
        importHistory: "Importaciones",
        importReport: "Informe de importación",
        articleImport: "Importación de artículos",
        articleTransformImport: "Importación de artículos transformados",
        clientImport: "Importación de clientes",
        supplementListImport: "Importación de suplementos de artículos",
        poImport: "Importación de pedido de compra",
        toImport: "Importación de orden de transferencia",
        shipmentImport: "Importación de albarán de expedición",
        rppslImport: "Importación de reabastecimiento automático",
        rppslFournisseurImport: "Importación de reabastecimiento proveedor",
        enCours: "En curso",
        open: "Abierto",
        close: "Cerrado",
        on: "Sobre",
        dataListpossible: "Lista posible de datos",
        editPersonalField: "Editar un campo personalizado",
        customFieldCreation: "Creación de campo personalizado",
        updateDatasRule: "Regla de actualización de datos",
        editBrand: "Editar una marca",
        clocking: "Fichaje",
        errorClocking: "Credencial no asignada para este comercio o incorrecta",
        errorPriorityCollect: "No puede definir dos veces el mismo comercio",
        errorNoBinsSelected: "No se ha seleccionado ningún bin ",
        validateProposalReassort: "¿Está seguro de que desea convertir esta propuesta de reabastecimiento en orden de transferencia?",
        errorClotureSaveTicket: "Elimine todos sus tickets guardados antes de cerrar su caja",
        nonAttribue: "No asignado",
        detailHistory: "Detalles del historial",
        detailArticle: "Detalles del artículo",
        detailPrice: "Detalles del precio",
        detailItem: "Detalles del artículo",
        stockItem: "Stock del artículo",
        stockItemPos: "Stock del artículo",
        negativeStock: "Stock negativo",
        importStock: "Importación de ajuste de stock",
        stockParent: "Stock padre",
        colonnes: "Columnas",
        rechercheSurValeurUnique: "Búsqueda por valor único",
        deleteLineItem: "Eliminar una línea de artículo",
        removeQuantityOnLineItem: "Retirar una cantidad de la línea de artículo",
        removeDepositPayment: "Eliminar una línea de pago",
        filtres: "Filtros",
        noFilter: "Sin filtro",
        prmpIndice: "Índice PMP",
        prIndice: "Índice de precio de costo",
        parent_name: "Nombre del padre",
        itemInfos: "Información sobre el artículo",
        paymentInfos: "Información sobre el pago",
        limitDatePay: "Fecha límite de pago",
        limitDateValidity: "Fecha límite de validez",
        detail: "Detalle",
        customer: "Cliente",
        customerProfil: "Perfil del cliente",
        customerInfos: "Información del cliente",
        requiredInformations: "Información obligatoria",
        principalInfo: "Información principal",
        secondInfo: "Información secundaria",
        warningImportInventaire: "Atención, esta funcionalidad sobrescribirá de forma irreversible su stock anterior con el nuevo stock indicado en su archivo, para cada uno de los artículos que se encuentren en él y en cada una de las zonas indicadas. NUNCA debe importar el inventario de un artículo para una zona si no ha realizado su inventario completo en el conjunto de dicha zona.",
        infoImportInventaireAddStock: "Esta funcionalidad añadirá el stock indicado en su archivo a su stock actual, para cada uno de los artículos que se encuentren en él y en cada una de las zonas indicadas.",
        infoSupplementListArticle: "Aquí se enumeran todos los artículos que poseen una lista de suplementos, pero que no pertenecen ellos mismos a ninguna lista de suplementos",
        infoAbonnementArticle: "Aquí se enumeran todos los artículos que poseen una configuración de suscripción",
        itemLinkAndNotLinkToTock: "Artículos vinculados y no vinculados al stock",
        itemLinkToTock: "Artículos vinculados al stock",
        itemNotLinkToTock: "Artículos no vinculados al stock",
        itemNoHavestock: "El artículo no está vinculado al stock",
        itemWithAndWitoutStock: "Artículos con y sin stock",
        itemWithStock: "Artículos con stock",
        itemWWitoutStock: "Artículos sin stock",
        carreposOutStock: "Venta Carrepos",
        setHook: "Activar el hook",
        noCarreposConfig: "Configuración de Carrepos incompleta",
        carreposConnexionFailed: "Autenticación de Carrepos fallida",
        storeUnavailable: "Tienda no disponible",
        connectorConfigMissing: "Falta la configuración del campo de conector",
        referConfigMissing: "Falta la configuración del campo de referencia",
        productNotFound: "Producto no encontrado",
        deleteHook: "Eliminar el hook",
        unavailable: "No disponible",
        diverseInfo: "Información diversa",
        devise: "Divisa",
        inDevise: "En divisa",
        migrate: "Migrar",
        migrateFrom: "Migrar de",
        vers: "hacia",
        errorMsgMin2: "Su mensaje debe contener al menos 2 caracteres",
        errorSelectFamily: "Debe indicar un destino de migración válido",
        aucune: "Ninguna",
        aucunArticleRaccourci: "Ningún artículo",
        noShops: "Ningún comercio",
        noSalesOrder: "Ningún pedido de cliente",
        justItemsWhoHaveStock: "Únicamente los artículos que tienen stock",
        impossibleExport: "Exportación imposible",
        maxLineAuth: "Puede exportar como máximo {limit} líneas de una vez. Actualmente está intentando exportar {actual}",
        csvWillBeReady: "Solicitud de exportación registrada. Su archivo CSV estará disponible en breve en su gestor de descargas de archivos CSV",
        inventoryUpdateWillBeReady: "Actualización del inventario en curso, será efectiva dentro de 5 minutos en {ecomName}",
        lastExportCsv: "Últimas exportaciones de archivos CSV",
        exportDate: "Fecha de exportación",
        exportSelectedColumnToCsv: "Exportar las columnas seleccionadas en CSV",
        state: "Estado",
        itemHasNoStock: "Este artículo no tiene stock",
        errorExport: "Se ha producido un error durante la exportación",
        errorImport: "Se ha producido un error durante la importación",
        errorNoStaffSelected: "No se ha seleccionado ningún miembro del personal",
        attributeSelectionToStaff: "¿Desea asignar su selección ahora mismo?",
        download: "Descargar",
        editArticle: "Edición de un artículo",
        editClient: "Edición del cliente",
        havestockInImport: "Debe indicar si este artículo debe depender de un stock",
        archivedInImport: "Debe indicar si este artículo está archivado (sí/no)",
        itemCard: "Ficha del artículo",
        defaultConfig: "Configuración predeterminada",
        personalizedConfig: "Configuración personalizada",
        addNewSection: "Añadir una nueva sección",
        add: "Añadir",
        newApiKey: "Nueva clave API",
        apiKey: "Clave API",
        msgApiKeyExpire: "Su clave API caducará en menos de 30 días",
        msgNoApiKey: "Ninguna clave API",
        noUserConf: "Ninguna configuración personalizada",
        createApiKey: "Crear una clave API",
        activeApiKey: "Clave API activa",
        createNewApiKey: "Crear una nueva clave API",
        msgApiKey: "Aquí tiene su clave API",
        msgRecreateApiKey: "¿Está seguro de que desea regenerar una clave API?",
        transformArticleAndOriginIsSame: "Una de las líneas que compone el artículo transformado es idéntica al artículo mismo",
        originAndComponentIsTheSame: "Los identificadores internos son idénticos",
        deleteUserConf: "Eliminar la configuración personalizada",
        persoConfigVide: "Su configuración personalizada está vacía",
        defautConfigVide: "Su configuración predeterminada está vacía",
        noDefaultConf: "Ninguna configuración predeterminada",
        noConfAvailable: "No hay ninguna configuración disponible",
        itemAndZoneDetail: "Detalle de artículos y zonas",
        customizeInterface: "Personalizar la interfaz",
        customizationInterface: "Personalización de la interfaz",
        importArticleAlreadyInProgress: "Ya hay una importación de artículos en curso",
        purchaseOrder: "Pedido a proveedor",
        selectMultiplePo: "Seleccionar varios pedidos de compra",
        cancelMultiSelection: "Cancelar la selección múltiple",
        receiveSelection: "Recibir la selección",
        multiPoReceipt: "Recepción de varios pedidos de compra",
        setReceptionPriority: "Definir el orden de prioridad de recepción",
        purchaseOrderB2b: "Pedido",
        purchaseOrderForm: "Formulario de pedido",
        orderDate: "Fecha del pedido",
        expectedDeliveryDate: "Fecha prevista de expedición",
        requestedDeliveryDate: "Fecha de expedición solicitada",
        requestedDeliveryDateNoAccent: "Fecha de expedicion solicitada",
        realDeliveryDate: "Fecha real de expedición",
        estimateDeliveryDate: "Fecha estimada de expedición",
        deliveryDate: "Fecha de expedición",
        deliveryDateNoAccent: "Fecha de expedicion",
        expectedReceiptDate: "Fecha prevista de recepción",
        expectedReceiptDateNoAccent: "Fecha prevista de recepcion",
        expectedReceiptDateDock: "Fecha prevista de recepción en el muelle",
        expectedReceiptDateInShop: "Fecha prevista de recepción en tienda",
        estimatedDelivery: "Entrega estimada",
        lastSalesOrder: "Último pedido de cliente",
        lastQuotation: "Último presupuesto",
        searchSalesOrder: "Buscar un pedido de cliente",
        searchBins: "Buscar una ubicación",
        quantity: "Cantidad",
        addOrRemoveStock: "Añadir/retirar stock",
        maxQuantity: "Cantidad máxima",
        leave: "Salir",
        leaveConversation: "Salir de la conversación",
        leaveNotifConfirm: "¿Está seguro de que desea salir de la conversación?",
        quantityTotal: "Cantidad total",
        quantityDisp: "Cantidad disponible",
        quantityBloque: "Cantidad bloqueada",
        quantiteOnPurchase: "Cantidad pedida",
        quantiteWait: "Cantidad pendiente",
        purchaseOrders: "Pedidos a proveedor",
        createPurchaseOrder: "Crear un pedido",
        purchaseOrderName: "Nombre del pedido",
        createdAt: "Fecha de creación",
        dateBeginAbonnement: "Fecha de inicio de suscripción",
        dateEndAbonnement: "Fecha de fin de suscripción",
        dateEnd: "Fecha de fin",
        availableCredit: "Crédito disponible",
        lostCredit: "Crédito perdido",
        abonnementCardNotValid: "Tarjeta no válida, póngase en contacto con un responsable",
        noAbonnementCardFound: "Tarjeta no encontrada, póngase en contacto con un responsable",
        abonnementCardTimeout: "Tarjeta validada hace menos de 5 minutos, inténtelo de nuevo más tarde",
        abonnementCardExists: "La tarjeta ya existe, inténtelo de nuevo",
        abonnementcard: "Tarjeta de suscripción",
        noClientAbonnementcard: "El cliente es obligatorio para vender una suscripción",
        dateBeginAndEndRequired: "Las fechas de inicio y fin deben indicarse obligatoriamente juntas",
        lastUpdate: "Última actualización",
        divers: "Varios",
        createBy: "Creado por",
        staff: "Personal",
        finalised: "Finalizado",
        acquitte: "Pagado",
        notAcquitte: "No pagado",
        partiallyAcquitte: "Parcialmente pagado",
        delivered: "Recepcionado",
        notDelivered: "No recepcionado",
        delivered2: "Entregado",
        deliveredOk: "Entrega realizada",
        notDelivered2: "No entregado",
        notDeliveredLines: "las líneas no recepcionadas",
        poCompletelyReceived: "Pedido totalmente recepcionado",
        noMoreItemToReceive: "Ya no hay artículos por recepcionar en este pedido",
        completed: "Finalizado",
        notCompleted: "No finalizado",
        includeAllPurchaseOrders: "Incluir los pedidos finalizados",
        editPurchaseOrder: "Editar el pedido",
        importPo: "Importar contenido a los pedidos",
        importShipment: "Importar contenido a los albaranes de expedición",
        importReassort: "Importar contenido al reabastecimiento automático",
        importReassortFournisseur: "Importar contenido al reabastecimiento automático de proveedor",
        importTo: "Importar contenido a las órdenes de transferencia",
        refer: "Nombre de referencia",
        billingRef: "Referencia de la factura",
        quota_recu: "Cantidad recibida",
        confirmLogout: "¿Desea realmente cambiar de personal?",
        status: "Estado",
        etat: "Estado",
        etat_conversion: "Estado de conversión",
        etat1: "Estado 1",
        etat2: "Estado 2",
        excludeCancelledDocument: "Excluir los documentos anulados",
        includeCancelledDocument: "Incluir los documentos anulados",
        justCancelledDocument: "Solo los documentos anulados",
        fromTo: "Desde orden de transferencia",
        fromPo: "Desde pedido",
        since: "Desde",
        regenerate: "Regenerar",
        depotBanqueTitle: "Justificante de depósito en efectivo",
        remiseCheckTitle: "Justificante de entrega de cheque",
        toAlreadyCompleted: "Esta orden de transferencia ya ha sido finalizada",
        allItems: "Todos los artículos",
        statusItems: "Estado de los artículos",
        statusLines: "Estado de las líneas",
        itemsTotallyReceived: "Artículos totalmente recepcionados",
        itemsPartiallyReceived: "Artículos parcialmente recepcionados",
        itemsNotReceived: "Artículos no recepcionados",
        sku: "SKU",
        january: "Enero",
        february: "Febrero",
        march: "Marzo",
        april: "Abril",
        may: "Mayo",
        june: "Junio",
        july: "Julio",
        august: "Agosto",
        september: "Septiembre",
        october: "Octubre",
        november: "Noviembre",
        december: "Diciembre",
        member: "Miembros",
        writeNewMessageHere: "Escriba su mensaje aquí...",
        relatedRecord: "Registros relacionados",
        relatedItems: "Artículos relacionados",
        addItemsInfoPromo: "Utilice el filtro para seleccionar los artículos que desea añadir a la promoción",
        redirect: "Redirigir",
        updatePoRecords: "Actualización en",
        insertPoRecords: "Añadido en",
        updateShipmentRecords: "Actualización en",
        updateInventory: "Actualización del stock",
        updateTheInventory: "Actualizar el stock",
        insertShipmentRecords: "Añadido en",
        entreStockRecords: "Entrada en stock",
        voirLe: "Ver",
        saleOrderCanceled: "Este pedido de cliente ha sido anulado",
        saleOrderFinish: "Este pedido de cliente ha sido finalizado",
        saleOrderFinishTicket: "Este pedido ha sido finalizado con el número de factura: ",
        itemsDetail: "Detalle del artículo",
        registrationDate: "Fecha de registro",
        shipmentVoucher: "Albarán de expedición",
        shipment: "Albarán de expedición",
        transferOrder: "Orden de transferencia",
        transferOrders: "Órdenes de transferencia",
        shipmentVoucherAccent: "Albaran de expedicion",
        entre: "Entrada",
        expected: "Previsto",
        numero_shipment: "Albarán de expedición",
        numero_container_shipment: "Número del contenedor",
        numero_container_shipment_accent: "Numero del contenedor",
        date_depart_shipment: "Fecha de salida",
        date_depart_shipment_accent: "Fecha de salida",
        date_arrive_shipment: "Fecha de llegada",
        date_alert: "Fecha de recordatorio",
        date_arrive_shipment_accent: "Fecha de llegada",
        status_shipment: "Estado",
        createShipmentVoucher: "Crear un albarán de expedición",
        manualEntry: "Entrada manual",
        inventoryZone: "Zona de inventario",
        inventoryOption: "Opción de inventario",
        inventoryZoneList: "Lista de zonas de inventario",
        countFromInventory: "Conteo del inventario",
        cours_chargement: "Cargando",
        alert_texte: "Texto del recordatorio",
        cancelReminder: "Eliminar el recordatorio",
        warehouse: "Muelle",
        mer: "En el mar",
        douane: "En aduana",
        dock: "En curso de recepción",
        receptione: "Recepcionado",
        receipt: "Recepción",
        receptioneLines: "líneas recepcionadas",
        includeAllShipmentVoucher: "Incluir todos los albaranes de expedición",
        exceptReceivedVoucher: "excepto los recepcionados",
        depositDate: "Fecha de depósito",
        only: "Únicamente",
        customCreateForm: "Personalizar el formulario de creación",
        customVoucherDetails: "Personalizar los detalles del albarán",
        PurchaseOrderCard: "Ficha del pedido",
        shipmentVoucherCard: "Ficha del albarán de expedición",
        shipmentVoucherForm: "Formulario de albarán de expedición",
        toCustomForm: "Formulario de orden de transferencia",
        no_box: "Sin caja",
        shde_carton_name: "Referencia de la caja",
        shde_quota_prevu: "Cantidad prevista en caja",
        shde_quota_prevu_accent: "Cantidad prevista en caja",
        shde_quota_recu: "Cantidad recibida",
        shde_carton_recu: "Caja recepcionada",
        shde_carton_recu_accent: "Caja recepcionada",
        receiptShipmentVoucher: "Recepción de albaranes de expedición",
        receiptPo: "Recepción de pedidos a proveedor",
        scanBoxHere: "Escanear una caja aquí",
        scanBoxToCheckHere: "Escanear una caja aquí",
        scanItems: "Escanear un artículo aquí",
        boxeChoice: "Selección de la caja",
        itemChoice: "Selección del artículo",
        drawerName: "Nombre del expedidor",
        priorityBox: "Caja prioritaria",
        french: "Francés",
        english: "Inglés",
        spanish: "Español",
        po: "Pedido a proveedor",
        to: "Orden de transferencia",
        totalPrmp: "Total PRMP",
        totalPr: "Total precio de coste",
        allBoxes: "Todas las cajas",
        allSalesOrder: "Todos los pedidos de cliente",
        allLines: "Todas las líneas",
        allInvoices: "Todas las facturas",
        allCompanies: "Todas las empresas",
        onlyUnpaidInvoices: "Solo las facturas no pagadas",
        boxesStatus: "Estado de las cajas",
        assignAWms: "Asignación WMS",
        forCollect: "para recogida de los artículos",
        forSignAndDelivery: "para firma y entrega",
        forSotckReentry: "para reingreso en stock",
        assignAShop: "Asignar a un comercio",
        sectionReception: "Sección de recepción",
        noWmsAttribution: "Ninguna asignación a un WMS",
        noShipmentVoucher: "Ningún albarán de expedición",
        noPurchaseOrder: "Ningún pedido",
        noReassortInterne: "Ningún reabastecimiento interno en curso",
        editShipmentVoucher: "Editar el albarán de expedición",
        editTransferOrder: "Editar la orden de transferencia",
        receivedBy: "Recepcionado por",
        of: "de",
        poLineAlreadyReceptione: "Este bloque ya ha sido recepcionado",
        ZoneWithBins: "No se ha indicado ninguna ubicación para esta zona",
        someItemsNotPresentInPo: "Algunos de los artículos recepcionados no forman parte del pedido",
        unauthorizedDivision: "La línea que desea duplicar no puede dividirse por el remanente",
        cannotOpenToBecauseAllClose: "No puede reabrir esta orden de transferencia porque todas las acciones ya están completadas",
        cannotEditToBecauseIsClose: "No puede editar esta orden de transferencia porque está cerrada",
        errorScan: "La caja {barcode} no existe",
        successScan: "La caja {barcode} se ha escaneado correctamente",
        reinstateScan: "La caja {barcode} ya ha sido escaneada, ¿desea reintegrarla a las cajas no escaneadas?",
        successReinstate: "La caja {barcode} se ha reintegrado correctamente",
        checkingBoxes: "Recepción de cajas",
        checkingItems: "Recepción de artículos",
        itemsReceipt: "Recepción de artículos",
        itemsCollect: "Recogida de artículos",
        notScannedYet: "Esta caja aún no ha sido escaneada, ¿desea ser redirigido a la página de recepción de cajas?",
        quantityCommande: "Cantidad pedida",
        createStorageSpace: "Crear ubicaciones en masa",
        binsList: "Lista de ubicaciones",
        createOneBins: "Crear una ubicación",
        beginningFirstLevel: "Inicio del primer nivel",
        endFirstLevel: "Fin del primer nivel",
        beginningSecondLevel: "Inicio del segundo nivel",
        endSecondLevel: "Fin del segundo nivel",
        beginningThirdLevel: "Inicio del tercer nivel",
        endThirdLevel: "Fin del tercer nivel",
        beginningFourthLevel: "Inicio del cuarto nivel",
        endFourthLevel: "Fin del cuarto nivel",
        beginningFifthLevel: "Inicio del quinto nivel",
        endFifthLevel: "Fin del quinto nivel",
        firstEndBinsGte: "El fin del primer nivel no puede ser superior al valor de inicio del primer nivel",
        secondEndBinsGte: "El fin del segundo nivel no puede ser superior al valor de inicio del segundo nivel",
        thirdEndBinsGte: "El fin del tercer nivel no puede ser superior al valor de inicio del tercer nivel",
        fourthEndBinsGte: "El fin del cuarto nivel no puede ser superior al valor de inicio del cuarto nivel",
        fifthEndBinsGte: "El fin del quinto nivel no puede ser superior al valor de inicio del quinto nivel",
        firstBins: "Primer nivel",
        secondBins: "Segundo nivel",
        thirdBins: "Tercer nivel",
        fourthBins: "Cuarto nivel",
        fifthBins: "Quinto nivel",
        zone: "Zona",
        successBinsSkip: "Operación realizada con éxito; sin embargo, las siguientes ubicaciones no se han creado porque ya existen",
        scanedBox: "Cajas escaneadas",
        scanBinsHere: "Escanear la ubicación aquí",
        attributeAStorageArea: "Asignar a un espacio de almacenamiento",
        selectAStorageArea: "Seleccionar una zona de almacenamiento",
        billing: "Factura",
        billings: "Facturas",
        quotation: "Presupuesto",
        quotationCreate: "Creación de presupuesto",
        purchaseOrderB2bCreate: "Creación de pedido",
        deliveryNoteCreate: "Creación de albarán de entrega",
        creditNoteCreate: "Creación de abono",
        returnNoteCreate: "Creación de albarán de devolución",
        billingBuyCreate: "Creación de factura de compra",
        poB2bCollectedUp: "Pedido: recogida",
        poB2bCollectedDown: "Pedido: colocación en zona de pedido",
        cancelledPoB2bCollectedUp: "Pedido: anulación de recogida",
        cancelledPoB2bCollectedDown: "Pedido: anulación de colocación en zona de pedido",
        poB2bMouvement: "Movimiento del pedido",
        deliveryNoteOutStock: "Salida de stock del albarán de entrega",
        outStock: "Salida de stock",
        cancelledOutStock: "Anulación de salida de stock",
        billingOutStock: "Salida de stock de la factura",
        returnNoteReturnInStock: "Devolución al stock del albarán de devolución",
        rnReceipt: "Devolución al stock",
        creditNote: "Abono",
        creditNotes: "Abonos",
        searchModel: "Buscar un modelo",
        searchRoughtDraft: "Buscar un borrador",
        selectOnProductList: "Seleccionar en la lista de productos",
        itemsSelection: "Selección de artículos",
        addStock: "Importar stock",
        or: "O",
        totalStock: "Total en stock",
        boxesInfos: "Información sobre las cajas",
        binsNumber: "Número de ubicación",
        binsNumb: "Numero de ubicacion",
        storageArea: "Zona de almacenamiento",
        articlesList: "Lista de artículos",
        boxNotScaned: "Caja no escaneada",
        itemNotExist: "El artículo {sku} no existe",
        itemNotExistInThisTo: "El artículo escaneado no aparece en esta orden de transferencia",
        itemNotExistInThisPoB2b: "El artículo escaneado no aparece en este pedido",
        finishScanBefore: "Debe terminar de escanear este artículo antes de escanear otro",
        selectRowScan: "Seleccionar el bloque a escanear",
        location: "Ubicación",
        binsDetails: "Contenido de la ubicación",
        zoneDetails: "Contenido de las zonas",
        onOrder: "En pedido a proveedor",
        receivedLines: "Línea recepcionada",
        totalHt: "Total sin impuestos",
        differencePrmp: "Diferencia PRMP",
        differencePr: "Diferencia precio de coste",
        differenceHt: "Diferencia sin impuestos",
        caddie: "Carrito",
        providedCashFund: "Fondo de caja previsto",
        prevu: "Fondo de caja previsto",
        prevu_session: "Previsto",
        recipient: "Destinatario",
        limitDayPayment: "Fecha límite de pago",
        caseLatePayment: "En caso de retraso en el pago",
        optionalNoteMsg: "Menciones opcionales que aparecerán en el documento",
        settleInvoice: "¿Desea pagar esta factura?",
        cancelLimitDatePaymentMsg: "Esto anulará la fecha límite de pago si la ha indicado",
        cancelSettleMsg: "Esto anulará el pago de la factura si lo ha indicado",
        indicateLimitDateOfPayment: "¿Desea indicar una fecha límite de pago?",
        indicateLimitValidDate: "¿Desea indicar una fecha límite de validez?",
        addTextOnTopPart: "¿Desea añadir un texto en la parte superior del documento?",
        addTextOnBottomPart: "¿Desea añadir un texto en la parte inferior del documento?",
        topText: "Texto superior",
        topTextSize: "Tamaño del texto superior (por defecto 10)",
        bottomText: "Texto inferior",
        bottomTextSize: "Tamaño del texto inferior (por defecto 9)",
        texteDocuments: "Texto de documentos",
        modeReplaceConfig: "Reemplaza la configuración por defecto",
        modeAddConfig: "Se añade a la configuración por defecto",
        sortField: "Campo de ordenación",
        groupField: "Campo de agrupación",
        paidOn: "Pagado el",
        generateFreebird: "Generado por Freebird",
        dashboard: "Panel de control",
        total: "Total",
        totalWithoutDiscount: "Total sin descuento",
        tax: "Impuesto",
        openWith: "Abierto con",
        binsMovement: "Movimiento de stock",
        stockDeplacement: "Desplazamiento de stock",
        simpleMove: "Movimiento simple",
        massMouvement: "Movimiento de stock en masa",
        avlQuantity: "Cantidad disponible",
        qteToMove: "Cantidad a desplazar",
        qteToTransfer: "Cantidad a transferir",
        qteReceived: "Cantidad recepcionada",
        receivedOn: "Recepcionado el",
        qteThinkMove: "Cantidad recogida",
        qteIsMove: "Cantidad depositada",
        collectedAt: "Recogido el",
        deposedAt: "Depositado el",
        collected: "Recogido",
        converted: "Convertido",
        notConverted: "No convertido",
        isFactured: "Facturado",
        isNotFactured: "No facturado",
        partiallyConverted: "Parcialmente convertido",
        qteToCollect: "Cantidad a recoger",
        inLivraison: "Puesto en entrega",
        outLivraison: "Retirado de entrega",
        devisNonConvertis: "Presupuestos no convertidos",
        bonDeCommandeNonCollectes: "Pedidos no recogidos",
        bonDeCommandeNonConvertis: "Pedidos no convertidos",
        bonDeLivraisonNonLivres: "Albaranes de entrega no entregados",
        bonDeLivraisonNonFactures: "Albaranes de entrega no facturados",
        avoirNonUtilises: "Abonos no utilizados",
        bonDeRetourNonCollectes: "Albaranes de devolución no recogidos",
        factureAcompteNonUtilise: "Facturas de anticipo no utilizadas",
        factureAchatNonAcquitte: "Facturas de compra no pagadas",
        shipmentDelivery: "Expedición y entrega",
        carriers: "Transportistas",
        orderPreparationZone: "Zona de preparación de pedidos",
        matchInternalId: "Asociar los identificadores internos",
        matchingInternalIdImport: "Asociación de los identificadores internos",
        deposed: "Depositado",
        closed: "Cerrado",
        qteReached: "Cantidad máxima alcanzada",
        qteExceed: "Cantidad máxima superada",
        qteAvlInsufficient: "La cantidad disponible es insuficiente",
        selectStorageDestination: "Seleccionar la zona de almacenamiento",
        cantScanDifferentItem: "No puede escanear varios artículos al mismo tiempo",
        itemNotInThisArea: "Este artículo no aparece en esta zona de almacenamiento",
        origin: "Procedencia",
        destination: "Destino",
        scanTheItemHere: "Escanear el artículo aquí",
        binsContent: "Contenido de la ubicación",
        emptyBins: "Esta ubicación está vacía",
        emptyTrolley: "Su carrito está vacío",
        totalDevise: "Total en divisa",
        referencePo: "Referencia",
        internetRef: "Referencia de pedido internet",
        seeReceiptVoucher: "Ver el albarán de recepción",
        voucherNumber: "Número de albarán",
        receiptDate: "Fecha de recepción",
        boxNumber: "Número de caja",
        itemsDetails: "Detalles de los artículos",
        receiptVoucher: "Albarán de recepción",
        cancelBoxReceipt: "Anulación de la recepción de una caja",
        cancelItemReceipt: "Anulación de la recepción de un artículo",
        cancellationOnReceipt: "Anulación en ticket",
        cancelAllReceipt: "Cancelar toda la recepción",
        confirmCancelAllReceipt: "Esta acción cancelará TODA la recepción de este albarán de expedición: el stock se restablecerá y las cantidades se retirarán del pedido de compra asociado. Esta acción es irreversible, ¿confirmar?",
        cancelAllReceiptSuccess: "Toda la recepción ha sido cancelada con éxito",
        inactiveStockArticles: "Artículos inactivos",
        lastMovementType: "Último tipo de movimiento",
        lastMovementDate: "Fecha del último movimiento",
        someItemsAlreadyScan: "Acción no posible, los artículos de esta caja ya están integrados en el stock",
        cancelItemsEntry: "Cancelar la entrada en stock de los artículos",
        itemsReinstate: "Reintegración de artículos",
        cancellationStockEntry: "Anulación de entrada en stock",
        resolveNegative: "Resolución automática de stock en tienda",
        errorReinstateNotPossible: "No puede reintegrar un artículo no recepcionado",
        selectBlockToReinstate: "Seleccionar el bloque a reintegrar",
        selectBlocksToReinstate: "Seleccionar los bloques a reintegrar",
        qteInSalesPoint: "Stock en el espacio de venta",
        qteInReserve: "Cantidad en reserva",
        errorStockReassortMsg: "Actualmente existen artículos con cantidades de stock negativas en su espacio de venta. Los artículos afectados se indican a continuación. Le recomendamos encarecidamente corregir estos stocks negativos antes de continuar. En caso contrario, los artículos con stock negativo no se tendrán en cuenta en el procesamiento del reabastecimiento interno",
        btnReadjustmentAndRestock: "Aplicar el reajuste y generar un reabastecimiento",
        btnReadjustmentAndNoRestock: "Continuar sin corregir los stocks negativos",
        autoRestock: "Reabastecimiento automático",
        autoRestockInternal: "Reabastecimiento automático interno",
        autoRestockSupplier: "Reabastecimiento automático de proveedor",
        reassortInterne: "Reabastecimientos internos",
        resolveNegative: "Corrección de stock automática",
        resolveShopNegative: "Corrección de stock negativo en tienda",
        internalRestock: "Reabastecimiento interno",
        backToInternalRestockList: "Volver a la lista de reabastecimientos internos",
        priorityInternalRestock: "Prioridad de reabastecimiento interno",
        restockList: "Lista de reabastecimientos",
        listSelection: "Selección de la lista",
        actionOnExistingListItem: "Acción sobre la lista de artículos existente",
        orderList: "Lista de pedidos de clientes",
        underwayRestockMsg: "Hay un reabastecimiento en curso",
        toCorrectionDeposed: "Corrección de stock por diferencia entre cantidad recogida y cantidad entregada",
        reorderPoint: "Nivel de stock mínimo RP",
        referenceTo: "Referencia",
        trolley: "Carrito",
        referenceToNoAccent: "Referencia",
        transfert_leNoAccent: "A ejecutar el",
        transfert_le: "A ejecutar el",
        origin_section: "Tienda de origen",
        availableInOriginSection: "Disponible en la tienda de origen",
        destination_section: "Tienda de destino",
        rhBarre: "Código de barras del personal",
        preferredStockLevel: "Nivel de stock óptimo PSL",
        actualStockDisp: "Stock actual disponible",
        actualStock: "Stock actual",
        reassortEnCours: "Reabastecimiento próximo",
        recommendedDestination: "Destinos recomendados",
        sameItem: "Mismo artículo",
        sameParent: "Mismo padre",
        box: "Caja",
        tagSize: "Dimensión de la etiqueta",
        rpInteger: "El nivel de stock mínimo RP de {name} debe ser un número entero",
        pslInteger: "El nivel de stock óptimo PSL de {name} debe ser un número entero",
        rppslAllOrNone: "No puede indicar un RP sin PSL (y viceversa) para {name}",
        detailProvider: "Detalles del proveedor",
        providerCard: "Ficha del proveedor",
        allPo: "Todos los pedidos de compra",
        generateABarCode: "Generar un código de barras",
        generateMasseBarCode: "Generar los códigos de barras en masa",
        generateMasseBarCodePdf: "Generar los códigos de barras pdf en masa",
        generateABarCodePdf: "Generar un código de barras pdf",
        quantityManualModification: "Modificación manual de las cantidades",
        stockReorganization: "Reorganización del stock",
        removeFromStock: "Retirar del stock",
        removeOption: "Retirar una opción",
        addToStock: "Añadir al stock",
        chooseAnAction: "Elegir una acción",
        choisir: "Elegir",
        selectSection: "Seleccionar una tienda",
        stockIntegration: "Integración al stock",
        stockRemove: "Retiro del stock",
        stockAdjustment: "Ajuste del stock",
        massStockAdjustment: "Ajuste del stock en masa",
        stockAdjustmentConfirmation: "¿Confirma los ajustes del stock?",
        stockAdjustmentResetConfirmation: "La lista de artículos se borrará, ¿confirma la reinicialización del ajuste del stock?",
        attemptedStockAdjustment: "Intento de ajuste del stock",
        error_open_checkout: "Error en la apertura de caja",
        error_close_checkout: "Error en el cierre de caja",
        validateAll: "Validar todo",
        reinstateAllItems: "Reintegrar todos los artículos",
        reinstateOneItem: "Reintegrar un artículo",
        reinstateSelection: "Reintegrar la selección",
        confirmReinstateItems: "¿Desea realmente reintegrar todos los artículos?",
        noBarcodeFounded: "No se ha encontrado ningún código de barras",
        rppsl: "Rppsl",
        allTransferOrders: "Todas las órdenes de transferencia",
        exceptFinished: "excepto finalizado",
        transferOrderNotStarted: "Solo órdenes de transferencia no iniciadas",
        notStarded: "No iniciado",
        processOfCollecting: "En curso de recogida",
        toEnCours: "Solo órdenes de transferencia en curso",
        processOfDelivery: "En curso de entrega",
        processOfEmptying: "En curso de descarga",
        transferOrderEdit: "Edición de una orden de transferencia",
        errorDeleteTO: "No puede eliminar esta orden de transferencia",
        wrongBins: "Ha escaneado el bin incorrecto",
        wrongItem: "Ha escaneado el artículo incorrecto",
        stockNegativeAlert: "Alerta de stock negativo",
        stockNegativeAlertLabel: "Alertar en una venta si el artículo vendido está o quedará en stock negativo",
        stockNegativeAlertMsg: "El artículo que acaba de añadir tendrá un stock negativo si finaliza esta venta",
        stockNegativeAlertMsgAutoReassort: "El artículo que acaba de añadir tendrá un stock negativo si finaliza esta venta. Si está disponible en la zona %zone%, se realizará automáticamente un ajuste de stock al finalizar la venta",
        reassortAutoLabel: "Reabastecimiento automático",
        zoneReassortAutoLabel: "Zona de reserva a utilizar",
        allowTransferOrderWithDifferentValue: "Órdenes de transferencia y pedidos con cantidades diferentes",
        zoneWithoutBins: "Zona sin bins",
        uncompletedLines: "Líneas sin finalizar",
        transferTo: "Transferir a",
        transferOrderCompleted: "Orden de transferencia finalizada",
        errorToStockMissing: "La orden de transferencia no pudo finalizarse correctamente debido a una falta de stock",
        confirmValidateAsIs: "¿Está seguro de que desea validar tal como está?",
        confirmCheckDeposit: "¿Está seguro de que desea validar su remesa de cheques?",
        confirmGenerateRestockNoReadjust: "¿Está seguro de que desea continuar? Los artículos con stock negativo no se tendrán en cuenta en el reabastecimiento",
        transferOrdersToCollect: "Órdenes de transferencia por recoger",
        transferOrdersToReceive: "Órdenes de transferencia por recepcionar",
        stockTransfer: "Transferencia de stock",
        stockTransferConfirm: "¿Está seguro de que desea transferir este stock?",
        ecomToCollect: "Pedido de cliente por recoger",
        transferOrderRelatedPo: "Esta orden de transferencia está vinculada a un pedido de cliente",
        quantityToReceive: "Cantidad recepcionada",
        receiveAllItems: "Recepcionar todos los artículos",
        receiveItemsByItems: "Recepcionar artículo por artículo",
        collectionAllItems: "Recoger todos los artículos",
        collectionItemsByItems: "Recoger artículo por artículo",
        validAllArticlePoReceive: "Validar todos los artículos en la recepción de un pedido de compra",
        validAllArticleToReceive: "Validar todos los artículos en la recepción de una orden de transferencia",
        validAllArticleToCollecte: "Validar todos los artículos en la recogida de una orden de transferencia",
        noTransferOrdersToReceive: "Ninguna orden de transferencia por recepcionar",
        consultationTransferOrders: "Consulta de las órdenes de transferencia en curso",
        noTransferOrdersInProgress: "Ninguna orden de transferencia en curso",
        filterAllStatus: "Todos",
        confirmReceptionWithDifferentQte: "La cantidad recepcionada es diferente de la cantidad recogida, esto provocará un reajuste de stock, ¿continuar?",
        linesNumber: "Número de líneas",
        notCollected: "No recogido",
        lineConverted: "Línea ya convertida",
        collectInProgress: "En curso de recogida",
        alertItemsNotCollected: "No se han recogido todos los artículos. Si continúa, probablemente tendrá errores de stock en el futuro. ¿Desea realmente continuar?",
        collection: "Recogida",
        depose: "Descarga",
        website: "Sitio web",
        previousMonthTurnover: "Facturación del mes anterior",
        presentMonthTurnover: "Facturación del mes en curso",
        itemsBase: "Base de artículos",
        stockInShop: "Stock en tienda",
        stockInOtherShop: "Stock en otra tienda",
        priority: "Prioridad",
        toBeCollectedpriority: "A recepcionar con prioridad",
        restockPriority: "Prioridad de reabastecimiento",
        collectedOn: "Recogido el",
        collectedBy: "Recogido por",
        rppslNotConfigured: "El RPPSL de este artículo no ha sido configurado",
        rppslEdit: "Edición del rppsl",
        nbMaxToInstruction: "Número máximo de instrucciones en una orden de transferencia",
        nbMaxEnumere: "Número máximo de enumerados de embalaje",
        allItemsAlreadyScaned: "Todos los artículos han sido escaneados",
        ecommerce: "E-commerce",
        carrepos: "Carré POS",
        shopLiaison: "Vinculación de tienda",
        seller: "Vendedor",
        discount: "Descuento",
        unitaireDiscount: "Descuento unitario",
        unitairePrice: "Precio unitario",
        unitaireDiscountPrice: "Precio unitario con descuento",
        unitairePriceModif: "Modificación del precio unitario",
        priceWithoutDiscount: "Precio sin descuento",
        priceEdit: "Edición unitaria del precio",
        priceModification: "Modificación del precio",
        newPrice: "Nuevo precio",
        titleOnReceipt: "Título en el ticket",
        discountPercent: "Descuento %",
        cancelDiscount: "Anulación de descuento manual",
        discountNet: "Descuento en valor",
        noDiscount: "Sin descuento",
        addNote: "Añadir una nota",
        editToPrepare: "Edición de cantidad a preparar",
        modifColumnPosition: "Modificar la posición de las columnas",
        clickToHideOrShow: "Hacer clic para mostrar u ocultar una {param}",
        dragAndDropToChangePosition: "Arrastrar y soltar para cambiar la posición de una {param}",
        espece: "Efectivo",
        check: "Cheque",
        card: "Tarjeta",
        kiosqueCard: "Tarjeta",
        scanCard: "Escanear tarjeta",
        other: "Otro",
        autre: "Otro",
        amount: "Importe",
        amountTtc: "Importe con impuestos",
        montantDu: "Importe adeudado",
        montantDisponible: "Importe disponible",
        insertToRecords: "Añadir a una orden de transferencia",
        discountedPrice: "Precio con descuento",
        programmedRecurrence: "Recurrencias programadas",
        availableTemplate: "Plantillas disponibles",
        checkNumber: "Número de cheque",
        modePay: "Modo de pago",
        modePayInvoice: "Modo de pago de facturas",
        bank: "Banco",
        checkNum: "Número de cheque",
        reason: "Motivo",
        numberGiftCard: "Número de tarjeta regalo",
        scanGiftCard: "Escanear la tarjeta regalo aquí",
        codeBarreContain: "Cuyo código de barras contiene",
        payment: "Pago",
        due: "Saldo pendiente",
        promotion: "Promociones",
        percentageException: "Porcentaje de excepción",
        percentageExceptionFixe: "Importe de excepción",
        percentageExceptionImport: "Excepción de refacturación",
        zoneNameErrorCarac: "El nombre de la zona no debe contener caracteres especiales",
        percent: "Descuento en %",
        badgeExceptionPercentage: "Porcentaje de comisión",
        franche: "Descuento neto",
        prixfixe: "Modificación del precio",
        xpoury: "Oferta X por Y",
        percentsecond: "Descuento en % sobre el N.º artículo",
        xpourfixe: "Precio fijo para N artículos",
        cadeaupourx: "Regalo por carrito superior a",
        suppercent: "Descuento adicional en % sobre artículo ya rebajado en %",
        suppercentInstruction: "Acumular los descuentos en %, separándolos con una coma",
        noPromoPeriodDefined: "Sin fecha de fin",
        specifyPaymentMode: "Indicar el modo de pago",
        createPromo: "Crear una promoción",
        createPercentageException: "Crear una excepción de porcentaje",
        createPersonalizedPrice: "Crear un precio personalizado",
        personalizedPrice: "Precio personalizado",
        deletePersonalizedPriceConfirm: "¿Qué desea hacer con este precio personalizado?",
        deleteFromLine: "Eliminar de la línea",
        deleteDefinitive: "Eliminar definitivamente",
        qteItems: "Cantidad de artículos",
        qteItemsRetour: "Cantidad de artículos a devolver",
        addImage: "Añadir una imagen",
        seeTheList: "Ver la lista",
        reviewAllGols: "Consultar todos los objetivos de los vendedores",
        reviewIndividualGoals: "Consultar los objetivos individuales",
        percentDesc: "Reducción en porcentaje, ejemplo: -20%",
        francheDesc: "Reducción neta del precio, ejemplo: -XXX {monnaie}",
        prixfixeDesc: "Asignación de un precio fijo a un artículo",
        xpouryDesc: "Venda una cantidad X de artículos por el precio de Y artículos, ejemplo: 2 por el precio de 1",
        percentsecondDesc: "Reducción en porcentaje sobre el N.º artículo, ejemplo: -50% en el 3.º artículo",
        onPosition: "en posición",
        positionArticle: "Posición del artículo (N)",
        positionMin2: "La posición debe ser 2 o superior",
        xpourfixeDesc: "Venda una cantidad X de artículos por un precio fijo, ejemplo: 2 por XXX {monnaie}",
        cadeaupourxDesc: "Un regalo ofrecido a partir de un carrito mínimo, ejemplo: una camiseta de regalo a partir de 100$ de compra",
        suppercentDesc: "Descuento adicional en porcentaje sobre un artículo ya rebajado: -10% adicional sobre un artículo ya rebajado un -30%",
        for: "Por",
        automaticRestockConfiguration: "Configuración de los reabastecimientos automáticos",
        reassortGrouping: "Agrupación de artículos",
        reassortGroupingFieldsLabel: "Campos de agrupación (el orden importa)",
        reassortGroupingFieldGeneral: "Campo de agrupación de artículos no válido",
        preparationTicketHeader: "Ticket de preparación",
        preparationGroupingField: "Campo de agrupación",
        noPreparationGrouping: "Sin agrupación",
        preparationGroupOthers: "Otros",
        preparationSentAt: "Hora de envío",
        preparationGroupingOrder: "Orden de clasificación",
        preparationPrintedItems: "Productos impresos en el ticket de preparación",
        preparationPrintAll: "Todos los productos",
        preparationPrintOnlyToPrepare: "Solo los productos a preparar",
        preparationGroupOrder: "Orden de impresión de los grupos",
        preparationGroupOrderHelp: "Los grupos se imprimen en este orden. Un valor ausente de la lista se imprime después, por orden alfabético.",
        preparationGroupMoveUp: "Subir",
        preparationGroupMoveDown: "Bajar",
        preparationGroupValuesEmpty: "No se encontró ningún valor para este campo",
        preparationGroupSearch: "Buscar un valor para añadir...",
        preparationGroupRemove: "Quitar de la lista",
        reassortGroupingFieldsRequired: "Seleccione al menos un campo de agrupación",
        reassortGroupingFieldDuplicate: "Un campo de agrupación no puede seleccionarse más de una vez",
        itemCreation: "Creación de un artículo",
        numberPointCumule: "Número de puntos acumulados",
        numberPointsToAccumulate: "Número de puntos a acumular",
        totalFideliteCumul: "Total de puntos acumulados",
        totalFideliteSpent: "Total de puntos gastados",
        totalFideliteAdjustment: "Total de los ajustes manuales",
        mergeWithCustomer: "Fusionar con otro cliente",
        perSliceOf: "Por tramo de",
        beginPromo: "Inicio de la promoción",
        beginPersonalizedPrice: "Inicio del precio personalizado",
        endPromo: "Fin de la promoción",
        endPersonalizedPrice: "Fin del precio personalizado",
        assignedPoint: "Puntos asignados",
        editLoyaltyPlan: "Modificar un plan de fidelidad",
        createLoyaltyPlan: "Crear un plan de fidelidad",
        editPromo: "Modificar una promoción",
        editPercentageException: "Modificar una excepción de porcentaje",
        editPersonalizedPrice: "Modificar un precio personalizado",
        editGeneralInfos: "Modificar la información general",
        generalInfos: "Información general",
        undefined: "No definido",
        addPromotion: "Añadir una promoción",
        currentAndUpcomingPromo: "Promociones en curso y próximas",
        currentAndUpcomingPersonalizedPrice: "Precios personalizados en curso y próximos",
        currentPromo: "Promoción en curso",
        currentPersonalizedPrice: "Precio personalizado en curso",
        upcomingPromo: "Promoción próxima",
        upcomingPersonalizedPrice: "Precio personalizado próximo",
        currentLoyaltyPlan: "Plan de fidelidad en curso",
        upcomingLoyaltyPlan: "Plan de fidelidad próximo",
        noCurrentPromo: "Ninguna promoción en curso",
        noUpcomingPromo: "Ninguna promoción próxima",
        addToTheSelection: "Añadir a la lista",
        replaceTheList: "Reemplazar la lista",
        addToPromotion: "Añadir a la promoción",
        additionPromo: "Adición de la promoción",
        currentAndUpcomingLoyaltyPlan: "Planes de fidelidad en curso y próximos",
        allLoyaltyPlans: "Todos los planes de fidelidad",
        dependingItemPrice: "Depende del precio de los artículos",
        giftOffered: "Regalo ofrecido",
        receiptSaved: "Tickets guardados",
        receiptNumber: "Número de ticket",
        saleSaved: "Venta guardada",
        favoriteSaved: "Favorito guardado",
        noCurrentSale: "Ninguna venta en curso",
        noSalesSaved: "Ninguna venta guardada",
        createGiftCard: "Creación de una tarjeta regalo",
        createAbonnementCard: "Creación de una tarjeta de suscripción",
        editAbonnementCard: "Edición de una tarjeta de suscripción",
        prmpOnItemTransform: "PRMP no editable en un artículo transformado",
        deposit: "Importe entregado",
        totalDeposit: "Total descuento",
        totalDiscountPrice: "Total con descuento",
        discountTotal: "Descuento total",
        cashDepositExecutedBy: "Remesa de efectivo realizada por",
        checkDeposit: "Remesa de cheque",
        checkDepositHistorical: "Historial de remesas de cheques",
        noCheckDeposit: "Ninguna remesa de cheque",
        checkAndCash: "Efectivo / Cheques",
        qteMoneyIn: "Cantidad de moneda en",
        doneOn: "Realizado el",
        changeBack: "Cambio devuelto",
        deposited: "Entregado",
        giveChange: "A devolver",
        notValidGiftCard: "Esta tarjeta regalo no es válida para este comercio",
        noFundAvailable: "No hay fondos disponibles en esta tarjeta regalo",
        noEnoughFund: "No hay fondos suficientes en esta tarjeta regalo",
        reminderMsg: "Ha programado un recordatorio para los siguientes documentos",
        recurrenceMsg: "Ha programado una recurrencia para los siguientes documentos",
        moreDetails: "Más detalles",
        credit: "Crédito",
        debit: "Débito",
        abonnement: "Suscripción",
        abonnement_article: "Artículo de suscripción",
        abonnement_achat_article: "Artículo de compra de suscripción",
        abonnementCredit: "Crédito y suscripción",
        abonnementFrom: "Suscripción del",
        abonnementTo: "al",
        dateExpire: "Fecha de vencimiento",
        itemReturn: "Devolución de artículo",
        dontRemise: "De los cuales descuento",
        scanReceiptHere: "Escanear el ticket aquí",
        scanSalesOrderHere: "Escanear el pedido de venta aquí",
        scanQuotationHere: "Escanear el presupuesto aquí",
        scanDocHere: "Escanear el código de barras aquí",
        docNum: "Número de documento",
        document: "Documento",
        documents: "Documentos",
        searchOneReceipt: "Buscar un ticket",
        receiptSearch: "Búsqueda de tickets",
        devisSearch: "Búsqueda de presupuestos",
        enterRefundMethod: "Indicar el modo de reembolso",
        ticket: "Ticket",
        tickets: "Tickets",
        vente: "Venta",
        retour: "Devolución",
        eatin: "Para consumir en el local",
        takeout: "Para llevar",
        toDeliver: "Para entregar",
        refundEspece: "Reembolso en efectivo",
        refund: "Reembolso",
        refundGiftcard: "Reembolso en tarjeta regalo",
        refundOther: "Otro reembolso",
        noItemsToReturn: "Ningún artículo para devolver",
        noItems: "Ningún artículo",
        paid: "Pagado",
        historical: "Historial",
        salesHistorical: "Historial de ventas",
        customerHistorical: "Historial de cliente",
        availableFund: "Fondos disponibles",
        lostFund: "Fondos perdidos",
        totalDepot: "Total de depósitos",
        depot: "Depósito",
        numberDepot: "Número de depósitos",
        itemsNumber: "Número de artículos",
        bosexNumber: "Número de cajas",
        receiptInProgress: "Ticket en curso",
        messageEndReceipt: "le agradece su visita",
        downloadingPdf: "Descarga del pdf",
        downloadInProgress: "Descarga en curso, por favor espere...",
        lastSale: "Última venta",
        noPreviousSale: "No se ha realizado ninguna venta anteriormente",
        noPreviousDevis: "No se ha realizado ningún presupuesto anteriormente",
        selectConcernedPeriod: "Elija el periodo correspondiente",
        addNewPayment: "Añadir un pago",
        beginningPeriod: "Inicio del periodo",
        endPeriod: "Fin del periodo",
        editPaymentMethod: "Modificación del modo de pago",
        noPaymentMethodToEdit: "Ningún modo de pago para modificar",
        checkoutState: "Estado de caja",
        totalWithGiftCard: "Total de ventas con tarjetas regalo",
        totalWithoutGiftCard: "Total de ventas sin tarjetas regalo",
        averageReceiptWithGiftCard: "Ticket medio con tarjetas regalo",
        averageReceiptWithoutGiftCard: "Ticket medio sin tarjetas regalo",
        wholeShop: "Todo el comercio",
        filterByEmployee: "Filtro por empleado",
        filterByCashRegister: "Filtro por caja",
        allStaff: "Todo el personal",
        thisCashRegister: "Esta caja",
        concernedShop: "Comercios afectados",
        typePromo: "Tipo de promoción",
        typePersonalizedPrice: "Tipo de precio personalizado",
        statePromo: "Estado de la promoción",
        statePersonalizedPrice: "Estado del precio personalizado",
        messageBienvenue: "Hola - Bienvenido",
        acroTel: "Tel",
        postalAdress: "Dirección postal",
        depotGiftCard: "Depósitos de tarjetas regalo",
        finished: "Finalizado",
        poNbr: "Pedido de compra n.º",
        removeAllArticlesConfirm: "¿Desea realmente vaciar los artículos de esta promoción?",
        removeSelectedArticlesConfirm: "¿Desea realmente quitar los artículos seleccionados de esta promoción?",
        removeSelectedPromotionsConfirm: "¿Desea realmente eliminar las promociones seleccionadas?",
        removeAllArticlesConfirmPricePersonalized: "¿Desea realmente vaciar los artículos de este precio personalizado?",
        manualDiscountPercent: "Descuento manual en %",
        manualDiscountNet: "Descuento manual en valor",
        manualDeposit: "Descuento manual",
        autreFrais: "Otros gastos",
        ecomConnexion: "Conexión e-commerce",
        caisseIdent: "Identificador de caja",
        posName: "Nombre de la caja",
        actualSumCaisse: "Fondo de caja esperado",
        actualEspeceCaisse: "Salida de efectivo esperada",
        sortieEspece: "Salida de efectivo",
        cashDepositgroup: "Remesa de efectivo agrupada",
        bill: "Billetes",
        coin: "Monedas",
        form: "Formulario",
        preview: "Vista previa",
        acutalSession: "Sesión actual",
        cashTotalInCaisse: "Total de efectivo",
        checksTotalDeposit: "Total de cheques en la remesa",
        derniersRetraitEspeces: "Últimos retiros de efectivo",
        dernierRetraitEspecesSingle: "Último retiro de efectivo",
        retraitEspeces: "Retiro de efectivo",
        exportRetraitEspeces: "Exportar retiro de efectivo",
        remiseEnBanque: "Remesa bancaria",
        lastTenRetraitEspeces: "Últimos 10 retiros de efectivo",
        thisRetraitEspeces: "este retiro de efectivo",
        generateAutoCashDeposit: "Generar una remesa de efectivo en banco con el total del efectivo, excluyendo el fondo de caja",
        newStaff: "Nuevo personal",
        refresh: "Actualizar",
        correspondanceItem: "Correspondencia sobre el detalle de los artículos",
        correspondanceMarque: "Correspondencia sobre el detalle de las marcas",
        connector: "Conector e-commerce",
        personalizedFilter: "Filtro personalizado",
        periodFilter: "Filtro por periodo",
        correspondenceDeliveryCost: "Correspondencia de los gastos de envío",
        correspondenceDatas: "Correspondencia de los datos",
        currentWeek: "Semana en curso",
        lastWeek: "Semana pasada",
        nextWeek: "Semana próxima",
        month: "Mes",
        currentMonth: "Mes en curso",
        lastMonth: "Mes pasado",
        nextMonth: "Mes próximo",
        currentYear: "Año en curso",
        lastYear: "Año pasado",
        saveSale: "Guardar una venta",
        cancelSaleAndOrder: "Cancelar una venta o un pedido",
        paymentDetail: "Detalle del pago",
        receiptDetail: "Detalle del ticket",
        depositDetail: "Detalle del anticipo",
        giftCardCredit: "Crédito de tarjeta regalo",
        giftCardPerimeterTitle: "Perímetro de las tarjetas regalo",
        giftCardPerimeterDesc: "Comercios en los que se puede utilizar una tarjeta regalo vendida en este comercio",
        printItemTag: "Imprimir una etiqueta",
        printItemTags: "Imprimir etiquetas",
        includeArchives: "Incluir los archivados",
        includeExpiredGiftCard: "Incluir las tarjetas regalo caducadas",
        includeExpiredAbonnementCard: "Incluir las tarjetas de suscripción caducadas",
        saleOrderDetail: "Detalle del pedido",
        devisDetail: "Detalle del presupuesto",
        openSaleOrder: "Abrir el pedido del cliente",
        objectifAndCa: "Objetivos y facturación",
        user: "Usuario",
        active: "Activo",
        draft: "Borrador",
        thisDraft: "este borrador",
        thisSavedDocument: "este documento guardado",
        roughDraftList: "Lista de borradores",
        templateList: "Lista de modelos",
        archived: "Archivado",
        peripheralDevice: "Periféricos",
        newPeripheralDevice: "Nuevo periférico",
        model: "Modelo",
        checkoutShortcut: "Acceso directo de caja",
        checkoutShortcuts: "Accesos directos de caja",
        newShortcut: "Nuevo acceso directo de caja",
        new: "Nuevo",
        allNotifications: "Todas las notificaciones",
        noNotifications: "Ninguna notificación",
        markAllAsRead: "Marcar todo como leído",
        confirmMarkAllAsRead: "¿Desea marcar todas las notificaciones como leídas?",
        noNewNotifications: "Ninguna notificación nueva",
        seeReceipt: "Ver el ticket",
        read: "Leído",
        unread: "No leído",
        newShipmentToPick: "Nuevo albarán de expedición asignado",
        newTo: "Nueva orden de transferencia por recoger",
        ipAdress: "Dirección IP o puerto COM",
        afficheur: "Visualizador",
        tpe: "TPV",
        ingenico: "Ingenico",
        comPort: "Puerto COM",
        imprimante_ticket: "Impresora de tickets",
        imprimante_ticket_preparation: "Impresora de tickets de preparación",
        imprimante_cheque: "Impresora de cheques",
        matchBarCode: "Asociar un código de barras",
        matchBarCodeToItem: "Asociar un código de barras a un artículo",
        imprimante_etiquette: "Impresora de etiquetas",
        etiquette: "Etiqueta",
        epson_tm_h6000V: "Epson TM-H6000V",
        zebra_zd421: "ZPL (Windows)",
        printCaisseIdent: "Imprimir el identificador de caja",
        aures_2_l: "Visualizador Aures",
        second_screen_display: "Visualizador de segunda pantalla",
        notAttributedPeripheral: "Periféricos no asignados",
        noPeripheral: "Ningún periférico",
        noConfiguredPeripheral: "Ningún periférico configurado",
        otherSection: "Otro comercio",
        disponibleMini: "Disp",
        blockedMini: "Bloq",
        workTimeToday: "Indicar un tiempo de trabajo",
        workTimeDetails: "Distribución de su tiempo de trabajo",
        workTime: "Tiempo de trabajo",
        chooseProject: "Seleccionar un proyecto",
        allProject: "Todos los proyectos",
        chooseTask: "Seleccionar una tarea",
        work_project: "Proyecto",
        work_project_detail: "Tarea",
        nbrHours: "Número de horas",
        nbrMinutes: "Número de minutos",
        aVenir: "Próximamente",
        datasRecorded: "Datos guardados",
        reorganizeColum: "Reorganizar las columnas",
        changePrinter: "Cambiar de impresora",
        changeZone: "Cambiar de zona",
        changeCustomer: "Cambiar de cliente",
        qteTag: "Cantidad de etiquetas",
        tagPrint: "Impresión de etiquetas",
        limitTagPrint100: "El límite de impresión es de 100 etiquetas",
        mintTagPrint1: "La cantidad mínima de etiquetas a imprimir es de 1",
        bankDeposit: "Depósito bancario",
        salesOrder: "Pedidos de clientes",
        addToOrder: "Añadir al pedido",
        expectedCollectDate: "Fecha prevista de recogida",
        numberShopifyOrder: "Número de pedido E-Com",
        collectZone: "Lugar de recogida",
        collectZoneChangeTitle: "Artículos ya recogidos",
        collectZoneChangeText: "Este pedido ya contiene artículos recogidos. ¿Desea que estos artículos se marquen automáticamente como recogidos en la nueva zona de recogida, o desea que se marquen como pendientes de recogida en la nueva zona de recogida?",
        collectZoneChangeKeepCollected: "Marcar como recogido",
        collectZoneChangeResetToCollect: "Marcar como pendiente de recogida",
        collectZoneDifferentTitle: "Lugar de recogida diferente",
        collectZoneDifferentText: "El lugar de recogida elegido es diferente de la tienda actual. ¿Desea que la mercancía sea recogida inmediatamente en ese lugar, o que permanezca pendiente de recogida?",
        order: "Pedir",
        commandeChangeCollectZone: "Modificación del lugar de recogida",
        commandeOut: "Salió de la zona de comercio",
        commandeRemoveOut: "Salió de la zona de pedido para pasar a orden de transferencia",
        commandePut: "Colocado en zona de pedido",
        commandeRemovePut: "Colocado en zona de comercio para pasar a orden de transferencia",
        commandeCancelledOut: "Cancelación de pedido - Salida de la zona de pedido",
        commandeCancelledPut: "Cancelación de pedido - Salida de la zona de comercio",
        orderHistorical: "Historial de pedidos de clientes",
        devisHistorical: "Historial de presupuestos",
        preparationHistorical: "Historial de preparación",
        searchByCreationDate: "Buscar por fecha de creación",
        searchByCollectDate: "Buscar por fecha prevista de recogida",
        searchASalesOrder: "Buscar un pedido de cliente",
        searchAQuotation: "Buscar un presupuesto",
        searchSalesOrder: "Búsqueda de pedidos de clientes",
        article: "Artículo",
        noCheckoutShortcut: "Ningún acceso directo de caja",
        validateNewOrder: "Validar la nueva orden",
        transferHere: "Transferir aquí",
        transferToOtherShop: "Transferir a otra tienda",
        expireSession: "¡Su sesión ha caducado! Va a ser redirigido.",
        myTime: "Mi tiempo",
        addQuantityByEnumere: "Añadir cantidades a partir del enumerado de embalaje",
        justMinQuantity: "Solo para la cantidad mínima",
        changeDocument: "Cambio de documento",
        bipeurNumber: "Número de buscapersonas",
        bipeurLabelSetting: "Término mostrado para el número de pedido",
        bipeurLabelBipeur: "Buscapersonas",
        btnAccess: "¡Ir!",
        btnCancelSalesOrder: "Cancelar el pedido del cliente",
        cancelPosOnly: "Salir del pedido",
        cancelCommandeOrPosTitle: "¿Qué desea hacer?",
        btnSeeEditDelete: "Ver / Editar / Eliminar",
        btnValidate: "Validar",
        btnValidateAndSave: "Validar y guardar",
        btnValidateStockAdjustment: "Validar el ajuste de stock",
        btnDeleteUser: "Eliminar este usuario",
        btnDeleteGrade: "Eliminar este grado",
        btnAddRewardLevel: "Añadir un nivel de recompensa",
        btnDeleteRh: "Eliminar este empleado",
        btnYes: "Sí",
        btnNo: "No",
        btnDelete: "Eliminar",
        editColor: "Modificar el color",
        editName: "Modificar el nombre",
        btnAddField: "Añadir un campo",
        btnRemoveRh: "Retirar del comercio",
        btnRemove: "Retirar",
        btnGoClotureCaisse: "Cerrar la caja",
        btnAddAllItems: "Añadir todos los artículos de la base de artículos",
        btnFilterItemsToAdd: "Seleccionar los artículos a añadir",
        btnCancel: "Cancelar",
        btnBackToWelcome: "Volver al inicio",
        btnPay: "Pagar",
        btnEffacer: "Borrar",
        btnReset: "Restablecer",
        btnClose: "Cerrar",
        closeFolder: "Cerrar el expediente",
        btnImport: "Importar",
        btnAddClientForm: "Añadir el formulario de cliente",
        btnRemoveClientForm: "Retirar el formulario de cliente",
        btnArchiveStaff: "Archivar este empleado",
        btnActiveStaff: "Activar este empleado",
        btnArchiveProvider: "Archivar este proveedor",
        btnDeleteProvider: "Eliminar este proveedor",
        btnUnarchiveProvider: "Activar este proveedor",
        btnSeeProfil: "Ver el perfil",
        btnDeleteAssociate: "Eliminar la asociación",
        btnSearchAssociateCustomer: "Iniciar una búsqueda de posibilidades de asociación",
        btnUnarchiveBrand: "Activar esta marca",
        btnArchiveBrand: "Archivar esta marca",
        btnDeleteBrand: "Eliminar esta marca",
        btnAssociate: "Asociar",
        btnCreateNewStaffCustomer: "Generar un nuevo cliente asociado a este empleado",
        btnUnarchiveZone: "Activar esta zona",
        btnArchiveZone: "Archivar esta zona",
        btnDeleteZone: "Eliminar esta zona",
        btnShowDetails: "Ver los detalles",
        btnShowReminders: "Ver los recordatorios",
        btnInsert: "Insertar",
        btnUpdate: "Actualizar",
        btnBack: "Volver",
        btnMove: "Mover",
        btnReturn: "Volver",
        btnSeeBinsContent: "Ver el contenido de la ubicación",
        btnSeeParentProfil: "Perfil del padre",
        btnValidateAsIs: "Validar tal cual",
        btnSeeStock: "Ver el stock",
        btnItemProfil: "Perfil del artículo",
        btnModifier: "Modificar",
        btnSave: "Guardar",
        btnSeePdf: "Ver el ticket en pdf",
        btnPdf: "Ver el pdf",
        btnSeeDevisPdf: "Ver el presupuesto en pdf",
        btnPrint: "Imprimir",
        btnSendMailTicket: "Enviar por correo electrónico",
        btnPayPrint: "Pagar e imprimir",
        btnGiftPrint: "Ticket regalo",
        btnRemoveAllItems: "Retirar todos los artículos",
        btnRemoveSelectedItems: "Retirar los artículos seleccionados",
        btnCancelDiscount: "Cancelar el descuento en curso",
        btnNewDocumentReliquat: "Generar un nuevo documento a partir de los saldos pendientes",
        btnNextStep: "Siguiente paso",
        welcome: "Inicio",
        usersList: "Lista de usuarios",
        usersCreate: "Crear un usuario",
        rhCreate: "Crear un empleado",
        newCustomer: "Nuevo cliente",
        administrationGenerale: "Administración general",
        administrationModePaiement: "Métodos de pago",
        administrationObjectifPos: "Objetivos",
        administrationTurnoverPos: "Facturación",
        ticketSalesOrder: "Tickets / Pedidos de clientes / Presupuestos",
        administrationCustomForm: "Formularios personalizados",
        administrationClientForm: "Cliente",
        administrationFournisseurForm: "Proveedor",
        administrationMarqueForm: "Marca",
        administrationArticleForm: "Artículo",
        administrationStaff: "Personal",
        administrationStaffList: "Lista de personal",
        year: "Año",
        shopName: "Nombre de la tienda",
        allCreate: "Crear",
        searchStock: "Búsqueda de stock",
        cashRegister: "Caja",
        item: "Artículo",
        licence_notification: "Actualizaciones",
        addToCart: "Añadir al carrito",
        addItem: "Añadir un artículo",
        addImageLink: "Añadir el enlace de la imagen de su artículo",
        importItem: "Importar artículos",
        importFournisseur: "Importar proveedores",
        importPromotion: "Importar promociones",
        importPersonalizedPrice: "Importar precios personalizados",
        importPercentageException: "Importar excepciones de porcentaje",
        number: "Número",
        importInventory: "Importar un inventario",
        inventaireStaffDelete: "Los conteos se eliminarán para los empleados eliminados",
        importStockOrInventory: "Importar un stock o un inventario",
        importItemLoyaltyPlan: "Importar artículos al plan de fidelización {name}",
        importItemPercentageException: "Importar artículos a la excepción de porcentaje {name}",
        importItemPromotion: "Importar artículos a la promoción {name}",
        importItemPromotionA: "Importar artículos en la lista A, a la promoción {name}",
        importItemPromotionB: "Importar artículos en la lista B, a la promoción {name}",
        importItemSupplementList: "Importar artículos en la lista de suplementos",
        importItemPersonalizedPrice: "Importar artículos al precio personalizado {name}",
        listAMsgInfo: "Importe aquí los artículos que activarán la promoción",
        listBMsgInfo: "Importe aquí los artículos que se beneficiarán de la promoción",
        listTriggerPromo: "Lista de artículos que activarán la promoción",
        listBenefitPromo: "Lista de artículos que se beneficiarán de la promoción",
        noRestockNeeded: "No es necesario ningún reabastecimiento",
        facturation: "Facturación",
        createBillingQuotation: "Crear factura/presupuesto",
        productOn: "Producto(s) sobre",
        formProvider: "Formulario de proveedor",
        formSaleOrder: "Formulario de pedido de cliente",
        itemFamily: "Familias de artículos",
        brand: "Marcas",
        client: "Clientes",
        customizedInterface: "Interfaz personalizada",
        createRead: "Crear y consultar",
        import: "Importar",
        allPromotions: "Todas las promociones",
        allPersonalizedPrice: "Todos los precios personalizados",
        promoWeight: "Peso de la promoción",
        percentageExceptionWeight: "Peso de la excepción de porcentaje",
        personalizedPriceWeight: "Peso del precio personalizado",
        valueBetween: "Valor entre",
        printingInProgress: "Impresión en curso",
        movePeripheralsShop: "¿Está seguro de que desea mover {deviceName} a {shopName}?",
        session: "Sesión",
        billingVsCreditNote: "Nº Facturas / Nº Abonos",
        etatCompte: "Estado de cuenta",
        donneesLigneArticle: "Datos adicionales sobre la línea de artículo",
        value: "Valor",
        confirmConvertReliquat: "¿Está seguro de que desea convertir el saldo pendiente en un nuevo {documentType}? El presente {documentType} ya solo contendrá los artículos ya convertidos y el nuevo {documentType} contendrá el conjunto de los saldos pendientes",
        created_at: "Creado el",
        exportDataConfiguration: "Exportación de datos",
        bbg_inventory_item: "Artículos con stock",
        bbg_non_inventory_item: "Artículos sin stock",
        bbg_item_parent_dates: "Fechas artículos padres",
        bbg_item_parent_monthly: "Artículos padres mensual",
        bbg_item_monthly: "Artículos mensual",
        bbg_item_parent_weekly: "Artículos padres semanal",
        bbg_item_soh: "Stock disponible (SOH)",
        bbg_sales: "Ventas",
        bbg_paiements: "Medios de pago",
        bbg_kpis: "KPIs",
        bbg_objectifs: "Objetivos",
        bbg_promotions: "Promociones",
        bbg_pos: "Órdenes de compra",
        bbg_tos: "Órdenes de transferencia",
        bbg_shipments: "Envíos",
        bbg_gift_card: "Tarjetas de regalo",
        bbg_failed_stock_adjustment: "Ajustes de stock fallidos",
        showReportConfiguration: "Visualización de los informes",
        pbi_items: "Artículos",
        pbi_stock_items: "Stock",
        pbi_stock_items_monthly: "Stock mensual",
        pbi_stock_items_weekly: "Stock semanal",
        pbi_client: "Clientes",
        pbi_fournisseur: "Proveedores",
        pbi_sales: "Ventas B2C",
        pbi_paiements: "Medios de pago en ventas B2C",
        pbi_promotion: "Promoción",
        pbi_factures: "Ventas B2B",
        pbi_documents_b2b: "Documentos B2B",
        pbi_po: "Orden de compra a proveedor",
        pbi_to: "Órdenes de transferencia",
        pbi_listes: "Listas de artículos",
        pbi_objectifs: "Objetivos",
        pbi_kpis: "KPIs",
        pbi_items_content: "Contenido de artículos",
        pbi_passages: "Pasos",
        pbiFileName: "Nombre del archivo",
        pbiExportActivate: "Activar",
        pbiExportLastExecution: "Última finalización de ejecución",
        pbiExportInProgress: "En curso",
        pbiExportRefresh: "Actualizar el estado",
        pbiExportGenerate: "Generar ahora",
        pbiExportNotActivated: "No activado",
        pbiGenerationInProgress: "Generación en curso",
        alreadyInProgress: "Ya se está generando",
        dataTable: "Tabla de datos",
        tableSearch: "Buscar",
        tableName: "Nombre",
        tableFirst: "Inicio",
        tableBack: "Anterior",
        tableNext: "Siguiente",
        tableLast: "Última",
        tableFistTitle: "Primera página",
        tableBackTitle: "Página anterior",
        tableNextTitle: "Página siguiente",
        tableLastTitle: "Última página",
        tableNoData: "Ningún dato",
        tableNoModePaiement: "Ningún método de pago añadido",
        tableNoCashOutReason: "Ningún justificante de retiro de efectivo en caja añadido",
        tableSex: "Sexo",
        tableFirstName: "Nombre",
        tablePhone: "Teléfono",
        tableRemove: "Retirar",
        tableBarCode: "Código de barras",
        tableOtherPhone: "Otro teléfono",
        tableProviderName: "Nombre del proveedor",
        tableContactName: "Nombre del contacto",
        tableBrandName: "Nombre de la marca",
        tableContraintes: "Restricciones",
        labelSex: "Sexo",
        labelName: "Nombre",
        labelCsvSeparator: "Separador CSV",
        labelCsvEncode: "Codificación CSV",
        labelFirstName: "Nombre",
        labelPassword: "Contraseña",
        labelPasswordConfirmation: "Confirmar contraseña",
        labelPhone: "Teléfono",
        labelMaxusemoisproforma: "Duración de validez de una proforma (en meses)",
        labelRaisonmodifprix: "Motivos por los que un vendedor puede justificar la modificación manual del precio de un artículo",
        labelInfosTicket: "La información introducida se mostrará tal como la ha escrito y en el orden en que la ha añadido.",
        labelPriorityCollect: "Defina el orden en el que debe realizarse la recogida de una orden de transferencia",
        labelPriorityInternalReassort: "Defina el orden de prioridad de las zonas de reserva para los reabastecimientos internos",
        labelDateFormat: "Formato de fecha",
        labelAdress: "Dirección",
        labelAdressLivraison: "Dirección de entrega",
        labelCodePostal: "Código postal",
        labelVille: "Ciudad",
        labelPays: "País",
        labelCodeBank: "Código de banco",
        labelCodeGuichet: "Código de sucursal",
        labelNumeroDeCompte: "Número de cuenta",
        labelCleRib: "Clave de cuenta bancaria",
        labelBank: "Banco",
        labelHoraires: "Horarios",
        labelProviderName: "Nombre del proveedor",
        labelContactName: "Nombre del contacto",
        labelArchived: "Archivado",
        labelBankName: "Nombre del banco",
        labelSelectConfigue: "Elija su configuración",
        labelReason: "Motivo",
        labelMaxReaInterne: "Cantidad máxima por artículo para un reabastecimiento interno",
        labelDelaiReglement: "Plazo de pago",
        labelModePaiement: "Método de pago",
        labelContact: "Contacto",
        labelMailrelance: "Correos de recordatorio",
        sucessUserCreate: "¡Usuario creado con éxito!",
        reportPbi: "Informes",
        listOfGroup: "Lista de grupos de informes",
        createAGroup: "Crear un grupo de informes",
        addPbiLink: "Añadir enlaces de informes",
        link: "Enlace",
        adressRequired: "El enlace es obligatorio",
        adressUrl: "El enlace debe ser una dirección válida",
        filterByUser: "Filtrar por usuario",
        filterByModule: "Filtrar por módulo",
        noReportingAvl: "Ningún informe disponible",
        espece: "Efectivo",
        cheque: "Cheque",
        emv_touch: "EMV sin contacto",
        emv_multiple: "EMV pago en varias veces",
        amex_touch: "American Express sin contacto",
        amex_multiple: "American Express pago en varias veces",
        cb: "Tarjeta Bleue/Visa",
        amex: "American Express",
        mastercard: "Mastercard",
        jade: "Tarjeta Jade",
        jcb: "Tarjeta Jcb",
        giftcard: "Tarjeta regalo",
        giftcardAvoir: "Tarjeta regalo (Abono)",
        virement: "Transferencia bancaria",
        emv: "EMV",
        bonmalistecadeaux: "Vale \"Ma Liste Cadeaux\"",
        bonatelierdujouet: "Vale \"Atelier du Jouet\"",
        annulCommande: "Pedido de cliente cancelado",
        card: "Tarjeta bancaria",
        monday: "Lunes",
        tuesday: "Martes",
        wednesday: "Miércoles",
        thursday: "Jueves",
        friday: "Viernes",
        saturday: "Sábado",
        sunday: "Domingo",
        createCreditNote: "Crear un abono",
        settleInvoiceAccess: "Liquidar una factura",
        assignUser: "Asignar usuarios",
        authorizationRequiredForThisAction: "Se requiere autorización para realizar esta acción",
        globalSearchPlaceholder: "Buscar...",
        globalSearchSearching: "Buscando...",
        globalSearchNoResult: "No se encontró ningún resultado",
        searchCatArticle: "Artículos",
        searchCatTo: "Órdenes de transferencia",
        searchCatShipment: "Expediciones",
        searchCatPo: "Órdenes de compra",
        searchCatFacture: "Documentos B2B",
        searchCatTicket: "Tickets",
        /*********journal comptable (PDF)***********/
        journalComptaVente: "Diario de ventas",
        journalComptaAchat: "Diario de compras",
        journalComptaEclatement: "Con desglose base e IVA",
        journalComptaEdit: "Editar el diario",
        journalComptaPeriodeFacturation: "Fecha de facturación: del {begin} al {end}",
        journalComptaEditionDevise: "Edición en {devise} de todas las facturas",
        journalComptaTotaux: "Totales",
        journalComptaDateEdition: "Fecha de edición",
        journalComptaPage: "Página {current} de {total}",
        journalComptaColDate: "Fecha",
        journalComptaColPiece: "Documento",
        journalComptaColTiers: "Tercero",
        journalComptaColTtc: "Con IVA",
        journalComptaColHt: "Base",
        journalComptaColTva: "IVA",
        journalComptaApercu: "Vista previa del diario",
        journalComptaApercuVide: "Indique el periodo y edite el diario para mostrarlo aquí.",
        journalComptaTelecharger: "Descargar el PDF",
        journalComptaNoDocument: "Ningún documento en el periodo seleccionado",
        journalComptaEcartHt: "La suma de los desgloses no coincide con la base de los documentos (diferencia: {ecart})",
        unvalidDate: "Fecha no válida",
        unvalidPeriode: "La fecha de inicio debe ser anterior a la fecha de fin",
        journalComptaFiltreCommerce: "Comercios",
        journalComptaFiltreCaisse: "Cajas",
        journalComptaFiltreVendeur: "Vendedores",
        journalComptaFiltreTous: "Todos",
        journalComptaFiltreToutSelectionner: "Seleccionar todo",
        journalComptaFiltreEffacer: "Borrar",
        journalComptaFiltreAucuneOption: "Ninguna opción",
        journalComptaFiltreChoisirCommerce: "Seleccione primero un comercio",
        razCaisseTitle: "Cierre Z de caja",
        razCaisseEdit: "Editar el cierre Z",
        razCaisseApercu: "Vista previa del cierre Z",
        razCaisseApercuVide: "Indique el período y edite el cierre Z para mostrarlo aquí.",
        razCaisseEmetteur: "Emisor",
        razCaissePeriode: "Período del {begin} al {end}",
        razCaisseSelectionCentre: "Selección centro",
        razCaisseSelectionCaisse: "Selección caja",
        razCaisseSelectionVendeur: "Selección vendedor",
        razCaisseSelectionTous: "Todos",
        razCaisseStatistiques: "Estadísticas generales",
        razCaisseNbTickets: "Nº de tickets",
        razCaisseNbArticles: "Nº de artículos",
        razCaissePanierMoyenTtc: "Cesta media con IVA",
        razCaissePanierMoyenHt: "Cesta media base",
        razCaisseArticleMoyenTtc: "Artículo medio con IVA",
        razCaisseTotalRemise: "Total descuento",
        razCaisseMoyenneRemise: "Descuento medio",
        razCaisseTotalTtcBrut: "Total bruto con IVA",
        razCaisseTotalHtBrut: "Total bruto base",
        razCaisseTotalTtcNet: "Total neto con IVA",
        razCaisseTotalHtNet: "Total neto base",
        razCaisseTotalTva: "Total IVA",
        razCaisseTotalRetour: "Total devoluciones",
        razCaisseCoutAchat: "Coste de compra",
        razCaisseMargeNette: "Margen neto",
        razCaisseMargePercent: "Margen",
        razCaisseCoefficient: "Coeficiente",
        razCaisseVentesParTaux: "Lista de ventas por tipo de IVA",
        razCaisseEncaissements: "Lista de cobros por forma de pago",
        razCaisseTotaux: "Totales",
        razCaisseColCode: "Código",
        razCaisseColLibelle: "Descripción",
        razCaisseColCaht: "Base",
        razCaisseColCattc: "Con IVA",
        razCaisseColNbArticles: "Nº artículos",
        razCaisseColTva: "IVA",
        razCaisseColMode: "Forma de pago",
        razCaisseColVentes: "Ventas",
        razCaisseColRemboursements: "Reembolsos",
        razCaisseColPrelevements: "Retiros",
        razCaisseColDepenses: "Gastos",
        razCaisseColTotal: "Total",
        razCaisseFondCaisse: "Fondo de caja",
        razCaisseNbSessions: "{nb} sesiones",
        destinatairesRequired: "Se requiere al menos un destinatario",
        destinatairesIsArray: "La lista de destinatarios no es válida",
        destinatairesElemRequired: "Un destinatario está vacío",
        destinatairesElemMin2: "Cada destinatario debe contener al menos 2 caracteres",
        destinatairesElemIsEmail: "Cada destinatario debe ser una dirección de correo válida",
        pdfMustBeAFile: "El PDF adjunto no es un archivo válido",
        pdfMustBeAPdf: "El archivo adjunto debe ser un PDF",
        pdfTooLarge: "El PDF adjunto supera los 50 MB",
        recurrenceRequired: "Debe indicar una recurrencia",
        dateDebutRequired: "Debe indicar una fecha de primera ejecución",
        dateDebutIsDate: "La fecha de primera ejecución no es válida",
        journalComptaEnvoyerMail: "Enviar por correo",
        journalComptaCorpsMail: "Mensaje (opcional)",
        journalComptaMailInfo: "El PDF mostrado se adjunta al correo, junto con un enlace de descarga.",
        journalComptaPublicChargement: "Generando el documento, espere por favor...",
        journalComptaLienInvalide: "Este enlace no es válido o ha caducado.",
        journalAutoExportTitre: "Envío automático de diarios / informes Z",
        journalAutoExportRegle: "Cada ejecución envía el período anterior a su fecha de vencimiento: el día anterior (diario), los 7 días anteriores (semanal) o el mes anterior (mensual). Ejemplo: un vencimiento mensual el 01/10 envía del 01/09 al 30/09. El correo solo contiene un enlace de descarga del documento, sin archivo adjunto.",
        journalAutoExportSansMail: "Ninguna cuenta de correo o destinatario: la ejecución tendrá lugar pero no se enviará ningún correo",
        journalAutoExportAjouter: "Añadir una configuración",
        journalAutoExportModifier: "Modificar la configuración",
        journalAutoExportSupprimerConfirm: "¿Eliminar este envío automático?",
        journalAutoExportAucune: "Ningún envío automático configurado",
        journalAutoExportType: "Documento",
        journalAutoExportFiltres: "Filtros",
        journalAutoExportPremiereEcheance: "Primera ejecución",
        journalAutoExportNbSelection: "{nb} seleccionado(s)",

        // ─── Traducciones ES faltantes (añadidas a posteriori) ─────────────────────
        customFieldArticleMatchRequired: 'El campo "campo personalizado" es obligatorio',
        selectShopsBeforeSearch: 'Seleccione una tienda de origen y de destino antes de buscar un artículo',
        confirmChangeShopTitle: '¿Cambiar de tienda?',
        confirmChangeShopText: 'Cambiar la tienda de origen o de destino borrará su lista de artículos. ¿Desea continuar?',
        exports: 'Exportaciones',
        priceEditableOnTheFly: 'Precio editable al vuelo (PEV)',
        priceEditableOnTheFlyInfo: 'Permite editar el precio mediante una ventana emergente que aparece al añadir el artículo al carrito.',
        rppslAutoGenerationDateDateFormat: 'La fecha de generación automática de RP/PSL no tiene un formato correcto. El formato correcto es AAAA-MM-DD.',
        onlyUncollectedItemsProposed: '(solo se muestran los artículos aún no recogidos en el pedido)',
        notifications: 'Notificaciones',
        notificationModule: 'Módulo',
        notificationAction: 'Acción',
        notificationLocation: 'Ubicación',
        notificationNotifiedUsers: 'Usuario(s) notificado(s)',
        notificationBulkEditUsers: 'Modificar los usuarios notificados',
        notificationBulkDelete: 'Eliminar la selección',
        notificationSelectedCount: '{count} seleccionado(s)',
        selectAll: 'Seleccionar todo',
        selectPlaceholder: '-- Seleccionar --',
        salesOrderNew: 'Nuevo pedido por preparar',
        salesOrderError: 'Error de procesamiento del pedido',
        sectionNotAllowedForDomain: 'Este dominio no puede limitarse a una tienda específica',
        notificationActionShipment: 'Albarán de expedición por recibir',
        notificationActionTo: 'Orden de transferencia por recoger',
        notificationActionItem: 'Artículo temporal creado',
        notificationActionSalesOrderNew: 'Nuevo pedido de comercio electrónico por preparar',
        notificationActionSalesOrderError: 'Pedido de comercio electrónico no procesable',
        notificationActionSalesOrderCollectAssigned: 'Recogida de pedido cliente B2C asignada',
        notificationActionRppslPack: 'Configuración de RP/PSL faltante en un pack RP/PSL',
        allRequired: 'Este campo es obligatorio',
        componentOf: 'Componente: {field}',
        filterRppsl: 'Filtro RP/PSL',
        filterRppslPack: 'Filtro de pack RP/PSL',
        quantiteParent: 'Cantidad padre',
        exportBinsListCsv: 'Exportar la lista de bins en CSV',
        showNeverUsedBinsOnly: 'Mostrar solo los bins nunca utilizados',
        binsHaveStockCantDelete: 'Este bin contiene actualmente stock, no se puede eliminar',
        binsHaveStockCantDeletePlural: 'Estos bins contienen actualmente stock, no se pueden eliminar',
        replacementBinsMustBeDifferent: 'El bin de reemplazo debe ser diferente del bin que se va a eliminar',
        replacementBinsMustBeSameZone: 'El bin de reemplazo debe estar en la misma zona que el bin que se va a eliminar',
        replacementBinsTitle: 'Bins de reemplazo',
        replacementBinsExplanation: 'Uno o varios de los bins seleccionados ya han tenido movimientos de stock en el pasado. Para eliminarlos, elija otro bin de la misma zona que asumirá su historial de movimientos (ej.: 1-2-3).',
        binsMustBeSameZone: 'Los bins seleccionados deben estar todos en la misma zona',
        deleteBinsSelection: 'Eliminar la selección',
        confirmDeleteBinsSelection: '¿Realmente desea eliminar los bins seleccionados:',
        totalEquivalenceDevise: 'Equivalencia {devise}',
        equivalenceDeviseOption: 'Mostrar una equivalencia de moneda',
        equivalenceDeviseHelp: 'Configure a continuación las monedas libres que se pueden ofrecer para mostrar en las facturas y estados de cuenta. Tasa = número de unidades de la moneda local por 1 unidad de la moneda elegida (el importe mostrado es el total dividido por esta tasa).',
        equivalenceDeviseCode: 'Código de moneda',
        noEquivalenceDevise: 'Ninguna',
        addEquivalenceDevise: 'Añadir una moneda',
        tauxConversion: 'Tasa de conversión',
        deviseEquivalenceDuplicate: 'Un código de moneda se usa más de una vez',
        deviseEquivalenceRequired: 'Equivalencia de moneda requerida',
        deviseEquivalenceInvalid: 'Equivalencia de moneda inválida',
        rppslAutoConfigTitle: 'Configuración de reabastecimiento automático RP/PSL',
        rppslAutoGenerationDate: 'Fecha de generación automática de RP/PSL',
        rppslPack: 'Pack RP/PSL',
        enableRppslPackFeature: 'Activar la función de packs RP/PSL',
        rppslPackNameAlreadyExists: 'Ya existe un pack RP/PSL con este nombre.',
        exportRppslPackMissingArticles: 'Exportar los artículos apuntados sin RP/PSL',
        exportRppslPackConfig: 'Exportar la configuración de los packs',
        importRppslPack: 'Importar un pack RP/PSL',
        csvPackName: 'Nombre del pack',
        csvPackMatching: 'Correspondencia',
        createRppslPack: 'Crear un pack RP/PSL',
        editRppslPack: 'Modificar el pack RP/PSL',
        packType: 'Tipo de pack',
        typeSpecial: 'Especial',
        customFieldArticleMatch: 'Campo personalizado (correspondencia de artículo)',
        restrictToSections: 'Restringir a secciones específicas',
        allSections: 'Todas las secciones',
        confirmDeleteRppslPack: 'Eliminar este pack RP/PSL',
        pslGteRp: 'El PSL debe ser mayor o igual al RP',
        productNomenclatureFilters: 'Filtros de nomenclatura de producto',
        addFilterGroup: 'Añadir una selección de criterios',
        noFilterGroup: 'No se ha añadido ninguna selección de criterios',
        noFilterFieldConfigured: 'Ningún campo configurado para los filtros de pack. Configúrelo en Administración > Personalización > RP/PSL > Filtro de pack RP/PSL.',
        rpPslByValueTitle: 'Definir el RP y el PSL para cada valor del campo "{field}"',
        rpPslValuesOptionalHint: 'Puede dejar valores en blanco y validar el pack de todas formas; podrán completarse más tarde mediante importación CSV.',
        and: 'Y',
        filterMode: 'Modo de filtro',
        filterModeInclude: 'Inclusión',
        filterModeExclude: 'Exclusión',
        concernedArticles: 'Artículos concernidos',
        noMatchingArticleValue: 'No se encontró ningún artículo correspondiente a los criterios seleccionados',
        rpPslValuesInvalid: 'Indique un RP y un PSL válidos (PSL mayor o igual al RP) para cada valor',
        excludeFilterSwitch: 'Excluir los productos correspondientes en lugar de incluirlos',
        backToPackList: 'Volver a la lista de packs',
        exportCsvArticles: 'Exportar los artículos en CSV',
        excludeFilterHelp: 'Por defecto, solo los productos que coinciden con las selecciones anteriores se incluyen en este pack. Active esta opción para excluirlos en su lugar: se incluirán todos los demás productos. Sin selección y con la exclusión activada, se incluyen todos los productos.',
        creationDate: 'Fecha de creación',
        setArticlePrice: 'Definir el precio del artículo',
        notifTypeSalesOrder: 'Pedido de cliente (B2C)',
        byShop: 'Por tienda',
        sessionsEnCours: 'Sesiones abiertas',
        sessionsFermees: 'Sesiones cerradas',
        onlyProblemSessions: 'Solo sesiones con diferencia',
        neverOpened: 'Nunca abierta',
        closedOn: 'Cerrada el',
        labelArticleMatching: 'Correspondencia de artículo',
        labelMatchingField: 'Campo de referencia para esta importación',
        labelArticleIdentificationField: 'Campo de identificación de artículos',
        matchingFieldInvalid: 'El campo de coincidencia seleccionado no es válido',
        matchingFieldDisabled: 'El campo de coincidencia seleccionado ya no está activado',
        matchingFieldNotMapped: 'El campo de coincidencia seleccionado no está asociado a ninguna columna CSV',
        matchingFieldEmpty: 'El valor de coincidencia está vacío',
        matchingFieldNotFound: 'Ningún artículo corresponde a este valor',
        matchingFieldAmbiguous: 'Varios artículos corresponden a este valor',
        matchingFieldCreateOrUpdate: 'Creación / Modificación',
        matchingFieldUpdateOnly: 'Modificación',
        importModeCreateTitle: 'Creación',
        importModeUpdateTitle: 'Actualización',
        importModeCreateText: 'Los datos a continuación se crearán porque no ha indicado ninguna correspondencia de {field} con su archivo CSV.',
        importModeUpdateText: 'Los datos a continuación se actualizarán porque ha indicado una correspondencia de {field} con su archivo CSV.',
        recapVenteGiftCard: 'Tarjetas de regalo vendidas',
        fidelite: 'Fidelidad',
      }
    }
  }

  export default translation